import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TemplatesService {

  constructor() { }

  receiptTemplates :any = {
    receiptTemp1 : `
    <div class="card container-fluid p4Rem">
    <div>
        <div class="row">  
          <div class="col-2">
            <img class="hW100px" [src]="displayData.logo" alt="">
          </div>
          <div class="col-7 textCenter ">
            <h3>{{displayData.entityDisplayName}}</h3>
            <p>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </p>
            <p>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </p>
          </div>
          <div class="col-3 textEnd">
            <h4 class="">Parent Copy</h4>
            <h3 class="pt30">Fee Receipt</h3>
          </div>
        </div>
          <div class="row m0">
              <div class="col-8 borderSolid">
    
              <div class="row">
                  <div class="col-12 textCenter borderBottom" >
                    <mat-label>Student Details</mat-label>
                  </div>
    
                  <div class="card-body row">
                    <div class="col-6">
                      <div class="row">{{displayData.displayNamesRegNo}}  : {{displayData.studentRegNo}}</div>
                      <div class="row">Student's Name : {{displayData.studentName}}</div>
                        <div class="row">Father's Name : {{displayData.studentFatherName}}</div>
                    </div>
                    <div class="col-6 ">
                      <div class="row">{{displayData.displayNamesCourse}}  : {{displayData.studentCourse}}</div>
                      <div class="row">Section : {{displayData.studentSection}}</div>
                      <div *ngIf="displayData.entityPreferencesShowBatch" class="row">Batch  : {{displayData.studentBatch}}</div>
                      <div class="row">Stream : {{displayData.studentStream}}</div>
                    </div>
                  </div>
              </div>
              </div>
              <div class="col-4 borderSolid">
                
                <div class="row">
        
                    <div class="col-12 textCenter borderBottom" >
                      <mat-label>Payment Details</mat-label>
                    </div>
                    
                    <div class="card-body row">
                      <div class="col-12">
                        <div class="row">
                          <div class="col-6">
                            <span>Receipt No  </span>
                          </div>
                          <div class="col-2">
                            :
                          </div>
                          <div class="col-4 textEnd">
                            <span>{{displayData.receiptId}} </span>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                      <div class="row">
                        <div class="col-6">
                          <span>Receipt Date</span>
                        </div>
                        <div class="col-2">
                          :
                        </div>
                        <div class="col-4 textEnd">
                          {{displayData.date | date: 'dd/MM/yyyy'}}
                        </div>
                      </div>
                      </div>
                      <div class="col-12">
                        <div class="row">
                            <div class="col-6">
                              <span>Academic Year</span>
                            </div>
                            <div class="col-2">
                              :
                            </div>
                            <div class="col-4 textEnd">
                              {{displayData.session}}
                            </div>
                        </div>
                      </div>
                      
                      <div class="col-12">
                          <div class="row">
                            <div class="col-6">
                              <span>Total Paid Amount</span>
                            </div>
                            <div class="col-2">
                              :
                            </div>
                            <div class="col-4 textEnd">
                              {{displayData.totalPaidAmount | number : '1.2-2' }}
                            </div>
                          </div>
                      </div>
                    </div>
                </div>
              </div>
          </div>
          
        <div *ngIf="!displayData.hasError" class="">
        
        <table class="table fontFamily mt3p">
        <thead class="borderS1P mt3p">
            <th  class=" fwBoldvw" >
               S.No
            </th>
            <th  class=" fwBoldvw">
              Fee Head
             </th>
             <th  class=" fwBoldvw" >
              Installment
           </th>
            <th  class=" fwBoldvw">
              Paid Amount
             </th>
        </thead>
        <tbody>
            <tr *ngFor="let row of displayData.dataSource.data; let i = index" >
              <td>
                {{i+1}}
              </td>
              <td>
                  {{row.feeHead}}
              </td>
              <td>
                  {{row.installment}}
              </td>
              <td>
                  {{row.paidAmount | number : '1.2-2'}}
              </td>
            </tr>
        </tbody>
      </table>
          
          <div class="row">
            <div class="col-6 textEnd">
              Total Invoice
            </div>
            <div class="col-4 textEnd ">
              {{displayData.totalPaybleAmount | number : '1.2-2' }}
            </div>
          </div>
          <div class="row">
            <div class="col-6 textEnd">
              Net Paid Amount
            </div>
            <div class="col-4 textEnd">
              {{displayData.totalPaidAmount | number : '1.2-2' }}
            </div>
          </div>
          <div class="row">
            <div class="col-6 textEnd">
              Balance Due
            </div>
            <div class="col-4 textEnd  ">
              {{displayData.balance | number : '1.2-2' }}
            </div>
          </div>
          
          <div class="row mt3p m0">
            <div class="col-2 borderSolid">
              <div class="row">
                <div class="col-12 textCenter borderBottom">
                  <mat-label>Paymet Mode</mat-label>
                </div>
                <div class="col-12 textCenter">
                  {{displayData.paymentDetailsPaymentMode}}
                </div>
              </div>
            </div>
            <div [hidden]="!displayData.cheque" class="col-2 borderSolid">
              <div class="row">
                <div class="col-12 textCenter borderBottom">
                  <mat-label>Cheque No.</mat-label>
                </div>
                <div class="col-12 textCenter">
                  {{displayData.paymentDetailsRefId}}
                </div>
              </div>
            </div>
            <div [hidden]="!displayData.demandDraft" class="col-2 borderSolid">
              <div class="row">
                <div class="col-12 textCenter borderBottom">
                  <mat-label>Demand Draft No.</mat-label>
                </div>
                <div class="col-12 textCenter">
                  {{displayData.paymentDetailsRefId}}
                </div>
              </div>
            </div>
            <div [hidden]="!displayData.cash" class="col-2 borderSolid">
              <div class="row">
                <div class="col-12 textCenter borderBottom">
                  <mat-label>Referernce No.</mat-label>
                </div>
                <div class="col-12 textCenter">
                  {{displayData.paymentDetailsRefId}}
                </div>
              </div>
            </div>
            <div [hidden]="displayData.cash" class="col-4 borderSolid">
              <div class="row">
                <div class="col-12 textCenter borderBottom">
                  <mat-label>Bank Name</mat-label>
                </div>
                <div class="col-12 textCenter">
                  {{displayData.paymentDetailsBankName}}
                </div>
              </div>
            </div>
            <div [hidden]="!displayData.cheque" class="col-2 borderSolid">
              <div class="row">
                <div class="col-12 textCenter borderBottom">
                  <mat-label>Cheque Date</mat-label>
                </div>
                <div class="col-12 textCenter">
                  {{displayData.paymentDetailsDate | date: 'dd/MM/yyyy'}}
                </div>
              </div>
            </div>
            <div [hidden]="!displayData.demandDraft" class="col-2 borderSolid">
              <div class="row">
                <div class="col-12 textCenter borderBottom">
                  <mat-label>Demand Draft Date</mat-label>
                </div>
                <div class="col-12 textCenter">
                  {{displayData.paymentDetailsDate | date: 'dd/MM/yyyy'}}
                </div>
              </div>
            </div>
            <div [hidden]="displayData.cash" class="col-2 borderSolid">
              <div class="row">
                <div class="col-12 textCenter borderBottom">
                  <mat-label>Net Paid Amount</mat-label>
                </div>
                <div class="col-12 textCenter">
                  {{displayData.totalPaidAmount | number : '1.2-2' }}
                </div>
              </div>
            </div>
            <div [hidden]="!displayData.cash" class="col-2 borderSolid offset-6">
              <div class="row">
                <div class="col-12 textCenter borderBottom">
                  <mat-label>Net Paid Amount</mat-label>
                </div>
                <div class="col-12 textCenter">
                  {{displayData.totalPaidAmount | number : '1.2-2' }}
                </div>
              </div>
            </div>
          </div>

          <div class="kt-space-20"></div>
          <div class="kt-space-20"></div>
        <div class="row justifyFlexEnd m0">
          <div> 
            <label>Fees Clerk/Accountant</label>
          </div>
        </div>

        <div class="kt-space-20"></div>
        <div class="kt-space-20"></div>
        
        </div>
   </div>
   <div class="kt-space-20"></div>
  </div>
    `,
    receiptTemp2 : `
    <div class="landscape card container-fluid p4Rem">
      <div class="row">  
        <div class="col-2">
          <img class="hW100px" [src]="displayData.logo" alt="">
        </div>
        <div class="col-7 textCenter ">
          <h3>{{displayData.entityDisplayName}}</h3>
          <p>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </p>
          <p>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </p>
        </div>
        <div class="col-3 textEnd">
          <h3 class="">Fee Receipt</h3>
        </div>
      </div>
        <div class="row m0">
            <div class="col-8 borderSolid">

            <div class="row">
                <div class="col-12 textCenter borderBottom" >
                  <mat-label>Student Details</mat-label>
                </div>

                <div class="card-body row">
                  <div class="col-6">
                    <div class="row">{{displayData.displayNamesRegNo}} : {{displayData.studentRegNo}}</div>
                    <div class="row">Student's Name : {{displayData.studentName}}</div>
                      <div class="row">Father's Name : {{displayData.studentFatherName}}</div>
                  </div>
                  <div class="col-6 ">
                    <div class="row">{{displayData.displayNamesCourse}} : {{displayData.studentCourse}}</div>
                    <div class="row">Section : {{displayData.studentSection}}</div>
                    <div *ngIf="displayData.entityPreferencesShowBatch" class="row">Batch : {{displayData.studentBatch}}</div>
                    <div class="row">Stream : {{displayData.studentStream}}</div>
                  </div>
                </div>
            </div>
          </div>
          <div class="col-4 borderSolid">
            
          <div class="row">

              <div class="col-12 textCenter borderBottom" >
                <mat-label>Payment Details</mat-label>
              </div>
              <div class="card-body row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-6">
                      <span>Receipt No  </span>
                    </div>
                    <div class="col-2">
                      :
                    </div>
                    <div class="col-4 textEnd">
                      <span>{{displayData.receiptId}} </span>
                    </div>
                  </div>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-6">
                    <span>Receipt Date</span>
                  </div>
                  <div class="col-2">
                    :
                  </div>
                  <div class="col-4 textEnd">
                    {{displayData.date | date: 'dd/MM/yyyy'}}
                  </div>
                </div>
            </div>
                  <div class="col-12">
                    <div class="row">
                        <div class="col-6">
                          <span>Academic Year</span>
                        </div>
                        <div class="col-2">
                          :
                        </div>
                        <div class="col-4 textEnd">
                          {{displayData.session}}
                        </div>
                    </div>
                  </div>
                
                  <div class="col-12">
                      <div class="row">
                        <div class="col-6">
                          <span>Total Paid Amount</span>
                        </div>
                        <div class="col-2">
                          :
                        </div>
                        <div class="col-4 textEnd">
                          {{displayData.totalPaidAmount | number : '1.2-2' }}
                        </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
        
    <div [hidden]="hasError" class="">
      
    <table class="table fontFamily mt3p">
    <thead class="borderS1P mt3p">
        <th  class=" fwBoldvw" >
           S.No
        </th>
        <th  class=" fwBoldvw">
          Fee Head
         </th>
         <th  class=" fwBoldvw" >
          Installment
       </th>
        <th  class=" fwBoldvw">
          Paid Amount
         </th>
    </thead>
    <tbody>
        <tr *ngFor="let row of displayData.dataSource.data; let i = index" >
          <td>
            {{i+1}}
          </td>
          <td>
              {{row.feeHead}}
          </td>
          <td>
              {{row.installment}}
          </td>
          <td>
              {{row.paidAmount | number : '1.2-2'}}
          </td>
        </tr>
    </tbody>
  </table>
        <div class="row">
          <div class="col-6 textEnd">
            Total Invoice
          </div>
          <div class="col-4 textEnd ">
            {{displayData.totalPaybleAmount | number : '1.2-2' }}
          </div>
        </div>
        <div class="row">
          <div class="col-6 textEnd">
            Net Paid Amount
          </div>
          <div class="col-4 textEnd">
            {{displayData.totalPaidAmount | number : '1.2-2' }}
          </div>
        </div>
        <div class="row">
          <div class="col-6 textEnd">
            Balance Due
          </div>
          <div class="col-4 textEnd  ">
            {{displayData.balance | number : '1.2-2' }}
          </div>
        </div>
        <div class="row mt3p m0">
          <div class="col-2 borderSolid">
            <div class="row">
              <div class="col-12 textCenter borderBottom">
                <mat-label>Paymet Mode</mat-label>
              </div>
              <div class="col-12 textCenter">
                {{displayData.paymentDetailsPaymentMode}}
              </div>
            </div>
          </div>
          <div [hidden]="!displayData.cheque" class="col-2 borderSolid">
            <div class="row">
              <div class="col-12 textCenter borderBottom">
                <mat-label>Cheque No.</mat-label>
              </div>
              <div class="col-12 textCenter">
                {{displayData.paymentDetailsRefId}}
              </div>
            </div>
          </div>
          <div [hidden]="!displayData.demandDraft" class="col-2 borderSolid">
            <div class="row">
              <div class="col-12 textCenter borderBottom">
                <mat-label>Demand Draft No.</mat-label>
              </div>
              <div class="col-12 textCenter">
                {{displayData.paymentDetailsRefId}}
              </div>
            </div>
          </div>
          <div [hidden]="!displayData.cash" class="col-2 borderSolid">
            <div class="row">
              <div class="col-12 textCenter borderBottom">
                <mat-label>Referernce No.</mat-label>
              </div>
              <div class="col-12 textCenter">
                {{displayData.paymentDetailsRefId}}
              </div>
            </div>
          </div>
          <div [hidden]="displayData.cash" class="col-4 borderSolid">
            <div class="row">
              <div class="col-12 textCenter borderBottom">
                <mat-label>Bank Name</mat-label>
              </div>
              <div class="col-12 textCenter">
                {{displayData.paymentDetailsBankName}}
              </div>
            </div>
          </div>
          <div [hidden]="!displayData.cheque" class="col-2 borderSolid">
            <div class="row">
              <div class="col-12 textCenter borderBottom">
                <mat-label>Cheque Date</mat-label>
              </div>
              <div class="col-12 textCenter">
                {{displayData.paymentDetailsDate | date: 'dd/MM/yyyy'}}
              </div>
            </div>
          </div>
          <div [hidden]="!displayData.demandDraft" class="col-2 borderSolid">
            <div class="row">
              <div class="col-12 textCenter borderBottom">
                <mat-label>Demand Draft Date</mat-label>
              </div>
              <div class="col-12 textCenter">
                {{displayData.paymentDetailsDate | date: 'dd/MM/yyyy'}}
              </div>
            </div>
          </div>
          <div [hidden]="displayData.cash" class="col-2 borderSolid">
            <div class="row">
              <div class="col-12 textCenter borderBottom">
                <mat-label>Net Paid Amount</mat-label>
              </div>
              <div class="col-12 textCenter">
                {{displayData.totalPaidAmount | number : '1.2-2' }}
              </div>
            </div>
          </div>
          <div [hidden]="!displayData.cash" class="col-2 borderSolid offset-6">
            <div class="row">
              <div class="col-12 textCenter borderBottom">
                <mat-label>Net Paid Amount</mat-label>
              </div>
              <div class="col-12 textCenter">
                {{displayData.totalPaidAmount | number : '1.2-2' }}
              </div>
            </div>
          </div>
        </div>
        
        <div class="kt-space-20"></div>
      </div>

    </div>
    `,
    multiReceiptTemp1 : `
    <div class="card container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="row">  
          <div class="col-4">
            <img class="hW100px img-rounded" [src]="displayData.logo" alt="">
          </div>
          <div class="col-8 textCenter ">
            <h4>{{displayData.entityDisplayName}}</h4>
            <span>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </span> <br>
            <span>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </span>
          </div>
        
        </div>
          <div class="row m0 borderSolid">
              <div class="col-12 textCenter borderBottom" >
                <mat-label> <strong> Fee Receipt </strong> </mat-label>
              </div>
              <div class="col-7 ">
    
                  <div class="card-body">
                      <div class="row">
                        <div class="col-6 p0">
                          <strong> Receipt No  </strong>
                        </div>
                        <div class="col-6 p0">
                          <span> : {{displayData.receiptId}} </span>
                        </div> 
                      </div>
                      <div class="row">
                        <div class="col-6 p0">
                          <strong> {{displayData.displayNamesRegNo}} </strong>
                        </div>
                        <div class="col-6 p0">
                          <span> : {{displayData.studentRegNo}} </span>
                        </div> 
                      </div><div class="row">
                        <div class="col-6 p0">
                          <strong> Student's Name  </strong>
                        </div>
                        <div class="col-6 p0">
                          <span> : {{displayData.studentName}} </span>
                        </div> 
                      </div><div class="row">
                        <div class="col-6 p0">
                          <strong> Father's Name  </strong>
                        </div>
                        <div class="col-6 p0">
                          <span> : {{displayData.studentFatherName}} </span>
                        </div> 
                      </div>
                      
                  
                  </div>
            </div>
            <div class="col-5 ">
                <div class="card-body ">
                    <div class="row">
                      <div class="col-5 p0">
                        <strong>Date</strong>
                      </div> 
                      <div class="col-7 p0">
                        :  {{displayData.date | date: 'dd/MM/yyyy'}}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-5 p0">
                        <strong>   Session  </strong>
                      </div> 
                      <div class="col-7 p0">
                        :  {{displayData.session}}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-5 p0">
                        <strong>  {{displayData.displayNamesCourse}}  </strong>
                      </div> 
                      <div class="col-7 p0">
                        :  {{displayData.studentCourse}}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-5 p0">
                        <strong>  Contact  </strong>
                      </div> 
                      <div class="col-7 p0">
                        :  {{displayData.studentPhone}}
                      </div>
                    </div>
                  
                
                </div>
          
          </div>
        </div>
          
        <div *ngIf="!hasError" class="">
        <table class="table fontFamily mt3p">
        <thead class="borderS1P mt3p">
            <th  class=" fwBoldvw" >
               S.No
            </th>
            <th  class=" fwBoldvw">
              Fee Head
             </th>
             <th  class=" fwBoldvw" >
              Installment
           </th>
            <th  class=" fwBoldvw">
              Paid Amount
             </th>
        </thead>
        <tbody>
            <tr *ngFor="let row of displayData.dataSource.data; let i = index" >
              <td>
                {{i+1}}
              </td>
              <td>
                  {{row.feeHead}}
              </td>
              <td>
                  {{row.installment}}
              </td>
              <td>
                  {{row.paidAmount | number : '1.2-2'}}
              </td>
            </tr>
        </tbody>
      </table>

        <div class="colorBlackDark">
          <div class="row">
            <div class="col-7 ">
              Payment Mode
            </div>
            <div class="col-1 ">
              :
            </div>
            <div class="col-4 textEnd ">
              {{displayData.paymentDetailsPaymentMode}}
            </div>
          </div>
          <div class="row">
            <div class="col-7 ">
              Instrument Date
            </div>
            <div class="col-1 ">
              :
            </div>
            <div class="col-4 textEnd ">
              {{displayData.paymentDetailsDate | date: 'dd/MM/yyyy'}}
            </div>
          </div>
          <div class="row">
            <div class="col-7 ">
              Instrument Number
            </div>
            <div class="col-1 ">
              :
            </div>
            <div class="col-4 textEnd ">
              {{displayData.paymentDetailsRefId}}
            </div>
          </div>
          <div class="row">
            <div class="col-7 ">
              Total Invoice
            </div>
            <div class="col-1 ">
              :
            </div>
            <div class="col-4 textEnd ">
              {{displayData.totalPaybleAmount | number : '1.2-2' }}
            </div>
          </div>
          <div class="row">
            <div class="col-7 ">
              Net Paid Amount
            </div>
            <div class="col-1 ">
              :
            </div>
            <div class="col-4 textEnd">
              {{displayData.totalPaidAmount | number : '1.2-2' }}
            </div>
          </div>
          <div class="row">
            <div class="col-7">
              Balance Due
            </div>
            <div class="col-1 ">
              :
            </div>
            <div class="col-4 textEnd  ">
              {{displayData.balance | number : '1.2-2' }}
            </div>
          </div>
        </div>
          <div class="kt-space-20"></div>
          <div class="kt-space-20"></div>
        <div class="row justifyFlexEnd m0">
          <div class="col-12">
            <strong>Remarks :</strong>
            {{displayData.remark}}
          </div>
          <div class="col-8">
            <strong> Amount in Words: </strong>
              Rs {{displayData.totalPaidAmountWords.toUpperCase()}} ONLY
          </div>
          <div class="col-4 p0"> 
            <label>Fees Clerk/Accountant</label>
          </div>
        </div>

        <div class="kt-space-20"></div>
        <div class="kt-space-20"></div>
        
        </div>
    </div>
    </div>
  </div>
  
    `,
    multiReceiptTemp2 : `
    <div class="container-fluid">
   <div style="font-size: large; font-weight: 700;" class="row">
      <div class="col-12">
         <div class="row">
            <div class="col-2">
               <img class="hW100px img-rounded" [src]="displayData.logo" alt="">
            </div>
            <div class="col-8 textCenter ">
               <h1>{{displayData.entityDisplayName}}</h1>
               <span>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </span> <br>
               <span>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </span>
            </div>
         </div>
         <div class="row m0 borderSolid">
            <div class="col-12 textCenter borderBottom" >
               <mat-label> <strong> Fee Receipt ({{displayData.session}}) </strong> </mat-label>
            </div>
            <div class="col-7 ">
               <div class="card-body">
                  <div class="row">
                     <div class="col-6 p0">
                        <strong> Receipt No  </strong>
                     </div>
                     <div class="col-6 p0">
                        <span> : {{displayData.receiptId}} </span>
                     </div>
                  </div>
                  <div class="row">
                     <div class="col-6 p0">
                        <strong> {{displayData.displayNamesRegNo}} </strong>
                     </div>
                     <div class="col-6 p0">
                        <span> : {{displayData.studentRegNo}} </span>
                     </div>
                  </div>
                  <div class="row">
                     <div class="col-6 p0">
                        <strong> Student's Name  </strong>
                     </div>
                     <div class="col-6 p0">
                        <span> : {{displayData.studentName}} </span>
                     </div>
                  </div>
                  <div class="row">
                     <div class="col-6 p0">
                        <strong> Father's Name  </strong>
                     </div>
                     <div class="col-6 p0">
                        <span> : {{displayData.studentFatherName}} </span>
                     </div>
                  </div>
               </div>
            </div>
            <div class="col-5 ">
               <div class="card-body ">
                  <div class="row">
                     <div class="col-5 p0">
                        <strong>Date</strong>
                     </div>
                     <div class="col-7 p0">
                        :  {{displayData.date | date: 'dd/MM/yyyy'}}
                     </div>
                  </div>
                  <div class="row">
                     <div class="col-5 p0">
                        <strong>  Contact  </strong>
                     </div>
                     <div class="col-7 p0">
                        :  {{displayData.studentPhone}}
                     </div>
                  </div>
                  <div class="row">
                     <div class="col-5 p0">
                        <strong>  {{displayData.displayNamesCourse}}  </strong>
                     </div>
                     <div class="col-7 p0">
                        :  {{displayData.studentCourse}}
                     </div>
                  </div>
                  <div class="row">
                     <div class="col-5 p0">
                        <strong> Section</strong>
                     </div>
                     <div class="col-7 p0">
                        :  {{displayData.studentSection}}
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div *ngIf="!hasError" class="">
            <table class="table fontFamily mt3p">
               <thead class="borderS1P mt3p">
                  <th style="font-size:17px;font-weight:700;">
                     S.No
                  </th>
                  <th  style="font-size:17px;font-weight:700;">
                     Fee Head
                  </th>
                  <th  style="font-size:17px;font-weight:700;">
                     Installment
                  </th>
                  <th style="font-size:17px;font-weight:700;">
                     Payable Amount
                  </th>
                  <th  style="font-size:17px;font-weight:700;">
                     Paid Amount
                  </th>
               </thead>
               <tbody>
                  <tr *ngFor="let row of displayData.dataSource.data; let i = index" >
                     <td>
                        {{i+1}}
                     </td>
                     <td>
                        {{row.feeHead}}
                     </td>
                     <td>
                        {{row.installment}}
                     </td>
                     <td>
                        <div *ngIf="row.payableAmount !=0">
                           {{row.payableAmount  | number : '1.2-2' }}
                        </div>
                        <div  *ngIf="row.payableAmount ==0">
                           NA
                        </div>
                     </td>
                     <td>
                        {{row.paidAmount | number : '1.2-2'}}
                     </td>
                  </tr>
               </tbody>
            </table>
            <div class="colorBlackDark">
               <div class="row">
                  <div class="col-7 ">
                     Payment Mode
                  </div>
                  <div class="col-1 ">
                     :
                  </div>
                  <div class="col-4 textEnd ">
                     {{displayData.paymentDetailsPaymentMode}}
                  </div>
               </div>
               <!-- <div class="row">
                  <div class="col-7 ">
                    Instrument Date
                  </div>
                  <div class="col-1 ">
                    :
                  </div>
                  <div class="col-4 textEnd ">
                    {{displayData.paymentDetailsDate | date: 'dd/MM/yyyy'}}
                  </div>
                  </div>-->
               <div class="row">
                  <div class="col-7 ">
                     Ref/Chq. Number
                  </div>
                  <div class="col-1 ">
                     :
                  </div>
                  <div class="col-4 textEnd ">
                     {{displayData.paymentDetailsRefId}}
                  </div>
               </div>
               <div class="row">
                  <div class="col-7 ">
                     Total Invoice
                  </div>
                  <div class="col-1 ">
                     :
                  </div>
                  <div class="col-4 textEnd ">
                     {{displayData.totalPaybleAmount | number : '1.2-2' }}
                  </div>
               </div>
               <div class="row">
                  <div class="col-7 ">
                     Net Paid Amount
                  </div>
                  <div class="col-1 ">
                     :
                  </div>
                  <div class="col-4 textEnd">
                     {{displayData.totalPaidAmount | number : '1.2-2' }}
                  </div>
               </div>
               <div class="row">
                  <div class="col-7">
                     Balance Due
                  </div>
                  <div class="col-1 ">
                     :
                  </div>
                  <div class="col-4 textEnd  ">
                     {{displayData.balance | number : '1.2-2' }}
                  </div>
               </div>
            </div>
            <div class="kt-space-20"></div>
            <div class="kt-space-20"></div>
            <div class="row justifyFlexEnd m0">
               <div class="col-12">
                  <strong>Remarks :</strong>
                  {{displayData.remark}}
               </div>
               <div class="col-8">
                  <strong> Amount in Words: </strong>
                  Rs {{displayData.totalPaidAmountWords.toUpperCase()}} ONLY
               </div>
               <div class="col-4 p0"> 
                  <label>Fees Clerk/Accountant</label>
               </div>
            </div>
            <div class="kt-space-20"></div>
            <div class="kt-space-20"></div>
         </div>
      </div>
   </div>
</div>
    `,
    receiptVerticaltemplate3slips : `
    <div class="card container-fluid">
    <div class="row">
        <div class="col-4 borderLeftD1p">
            <div class="row">  
                <div class="col-4">
                <img class="hW100px img-rounded" [src]="displayData.logo" alt="">
                </div>
                <div class="col-8 textCenter ">
                <h4>{{displayData.entityDisplayName}}</h4>
                <span>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </span> <br>
                <span>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </span>
                </div>
            
            </div>
                <div class="row m0 borderSolid">
                    <div class="col-12 textCenter borderBottom" >
                    <mat-label> <strong> Fee Receipt </strong> </mat-label>
                    </div>
                    <div class="col-12 ">

                        <div class="card-body">
                            <div class="row">
                            <div class="col-6 p0">
                                <strong> Receipt No  </strong>
                            </div>
                            <div class="col-6 p0">
                                <span> : {{displayData.receiptId}} </span>
                            </div> 
                            </div>
                            <div class="row">
                            <div class="col-6 p0">
                                <strong> {{displayData.displayNamesRegNo}} </strong>
                            </div>
                            <div class="col-6 p0">
                                <span> : {{displayData.studentRegNo}} </span>
                            </div> 
                            </div><div class="row">
                            <div class="col-6 p0">
                                <strong> Student's Name  </strong>
                            </div>
                            <div class="col-6 p0">
                                <span> : {{displayData.studentName}} </span>
                            </div> 
                            </div><div class="row">
                            <div class="col-6 p0">
                                <strong> Father's Name  </strong>
                            </div>
                            <div class="col-6 p0">
                                <span> : {{displayData.studentFatherName}} </span>
                            </div> 
                            </div>
                            <div class="row">
                            <div class="col-6 p0">
                                <strong>Date</strong>
                            </div> 
                            <div class="col-6 p0">
                                :  {{displayData.date | date: 'dd/MM/yyyy'}}
                            </div>
                            </div>
                            <div class="row">
                            <div class="col-6 p0">
                                <strong>   Session  </strong>
                            </div> 
                            <div class="col-6 p0">
                                :  {{displayData.session}}
                            </div>
                            </div>
                            <div class="row">
                            <div class="col-6 p0">
                                <strong>  {{displayData.displayNamesCourse}}  </strong>
                            </div> 
                            <div class="col-6 p0">
                                :  {{displayData.studentCourse}}
                            </div>
                            </div>
                            <div class="row">
                            <div class="col-6 p0">
                                <strong>  Contact  </strong>
                            </div> 
                            <div class="col-6 p0">
                                :  {{displayData.studentPhone}}
                            </div>
                            </div>
                        </div>
                </div>
            </div>
            <div *ngIf="!hasError" class="">
                <table class="table fontFamily mt3p">
                <thead class="borderS1P mt3p">
                    <th  class=" fwBoldvw" >
                        S.No
                    </th>
                    <th  class=" fwBoldvw">
                        Fee Head
                        </th>
                        <!-- <th  class=" fwBoldvw" >
                        Installment
                    </th> -->
                    <th  class=" fwBoldvw">
                        Payable Amount
                    </th>
                    <th  class=" fwBoldvw">
                        Paid Amount
                        </th>
                </thead>
                <tbody>
                    <tr *ngFor="let row of displayData.dataSource.data; let i = index" >
                        <td>
                        {{i+1}}
                        </td>
                        <td>
                            {{row.feeHead}}
                        </td>
                        <!-- <td>
                            {{row.installment}}
                        </td> -->
                        <td>
                        <div *ngIf="row.payableAmount !=0">
                        {{row.payableAmount  | number : '1.2-2' }}
                        </div>
                        <div  *ngIf="row.payableAmount ==0">
                            NA
                        </div>
                        </td>
                        <td>
                            {{row.paidAmount | number : '1.2-2'}}
                        </td>
                    </tr>
                </tbody>
                </table>

                <div class="colorBlackDark">
                    <div class="row">
                    <div class="col-7 ">
                        Payment Mode
                    </div>
                    <div class="col-1 ">
                        :
                    </div>
                    <div class="col-4 textEnd ">
                        {{displayData.paymentDetailsPaymentMode}}
                    </div>
                    </div>
                    <div class="row">
                    <div class="col-7 ">
                        Instrument Date
                    </div>
                    <div class="col-1 ">
                        :
                    </div>
                    <div class="col-4 textEnd ">
                        {{displayData.paymentDetailsDate | date: 'dd/MM/yyyy'}}
                    </div>
                    </div>
                    <div class="row">
                    <div class="col-7 ">
                        Instrument Number
                    </div>
                    <div class="col-1 ">
                        :
                    </div>
                    <div class="col-4 textEnd ">
                        {{displayData.paymentDetailsRefId}}
                    </div>
                    </div>
                    <div class="row">
                    <div class="col-7 ">
                        Total Invoice
                    </div>
                    <div class="col-1 ">
                        :
                    </div>
                    <div class="col-4 textEnd ">
                        {{displayData.totalPaybleAmount | number : '1.2-2' }}
                    </div>
                    </div>
                    <div class="row">
                    <div class="col-7 ">
                        Net Paid Amount
                    </div>
                    <div class="col-1 ">
                        :
                    </div>
                    <div class="col-4 textEnd">
                        {{displayData.totalPaidAmount | number : '1.2-2' }}
                    </div>
                    </div>
                    <div class="row">
                    <div class="col-7">
                        Balance Due
                    </div>
                    <div class="col-1 ">
                        :
                    </div>
                    <div class="col-4 textEnd  ">
                        {{displayData.balance | number : '1.2-2' }}
                    </div>
                    </div>
                </div>
                    <div class="kt-space-20"></div>
                    <div class="kt-space-20"></div>
                <div class="row justifyFlexEnd m0">
                    <div class="col-12">
                    <strong>Remarks :</strong>
                    {{displayData.remark}}
                    </div>
                    <div class="col-8">
                    <strong> Amount in Words: </strong>
                        Rs {{displayData.totalPaidAmountWords.toUpperCase()}} ONLY
                    </div>
                    <div class="col-4 p0"> 
                    <label>Fees Clerk/Accountant</label>
                    </div>
                </div>

                <div class="kt-space-20"></div>
                <div class="kt-space-20"></div>
            
            </div>
        </div>
        <div class="col-4 borderLeftD1p">
            <div class="row">  
                <div class="col-4">
                <img class="hW100px img-rounded" [src]="displayData.logo" alt="">
                </div>
                <div class="col-8 textCenter ">
                <h4>{{displayData.entityDisplayName}}</h4>
                <span>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </span> <br>
                <span>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </span>
                </div>
            
            </div>
                <div class="row m0 borderSolid">
                    <div class="col-12 textCenter borderBottom" >
                    <mat-label> <strong> Fee Receipt </strong> </mat-label>
                    </div>
                    <div class="col-12 ">

                        <div class="card-body">
                            <div class="row">
                            <div class="col-6 p0">
                                <strong> Receipt No  </strong>
                            </div>
                            <div class="col-6 p0">
                                <span> : {{displayData.receiptId}} </span>
                            </div> 
                            </div>
                            <div class="row">
                            <div class="col-6 p0">
                                <strong> {{displayData.displayNamesRegNo}} </strong>
                            </div>
                            <div class="col-6 p0">
                                <span> : {{displayData.studentRegNo}} </span>
                            </div> 
                            </div><div class="row">
                            <div class="col-6 p0">
                                <strong> Student's Name  </strong>
                            </div>
                            <div class="col-6 p0">
                                <span> : {{displayData.studentName}} </span>
                            </div> 
                            </div><div class="row">
                            <div class="col-6 p0">
                                <strong> Father's Name  </strong>
                            </div>
                            <div class="col-6 p0">
                                <span> : {{displayData.studentFatherName}} </span>
                            </div> 
                            </div>
                            <div class="row">
                            <div class="col-6 p0">
                                <strong>Date</strong>
                            </div> 
                            <div class="col-6 p0">
                                :  {{displayData.date | date: 'dd/MM/yyyy'}}
                            </div>
                            </div>
                            <div class="row">
                            <div class="col-6 p0">
                                <strong>   Session  </strong>
                            </div> 
                            <div class="col-6 p0">
                                :  {{displayData.session}}
                            </div>
                            </div>
                            <div class="row">
                            <div class="col-6 p0">
                                <strong>  {{displayData.displayNamesCourse}}  </strong>
                            </div> 
                            <div class="col-6 p0">
                                :  {{displayData.studentCourse}}
                            </div>
                            </div>
                            <div class="row">
                            <div class="col-6 p0">
                                <strong>  Contact  </strong>
                            </div> 
                            <div class="col-6 p0">
                                :  {{displayData.studentPhone}}
                            </div>
                            </div>
                        </div>
                </div>
            </div>
            <div *ngIf="!hasError" class="">
                <table class="table fontFamily mt3p">
                <thead class="borderS1P mt3p">
                    <th  class=" fwBoldvw" >
                        S.No
                    </th>
                    <th  class=" fwBoldvw">
                        Fee Head
                        </th>
                        <!-- <th  class=" fwBoldvw" >
                        Installment
                    </th> -->
                    <th  class=" fwBoldvw">
                        Payable Amount
                    </th>
                    <th  class=" fwBoldvw">
                        Paid Amount
                        </th>
                </thead>
                <tbody>
                    <tr *ngFor="let row of displayData.dataSource.data; let i = index" >
                        <td>
                        {{i+1}}
                        </td>
                        <td>
                            {{row.feeHead}}
                        </td>
                        <!-- <td>
                            {{row.installment}}
                        </td> -->
                        <td>
                        <div *ngIf="row.payableAmount !=0">
                        {{row.payableAmount  | number : '1.2-2' }}
                        </div>
                        <div  *ngIf="row.payableAmount ==0">
                            NA
                        </div>
                        </td>
                        <td>
                            {{row.paidAmount | number : '1.2-2'}}
                        </td>
                    </tr>
                </tbody>
                </table>

                <div class="colorBlackDark">
                    <div class="row">
                    <div class="col-7 ">
                        Payment Mode
                    </div>
                    <div class="col-1 ">
                        :
                    </div>
                    <div class="col-4 textEnd ">
                        {{displayData.paymentDetailsPaymentMode}}
                    </div>
                    </div>
                    <div class="row">
                    <div class="col-7 ">
                        Instrument Date
                    </div>
                    <div class="col-1 ">
                        :
                    </div>
                    <div class="col-4 textEnd ">
                        {{displayData.paymentDetailsDate | date: 'dd/MM/yyyy'}}
                    </div>
                    </div>
                    <div class="row">
                    <div class="col-7 ">
                        Instrument Number
                    </div>
                    <div class="col-1 ">
                        :
                    </div>
                    <div class="col-4 textEnd ">
                        {{displayData.paymentDetailsRefId}}
                    </div>
                    </div>
                    <div class="row">
                    <div class="col-7 ">
                        Total Invoice
                    </div>
                    <div class="col-1 ">
                        :
                    </div>
                    <div class="col-4 textEnd ">
                        {{displayData.totalPaybleAmount | number : '1.2-2' }}
                    </div>
                    </div>
                    <div class="row">
                    <div class="col-7 ">
                        Net Paid Amount
                    </div>
                    <div class="col-1 ">
                        :
                    </div>
                    <div class="col-4 textEnd">
                        {{displayData.totalPaidAmount | number : '1.2-2' }}
                    </div>
                    </div>
                    <div class="row">
                    <div class="col-7">
                        Balance Due
                    </div>
                    <div class="col-1 ">
                        :
                    </div>
                    <div class="col-4 textEnd  ">
                        {{displayData.balance | number : '1.2-2' }}
                    </div>
                    </div>
                </div>
                    <div class="kt-space-20"></div>
                    <div class="kt-space-20"></div>
                <div class="row justifyFlexEnd m0">
                    <div class="col-12">
                    <strong>Remarks :</strong>
                    {{displayData.remark}}
                    </div>
                    <div class="col-8">
                    <strong> Amount in Words: </strong>
                        Rs {{displayData.totalPaidAmountWords.toUpperCase()}} ONLY
                    </div>
                    <div class="col-4 p0"> 
                    <label>Fees Clerk/Accountant</label>
                    </div>
                </div>

                <div class="kt-space-20"></div>
                <div class="kt-space-20"></div>
            
            </div>
        </div>
        <div class="col-4 borderLeftD1p">
            <div class="row">  
                <div class="col-4">
                <img class="hW100px img-rounded" [src]="displayData.logo" alt="">
                </div>
                <div class="col-8 textCenter ">
                <h4>{{displayData.entityDisplayName}}</h4>
                <span>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </span> <br>
                <span>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </span>
                </div>
            
            </div>
                <div class="row m0 borderSolid">
                    <div class="col-12 textCenter borderBottom borderRightD1p" >
                    <mat-label> <strong> Fee Receipt </strong> </mat-label>
                    </div>
                    <div class="col-12 ">

                        <div class="card-body">
                            <div class="row">
                            <div class="col-6 p0">
                                <strong> Receipt No  </strong>
                            </div>
                            <div class="col-6 p0">
                                <span> : {{displayData.receiptId}} </span>
                            </div> 
                            </div>
                            <div class="row">
                            <div class="col-6 p0">
                                <strong> {{displayData.displayNamesRegNo}} </strong>
                            </div>
                            <div class="col-6 p0">
                                <span> : {{displayData.studentRegNo}} </span>
                            </div> 
                            </div><div class="row">
                            <div class="col-6 p0">
                                <strong> Student's Name  </strong>
                            </div>
                            <div class="col-6 p0">
                                <span> : {{displayData.studentName}} </span>
                            </div> 
                            </div><div class="row">
                            <div class="col-6 p0">
                                <strong> Father's Name  </strong>
                            </div>
                            <div class="col-6 p0">
                                <span> : {{displayData.studentFatherName}} </span>
                            </div> 
                            </div>
                            <div class="row">
                            <div class="col-6 p0">
                                <strong>Date</strong>
                            </div> 
                            <div class="col-6 p0">
                                :  {{displayData.date | date: 'dd/MM/yyyy'}}
                            </div>
                            </div>
                            <div class="row">
                            <div class="col-6 p0">
                                <strong>   Session  </strong>
                            </div> 
                            <div class="col-6 p0">
                                :  {{displayData.session}}
                            </div>
                            </div>
                            <div class="row">
                            <div class="col-6 p0">
                                <strong>  {{displayData.displayNamesCourse}}  </strong>
                            </div> 
                            <div class="col-6 p0">
                                :  {{displayData.studentCourse}}
                            </div>
                            </div>
                            <div class="row">
                            <div class="col-6 p0">
                                <strong>  Contact  </strong>
                            </div> 
                            <div class="col-6 p0">
                                :  {{displayData.studentPhone}}
                            </div>
                            </div>
                        </div>
                </div>
            </div>
            <div *ngIf="!hasError" class="">
                <table class="table fontFamily mt3p">
                <thead class="borderS1P mt3p">
                    <th  class=" fwBoldvw" >
                        S.No
                    </th>
                    <th  class=" fwBoldvw">
                        Fee Head
                        </th>
                        <!-- <th  class=" fwBoldvw" >
                        Installment
                    </th> -->
                    <th  class=" fwBoldvw">
                        Payable Amount
                    </th>
                    <th  class=" fwBoldvw">
                        Paid Amount
                        </th>
                </thead>
                <tbody>
                    <tr *ngFor="let row of displayData.dataSource.data; let i = index" >
                        <td>
                        {{i+1}}
                        </td>
                        <td>
                            {{row.feeHead}}
                        </td>
                        <!-- <td>
                            {{row.installment}}
                        </td> -->
                        <td>
                        <div *ngIf="row.payableAmount !=0">
                        {{row.payableAmount  | number : '1.2-2' }}
                        </div>
                        <div  *ngIf="row.payableAmount ==0">
                            NA
                        </div>
                        </td>
                        <td>
                            {{row.paidAmount | number : '1.2-2'}}
                        </td>
                    </tr>
                </tbody>
                </table>

                <div class="colorBlackDark">
                    <div class="row">
                    <div class="col-7 ">
                        Payment Mode
                    </div>
                    <div class="col-1 ">
                        :
                    </div>
                    <div class="col-4 textEnd ">
                        {{displayData.paymentDetailsPaymentMode}}
                    </div>
                    </div>
                    <div class="row">
                    <div class="col-7 ">
                        Instrument Date
                    </div>
                    <div class="col-1 ">
                        :
                    </div>
                    <div class="col-4 textEnd ">
                        {{displayData.paymentDetailsDate | date: 'dd/MM/yyyy'}}
                    </div>
                    </div>
                    <div class="row">
                    <div class="col-7 ">
                        Instrument Number
                    </div>
                    <div class="col-1 ">
                        :
                    </div>
                    <div class="col-4 textEnd ">
                        {{displayData.paymentDetailsRefId}}
                    </div>
                    </div>
                    <div class="row">
                    <div class="col-7 ">
                        Total Invoice
                    </div>
                    <div class="col-1 ">
                        :
                    </div>
                    <div class="col-4 textEnd ">
                        {{displayData.totalPaybleAmount | number : '1.2-2' }}
                    </div>
                    </div>
                    <div class="row">
                    <div class="col-7 ">
                        Net Paid Amount
                    </div>
                    <div class="col-1 ">
                        :
                    </div>
                    <div class="col-4 textEnd">
                        {{displayData.totalPaidAmount | number : '1.2-2' }}
                    </div>
                    </div>
                    <div class="row">
                    <div class="col-7">
                        Balance Due
                    </div>
                    <div class="col-1 ">
                        :
                    </div>
                    <div class="col-4 textEnd  ">
                        {{displayData.balance | number : '1.2-2' }}
                    </div>
                    </div>
                </div>
                    <div class="kt-space-20"></div>
                    <div class="kt-space-20"></div>
                <div class="row justifyFlexEnd m0">
                    <div class="col-12">
                    <strong>Remarks :</strong>
                    {{displayData.remark}}
                    </div>
                    <div class="col-8">
                    <strong> Amount in Words: </strong>
                        Rs {{displayData.totalPaidAmountWords.toUpperCase()}} ONLY
                    </div>
                    <div class="col-4 p0"> 
                    <label>Fees Clerk/Accountant</label>
                    </div>
                </div>

                <div class="kt-space-20"></div>
                <div class="kt-space-20"></div>
            
            </div>
        </div>
    </div>
</div>
    `,
    admissionTransactionTemp1: `
    
    <div class="container-fluid">
    <div style="font-size: large; font-weight: 400;" class="row">
       <div class="col-12">
          <div class="row">
             <div class="col-2">
                <img class="hW100px img-rounded" [src]="displayData.logo" alt=""> 
             </div>
             <div class="col-8 textCenter ">
                <h1>{{displayData.entityDisplayName}}</h1>
                <span>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}},{{displayData.entityPin}} </span> <br>
                <span>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </span>
             </div>
          </div>
          <div class="row m0 borderSolid">
             <div class="col-12 textCenter borderBottom" >
                <mat-label> <strong> Registration Receipt </strong> </mat-label>
             </div>
             <div class="col-7 ">
                <div class="card-body">
                   <div class="row">
                      <div class="col-6 p0">
                         <strong> Receipt No  </strong>
                      </div>
                      <div class="col-6 p0">
                         <span> : {{displayData.receiptId}} </span>
                      </div>
                   </div>
                   <div class="row">
                      <div class="col-6 p0">
                         <strong> Form No. </strong>
                      </div>
                      <div class="col-6 p0">
                         <span> : {{displayData.applicationNumber}} </span>
                      </div>
                   </div>
                   <div class="row">
                      <div class="col-6 p0">
                         <strong> Student's Name  </strong>
                      </div>
                      <div class="col-6 p0">
                         <span> : {{displayData.studentName}} </span>
                      </div>
                   </div>
                   <div class="row">
                      <div class="col-6 p0">
                         <strong> Father's Name  </strong>
                      </div>
                      <div class="col-6 p0">
                         <span> : {{displayData.studentFatherName}} </span>
                      </div>
                   </div>
                </div>
             </div>
             <div class="col-5 ">
                <div class="card-body ">
                   <div class="row">
                      <div class="col-5 p0">
                         <strong>Date</strong>
                      </div>
                      <div class="col-7 p0">
                         :  {{displayData.date | date: 'dd/MM/yyyy'}}
                      </div>
                   </div>
                   <div class="row">
                      <div class="col-5 p0">
                         <strong>   Session  </strong>
                      </div>
                      <div class="col-7 p0">
                         :  {{displayData.session}}
                      </div>
                   </div>
                   <div class="row">
                      <div class="col-5 p0">
                         <strong>  {{displayData.displayNamesCourse}}  </strong>
                      </div>
                      <div class="col-7 p0">
                         :  {{displayData.studentCourse}}
                      </div>
                   </div>
                   <div class="row">
                      <div class="col-5 p0">
                         <strong>  Contact  </strong>
                      </div>
                      <div class="col-7 p0">
                         :  {{displayData.studentPhone}}
                      </div>
                   </div>
                </div>
             </div>
          </div>
          <div *ngIf="!hasError" class="">
             <table class="table fontFamily mt3p">
                <thead class="borderS1P mt3p">
                   <th  style="font-size:17px;font-weight:700;">
                      S.No
                   </th>
                   <th  style="font-size:17px;font-weight:700;">
                      Fee Head
                   </th>
                   <th  style="font-size:17px;font-weight:700;">
                      Paid Amount
                   </th>
                </thead>
                <tbody>
                   <tr *ngFor="let row of displayData.dataSource.data; let i = index" >
                      <td>
                         {{i+1}}
                      </td>
                      <td>
                         {{row.admissionHead}}
                      </td>
                      <td>
                         {{row.paidAmount | number : '1.2-2'}}
                      </td>
                   </tr>
                </tbody>
             </table>
             <div class="colorBlackDark">
                <div class="row">
                   <div class="col-7 ">
                      Payment Mode
                   </div>
                   <div class="col-1 ">
                      :
                   </div>
                   <div class="col-4 textEnd ">
                      {{displayData.paymentDetailsPaymentMode}}
                   </div>
                </div>
                <div class="row">
                   <div class="col-7 ">
                      Instrument Date
                   </div>
                   <div class="col-1 ">
                      :
                   </div>
                   <div class="col-4 textEnd ">
                      {{displayData.paymentDetailsDate | date: 'dd/MM/yyyy'}}
                   </div>
                </div>
                <div class="row">
                   <div class="col-7 ">
                      Instrument Number
                   </div>
                   <div class="col-1 ">
                      :
                   </div>
                   <div class="col-4 textEnd ">
                      {{displayData.paymentDetailsRefId}}
                   </div>
                </div>
                <div class="row">
                   <div class="col-7 ">
                      Net Paid Amount
                   </div>
                   <div class="col-1 ">
                      :
                   </div>
                   <div class="col-4 textEnd">
                      {{displayData.totalPaidAmount | number : '1.2-2' }}
                   </div>
                </div>
             </div>
             <div class="kt-space-20"></div>
             <div class="kt-space-20"></div>
             <div class="row justifyFlexEnd m0">
                <div class="col-12">
                   <strong>Remarks :</strong>
                   The amount will be Non-Refundable.
                </div>
                <div class="col-8">
                   <strong> Amount in Words: </strong>
                   Rs. {{displayData.totalPaidAmountWords}}.
                </div>
                <div class="col-4 p0"> 
                   <label>Fees Clerk/Accountant</label>
                </div>
             </div>
             <br>
             <div class="kt-space-20"></div>
             <div class="kt-space-20"></div>
          </div>
       </div>
    </div>
 </div>

    `,
    studentAdmissionForm1: `
    <ng-container *ngFor="let displayData of displayDataArray">
    <div style="font-weight: 500;  font-size: large;" class="container card">
    <div class="row mt10">
       <br>
       <br>
       <div class="col-3">
          <img style="height: 100%; width: 100%;" class="img-rounded" [src]="displayData.logo" alt="">
       </div>
       <div class="col-9 textCenter ">
          <strong>
             <h1>{{displayData.entityDisplayName}}</h1>
          </strong>
          <h4>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </h4>
          <h4>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </h4>
       </div>
    </div>
    <article class="mt20p">
       <div class="row mt10">
          <div class="col-7">
             <div class="row mt10">
                <div class="col-5 offset-1">
                   <strong>
                   Course
                   </strong> 
                </div>
                <div class="col-1">
                   :
                </div>
                <div class="col-5">
                   {{displayData.course}}
                </div>
             </div>
             <div class="row mt10" *ngIf="displayData.applicationNumber">
                <div class="col-5 offset-1">
                   <strong>
                   Application No.
                   </strong> 
                </div>
                <div class="col-1">
                   :
                </div>
                <div class="col-5">
                   {{displayData.applicationNumber}}
                </div>
             </div>
             <div class="row mt10" *ngIf="displayData.date">
                <div class="col-5 offset-1">
                   <strong>
                   Date of Application
                   </strong> 
                </div>
                <div class="col-1">
                   :
                </div>
                <div class="col-5">
                   {{displayData.date | date : 'dd/MM/yyyy'}}
                </div>
             </div>
             <div class="row mt10" *ngIf="displayData.batch">
                <div class="col-5 offset-1">
                   <strong>
                   Batch
                   </strong> 
                </div>
                <div class="col-1">
                   :
                </div>
                <div class="col-5">
                   {{displayData.batch}}
                </div>
             </div>
             <div class="row mt10" *ngIf="displayData.section">
                <div class="col-5 offset-1">
                   <strong>
                   Section
                   </strong> 
                </div>
                <div class="col-1">
                   :
                </div>
                <div class="col-5">
                   {{displayData.section}}
                </div>
             </div>
             <div class="row mt10" *ngIf="displayData.oldNew">
                <div class="col-5 offset-1">
                   <strong>
                   Old/New
                   </strong> 
                </div>
                <div class="col-1">
                   :
                </div>
                <div class="col-5">
                   {{displayData.oldNew}}
                </div>
             </div>
             <div class="row mt10" *ngIf="displayData.category">
                <div class="col-5 offset-1">
                   <strong>
                   Category
                   </strong> 
                </div>
                <div class="col-1">
                   :
                </div>
                <div class="col-5">
                   {{displayData.category}}
                </div>
             </div>
             <div class="row mt10" *ngIf="displayData.totalPaybleAmount">
                <div class="col-5 offset-1">
                   <strong>
                   Total Payable Amount
                   </strong> 
                </div>
                <div class="col-1">
                   :
                </div>
                <div class="col-5">
                   {{displayData.totalPaybleAmount}}
                </div>
             </div>
             <div class="row mt10" *ngIf="displayData.totalPaidAmount">
                <div class="col-5 offset-1">
                   <strong>
                   Total Paid Amount
                   </strong> 
                </div>
                <div class="col-1">
                   :
                </div>
                <div class="col-5">
                   {{displayData.totalPaidAmount}}
                </div>
             </div>
          </div>
          <div class="col-5 textCenter">
             <img style="height: 150px;" class="img" [src]="displayData.photo" />
          </div>
       </div>
    </article>
    <article class="mt20p">
       <div class="row mt10">
          <div class="col-10 offset-1">
             <h4>
                Applicant Details:
             </h4>
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.name">
          <div class="col-4 offset-2">
             <strong>
             Name of the Applicant
             </strong>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.name}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.dob">
          <div class="col-4 offset-2">
             <strong>
             Date of Birth
             </strong>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.dob | date : 'dd/MM/yyyy'}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.gender">
          <div class="col-4 offset-2">
             <strong>
             Gender
             </strong>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.gender}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.doa">
          <div class="col-4 offset-2">
             <strong>
             Date of Admission
             </strong>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.doa | date : 'dd/MM/yyyy'}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.uid">
          <div class="col-4 offset-2">
             <strong>
             Aadhar card no.
             </strong>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.uid}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.phone">
          <div class="col-4 offset-2">
             <strong>
             Contact No. for SMS
             </strong>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.phone}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.email">
          <div class="col-4 offset-2">
             <strong>
             Email
             </strong>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.email}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.fatherName">
          <div class="col-4 offset-2">
             <strong>
             Father's Name
             </strong>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.fatherName}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.motherName">
          <div class="col-4 offset-2">
             <strong>
             Mother's Name
             </strong>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.motherName}}
          </div>
       </div>
    </article>
    <article class="mt20p">
       <div class="row mt10">
          <div class="col-10 offset-1">
             <h4>
                Address Details:
             </h4>
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.address">
          <div class="col-4 offset-2">
             <strong>
             Home Address
             </strong>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.address}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.city">
          <div class="col-4 offset-2">
             <strong>
             City
             </strong>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.city}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.state">
          <div class="col-4 offset-2">
             <strong>
             State
             </strong>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.state}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.country">
          <div class="col-4 offset-2">
             <strong>
             Country
             </strong>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.country}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.pinCode">
          <div class="col-4 offset-2">
             <strong>
             Pin Code
             </strong>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.pinCode}}
          </div>
       </div>
    </article>
    <article class="mt20p">
       <div class="row mt10">
          <div class="col-10 offset-1">
             <h4>
                Other Details:
             </h4>
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.fatherMobile">
          <div class="col-4 offset-2">
             <strong>
             Father's Mobile
             </strong>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.fatherMobile}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.fatherEmail">
          <div class="col-4 offset-2">
             <strong>
             Father Email 
             </strong>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.fatherEmail}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.fatherDOB">
          <div class="col-4 offset-2">
             <strong>
             Father DOB 
             </strong>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.fatherDOB}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.fatherUID">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Father UID 
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.fatherUID}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.fatherQualification">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Father Qualification 
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.fatherQualification}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.fatherOccupation">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Father Occupation 
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.fatherOccupation}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.fatherOrganisation">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Father Organisation
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.fatherOrganisation}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.fatherDesignation">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Father Designation 
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.fatherDesignation}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.fatherAnnualIncome">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Father Annual Income 
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.fatherAnnualIncome}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.fatherAddress">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Father Address 
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.fatherAddress}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.fatherCity">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Father City
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.fatherCity}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.fatherState">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Father State
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.fatherState}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.fatherCountry">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Father Country
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.fatherCountry}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.fatherPinCode">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Father Pin Code
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.fatherPinCode}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.fatherEmployeeOfInstitute">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Father Employee Of Institute
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.fatherEmployeeOfInstitute}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.motherMobile">
          <div class="col-4 offset-2">
             <strong>
             Mother's Mobile
             </strong>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.motherMobile}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.motherEmail">
          <div class="col-4 offset-2">
             <strong>
             Mother Email 
             </strong>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.motherEmail}}
          </div>
       </div>
       <div class="row mt10"  *ngIf="displayData.motherDOB">
          <div class="col-4 offset-2">
             <strong>
             Mother DOB 
             </strong>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.motherDOB}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.motherUID">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Mother UID 
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.motherUID}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.motherQualification">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Mother Qualification 
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.motherQualification}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.motherOccupation">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Mother Occupation 
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.motherOccupation}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.motherOrganisation">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Mother Organisation
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.motherOrganisation}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.motherDesignation">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Mother Designation 
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.motherDesignation}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.motherAnnualIncome">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Mother Annual Income 
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.motherAnnualIncome}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.motherAddress">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Mother Address 
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.motherAddress}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.motherCity">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Mother City
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.motherCity}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.motherState">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Mother State
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.motherState}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.motherCountry">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Mother Country
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.motherCountry}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.motherPinCode">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Mother Pin Code
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.motherPinCode}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.motherEmployeeOfInstitute">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Mother Employee Of Institute
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.motherEmployeeOfInstitute}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.guardianName">
          <div class="col-4 offset-2">
             <strong>
             Guardian name
             </strong>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.guardianName}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.relationWithGuardian">
          <div class="col-4 offset-2">
             <strong>
             Relation with Guardian
             </strong>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.relationWithGuardian}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.guardianMobile">
          <div class="col-4 offset-2">
             <strong>
             Guardian's Mobile
             </strong>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.guardianMobile}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.guardianEmail">
          <div class="col-4 offset-2">
             <strong>
             Guardian Email 
             </strong>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.guardianEmail}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.guardianDOB">
          <div class="col-4 offset-2">
             <strong>
             Guardian DOB 
             </strong>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.guardianDOB}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.guardianUID">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Guardian UID 
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.guardianUID}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.guardianQualification">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Guardian Qualification 
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.guardianQualification}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.guardianOccupation">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Guardian Occupation 
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.guardianOccupation}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.guardianOrganisation">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Guardian Organisation
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.guardianOrganisation}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.guardianDesignation">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Guardian Designation 
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.guardianDesignation}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.guardianAnnualIncome">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Guardian Annual Income 
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.guardianAnnualIncome}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.guardianAddress">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Guardian Address 
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.guardianAddress}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.guardianCity">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Guardian City
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.guardianCity}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.guardianState">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Guardian State
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.guardianState}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.guardianCountry">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Guardian Country
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.guardianCountry}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.guardianPinCode">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Guardian Pin Code
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.guardianPinCode}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.guardianEmployeeOfInstitute">
          <div class="col-4 offset-2">
             <span>
             <strong>
             Guardian Employee Of Institute
             </strong>
             </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.guardianEmployeeOfInstitute}}
          </div>
       </div>
    </article>
    <article class="mt20p">
       <div class="row mt10">
          <div class="col-10 offset-1">
             <h4>
                Education Details:
             </h4>
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.bloodGroup">
          <div class="col-4 offset-2">
             <span><strong>
             Blood Group
             </strong> </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.bloodGroup}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.height">
          <div class="col-4 offset-2">
             <span><strong>
             Height
             </strong> </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.height}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.weight">
          <div class="col-4 offset-2">
             <span><strong>
             Weight
             </strong> </span>
          </div>
          <div class="col-1">
             :
          </div>
          <div class="col-4">
             {{displayData.weight}}
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.educationDetails1Class">
          <div class="col-4 offset-2">
             <span><strong>
             Class Passed
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.educationDetails1Class}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.educationDetails1School">
          <div class="col-4 offset-2">
             <span><strong>
             10th School Name
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.educationDetails1School}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.educationDetails1University">
          <div class="col-4 offset-2">
             <span><strong>
             10th Board
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.educationDetails1University}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.educationDetails1PassingYear">
          <div class="col-4 offset-2">
             <span><strong>
             10th Passing Year
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.educationDetails1PassingYear}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.educationDetails1RollNo">
          <div class="col-4 offset-2">
             <span><strong>
             10th Roll No.
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.educationDetails1RollNo}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.educationDetails1MaxMarks">
          <div class="col-4 offset-2">
             <span><strong>
             Maximum Marks 10th
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.educationDetails1MaxMarks}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.educationDetails1ObtainedMarks">
          <div class="col-4 offset-2">
             <span><strong>
             Obtained Marks 10th
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.educationDetails1ObtainedMarks}}  
          </div>
       </div>
       <!--new-->
       <div class="row mt10" *ngIf="displayData.educationDetails1Result">
          <div class="col-4 offset-2">
             <span><strong>
             Result 10th
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.educationDetails1Result}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.educationDetails1Percentage">
          <div class="col-4 offset-2">
             <span><strong>
             10th Percentage
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.educationDetails1Percentage}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.educationDetails1Remark">
          <div class="col-4 offset-2">
             <span><strong>
             10th Remark
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.educationDetails1Remark}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.educationDetails1SchoolCity">
          <div class="col-4 offset-2">
             <span><strong>
             10th School City
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.educationDetails1SchoolCity}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.educationDetails1SchoolState">
          <div class="col-4 offset-2">
             <span><strong>
             10th School State
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.educationDetails1SchoolState}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.educationDetails2Class">
          <div class="col-4 offset-2">
             <span><strong>
             Class Passed
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.educationDetails2Class}}  
          </div>
       </div>
       <!--new-->
       <div class="row mt10" *ngIf="displayData.educationDetails2University">
          <div class="col-4 offset-2">
             <span><strong>
             ITI/12th University
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.educationDetails2University}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.educationDetails2PassingYear">
          <div class="col-4 offset-2">
             <span><strong>
             ITI/12th Passing Year
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.educationDetails2PassingYear}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.educationDetails2School">
          <div class="col-4 offset-2">
             <span><strong>
             ITI/12th School
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.educationDetails2School}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.educationDetails2RollNo">
          <div class="col-4 offset-2">
             <span><strong>
             ITI/12th Roll No.
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.educationDetails2RollNo}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.educationDetails2MaxMarks">
          <div class="col-4 offset-2">
             <span><strong>
             Maximum Marks ITI/12th
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.educationDetails2MaxMarks}}  
          </div>
       </div>
       <!--new-->
       <div class="row mt10" *ngIf="displayData.educationDetails2ObtainedMarks">
          <div class="col-4 offset-2">
             <span><strong>
             Obtained Marks ITI/12th
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.educationDetails2ObtainedMarks}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.educationDetails2Result">
          <div class="col-4 offset-2">
             <span><strong>
             ITI/12th Result
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.educationDetails2Result}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.educationDetails2Percentage">
          <div class="col-4 offset-2">
             <span><strong>
             ITI/12th Percentage
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.educationDetails2Percentage}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.educationDetails2Remark">
          <div class="col-4 offset-2">
             <span><strong>
             ITI/12th Remark
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.educationDetails2Remark}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.educationDetails2SchoolCity">
          <div class="col-4 offset-2">
             <span><strong>
             ITI/12th School City
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.educationDetails2SchoolCity}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.educationDetails2SchoolState">
          <div class="col-4 offset-2">
             <span><strong>
             ITI/12th School State
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.educationDetails2SchoolState}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.actualGraduationYear">
          <div class="col-4 offset-2">
             <span><strong>
             Actual Graduation Year
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.actualGraduationYear}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.qualifyingExamName">
          <div class="col-4 offset-2">
             <span><strong>
             Qualifying Exam Name
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.qualifyingExamName}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.currentStage">
          <div class="col-4 offset-2">
             <span><strong>
             Current Stage
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.currentStage}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.qualifyingExamRollNo">
          <div class="col-4 offset-2">
             <span><strong>
             Qualifying Exam Roll No
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.qualifyingExamRollNo}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.qualifyingExamRank1">
          <div class="col-4 offset-2">
             <span><strong>
             Qualifying Exam Rank1
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.qualifyingExamRank1}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.qualifyingExamRank2">
          <div class="col-4 offset-2">
             <span><strong>
             Qualifying Exam Rank2
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.qualifyingExamRank2}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.utmSource">
          <div class="col-4 offset-2">
             <span><strong>
             Utm Source
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.utmSource}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.utmMedium">
          <div class="col-4 offset-2">
             <span><strong>
             Utm Medium
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.utmMedium}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.utmCampaign">
          <div class="col-4 offset-2">
             <span><strong>
             Utm Campaign
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.utmCampaign}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.customField2">
          <div class="col-4 offset-2">
             <span><strong>
             Custom Field 2
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.customField2}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.customField3">
          <div class="col-4 offset-2">
             <span><strong>
             Password
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.customField3}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.customField4">
          <div class="col-4 offset-2">
             <span><strong>
             Rank
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.customField4}}  
          </div>
       </div>
       <div class="row mt10" *ngIf="displayData.customField5">
          <div class="col-4 offset-2">
             <span><strong>
             Custom Field 5
             </strong> </span>
          </div>
          <div class="col-1">
             :     
          </div>
          <div class="col-4">
             {{displayData.customField5}}  
          </div>
       </div>
    </article>
    <article class="mt20p">
       <div class="row mt10">
       </div>
       <div class="row mt10">
          <div class="col-12">
             <p>
                <strong>Declaration: </strong>  I, verify that I have applied for {{displayData.course}}. The photo pasted above and all the particulars given are correct to the best of my knowledge. I have no objection, if my admission is cancelled at any stage due to false information given by me.
             </p>
             <br>
             <br>
          </div>
          <div class="col-6">
             <strong>Parent/Guardian Signature</strong>
          </div>
          <div class="col-6 textEnd">
             <strong>Candidate Signature</strong>
          </div>
       </div>
       <div class="row mt10">
          <div class="col-12">
             <hr>
          </div>
          <div class="col-12">
             <strong>Documents Attached:</strong>
          </div>
          <div class="col-3">
             <input type=checkbox> Aadhar Card
          </div>
          <div class="col-3">
             <input type=checkbox> Matric Certificate
          </div>
          <div class="col-3">
             <input type=checkbox> 12th Certificate
          </div>
          <div class="col-3">
             <input type=checkbox> Character Certificate
          </div>
          <p>
          <div class="col-3">
             <input type=checkbox> Gap Year Certificate
          </div>
          <div class="col-3">
             <input type=checkbox> Medical Certificate
          </div>
          <div class="col-3">
             <input type=checkbox> Income Certificate
          </div>
          <div class="col-3">
             <input type=checkbox> Counselling Receipt
          </div>
          <p>
       </div>
    </article>
 </div>
    </ng-container>
    `,
    studentAdmissionForm2: `
    <ng-container *ngFor="let displayData of displayDataArray">
    <div class="container card">
    <div class="row mt10">  
        <div class="col-12">
          <img class="hW100px img-rounded" [src]="displayData.logo" alt="">
          <hr>
        </div>
        <br>
        <br>
        <div class="col-12  ">
          <h3>{{displayData.entityDisplayName}}</h3>
          <h4>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </h4> <br>
          <h4>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </h4>
        </div>
    </div>
    <article class="mt20p">
        <div class="row mt10">
            <div class="col-7">
                <div class="row mt10">
                    <div class="col-5 offset-1">
                        <strong>
                            Applied For
                    </strong> 
                    </div>
                    <div class="col-1">
                        :
                    </div>
                    <div class="col-5">
                        {{displayData.course}} - {{displayData.stream}}
                    </div>
                </div>
                <div class="row mt10" *ngIf="displayData.applicationNumber">
                    <div class="col-5 offset-1">
                        <strong>
                            Application Number
                    </strong> 
                    </div>
                    <div class="col-1">
                        :
                    </div>
                    <div class="col-5">
                            {{displayData.applicationNumber}}
                    </div>
                </div>
                <div class="row mt10" *ngIf="displayData.date">
                    <div class="col-5 offset-1">
                        <strong>
                            Date of Application
                    </strong> 
                    </div>
                    <div class="col-1">
                        :
                    </div>
                    <div class="col-5">
                            {{displayData.date | date : 'dd/MM/yyyy'}}
                    </div>
                </div>
                <div class="row mt10" *ngIf="displayData.batch">
                    <div class="col-5 offset-1">
                        <strong>
                            Batch
                    </strong> 
                    </div>
                    <div class="col-1">
                        :
                    </div>
                    <div class="col-5">
                            {{displayData.batch}}
                    </div>
                </div>
                <div class="row mt10" *ngIf="displayData.section">
                    <div class="col-5 offset-1">
                        <strong>
                            Section
                    </strong> 
                    </div>
                    <div class="col-1">
                        :
                    </div>
                    <div class="col-5">
                            {{displayData.section}}
                    </div>
                </div>
                <div class="row mt10" *ngIf="displayData.oldNew">
                    <div class="col-5 offset-1">
                        <strong>
                            Old/New
                    </strong> 
                    </div>
                    <div class="col-1">
                        :
                    </div>
                    <div class="col-5">
                            {{displayData.oldNew}}
                    </div>
                </div>
                <div class="row mt10" *ngIf="displayData.category">
                    <div class="col-5 offset-1">
                        <strong>
                            Category
                    </strong> 
                    </div>
                    <div class="col-1">
                        :
                    </div>
                    <div class="col-5">
                            {{displayData.category}}
                    </div>
                </div>
                
                <div class="row mt10" *ngIf="displayData.transactionRequired">
                    <div class="col-5 offset-1">
                        <strong>
                            If Payment Required 
                    </strong> 
                    </div>
                    <div class="col-1">
                        :
                    </div>
                    <div class="col-5">
                            {{displayData.transactionRequired}}
                    </div>
                </div>
                <div class="row mt10" *ngIf="displayData.totalPaybleAmount">
                    <div class="col-5 offset-1">
                        <strong>
                            Total Payable Amount
                    </strong> 
                    </div>
                    <div class="col-1">
                        :
                    </div>
                    <div class="col-5">
                            {{displayData.totalPaybleAmount}}
                    </div>
                </div>
                <div class="row mt10" *ngIf="displayData.totalPaidAmount">
                    <div class="col-5 offset-1">
                        <strong>
                            Total Paid Amount
                    </strong> 
                    </div>
                    <div class="col-1">
                        :
                    </div>
                    <div class="col-5">
                            {{displayData.totalPaidAmount}}
                    </div>
                </div>
            </div>
            <div class="col-5 textCenter">
                <img class="img" [src]="displayData.photo" />
            </div>
        </div>
    </article>
    <article class="mt20p">
        <div class="row mt10">
            <div class="col-10 offset-1">
               <h4>
                Applicant Details:
               </h4> 
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.entityDisplayName">
            <div class="col-4 offset-2">
                <strong>
                    Institute Name to Apply for
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.entityDisplayName}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.name">
            <div class="col-4 offset-2">
                <strong>
                    Name of the Applicant (As per DOB Certificate)
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.name}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.dob">
            <div class="col-4 offset-2">
                <strong>
                    Date of Birth
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.dob | date : 'dd/MM/yyyy'}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.gender">
            <div class="col-4 offset-2">
                <strong>
                   Gender
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.gender}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.doa">
            <div class="col-4 offset-2">
                <strong>
                    Date of Admission
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.doa | date : 'dd/MM/yyyy'}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.uid">
            <div class="col-4 offset-2">
                <strong>
                    Aadhar card no.
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.uid}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.phone">
            <div class="col-4 offset-2">
                <strong>
                    Contact No. for SMS
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.phone}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.email">
            <div class="col-4 offset-2">
                <strong>
                    Email
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.email}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.fatherName">
            <div class="col-4 offset-2">
                <strong>
                    Father's Name (As per DOB Certificate)
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.fatherName}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.motherName">
            <div class="col-4 offset-2">
                <strong>
                    Mother's Name (As per DOB Certificate)
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.motherName}}
            </div>
        </div>
    </article>
    <article class="mt20p">
        <div class="row mt10">
            <div class="col-10 offset-1">
               <h4>
                Address Details:
               </h4> 
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.address">
            <div class="col-4 offset-2">
                <strong>
                    Home Address
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.address}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.city">
            <div class="col-4 offset-2">
                <strong>
                    City
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.city}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.state">
            <div class="col-4 offset-2">
                <strong>
                    State
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.state}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.country">
            <div class="col-4 offset-2">
                <strong>
                    Country
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.country}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.pinCode">
            <div class="col-4 offset-2">
                <strong>
                    Pin Code
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.pinCode}}
            </div>
        </div>
       
    </article>
    <article class="mt20p">
        <div class="row mt10">
            <div class="col-10 offset-1">
               <h4>
                Parents Details:
               </h4> 
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.fatherMobile">
            <div class="col-4 offset-2">
                <strong>
                    Father's Mobile
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.fatherMobile}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.fatherEmail">
            <div class="col-4 offset-2">
                <strong>
                    Father Email 
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.fatherEmail}}

            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.fatherDOB">
            <div class="col-4 offset-2">
                    <strong>
                        Father DOB 
                    </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.fatherDOB}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.fatherUID">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Father UID 
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.fatherUID}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.fatherQualification">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Father Qualification 
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.fatherQualification}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.fatherOccupation">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Father Occupation 
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.fatherOccupation}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.fatherOrganisation">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Father Organisation
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.fatherOrganisation}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.fatherDesignation">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Father Designation 
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.fatherDesignation}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.fatherAnnualIncome">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Father Annual Income 
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.fatherAnnualIncome}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.fatherAddress">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Father Address 
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.fatherAddress}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.fatherCity">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Father City
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.fatherCity}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.fatherState">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Father State
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.fatherState}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.fatherCountry">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Father Country
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.fatherCountry}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.fatherPinCode">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Father Pin Code
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.fatherPinCode}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.fatherEmployeeOfInstitute">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Father Employee Of Institute
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.fatherEmployeeOfInstitute}}
            </div>
        </div>
        
        <div class="row mt10" *ngIf="displayData.motherMobile">
            <div class="col-4 offset-2">
                <strong>
                    Mother's Mobile
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.motherMobile}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.motherEmail">
            <div class="col-4 offset-2">
                <strong>
                    Mother Email 
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.motherEmail}}

            </div>
        </div>
        <div class="row mt10"  *ngIf="displayData.motherDOB">
            <div class="col-4 offset-2">
                    <strong>
                        Mother DOB 
                    </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.motherDOB}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.motherUID"> 
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Mother UID 
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.motherUID}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.motherQualification">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Mother Qualification 
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.motherQualification}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.motherOccupation">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Mother Occupation 
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.motherOccupation}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.motherOrganisation">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Mother Organisation
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.motherOrganisation}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.motherDesignation">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Mother Designation 
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.motherDesignation}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.motherAnnualIncome">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Mother Annual Income 
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.motherAnnualIncome}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.motherAddress">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Mother Address 
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.motherAddress}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.motherCity">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Mother City
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.motherCity}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.motherState">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Mother State
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.motherState}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.motherCountry">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Mother Country
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.motherCountry}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.motherPinCode">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Mother Pin Code
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.motherPinCode}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.motherEmployeeOfInstitute"> 
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Mother Employee Of Institute
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.motherEmployeeOfInstitute}}
            </div>
        </div>

        <div class="row mt10" *ngIf="displayData.guardianName">
            <div class="col-4 offset-2">
                <strong>
                    Guardian name
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.guardianName}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.relationWithGuardian">
            <div class="col-4 offset-2">
                <strong>
                    Relation with Guardian
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.relationWithGuardian}}
            </div>
        </div>

        <div class="row mt10" *ngIf="displayData.guardianMobile">
            <div class="col-4 offset-2">
                <strong>
                    Guardian's Mobile
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.guardianMobile}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.guardianEmail">
            <div class="col-4 offset-2">
                <strong>
                    Guardian Email 
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.guardianEmail}}

            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.guardianDOB">
            <div class="col-4 offset-2">
                    <strong>
                        Guardian DOB 
                    </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.guardianDOB}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.guardianUID">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Guardian UID 
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.guardianUID}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.guardianQualification">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Guardian Qualification 
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.guardianQualification}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.guardianOccupation">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Guardian Occupation 
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.guardianOccupation}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.guardianOrganisation">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Guardian Organisation
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.guardianOrganisation}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.guardianDesignation">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Guardian Designation 
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.guardianDesignation}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.guardianAnnualIncome">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Guardian Annual Income 
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.guardianAnnualIncome}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.guardianAddress">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Guardian Address 
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.guardianAddress}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.guardianCity">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Guardian City
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.guardianCity}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.guardianState">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Guardian State
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.guardianState}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.guardianCountry">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Guardian Country
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.guardianCountry}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.guardianPinCode">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Guardian Pin Code
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.guardianPinCode}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.guardianEmployeeOfInstitute">
            <div class="col-4 offset-2">
                <span>
                    <strong>
                        Guardian Employee Of Institute
                    </strong>
                </span>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                {{displayData.guardianEmployeeOfInstitute}}
            </div>
        </div>
    </article>
    <article class="mt20p">
        <div class="row mt10">
            <div class="col-10 offset-1">
               <h4>
                School Specific Parameters
               </h4> 
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.lastSchool">
            <div class="col-4 offset-2">
                <strong>
                    Last School
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.lastSchool}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.lastSchoolBoard ">
            <div class="col-4 offset-2">
                <strong>
                    Last School Board
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.lastSchoolBoard}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.passingOutCourse">
            <div class="col-4 offset-2">
                <strong>
                    Passing Out Course Percentage Achieved
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.passingOutCourse}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.percentageAchieved">
            <div class="col-4 offset-2">
                <strong>
                    Percentage Achieved
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.percentageAchieved}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.admissionCourse">
            <div class="col-4 offset-2">
                <strong>
                    Admission Course
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.admissionCourse}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.admissionYear">
            <div class="col-4 offset-2">
                <strong>
                    Admission Year
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.admissionYear}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.expectedGraduationYear">
            <div class="col-4 offset-2">
                <strong>
                    Expected Graduation Year
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.expectedGraduationYear}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.actualGraduationYear">
            <div class="col-4 offset-2">
                <strong>
                    Actual Graduation Year
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.actualGraduationYear}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.source">
            <div class="col-4 offset-2">
                <strong>
                    Source
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.source}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.reference">
            <div class="col-4 offset-2">
                <strong>
                    Reference
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.reference}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.photo">
            <div class="col-4 offset-2">
                <strong>
                    Photo
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.photo}}
            </div>
        </div>
       
    </article>
    <article class="mt20p">
        <div class="row mt10">
            <div class="col-10 offset-1">
               <h4>
                Personal Details
               </h4> 
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.caste">
            <div class="col-4 offset-2">
                <strong>
                    Caste
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.caste}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.socialCategory">
            <div class="col-4 offset-2">
                <strong>
                    Social
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.socialCategory}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.religion">
            <div class="col-4 offset-2">
                <strong>
                    Religion
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.religion}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.birthPlace">
            <div class="col-4 offset-2">
                <strong>
                    Birth Place
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.birthPlace}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.nationality">
            <div class="col-4 offset-2">
                <strong>
                    Nationality
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.nationality}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.motherTongue">
            <div class="col-4 offset-2">
                <strong>
                     Mother Tongue
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.motherTongue}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.identificationMark">
            <div class="col-4 offset-2">
                <strong>
                     Identification Mark
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.identificationMark}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.otherLanguages">
            <div class="col-4 offset-2">
                <strong>
                     Other Languages
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.otherLanguages}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.srn">
            <div class="col-4 offset-2">
                <strong>
                     SRN
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.srn}}
            </div>
        </div>
       
    </article>
    <article class="mt20p">
        <div class="row mt10">
            <div class="col-10 offset-1">
               <h4>
                Medical Details
               </h4> 
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.bloodGroup">
            <div class="col-4 offset-2">
                <strong>
                    Blood Group
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.bloodGroup}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.height">
            <div class="col-4 offset-2">
                <strong>
                    Height
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.height}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.weight">
            <div class="col-4 offset-2">
                <strong>
                    Weight
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.weight}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.medicalHistory">
            <div class="col-4 offset-2">
                <strong>
                    Medical History
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.medicalHistory}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.bmi">
            <div class="col-4 offset-2">
                <strong>
                    BMI
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.bmi}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.leftVision">
            <div class="col-4 offset-2">
                <strong>
                     Left Vision
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.leftVision}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.rightVision">
            <div class="col-4 offset-2">
                <strong>
                     Right Vision
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.rightVision}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.colourVision">
            <div class="col-4 offset-2">
                <strong>
                     Colour Vision
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.colourVision}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.leftGlasses">
            <div class="col-4 offset-2">
                <strong>
                     Left Glasses
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.leftGlasses}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.rightGlasses">
            <div class="col-4 offset-2">
                <strong>
                     Right Glasses
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.rightGlasses}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.oralHygiene">
            <div class="col-4 offset-2">
                <strong>
                     Oral Hygiene
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.oralHygiene}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.disease">
            <div class="col-4 offset-2">
                <strong>
                     Disease
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.disease}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.allergy">
            <div class="col-4 offset-2">
                <strong>
                     Allergy
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.allergy}}
            </div>
        </div>
        <div class="row mt10" *ngIf="displayData.currentMedication">
            <div class="col-4 offset-2">
                <strong>
                     Current Medication
                </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-4">
                   {{displayData.currentMedication}}
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.domicile">
            <div class="col-4 offset-2">
                <strong>
                    Domicile
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.domicile}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.gapYear">
            <div class="col-4 offset-2">
                <strong>
                    Gap Year
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.gapYear}}  
            </div>
        </div>
        <!--new-->
        <div class="row-mt10" *ngIf="displayData.educationDetails1Class">
            <div class="col-4 offset-2">
                <strong>
                    Education Details1 Class
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails1Class}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails1School">
            <div class="col-4 offset-2">
                <strong>
                    Education Details1 School
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails1School}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails1University">
            <div class="col-4 offset-2">
                <strong>
                    Education Details1 University
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails1University}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails1PassingYear">
            <div class="col-4 offset-2">
                <strong>
                    Education Details1 Passing Year
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails1PassingYear}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails1MaxMarks">
            <div class="col-4 offset-2">
                <strong>
                    Education Details1 Max Marks
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails1MaxMarks}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails1RollNo">
            <div class="col-4 offset-2">
                <strong>
                    Education Details1 RollNo
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails1RollNo}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails1ObtainedMarks">
            <div class="col-4 offset-2">
                <strong>
                    Education Details1 Obtained Marks
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails1ObtainedMarks}}  
            </div>
        </div>
        <!--new-->
        <div class="row-mt10" *ngIf="displayData.educationDetails1Result">
            <div class="col-4 offset-2">
                <strong>
                    Education Details1 Result
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails1Result}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails1Percentage">
            <div class="col-4 offset-2">
                <strong>
                    Education Details1 Percentage
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails1Percentage}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails1Remark">
            <div class="col-4 offset-2">
                <strong>
                    Education Details1 Remark
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails1Remark}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails1SchoolCity">
            <div class="col-4 offset-2">
                <strong>
                    Education Details1 School City
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails1SchoolCity}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails1ObtainedMarks">
            <div class="col-4 offset-2">
                <strong>
                    Education Details1 Obtained Marks
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails1ObtainedMarks}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails1SchoolState">
            <div class="col-4 offset-2">
                <strong>
                    Education Details1 School State
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails1SchoolState}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails2Class">
            <div class="col-4 offset-2">
                <strong>
                    Education Details2 Class
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails2Class}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails2School">
            <div class="col-4 offset-2">
                <strong>
                    Education Details2 School
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails2School}}  
            </div>
        </div>
        <!--new-->
        <div class="row-mt10" *ngIf="displayData.educationDetails2University">
            <div class="col-4 offset-2">
                <strong>
                    Education Details2 University
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails2University}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails2PassingYear">
            <div class="col-4 offset-2">
                <strong>
                    Education Details2 Passing Year
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails2PassingYear}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails2School">
            <div class="col-4 offset-2">
                <strong>
                    Education Details2 School
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails2School}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails2RollNo">
            <div class="col-4 offset-2">
                <strong>
                    Education Details2 RollNo
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails2RollNo}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails2School">
            <div class="col-4 offset-2">
                <strong>
                    Education Details2 School
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails2School}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails2MaxMarks">
            <div class="col-4 offset-2">
                <strong>
                    Education Details2 Max Marks
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails2MaxMarks}}  
            </div>
        </div>
        <!--new-->
        <div class="row-mt10" *ngIf="displayData.educationDetails2ObtainedMarks">
            <div class="col-4 offset-2">
                <strong>
                    Education Details2 Obtained Marks
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails2ObtainedMarks}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails2Result">
            <div class="col-4 offset-2">
                <strong>
                    Education Details2 Result
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails2Result}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails2Percentage">
            <div class="col-4 offset-2">
                <strong>
                    Education Details2 Percentage
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails2Percentage}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails2Remark">
            <div class="col-4 offset-2">
                <strong>
                    Education Details2 Remark
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails2Remark}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails2SchoolCity">
            <div class="col-4 offset-2">
                <strong>
                    Education Details2 School City
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails2SchoolCity}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails2SchoolState">
            <div class="col-4 offset-2">
                <strong>
                    Education Details2 School State
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails2SchoolState}}  
            </div>
        </div>   <div class="row-mt10" *ngIf="displayData.educationDetails3Class">
            <div class="col-4 offset-2">
                <strong>
                    Education Details3 Class
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails3Class}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails2MaxMarks">
            <div class="col-4 offset-2">
                <strong>
                    Education Details2 Max Marks
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails2MaxMarks}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails3School">
            <div class="col-4 offset-2">
                <strong>
                    Education Details3 School
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails3School}}  
            </div>
        </div>   <div class="row-mt10" *ngIf="displayData.educationDetails3University">
            <div class="col-4 offset-2">
                <strong>
                    Education Details3 University
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails3University}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails3PassingYear">
            <div class="col-4 offset-2">
                <strong>
                    Education Details3 Passing Year
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails3PassingYear}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails3RollNo">
            <div class="col-4 offset-2">
                <strong>
                    Education Details3 RollNo
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails3RollNo}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails3MaxMarks">
            <div class="col-4 offset-2">
                <strong>
                    Education Details3 Max Marks
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails3MaxMarks}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails3ObtainedMarks">
            <div class="col-4 offset-2">
                <strong>
                    Education Details3 Obtained Marks
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails3ObtainedMarks}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails3Result">
            <div class="col-4 offset-2">
                <strong>
                    Education Details3 Result
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails3Result}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails3Percentage">
            <div class="col-4 offset-2">
                <strong>
                    Education Details3 Percentage
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails3Percentage}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.educationDetails3Remark">
            <div class="col-4 offset-2">
                <strong>
                    Education Details3 Remark
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails3Remark}}  
            </div>
        </div>
        <!--new-->
        <div class="row-mt10" *ngIf="displayData.educationDetails3SchoolState">
            <div class="col-4 offset-2">
                <strong>
                    Education Details3 School State
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.educationDetails3SchoolState}}  
            </div>
        </div>
        <div class="row-mt10" *ngIf="displayData.actualGraduationYear">
            <div class="col-4 offset-2">
                <strong>
                    Actual Graduation Year
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.actualGraduationYear}}  
            </div>
        </div><div class="row-mt10" *ngIf="displayData.qualifyingExamName">
            <div class="col-4 offset-2">
                <strong>
                    Qualifying Exam Name
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.qualifyingExamName}}  
            </div>
        </div><div class="row-mt10" *ngIf="displayData.currentStage">
            <div class="col-4 offset-2">
                <strong>
                    Current Stage
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.currentStage}}  
            </div>
        </div><div class="row-mt10" *ngIf="displayData.qualifyingExamRollNo">
            <div class="col-4 offset-2">
                <strong>
                    Qualifying Exam Roll No
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.qualifyingExamRollNo}}  
            </div>
        </div><div class="row-mt10" *ngIf="displayData.qualifyingExamRank1">
            <div class="col-4 offset-2">
                <strong>
                    Qualifying Exam Rank1
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.qualifyingExamRank1}}  
            </div>
        </div><div class="row-mt10" *ngIf="displayData.qualifyingExamRank2">
            <div class="col-4 offset-2">
                <strong>
                    Qualifying Exam Rank2
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.qualifyingExamRank2}}  
            </div>
        </div><div class="row-mt10" *ngIf="displayData.utmSource">
            <div class="col-4 offset-2">
                <strong>
                    Utm Source
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.utmSource}}  
            </div>
        </div><div class="row-mt10" *ngIf="displayData.utmMedium">
            <div class="col-4 offset-2">
                <strong>
                    Utm Medium
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.utmMedium}}  
            </div>
        </div><div class="row-mt10" *ngIf="displayData.utmCampaign">
            <div class="col-4 offset-2">
                <strong>
                    Utm Campaign
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.utmCampaign}}  
            </div>
        </div><div class="row-mt10" *ngIf="displayData.customField1">
            <div class="col-4 offset-2">
                <strong>
                    Custom Field 1
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.customField1}}  
            </div>
        </div><div class="row-mt10" *ngIf="displayData.customField2">
            <div class="col-4 offset-2">
                <strong>
                    Custom Field 2
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.customField2}}  
            </div>
        </div><div class="row-mt10" *ngIf="displayData.customField3">
            <div class="col-4 offset-2">
                <strong>
                    Custom Field 3
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.customField3}}  
            </div>
        </div><div class="row-mt10" *ngIf="displayData.customField4">
            <div class="col-4 offset-2">
                <strong>
                    Custom Field 4
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.customField4}}  
            </div>
        </div><div class="row-mt10" *ngIf="displayData.customField5">
            <div class="col-4 offset-2">
                <strong>
                    Custom Field 5
                </strong>
            </div>
            <div class="col-1">
               :     
            </div>
            <div class="col-4">
                  {{displayData.customField5}}  
            </div>
        </div>

       
    </article>
    <article class="mt20p">
        <div class="row mt10">
            <div class="col-11 offset-1">
                <h4>
                    For Office Use Only
                </h4>
            </div>
            <div class="col-12">
                <hr>
            </div>
        </div>
        <div class="row mt10">
            <div class="col-2 offset-1">
              <strong>
                Admitted to Class
              </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-8">
                <hr>
            </div>
        </div>
        <div class="row mt10">
            <div class="col-2 offset-1">
              <strong>
                Adm No.
              </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-8">
                <hr>
            </div>
        </div>
        <div class="row mt10">
            <div class="col-2 offset-1">
              <strong>
                Approved By
              </strong>
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-8">
                <hr>
            </div>
        </div>
    </article>
    <article class="mt20p">
        <div class="row mt10">
            <div class="col-11 offset-1">
                <h4>
                    CERTIFICATE FROM PARENTS/UNDERTAKING
                </h4>
            </div>
            <div class="col-12">
                <hr>
            </div>
        </div>
        <div class="row mt10">
            <div class="col-8 offset-2">
                <p>
                    1. I/We hereby certify that the above information provided by me/us is correct. I/We understand that if
                    the information is found to be incorrect or false at any point of time, my ward will be automatically
                    debarred from the selection/admission process. Admission will be cancelled by school without any
                    correspondence in this regard. I/We also understand that the application/registration/waiting list does
                    not guarantee admission to my ward. I/We accept the process of admission undertaken by the school
                    and I/We will abide by the decision taken by the school authorities.
                </p>
                <p>
                    2. I undertake to submit all the required documents in original for verification by the school and pay
                    fees within the stipulated time period.
                </p>
            </div>
        </div>
        <div class="row mt10">
            <div class="col-12">
                <hr>
            </div>
            <div class="col-6">
                Thank you!! for using www.okiedokiepay.com
            </div>
            <div class="col-6 textEnd">
                For any queries contact us at wecare@okiedokiepay.com
            </div>
        </div>
    </article>
</div>
    `,
    admissionTransactionTemp2 : `
    <div class="card container-fluid p4Rem">
    <div *ngIf="!hasError" class="borderSolid">
        <div  style="font-size: large; font-weight: 400;" class="row">  
          <div class="col-3">
            <img class="hW100px" [src]="displayData.logo" alt="">
          </div>
          <div class="col-6 textCenter ">
            <h3><strong> {{displayData.entityDisplayName}}</strong></h3>
            <p><strong>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}}</strong> </p>
            <p><strong>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </strong></p>
          </div>
          <div class="col-3 textEnd">
            <!-- <h4 class="">Parent Copy</h4>
            <h3 class="pt30">Fee Receipt</h3> -->
          </div>
        </div>
        <div  style="font-size: large; font-weight: 400;" class="row">
            <div class="col-4 ">
                Receipt No: {{displayData.receiptId}}
            </div>
            <div class="col-4 textCenter">
                <strong>Registration Slip</strong>
            </div>
            <div class="col-4 textEnd">
                Date: {{displayData.date | date : 'dd/MM/yyyy'}}
            </div>
        </div>
        <div class="row"></div>
        <div  style="font-size: large; font-weight: 400;" class="row m0 ">
            <div class="col-12 textCenter borderBottom" >
            </div>
            <div class="col-7 ">
                <div class="card-body">
                    <div class="row">
                        <div class="col-6 p0">
                          <strong>  Name  </strong>
                        </div>
                        <div class="col-6 p0">
                          <span> : {{displayData.studentName}} </span>
                        </div> 
                      </div>
                      <div class="row">
                        <div class="col-6 p0">
                          <strong> Father's Name  </strong>
                        </div>
                        <div class="col-6 p0">
                          <span> : {{displayData.studentFatherName}} </span>
                        </div> 
                      </div>
                    <div class="row">
                      <div class="col-6 p0">
                        <strong>D.O.B  </strong>
                      </div>
                      <div class="col-6 p0">
                        <span> : {{displayData.dob | date: 'dd/MM/yyyy'}} </span>
                      </div> 
                    </div>
                    <div class="row">
                        <div class="col-6 p0">
                          <strong>Phone </strong>
                        </div>
                        <div class="col-6 p0">
                          <span> : {{displayData.phone}} </span>
                        </div> 
                      </div>
                    
                </div>
          </div>
          <div class="col-5 ">
              <div class="card-body ">
                  <div class="row">
                    <div class="col-5 p0">
                      <strong>{{displayData.displayNamesCourse}}</strong>
                    </div> 
                    <div class="col-7 p0">
                      :  {{displayData.studentCourse}} / {{displayData.studentStream}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-5 p0">
                      <strong>   Mother's Name  </strong>
                    </div> 
                    <div class="col-7 p0">
                      :  {{displayData.motherName}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-5 p0">
                      <strong>  Form No  </strong>
                    </div> 
                    <div class="col-7 p0">
                      :  {{displayData.applicationNumber}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-5 p0">
                      <strong> Address  </strong>
                    </div> 
                    <div class="col-7 p0">
                      :  {{displayData.address}}
                    </div>
                  </div>
              </div>
          </div>
        </div>
       

        <div class="row m0" style="font-size: large; font-weight: 400;">
          <!-- <div *ngIf="!hasError" class=""> -->
            <table class="table fontFamily mt3p">
            <thead class="borderS1P mt3p">
                <th  class=" fwBoldvw" >
                   S.No
                </th>
                <th  class=" fwBoldvw">
                  Admission Heads
                 </th>
                
                <th  class=" fwBoldvw">
                  Paid Amount
                 </th>
            </thead>
            <tbody>
                <tr *ngFor="let row of displayData.dataSource.data; let i = index" >
                  <td>
                    {{i+1}}
                  </td>
                  <td>
                      {{row.admissionHead}}
                  </td>
                  
                  <td>
                      {{row.paidAmount | number : '1.2-2'}}
                  </td>
                </tr>
            </tbody>
          </table>
        </div> 
          <div class="row">
            <div class="col-12">
              <hr>
            </div>
          <!-- </div> -->
          <div class="col-12">
            <div class="row">
              <div class="col-7 ">
                Payment Mode
              </div>
              <div class="col-1 ">
                :
              </div>
              <div class="col-4 textEnd ">
                {{displayData.paymentDetailsPaymentMode}}
              </div>
            </div>
            <div class="row">
              <div class="col-7 ">
                Instrument Date
              </div>
              <div class="col-1 ">
                :
              </div>
              <div class="col-4 textEnd ">
                {{displayData.paymentDetailsDate | date: 'dd/MM/yyyy'}}
              </div>
            </div>
            <div class="row">
              <div class="col-7 ">
                Instrument Number
              </div>
              <div class="col-1 ">
                :
              </div>
              <div class="col-4 textEnd ">
                {{displayData.paymentDetailsRefId}}
              </div>
            </div>
            <div class="row">
              <div class="col-7 ">
                Total Invoice
              </div>
              <div class="col-1 ">
                :
              </div>
              <div class="col-4 textEnd ">
                {{displayData.totalPaybleAmount | number : '1.2-2' }}
              </div>
            </div>
            <div class="row">
              <div class="col-7 ">
                Net Paid Amount
              </div>
              <div class="col-1 ">
                :
              </div>
              <div class="col-4 textEnd">
                {{displayData.totalPaidAmount | number : '1.2-2' }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <hr>
          </div>
        </div>
          <div class="kt-space-20"></div>
        <div style="font-size: large; font-weight: 400;" class="row justifyFlexEnd m0">
          <div class="col-12">
            <strong>Remarks :</strong>
            {{displayData.remark}}
          </div>
          <div class="col-8">
            <strong> Amount in Words: </strong>
              Rs {{displayData.totalPaidAmountWords.toUpperCase()}} ONLY
          </div>
          <div class="col-4 p0"> 
            <label>Fees Clerk/Accountant</label>
          </div>
        </div>
  
        <div class="kt-space-20"></div>
        <div class="row">
            <div class="col-12 textEnd">
                Office Incharge
            </div>
        </div>
    </div>
  </div>
    `,
    otherIncomeTemp1 : `
    <div class="container-fluid">
   <div style="font-size: large; font-weight: 700;" class="row">
      <div class="col-12">
         <div class="row">
            <div class="col-2">
               <img class="hW100px img-rounded" [src]="displayData.logo" alt="">
            </div>
            <div class="col-8 textCenter ">
               <h1>{{displayData.entityDisplayName}}</h1>
               <span>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </span> <br>
               <span>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </span>
            </div>
         </div>
         <div class="row m0 borderSolid">
            <div class="col-12 textCenter borderBottom" >
               <mat-label> <strong> Other Income Receipt</strong> </mat-label>
            </div>
            <div class="col-7 ">
               <div class="card-body">
                  <div class="row">
                     <div class="col-6 p0">
                        <strong> Receipt No  </strong>
                     </div>
                     <div class="col-6 p0">
                        <span> : {{displayData.receiptId}} </span>
                     </div>
                  </div>
                  <div class="row">
                     <div class="col-6 p0">
                        <strong> Student's Name  </strong>
                     </div>
                     <div class="col-6 p0">
                        <span> : {{displayData.studentName}} </span>
                     </div>
                  </div>
               </div>
            </div>
            <div class="col-5 ">
               <div class="card-body ">
                  <div class="row">
                     <div class="col-5 p0">
                        <strong>Date</strong>
                     </div>
                     <div class="col-7 p0">
                        :  {{displayData.date | date: 'dd/MM/yyyy'}}
                     </div>
                  </div>
                  <div class="row">
                     <div class="col-5 p0">
                        <strong>  Session</strong>
                     </div>
                     <div class="col-7 p0">
                        :  {{displayData.session}}
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div *ngIf="!hasError" class="">
            <table class="table fontFamily mt3p">
               <thead class="borderS1P mt3p">
                  <th style="font-size:17px;font-weight:700;">
                     S.No
                  </th>
                  <th  style="font-size:17px;font-weight:700;">
                     Income Head
                  </th>
                  <th  style="font-size:17px;font-weight:700;">
                     Paid Amount
                  </th>
               </thead>
               <tbody>
                  <tr *ngFor="let row of displayData.dataSource.data; let i = index" >
                     <td>
                        {{i+1}}
                     </td>
                     <td>
                        {{row.otherIncomeHead}}
                     </td>
                     <td>
                        {{row.paidAmount | number : '1.2-2'}}
                     </td>
                  </tr>
               </tbody>
            </table>
            <div class="colorBlackDark">
               <div class="row">
                  <div class="col-7 ">
                     Payment Mode
                  </div>
                  <div class="col-1 ">
                     :
                  </div>
                  <div class="col-4 textEnd ">
                     {{displayData.paymentDetailsPaymentMode}}
                  </div>
               </div>
               <div class="row">
                  <div class="col-7 ">
                     Ref/Chq. Number
                  </div>
                  <div class="col-1 ">
                     :
                  </div>
                  <div class="col-4 textEnd ">
                     {{displayData.paymentDetailsRefId}}
                  </div>
               </div>
               <div class="row">
                  <div class="col-7 ">
                     Net Paid Amount
                  </div>
                  <div class="col-1 ">
                     :
                  </div>
                  <div class="col-4 textEnd">
                     {{displayData.totalPaidAmount | number : '1.2-2' }}
                  </div>
               </div>
            </div>
            <div class="kt-space-20"></div>
            <div class="kt-space-20"></div>
            <div class="row justifyFlexEnd m0">
               <div class="col-12">
                  <strong>Remarks :</strong>
                  {{displayData.remark}}
               </div>
               <div class="col-8">
                  <strong> Amount in Words: </strong>
                  Rs {{displayData.totalPaidAmountWords.toUpperCase()}} ONLY
               </div>
               <div class="col-4 p0"> 
                  <label>Fees Clerk/Accountant</label>
               </div>
            </div>
            <div class="kt-space-20"></div>
            <div class="kt-space-20"></div>
         </div>
      </div>
   </div>
</div>
    `,
    tcCertificate: `
    <section style="font-weight: 500;  font-size: large;" class="container">
    <div class="row mt10">
       <div class="col-2">  
          <img style="height: 75%; width: 75%;" class="img-
             rounded" [src]="displayData.logo" alt=""> 
       </div>
       <div class="col-8 textCenter">
          <h1 style=font-size:35px>{{displayData.entityDisplayName}}</h1>
          <h5>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </h5>
          <h5>Affiliated to CBSE, New Delhi (Affiliation No.: ******)</h5>
          <h5>Mob No: {{displayData.entityReceptionNumber}}, Email Id: {{displayData.entityContactEmail}} </h5>
       </div>
       <div class="col-12 textCenter">
          <h3>
             <strong>
             Transfer Certificate 
             (Session : {{displayData.session}})
             </strong> 
          </h3>
       </div>
    </div>
    <!--<div class="kt-space-20"></div>-->
    <div class="row mt20">
       <div class="col-5">
          <h5> <strong> Serial No :</strong> 
             <input style="width: 100px;border:2px solid black"  [(ngModel)]="displayData.tcNumber"  value="" >
          </h5>
       </div>
       <div class="col-3">
          <h5> <Strong>{{displayData.displayNamesRegNo}} :  </Strong> 
             {{displayData.studentRegNo}}
          </h5>
       </div>
       <div class="col-4">
          <h5><strong>CBSE School No : </strong>******</h5>
       </div>
    </div>
    <br> 
    <article class="mt5p">
       <div class="row mt10">
          <div class="col-1">
             1
          </div>
          <div class="col-4">
             Name of Pupil 
          </div>
          <div class="col-1">
             :  
          </div>
          <div class="col-6">
             <input style="width: 100%; margin: 5px; border:2px solid black"  [(ngModel)]="displayData.studentName"  value="" >
          </div>
       </div>
       <div class="row mt10">
          <div class="col-1">
             2
          </div>
          <div class="col-4">
             Father's/Guardian's Name
          </div>
          <div class="col-1">
             :  
          </div>
          <div class="col-6">
             <input style="width: 100%; margin: 5px; border:2px solid black" [(ngModel)]="displayData.studentFatherName"  value="" >
          </div>
       </div>
       <div class="row mt10">
          <div class="col-1">
             3
          </div>
          <div class="col-4">
             Mother's Name
          </div>
          <div class="col-1">
             :  
          </div>
          <div class="col-6">
             <input style="width: 100%; margin: 5px; border:2px solid black" [(ngModel)]="displayData.motherName"  value="" >
          </div>
       </div>
       <div class="row mt10">
          <div class="col-1">
             4
          </div>
          <div class="col-4">
             Nationality
          </div>
          <div class="col-1">
             :  
          </div>
          <div class="col-6">
             <input style="width: 100%; margin: 5px; border:2px solid black" [(ngModel)]="displayData.nationality"  value="" >
          </div>
       </div>
       <div class="row mt10">
          <div class="col-1">
             5
          </div>
          <div class="col-4">
             Whether the candidate belongs to Scheduled Caste/Scheduled Tribe/OBC
          </div>
          <div class="col-1">
             :  
          </div>
          <div class="col-6">
             <input style="width: 100%; margin: 5px; border:2px solid black" [(ngModel)]="displayData.caste"  value="" >
          </div>
       </div>
       <div class="row mt10">
          <div class="col-1">
             6
          </div>
          <div class="col-4">
             Date of first admission in the School
             with class
          </div>
          <div class="col-1">
             :  
          </div>
          <div class="col-3">
             <input style="width: 100%; margin: 5px;border:2px solid black" [matDatepicker]="datePicker"                             
             (click)="datePicker.open()" [(ngModel)]="displayData.doa" />
             <mat-datepicker #datePicker ></mat-datepicker>
          </div>
          <div class="col-3">
             <input style="width: 100%; margin: 5px;border:2px solid black" [(ngModel)]="displayData.class"  value="">
          </div>
       </div>
       <div class="row mt10">
          <div class="col-1">
             7
          </div>
          <div class="col-4">
             Date of Birth (in Christian era) according
             to Admission Register
          </div>
          <div class="col-1">
             :  
          </div>
          <div class="col-6">
             <input style="width: 100%; margin: 5px;border:2px solid black" [matDatepicker]="datePicke"                             
             (click)="datePicke.open()" [(ngModel)]="displayData.dob" />
             <mat-datepicker #datePicke ></mat-datepicker>
          </div>
       </div>
       <div class="row mt10">
          <div class="col-1">
             8
          </div>
          <div class="col-4">
             Class in which the Student last studied in
             (In figures)
          </div>
          <div class="col-1">
             :  
          </div>
          <div class="col-6">
             <input style="width: 100%; margin: 5px;border:2px solid black" [(ngModel)]="displayData.studentCourse"  value="" >
          </div>
       </div>
       <div class="row mt10">
          <div class="col-1">
             9
          </div>
          <div class="col-4">
             School/Board/Annual Examination last
             taken with result
          </div>
          <div class="col-1">
             :  
          </div>
          <div class="col-6">
             <input style="width: 100%; margin: 5px;border:2px solid black" [(ngModel)]="displayData.board"  value="" >
          </div>
       </div>
       <div class="row mt10">
          <div class="col-1">
             10
          </div>
          <div class="col-4">
             Whether failed, if so once/twice in the same class
          </div>
          <div class="col-1">
             :  
          </div>
          <div class="col-6">
             <input style="width: 100%; margin: 5px;border:2px solid black" [(ngModel)]="displayData.classFailed"  value="" >
          </div>
       </div>
       <div class="row mt10">
          <div class="col-1">
             11
          </div>
          <div class="col-4">
             Subject studied
          </div>
          <div class="col-1">
             :  
          </div>
          <div class="col-6">
             <input style="width: 100%; margin: 5px;border:2px solid black" [(ngModel)]="displayData.subjectStudied"  value="" >
          </div>
       </div>
       <div class="row mt10">
          <div class="col-1">
             12
          </div>
          <div class="col-4">
             Whether qualied for promotion to the higher class<br>
          </div>
          <div class="col-1">
             :  
          </div>
          <div class="col-6">
             <input style="width: 100%; margin: 5px;border:2px solid black" [(ngModel)]="displayData.classPromoted"  value="" >
          </div>
       </div>
       <div class="row mt10">
          <div class="col-1">
             13
          </div>
          <div class="col-4">
             Month upto which the (Pupil has paid) the school dues
          </div>
          <div class="col-1">
             :  
          </div>
          <div class="col-6">
             <input style="width: 100%; margin: 5px;border:2px solid black" [(ngModel)]="displayData.duePayMonth"  value="" >
          </div>
       </div>
       <div class="row mt10">
          <div class="col-1">
             14
          </div>
          <div class="col-4">
             Any fee concession availed of, if so, the nature of such concession
          </div>
          <div class="col-1">
             :  
          </div>
          <div class="col-6">
             <input style="width: 100%; margin: 5px;border:2px solid black" [(ngModel)]="displayData.concessionGroupName"  value="" >
          </div>
       </div>
       <div class="row mt10">
          <div class="col-1">
             15
          </div>
          <div class="col-4">
             Total Number of working days
          </div>
          <div class="col-1">
             :  
          </div>
          <div class="col-6">
             <input style="width: 100%; margin: 5px;border:2px solid black" [(ngModel)]="displayData.totalMaxAttendance"  value="" >
          </div>
       </div>
       <div class="row mt10">
          <div class="col-1">
             16
          </div>
          <div class="col-4">
             Total Number of working days Student present in the school
          </div>
          <div class="col-1">
             :  
          </div>
          <div class="col-6">
             <input style="width: 100%; margin: 5px;border:2px solid black" [(ngModel)]="displayData.totalPresentAttendance"  value="" >
          </div>
       </div>
       <div class="row mt10">
          <div class="col-1">
             17
          </div>
          <div class="col-4">
             Whether NCC Cadet/Boy Scout/Girl Guide (details may be given)
          </div>
          <div class="col-1">
             :  
          </div>
          <div class="col-6">
             <input style="width: 100%; margin: 5px;border:2px solid black" [(ngModel)]="displayData.ncc"  value="" >
          </div>
       </div>
       <div class="row mt10">
          <div class="col-1">
             18
          </div>
          <div class="col-4">
             Games played or extra curricular activities in which the student usually took part (mention achievement level therein)
          </div>
          <div class="col-1">
             :  
          </div>
          <div class="col-6">
             <input style="width: 100%; margin: 5px;border:2px solid black" [(ngModel)]="displayData.extraActivities"  value="" >
          </div>
       </div>
       <div class="row mt10">
          <div class="col-1">
             19
          </div>
          <div class="col-4">
             General Conduct
          </div>
          <div class="col-1">
             :  
          </div>
          <div class="col-6">
             <input style="width: 100%; margin: 5px;border:2px solid black" [(ngModel)]="displayData.generalConduct"  value="" >
          </div>
       </div>
       <div class="row mt10">
          <div class="col-1">
             20
          </div>
          <div class="col-4">
             Date of application for certicate
          </div>
          <div class="col-1">
             :  
          </div>
          <div class="col-6">
             <input style="width: 100%; margin: 5px;border:2px solid black" [matDatepicker]="datePick"                             
             (click)="datePick.open()" [(ngModel)]="displayData.certificateApplicationDate" />
             <mat-datepicker #datePick ></mat-datepicker>
          </div>
       </div>
       <div class="row mt10">
          <div class="col-1">
             21
          </div>
          <div class="col-4">
             Date of issue of certicate
          </div>
          <div class="col-1">
             :  
          </div>
          <div class="col-6">
             <input style="width: 100%; margin: 5px;border:2px solid black" [matDatepicker]="datePic"                             
             (click)="datePic.open()" [(ngModel)]="displayData.certificateIssueDate" />
             <mat-datepicker #datePic ></mat-datepicker>
          </div>
       </div>
       <div class="row mt10">
          <div class="col-1">
             22
          </div>
          <div class="col-4">
             Reason for leaving the school
          </div>
          <div class="col-1">
             :  
          </div>
          <div class="col-6">
             <input style="width: 100%; margin: 5px;border:2px solid black" [(ngModel)]="displayData.schoolLeavingReason"  value="" >
          </div>
       </div>
       <div class="row mt10">
          <div class="col-1">
             23
          </div>
          <div class="col-4">
             Any other remakrs
          </div>
          <div class="col-1">
             :  
          </div>
          <div class="col-6">
             <input style="width: 100%; margin: 5px;border:2px solid black" [(ngModel)]="displayData.otherRemark"  value="" >
          </div>
       </div>
       <br>
       <br>
       <br>
       <br>
       <br>
       <div class="row mt10">
          <div class="col-4">
             <strong>
             Sign. of Class Teacher
             </strong> 
          </div>
          <div class="col-4 textCenter">
             <strong>
             Checked By
             </strong>
             <br>
             (with full name & designation)
          </div>
          <div class="col-4 textCenter">
             <strong>
             Sign. of Principal
             </strong>
             <br>
             (with date & school seal)
          </div>
       </div>
    </article>
 </section>
    </ng-container>
    `,
    tuitionFeeCertificate: `
    
    <section style="font-weight: 800; font-size: 150%">
    <div  class="container-fluid">  
        <div class="row">  
            <div class="col-12"> 
                <div class="row">   
                    <div class="col-3"> 
                <img style="height: 80%; width: 80%;" class="img-rounded" [src]="displayData.logo" alt="">
                </div> 
                    <div class="col-6 textCenter ">
                        <strong><h1>{{displayData.entityDisplayName}}</h1></strong>
                        <span>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </span> <br>
                        <span>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </span><br>
<br>
                        <span>Fee Certificate</span><br>
                        <span>FOR THE FINANCIAL YEAR ({{displayData.session}})</span>
                    </div>
                </div>
                <div class="row m0 borderSolid">
                    <div class="col-12 textCenter borderBottom" >
                        <mat-label> <strong> To Whomsoever It May Concern </strong> </mat-label>
                    </div>
                    <div class="col-12 ">
            
                        <div class="card-body">
                            <div class="row">
                                <div class="col-6 p0">
                                <strong> Ref No. :  </strong>
                                </div>
                                <div class="col-6 textEnd">
                                <span> Date: {{displayData.dateNow | date: 'dd/MM/yyyy'}} </span>
                                </div> 
                            </div>
                            <div class="row">
                                <div class="col-3 p0">
                                <strong> Student's Name  </strong>
                                </div>
                                <div class="col-1 p0">
                                    :
                                </div>
                                <div class="col-6 p0">
                                <span>  {{displayData.studentName}} </span>
                                </div> 
                            </div>
                            <div class="row">
                                <div class="col-3 p0">
                                <strong> {{displayData.displayNamesRegNo}} </strong>
                                </div>
                                <div class="col-1 p0">
                                    :
                                </div>
                                <div class="col-6 p0">
                                <span>  {{displayData.studentRegNo}} </span>
                                </div> 
                            </div>
                            <div class="row">
                                <div class="col-3 p0">
                                <strong> Class</strong>
                                </div>
                                <div class="col-1 p0">
                                    :
                                </div>
                                <div class="col-6 p0">
                                <span>  {{displayData.studentCourse}} </span>
                                </div> 
                            </div>

                            <div class="row">
                                <div class="col-3 p0">
                                <strong> Father's Name  </strong>
                                </div>
                                <div class="col-1 p0">
                                    :
                                </div>
                                <div class="col-6 p0">
                                <span>  {{displayData.studentFatherName}} </span>
                                </div> 
                            </div>
                           <div class="row">
                                <div class="col-3 p0">
                                <strong> Mother's Name  </strong>
                                </div>
                                <div class="col-1 p0">
                                    :
                                </div>
                                <div class="col-6 p0">
                                <span>  {{displayData.studentMotherName}} </span>
                                </div> 
                            </div>
                            <div class="row">
                                <div class="col-3 p0">
                                <strong> Demand  </strong>
                                </div>
                                <div class="col-1 p0">
                                    :
                                </div> 
                                <div class="col-6 p0">
                                <span>  {{displayData.studentTuitionCertificate.demand}} </span>
                                </div> 
                            </div>
                            
                            <div class="row">
                                <div class="col-3 p0">
                                <strong> Concession  </strong>
                                </div>
                                <div class="col-1 p0">
                                    :
                                </div>
                                <div class="col-6 p0">
                                <span>  {{displayData.studentTuitionCertificate.concession}} </span>
                                </div> 
                            </div>
<div class="row">
                                <div class="col-3 p0">
                                <strong>Payable  </strong>
                                </div>
                                <div class="col-1 p0">
                                    :
                                </div>
                                <div class="col-6 p0">
                                <span>  {{displayData.studentTuitionCertificate.payable}} </span>
                                </div> 
                            </div><div class="row">
                                <div class="col-3 p0">
                                <strong>Received  </strong>
                                </div>
                                <div class="col-1 p0">
                                    :
                                </div>
                                <div class="col-6 p0">
                                <span>  {{displayData.studentTuitionCertificate.received}} </span>
                                </div> 
                            </div>
<div class="row">
                                <div class="col-3 p0">
                                <strong> Due Amount  </strong>
                                </div>
                                <div class="col-1 p0">
                                    :
                                </div>
                                <div class="col-6 p0">
                                <span>  {{displayData.studentTuitionCertificate.dueAmount}} </span>
                                </div> 
                            </div>
                            <div class="row">
                                <div class="col-3 p0">
                                <strong> Installements  </strong>
                                </div>
                                <div class="col-1 p0">
                                    :
                                </div>
                                <div class="col-7 p0">
                                <span>  {{displayData. studentTuitionCertificate.installments}} </span>
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row m0 borderSolid" style="padding-top: 50px;">
                    <div class="col-12">
                        <strong>
                            This Certificate is being issued for the purpose of Income Tax/Reimbursement only.
                        </strong>
                    </div>
                    <div class="col-12 textEnd">
                        Authorised Signatory
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
    `,
    noDuesTemlate: `
    <section style="font-weight: 500;">
    <div  class="card container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="row">  
              <div class="col-2">
                <img class="hW100px img-rounded" [src]="displayData.logo" alt="">
              </div>
              <div class="col-8 textCenter ">
                <h4>{{displayData.entityDisplayName}}</h4>
                <span>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </span> <br>
                <span>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </span>
              </div>
            
            </div>
              <div class="row m0 borderSolid">
                  <div class="col-12 textCenter borderBottom" >
                    <mat-label> <strong> No Due's Certicate </strong> </mat-label>
                  </div>
                  <div class="col-7 ">
        
                      <div class="card-body">
                          <div class="row">
                            <div class="col-6 p0">
                              <strong> Date  </strong>
                            </div>
                            <div class="col-6 p0">
                              <span> : {{displayData.date | date: 'dd/MM/yyyy'}} </span>
                            </div> 
                          </div>
                          <div class="row">
                            <div class="col-6 p0">
                              <strong> {{displayData.displayNamesRegNo}} </strong>
                            </div>
                            <div class="col-6 p0">
                              <span> : {{displayData.studentRegNo}} </span>
                            </div> 
                          </div><div class="row">
                            <div class="col-6 p0">
                              <strong> Student's Name  </strong>
                            </div>
                            <div class="col-6 p0">
                              <span> : {{displayData.studentName}} </span>
                            </div> 
                          </div><div class="row">
                            <div class="col-6 p0">
                              <strong> Father's Name  </strong>
                            </div>
                            <div class="col-6 p0">
                              <span> : {{displayData.studentFatherName}} </span>
                            </div> 
                          </div>
                          
                      
                      </div>
                </div>
                <div class="col-5 ">
                    <div class="card-body ">
                        <div class="row">
                          <div class="col-5 p0">
                            <strong>   Session  </strong>
                          </div> 
                          <div class="col-7 p0">
                            :  {{displayData.session}}
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-5 p0">
                            <strong>  {{displayData.displayNamesCourse}}  </strong>
                          </div> 
                          <div class="col-7 p0">
                            :  {{displayData.studentCourse}}
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-5 p0">
                            <strong>  Contact  </strong>
                          </div> 
                          <div class="col-7 p0">
                            :  {{displayData.studentPhone}}
                          </div>
                        </div>
                      
                    
                    </div>
              
              </div>
            </div>
            <div style="padding-top: 30px; padding-bottom: 30px;" class="row m0 borderSolid">
                <div style="border: solid 1px;" class="col-12 textCenter">
                    <p>
                        No Dues
                    </p>
                </div>
            </div>
            <div class="row m0 borderSolid" style="padding-top: 30px;">
                <div class="col-4">
                    Admin
                </div>
                <div class="col-4 textCenter">
                    Class Teacher
                </div>
                <div class="col-4 textEnd">
                    Authorised Signatory
                </div>
            </div>
        </div>
        </div>
      </div>
</section>
    `,
    bonafideCertificate: `
    <section style="font-weight: 800; font-size: 150%; border: solid"> 
    <div  class="card container-fluid"> 
        <div class="row"> 
            <div class="col-12"> 
                <div class="row">  
                    <div class="col-2"> 
                <img style="height: 100%; width: 100%;" class="img-rounded" [src]="displayData.logo" alt="">
                </div>
                    <div style="font-weight: 800; font-size: 140%" class="col-9 textCenter ">
                        <strong><span style="font-size: 40px">{{displayData.entityDisplayName}}</span></strong><br>
                        <span>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </span> <br>
                        <span>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </span><br>
</div>
                </div>
<br>
<br>
                <div class="row m0 borderSolid">
                    <div style="font-weight: 600; font-size: 200%" class="col-12 borderBottom" >
 <div class="row">
                                <div class="col-8">
                                <span><strong> Ref. No.: </strong> ____________</span>
                                </div> 
                                <div class="col-4 textEnd">
                                <span><strong> Date: </strong> {{displayData.dateNow | date: 'dd/MM/yyyy'}} </span>
                                </div> 
                            </div>
                    </div>
                    <div class="col-12 ">
                        <div class="card-body" style="font-weight: 500; font-size: 200%">
<br>
                            <div class="row">
                                <div class="col-12 textCenter">
                                <span><strong>Bonafide Certificate</strong></span>
                                </div> 
                            </div>
                            <div class="row">
                                <div class="col-12 p0">
                               <p>
<br>
                                   It is certify that <strong>{{displayData.studentName}}</strong> {{displayData.gender === 'Male' ? 'S/O' : 'D/O'}} <strong>{{displayData.studentFatherName}}</strong> is a bonafide student of <strong> {{displayData.entityDisplayName}} </strong> of <strong>{{displayData.studentCourse}}</strong> in the session <strong>{{displayData.session}} </strong>. As per school record {{displayData.gender === 'Male' ? 'his' : 'her'}} <strong> {{displayData.displayNamesRegNo}}- {{displayData.studentRegNo}} </strong>, date of birth is <strong> {{displayData.studentDob | date: 'dd/MM/yyyy'}} </strong> and address is <strong>{{displayData.studentAddress}} </strong>.
                               </p>
                                    <br>
<br>
<br>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
<br>
<br>
<br>
                <div class="row m0" style="padding-top: 50px;">
                     <div class="col-11 textEnd"  style="font-weight: 400; font-size: 150%">
                        <strong>Principal</strong>
                    </div>
                </div>
<br>
<br>
<br>
<br>
            </div>
        </div>
    </div>
</section>
    `,
    reportCardv2SkillTemplate:`
    <section  class="pagebreak" *ngFor="let displayData of displayDataArray"> 
    <div style="color: black;" class="reportCard card container-fluid ">
        <div class="card-body" style="border: solid;" >
            <div style="font-size: large; font-weight: 400;" class="row">  
                <div class="col-2">
                <img class="widthInherit img-rounded" [src]="displayData.logo" alt="">
                </div>
                <div class="col-8 textCenter ">
               <h1 style="font-size: 35px;"> <strong>{{displayData.entityDisplayName}}</strong></h1>
                <strong>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </strong> <br>
                <strong>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </strong><br>
                <strong style="font-size: 25px;"> Report Card  (Session: {{displayData.session}} )</strong> 
                </div>
                <hr>
            </div>
            <div  style="font-size: large; font-weight: 400;" class="row">            
                <div class="col-12 textCenter">
                    
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <hr>
                    <hr>
                </div>
            </div>
            <div  style="font-size: large; font-weight: 400;" class="row m0 ">
                <div class="col-12 textCenter " >
                </div>
                <div class="col-7 ">
                    <div class="card-body p0">
                        <div class="row">
                            <div class="col-6 p0">
                            <strong>  Student's Name  </strong>
                            </div>
                            <div class="col-6 p0">
                            <span>  {{displayData.studentName}} </span>
                            </div> 
                        </div>
                        <div class="row">
                            <div class="col-6 p0">
                                <strong> Father's Name  </strong>
                            </div>
                            <div class="col-6 p0">
                                <span>  {{displayData.studentFatherName}} </span>
                            </div> 
                        </div>
                        <div class="row">
                            <div class="col-6 p0">
                                <strong> Mother's Name  </strong>
                            </div>
                            <div class="col-6 p0">
                                <span>  {{displayData.motherName}} </span>
                            </div> 
                        </div>
                        <div class="row">
                        <div class="col-6 p0">
                            <strong>D.O.B  </strong>
                        </div>
                        <div class="col-6 p0">
                            <span>  {{displayData.dob | date: 'dd/MM/yyyy'}} </span>
                        </div> 
                        </div>
                    </div>
                </div>
                <div class="col-5 ">
                    <div class="card-body p0">
                        <div class="row">
                            <div class="col-5 p0">
                                <strong>   Roll No.  </strong>
                            </div> 
                            <div class="col-7 p0">
                                {{displayData.studentRollNo}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-5 p0">
                                <strong>{{displayData.displayNamesCourse}}/Section</strong>
                            </div> 
                            <div class="col-7 p0">
                                {{displayData.studentCourse}} / {{displayData.studentSection}}
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col-5 p0">
                                <strong> {{displayData.displayNamesRegNo}} </strong>
                            </div> 
                            <div class="col-7 p0">
                                {{displayData.studentRegNo}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-5 p0">
                                <strong> Attendance  </strong>
                            </div> 
                            <div class="col-7 p0">
                                {{displayData.academicAttendance}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <hr>
                    <hr>
                </div>
            </div>
            <div class="row" style="font-size: small; font-weight: 400;">
                <div class="col-12">
                    <table style="padding: 0.5rem;" class="table textCenter table-bordered fontFamily mt3p">
                        <thead style="padding: 0.5rem;" class="borderS1P mt3p">
                            <tr class="buttonTheme">
                              
                            <th style="padding: 0.5rem;"  [attr.colspan]="2"  >
                               <strong> Scholastic Area</strong>
                            </th>
                            <ng-container *ngFor="let grp of displayData.scholasticTableHeads" >
                                <th style="padding: 0.5rem;" [attr.colspan]="grp.subHeads.length+4">
                                    <strong>{{grp.name}}</strong>
                                </th>
                            </ng-container>
                            </tr>
                            <tr>
                            <th style="padding: 0.5rem;">
                                <strong>Subject Group</strong>
                            </th>
                            <th style="padding: 0.5rem;"  >
                               <strong> Subjects</strong>
                            </th>
                            <ng-container *ngFor="let grp of displayData.scholasticTableHeads">
                                <th style="padding: 0.5rem;"   *ngFor="let item of grp.subHeads">
                                <strong>{{item}}</strong>
                                </th>
                                <th style="padding: 0.5rem;" >Total</th>
                                <th style="padding: 0.5rem;" >Grade</th>
                                <th style="padding: 0.5rem;" >Group Total</th>
                                <th style="padding: 0.5rem;" >Group Grade</th>
                            </ng-container>
                            
                            </tr>
                        </thead>
                        <tbody style="padding: 0.5rem;">
                            <ng-container *ngFor="let subGrp of displayData.scholasticSubjectGroup">
                                
                                <tr *ngFor="let sub of subGrp.subjects; index as i" >
                                    <td style="padding: 0.5rem;" *ngIf="i == 0" [attr.rowspan]="subGrp.subjects.length" >
                                        <strong> {{subGrp.name}} </strong>
                                     </td>                                    
    
                                         <td style="padding: 0.5rem;" >
                                             <strong> {{sub.name}} </strong>
                                         </td>
                                         <ng-container *ngFor="let grp of sub.assessmentGroups; index as j">
         
                                             <td style="padding: 0.5rem;"  *ngFor="let item of grp.assessments">
                                             
                                             <span *ngIf="item.attendance =='present'">
                                             {{item.obtainedMarks }}
                                             </span>
                                             <span *ngIf="item.attendance !='present'">
                                                 <strong>Ab</strong>
                                             </span>
                                             </td>
         
                                             <td style="padding: 0.5rem;" >{{grp.total }}</td>
                                             <td style="padding: 0.5rem;" >{{grp.grade}}</td>
                                             <td style="padding: 0.5rem;" *ngIf="i == 0" [attr.rowspan]="subGrp.subjects.length">{{subGrp.groupTotal[j]}}</td>
                                             <td style="padding: 0.5rem;" *ngIf="i == 0" [attr.rowspan]="subGrp.subjects.length">{{subGrp.groupGrade[j]}}</td>
                                         </ng-container>
                                   
                                     
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
                <div class="col-12">
                    <table style="padding: 0.5rem;" class="table textCenter table-bordered fontFamily mt3p">
                        <thead style="padding: 0.5rem;" class="borderS1P mt3p">
                            <tr class="buttonTheme">
                                <th style="padding: 0.5rem;" >
                                   <strong> Scholastic Area</strong>
                                </th>
                                    <th style="padding: 0.5rem;"  *ngFor="let grp of displayData.scholasticAssessmentGroupTotal">
                                        <strong>{{grp.groupName}}</strong>
                                    </th>
                                <th style="padding: 0.5rem;">
                                   <strong> Grand Total</strong>
                                </th>
                            </tr>
                        </thead>
                        <tbody style="padding: 0.5rem;">
                            <tr>
                                <td style="padding: 0.5rem;" >
                                    Grand Total
                                </td>
                                <td style="padding: 0.5rem;"  *ngFor="let grp of displayData.scholasticAssessmentGroupTotal">
                                    {{grp.totalObtained }} / {{grp.totalMaxMarks}}
                                </td>
                                <td style="padding: 0.5rem;">
                                    {{displayData.scholasticTotal }} / {{displayData.scholasticMaxTotalMarks}}
                                </td>
                            </tr>
                            <tr>
                                <td style="padding: 0.5rem;" >
                                    Percentage 
                                </td>
                                <td style="padding: 0.5rem;"  *ngFor="let grp of displayData.scholasticAssessmentGroupTotal">
                                    {{grp.percentage}}
                                </td>
                                <td style="padding: 0.5rem;">
                                    {{displayData.scholasticTotalPercentage }}
                                </td>
                            </tr>
                            
                        </tbody>
                    </table>
                </div>
                
                    
            </div> 
            <div class="row" style="font-size: small; font-weight: 400;">
                <div class="col-6">
                    <table style="padding: 0.5rem;" class="table textCenter table-bordered fontFamily mt3p">
                        <thead style="padding: 0.5rem;" class="borderS1P mt3p">
                            <tr class="buttonTheme">
                            <th style="padding: 0.5rem;"  [attr.colspan]="2"  >
                           <strong> Co-Scholastic Area</strong>
                            </th>
                            <ng-container *ngFor="let grp of displayData.coScholasticTableHeads" >
                                <th style="padding: 0.5rem;"   [attr.colspan]="grp.subHeads.length">
                                    <strong>{{grp.name}}</strong>
                                </th>
                            </ng-container>
                            </tr>
                        </thead>
                        <tbody style="padding: 0.5rem;">
                            <ng-container *ngFor="let subGrp of displayData.coScholasticSubjectGroup">
                                
                                <tr *ngFor="let sub of subGrp.subjects; index as i" >
                                    <td style="padding: 0.5rem;" *ngIf="i == 0" [attr.rowspan]="subGrp.subjects.length" >
                                        <strong> {{subGrp.name}} </strong>
                                     </td> 
                                <td style="padding: 0.5rem;" >
                                <strong> {{sub.name}}</strong>
                                </td>
                                <ng-container *ngFor="let grp of sub.assessmentGroups">
                                    <td style="padding: 0.5rem;"  *ngFor="let item of grp.assessments">
                                        {{item.grade}}
                                    </td>
                                </ng-container>
                            </tr>
                        </ng-container>
                        </tbody>
                    </table>
                </div>
                <div class="col-6">
                    <table style="padding: 0.5rem;" class="table textCenter table-bordered fontFamily mt3p">
                        <thead style="padding: 0.5rem;" class="borderS1P mt3p">
                            <tr class="buttonTheme">
                            <th style="padding: 0.5rem;"  [attr.colspan]="2"  >
                                <strong> Discipline</strong>
                            </th>
                            <ng-container *ngFor="let grp of displayData.disciplineTableHeads" >
                                <th style="padding: 0.5rem;"   [attr.colspan]="grp.subHeads.length">
                                  <strong>  {{grp.name}} </strong>
                                </th>
                            </ng-container>
                            </tr>
                        </thead>
                        <tbody style="padding: 0.5rem;">
                            <ng-container *ngFor="let sub of displayData.disciplineSubjectGroup">
                                <tr *ngFor="let sub of sub.subjects; index as i" >
                                    <td style="padding: 0.5rem;" *ngIf="i == 0" [attr.rowspan]="subGrp.subjects.length" >
                                        <strong> {{subGrp.name}} </strong>
                                     </td>
                                <td style="padding: 0.5rem;" >
                                   <strong> {{sub.name}}</strong>
                                </td>
                                <ng-container *ngFor="let grp of sub.assessmentGroups">
                                    <td style="padding: 0.5rem;"  *ngFor="let item of grp.assessments">
                                        {{item.grade}}
                                    </td>
                                    
                                </ng-container>
                                
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
            
            <div *ngFor="let skill of displayData.skillGroup" class="row" style="font-size: small; font-weight: 400;">
                <div class="col-12 textCenter ">

                    <h1 >{{skill.name}}</h1>                
                </div>
                <div class="col-12">
                    <table  style="padding: 0.5rem;" class="table textCenter table-bordered fontFamily mt3p">
                        <thead style="padding: 0.5rem;" class="borderS1P mt3p">
                            <tr class="buttonTheme">
                              
                            <th style="padding: 0.5rem;"  [attr.colspan]="2"  >
                               <strong> Skills</strong>
                            </th>
                            <ng-container *ngFor="let grp of displayData.skillTableHeads" >
                                <th style="padding: 0.5rem;" [attr.colspan]="grp.subHeads.length+4">
                                    <strong>{{grp.name}}</strong>
                                </th>
                            </ng-container>
                            </tr>
                            <tr>
                            <th style="padding: 0.5rem;">
                                <strong>Skill Group</strong>
                            </th>
                            <th style="padding: 0.5rem;"  >
                               <strong> Subjects</strong>
                            </th>
                            <ng-container *ngFor="let grp of displayData.skillTableHeads">
                                <th style="padding: 0.5rem;"   *ngFor="let item of grp.subHeads">
                                <strong>{{item}}</strong>
                                </th>
                                <th style="padding: 0.5rem;" >Total</th>
                                <th style="padding: 0.5rem;" >Grade</th>
                                <th style="padding: 0.5rem;" >Group Total</th>
                                <th style="padding: 0.5rem;" >Group Grade</th>
                            </ng-container>
                            
                            </tr>
                        </thead>
                        <tbody style="padding: 0.5rem;">
                            <ng-container *ngFor="let subGrp of skill.skillGroup">
                                
                                <tr *ngFor="let sub of subGrp.subjects; index as i" >
                                    <ng-container *ngIf="subGrp.name.split(':').length == 2">
                                        <td style="padding: 0.5rem;" *ngIf="i == 0" [attr.rowspan]="subGrp.subjects.length" >
                                            <strong> {{subGrp.name.split(':')[1]}} </strong>
                                         </td>                                    

                                    </ng-container>
                                    <ng-container *ngIf="subGrp.name.split(':').length != 2">
                                        <td style="padding: 0.5rem; " *ngIf="i == 0" [attr.rowspan]="subGrp.subjects.length" >
                                            <strong> {{subGrp.name}} </strong>
                                         </td> 
                                    </ng-container>
                                    <ng-container *ngIf="sub.name.split(':').length == 2">
                                        <td style="padding: 0.5rem; " >
                                            <strong> {{sub.name.split(':')[1]}} </strong>
                                        </td>
                                    </ng-container>
                                    <ng-container *ngIf="sub.name.split(':').length != 2">
                                        <td style="padding: 0.5rem;" >
                                            <strong> {{sub.name}} </strong>
                                        </td>
                                    </ng-container>
                                         <ng-container *ngFor="let grp of sub.assessmentGroups; index as j">
         
                                             <td style="padding: 0.5rem;"  *ngFor="let item of grp.assessments">
                                             
                                                 {{item.obtainedMarks }}
                                             </td>
         
                                             <td style="padding: 0.5rem;" >{{grp.total }}</td>
                                             <td style="padding: 0.5rem;" >{{grp.grade}}</td>
                                             <td style="padding: 0.5rem;" *ngIf="i == 0" [attr.rowspan]="subGrp.subjects.length">{{subGrp.groupTotal[j]}}</td>
                                             <td style="padding: 0.5rem;" *ngIf="i == 0" [attr.rowspan]="subGrp.subjects.length">{{subGrp.groupGrade[j]}}</td>
                                         </ng-container>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
                
                
                    
            </div> 
            <div class="kt-space-20"></div>
            <div class="row" style="font-size: large; font-weight: 400;">
               
                <div class="col-12">
                    <table style="padding: 0.5rem;" class="table table-bordered fontFamily mt3p">
                        <tbody>
                            <tr style="height: 100px;">
                                <td>
                                    <span style="padding: 0.5rem;">
                                        <strong>Remarks :- </strong> {{displayData.academicRemark}}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="kt-space-20"></div>
            <div class="row" style="font-size: large; font-weight: 400;">
                <div  class="col-12">
                    <span style="padding: 0.5rem;">
                       <strong> <span>Result : </span> {{displayData.academicResult}} </strong>
                    </span>
                </div>
            </div>
            <div class="kt-space-20"></div>
            <div class="row" style="font-size: small; font-weight: 400;">
                <div class="col-12">
                    <table style="padding: 0.5rem;" class="table textCenter table-bordered fontFamily mt3p">
                        <thead class="borderS1P mt3p">
                            <tr class="buttonTheme">
                                <th style="padding: 0.5rem;"  class="textCenter" [attr.colspan]="displayData.scholasticGradeConfig.length">
                                Grading Criteria
                                </th>
                            </tr>
                            <tr>
                                <th style="padding: 0.5rem;"  *ngFor=" let item of displayData.scholasticGradeConfig">
                                    {{item.grade}}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td style="padding: 0.5rem;"  *ngFor=" let item of displayData.scholasticGradeConfig">
                                {{item.minMarks}} -  {{item.maxMarks}}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                
            </div>
            <div class="kt-space-20"></div>

            <div class="row height100p" style="padding: 0.5rem; font-size: large; font-weight: 400;">
                <div  class="col-4 borderS1P textCenter">
                    <span style="left: 25%;" class="positionBottom">
                       <strong> Parent's Signature</strong>
                    </span>
                </div>
                <div class="col-4 borderS1P textCenter">
                    <span style="left: 12%;" class="positionBottom">
                       <strong> Class Teacher's Signature</strong>
                    </span>
                </div>
                <div class="col-4 borderS1P textCenter">
                    <span style="left: 25%;" class="positionBottom">
                       <strong> Principal's Signature</strong>
                    </span>
                </div>
            </div>
        </div>
    </div>
</section>
    `,
    characterCertificate: `
    <section style="font-weight: 800; font-size: 150%; border: solid">   
    <div  class="card container-fluid"> 
       <div class="row"> 
          <div class="col-12">
             <div class="row">
                <div class="col-2"> 
                   <img style="height: 100%; width: 100%;" class="img-rounded" [src]="displayData.logo" alt="">
                </div>
                <div style="font-weight: 800; font-size: 140%" class="col-9 textCenter ">
                   <strong><span style="font-size: 40px">{{displayData.entityDisplayName}}</span></strong><br>
                   <span>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </span> <br>
                   <span>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </span><br>
                </div>
             </div>
             <br>
             <br>
             <div class="row m0 borderSolid">
                <div style="font-weight: 600; font-size: 200%" class="col-12 borderBottom" >
                   <div class="row">
                      <div class="col-8">
                         <span><strong> Ref. No.: </strong> ___________</span>
                      </div>
                      <div class="col-4 textEnd">
                         <span><strong> Date: </strong> {{displayData.dateNow | date: 'dd/MM/yyyy'}} </span>
                      </div>
                   </div>
                </div>
                <div class="col-12 ">
                   <div class="card-body" style="font-weight: 500; font-size: 200%">
                      <br>
                      <div class="row">
                         <div class="col-12 textCenter">
                            <span><strong>Character Certificate</strong></span>
                         </div>
                      </div>
                      <div class="row">
                         <div class="col-12 p0">
                            <p>
                               <br>
                               Certified that {{displayData.gender === 'Male' ? 'Mr.' : 'Ms.'}} <span style="text-decoration: underline;">  {{displayData.studentName}}</span> {{displayData.gender === 'Male' ? 'son' : 'daughter'}} of <span style="text-decoration: underline;">{{displayData.studentFatherName}}</span> is a bonafide student of {{displayData.studentCourse}} in the session {{displayData.session}}. As per school record {{displayData.gender === 'Male' ? 'his' : 'her'}} {{displayData.displayNamesRegNo}}- {{displayData.studentRegNo}}, date of birth is {{displayData.studentDob | date: 'dd/MM/yyyy'}} and address is {{displayData.studentAddress}}.
                               <br>
                               <br>
                               {{displayData.gender === 'Male' ? 'He' : 'She'}} bears a Good Moral Character.<br>
                               We wish success in {{displayData.gender === 'Male' ? 'his' : 'her'}} life.
                            </p>
                         </div>
                      </div>
                   </div>
                   <div class="row" style="padding-top: 50px;">
                      <div class="col-1">
                         1.
                      </div>
                      <div class="col-4">
                         Character
                      </div>
                      <div class="col-7">
                         <strong> : Good</strong>
                      </div>
                   </div>
                   <div class="row">
                      <div class="col-1">
                         2.
                      </div>
                      <div class="col-4">
                         Game in which Participated
                      </div>
                      <div class="col-7">
                         <strong> : Football</strong>
                      </div>
                   </div>
                   <div class="row">
                      <div class="col-1">
                         3.
                      </div>
                      <div class="col-4">
                         Hobbies in which intrested
                      </div>
                      <div class="col-7">
                         <strong> : Sports</strong>
                      </div>
                   </div>
                   <div class="row" style="padding-bottom: 50px;">
                      <div class="col-1">
                         4.
                      </div>
                      <div class="col-4">
                         General Behaviour
                      </div>
                      <div class="col-7">
                         <strong> : Good</strong>
                      </div>
                   </div>
                </div>
             </div>
             <br>
             <br>
             <br>
             <div class="row m0" style="padding-top: 50px;">
                <div class="col-11 textEnd"  style="font-weight: 400; font-size: 150%">
                   <strong>Principal</strong>
                </div>
             </div>
             <br>
             <br>
          </div>
       </div>
    </div>
 </section>
    `,
    reportCardTemplate1: `<style media="print">
    .pagebreak {
        page-break-before: always;
    } /* page-break-after works, as well */
    .border2SP {
        border: solid 2px black !important;
    }
    .border1SP {
        border: solid 1px black !important;
    }
    .table-bordered th {
        border: solid 2px black !important;
    }
    .table-bordered td {
        border: solid 2px black !important;
    }
</style>

<section class="pagebreak" *ngFor="let displayData of displayDataArray">
    <div style="color: black;" class="reportCard card container-fluid">
        <div class="card-body" style="border: solid;">
            <div style="font-size: large; font-weight: 400;" class="row">
                <div class="col-2">
                    <img class="widthInherit img-rounded" [src]="displayData.logo" alt="" />
                </div>
                <div class="col-8 textCenter">
                    <h1 style="font-size: 40px;"><strong>{{displayData.entityDisplayName}}</strong></h1>
                    <strong>{{displayData.entityAddress}}, {{displayData.entityCity}}</strong> <br />
                    <strong>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </strong><br />
                    <strong style="font-size: 25px;"> Report Card (Session: {{displayData.session}} )</strong>
                </div>
                <hr />
            </div>
            <div style="font-size: large; font-weight: 400;" class="row">
                <div class="col-12 textCenter"></div>
            </div>
            <div class="row">
                <div class="col-12">
                    <hr class="border1SP" />
                    <hr class="border1SP" />
                </div>
            </div>
            <div style="font-size: large; font-weight: 400;" class="row m0">
                <div class="col-12 textCenter"></div>
                <div class="col-7">
                    <div class="card-body p0">
                        <div class="row">
                            <div class="col-6 p0">
                                <strong> Student's Name </strong>
                            </div>
                            <div class="col-6 p0">
                                <span> {{displayData.studentName}} </span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 p0">
                                <strong> Father's Name </strong>
                            </div>
                            <div class="col-6 p0">
                                <span> {{displayData.studentFatherName}} </span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 p0">
                                <strong> Mother's Name </strong>
                            </div>
                            <div class="col-6 p0">
                                <span> {{displayData.motherName}} </span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 p0">
                                <strong>D.O.B </strong>
                            </div>
                            <div class="col-6 p0">
                                <span> {{displayData.dob | date: 'dd/MM/yyyy'}} </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-5">
                    <div class="card-body p0">
                        <div class="row">
                            <div class="col-5 p0">
                                <strong> Roll No. </strong>
                            </div>
                            <div class="col-7 p0">
                                {{displayData.studentRollNo}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-5 p0">
                                <strong>{{displayData.displayNamesCourse}}/Section</strong>
                            </div>
                            <div class="col-7 p0">
                                {{displayData.studentCourse}} / {{displayData.studentSection}}
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-5 p0">
                                <strong> {{displayData.displayNamesRegNo}} </strong>
                            </div>
                            <div class="col-7 p0">
                                {{displayData.studentRegNo}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-5 p0">
                                <strong> Attendance </strong>
                            </div>
                            <div class="col-7 p0">
                                {{displayData.academicAttendance}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <hr class="border1SP" />
                    <hr class="border1SP" />
                </div>
            </div>
            <div class="row" style="font-size: medium; font-weight: 500;">
                <div class="col-12">
                    <table style="padding: 0.5rem;" class="table textCenter table-bordered fontFamily mt3p border2SP">
                        <thead style="padding: 0.5rem;" class="borderS1P mt3p">
                            <tr class="buttonTheme">
                                <th style="padding: 0.5rem;" class="border2SP" [attr.colspan]="2">
                                    <strong> Scholastic Area</strong>
                                </th>
                                <ng-container *ngFor="let grp of displayData.scholasticTableHeads">
                                    <th style="padding: 0.5rem;" class="border2SP" [attr.colspan]="grp.subHeads.length+2">
                                        <strong>{{grp.name}}</strong>
                                    </th>
                                </ng-container>
                            </tr>
                            <tr>
                                <th style="padding: 0.5rem;" class="border2SP">
                                    <strong> Subjects</strong>
                                </th>
                                <th style="padding: 0.5rem;" class="border2SP">
                                    <strong> Attendance</strong>
                                </th>
                                <ng-container *ngFor="let grp of displayData.scholasticTableHeads">
                                    <th style="padding: 0.5rem;" *ngFor="let item of grp.subHeads" class="border2SP">
                                        <strong>{{item}}</strong>
                                    </th>
                                    <th style="padding: 0.5rem;" class="border2SP">Total (100)</th>
                                    <th style="padding: 0.5rem;" class="border2SP">Grade</th>
                                </ng-container>
                            </tr>
                        </thead>
                        <tbody style="padding: 0.5rem;">
                            <tr *ngFor="let sub of displayData.scholastic">
                                <td style="padding: 0.5rem;">
                                    <strong> {{sub.name}} </strong>
                                </td>
                                <td style="padding: 0.5rem; border: 1.5px solid black;">
                                    {{(sub.attendedLectures !== undefined && sub.attendedLectures !== null) ? sub.attendedLectures : '-'}} / {{(sub.totalLectures !== undefined && sub.totalLectures !== null) ? sub.totalLectures : '-'}}
                                </td>
                                <ng-container *ngFor="let grp of sub.assessmentGroups">
                                    <td style="padding: 0.5rem; border: 1.5px solid black;" *ngFor="let item of grp.assessments">
                                        <span *ngIf="item.attendance =='present'">
                                            {{item.obtainedMarks}}
                                        </span>
                                        <span *ngIf="item.attendance =='absent'">
                                            <strong>Ab</strong>
                                        </span>
                                        <span *ngIf="item.attendance =='-'">
                                            <strong>-</strong>
                                        </span>
                                    </td>

                                    <td style="padding: 0.5rem; border: 1.5px solid black;">{{grp.total.toFixed(2)}}</td>
                                    <td style="padding: 0.5rem; border: 1.5px solid black;">{{grp.grade}}</td>
                                </ng-container>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-12">
                    <table style="padding: 0.5rem;" class="table textCenter table-bordered fontFamily mt3p">
                        <thead style="padding: 0.5rem;" class="borderS1P mt3p">
                            <tr class="buttonTheme">
                                <th style="padding: 0.5rem; border: 1.5px solid black;">
                                    <strong> Scholastic Area</strong>
                                </th>
                                <th style="padding: 0.5rem; border: 1.5px solid black;" *ngFor="let grp of displayData.scholasticAssessmentGroupTotal">
                                    <strong>{{grp.groupName}}</strong>
                                </th>
                                <th style="padding: 0.5rem; border: 1.5px solid black;">
                                    <strong> Grand Total</strong>
                                </th>
                            </tr>
                        </thead>
                        <tbody style="padding: 0.5rem;">
                            <tr>
                                <td style="padding: 0.5rem; border: 1.5px solid black;">
                                    Grand Total
                                </td>
                                <td style="padding: 0.5rem; border: 1.5px solid black;" *ngFor="let grp of displayData.scholasticAssessmentGroupTotal">
                                    {{grp.totalObtained.toFixed(2)}} / {{grp.totalMaxMarks}}
                                </td>
                                <td style="padding: 0.5rem; border: 1.5px solid black;">
                                    {{displayData.scholasticTotal.toFixed(2)}} / {{displayData.scholasticMaxTotalMarks}}
                                </td>
                            </tr>
                            <tr>
                                <td style="padding: 0.5rem; border: 1.5px solid black;">
                                    Percentage
                                </td>
                                <td style="padding: 0.5rem; border: 1.5px solid black;" *ngFor="let grp of displayData.scholasticAssessmentGroupTotal">
                                    {{grp.percentage}}
                                </td>
                                <td style="padding: 0.5rem; border: 1.5px solid black;">
                                    {{displayData.scholasticTotalPercentage}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row" style="font-size: medium; font-weight: 500;">
                <div class="col-6">
                    <table style="padding: 0.5rem;" class="table textCenter table-bordered fontFamily mt3p">
                        <thead style="padding: 0.5rem;" class="borderS1P mt3p">
                            <tr class="buttonTheme">
                                <th style="padding: 0.5rem; border: 1.5px solid black;">
                                    <strong> Co-Scholastic Area</strong>
                                </th>
                                <ng-container *ngFor="let grp of displayData.coScholasticTableHeads">
                                    <th style="padding: 0.5rem; border: 1.5px solid black;" [attr.colspan]="grp.subHeads.length">
                                        <strong>{{grp.name}}</strong>
                                    </th>
                                </ng-container>
                            </tr>
                        </thead>
                        <tbody style="padding: 0.5rem;">
                            <tr *ngFor="let sub of displayData.coScholastic">
                                <td style="padding: 0.5rem; border: 1.5px solid black;">
                                    <strong> {{sub.name}}</strong>
                                </td>
                                <ng-container *ngFor="let grp of sub.assessmentGroups">
                                    <td style="padding: 0.5rem; border: 1.5px solid black;" *ngFor="let item of grp.assessments">
                                        {{item.grade}}
                                    </td>
                                </ng-container>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-6">
                    <table style="padding: 0.5rem; border: 1.5px solid black;" class="table textCenter table-bordered fontFamily mt3p">
                        <thead style="padding: 0.5rem;" class="borderS1P mt3p">
                            <tr class="buttonTheme">
                                <th style="padding: 0.5rem; border: 1.5px solid black;">
                                    <strong> Discipline</strong>
                                </th>
                                <ng-container *ngFor="let grp of displayData.disciplineTableHeads">
                                    <th style="padding: 0.5rem; border: 1.5px solid black;" [attr.colspan]="grp.subHeads.length">
                                        <strong> {{grp.name}} </strong>
                                    </th>
                                </ng-container>
                            </tr>
                        </thead>
                        <tbody style="padding: 0.5rem;">
                            <tr *ngFor="let sub of displayData.discipline">
                                <td style="padding: 0.5rem; border: 1.5px solid black;">
                                    <strong> {{sub.name}}</strong>
                                </td>
                                <ng-container *ngFor="let grp of sub.assessmentGroups">
                                    <td style="padding: 0.5rem; border: 1.5px solid black;" *ngFor="let item of grp.assessments">
                                        {{item.grade}}
                                    </td>
                                </ng-container>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row" style="font-size: large; font-weight: 400;">
                <div class="col-12">
                    <table style="padding: 0.5rem; border: 1.5px solid black;" class="table table-bordered fontFamily mt3p">
                        <tbody>
                            <tr style="height: 50px;">
                                <td>
                                    <span style="padding: 0.5rem;"> <strong>Remarks :- </strong> {{displayData.academicRemark}} </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row" style="font-size: large; font-weight: 400;">
                <div class="col-12">
                    <span style="padding: 0.5rem;">
                        <strong> <span>Result : </span> {{displayData.academicResult}} </strong>
                    </span>
                </div>
            </div>
            <div class="row" style="font-size: small; font-weight: 400;">
                <div class="col-12">
                    <table style="padding: 0.5rem; border: 1.5px solid black;" class="table textCenter table-bordered fontFamily mt3p">
                        <thead class="borderS1P mt3p">
                            <tr class="buttonTheme">
                                <th style="padding: 0.5rem; border: 1.5px solid black;" class="textCenter" [attr.colspan]="displayData.scholasticGradeConfig.length">
                                    Grading Criteria
                                </th>
                            </tr>
                            <tr>
                                <th style="padding: 0.5rem; border: 1.5px solid black;" *ngFor=" let item of displayData.scholasticGradeConfig">
                                    {{item.grade}}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style="padding: 0.5rem; border: 1.5px solid black;" *ngFor=" let item of displayData.scholasticGradeConfig">
                                    {{item.minMarks}} - {{item.maxMarks}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row height100p" style="padding: 0.5rem; font-size: large; font-weight: 400;">
                <div class="col-4 textCenter">
                    <span style="left: 25%;" class="positionBottom">
                        <strong> Parent's Signature</strong>
                    </span>
                </div>
                <div class="col-4 textCenter">
                    <span style="left: 12%;" class="positionBottom">
                        <strong> Class Teacher's Signature</strong>
                    </span>
                </div>
                <div class="col-4 textCenter">
                    <span style="left: 25%;" class="positionBottom">
                        <strong> Principal's Signature</strong>
                    </span>
                </div>
            </div>
        </div>
    </div>
</section>`,

    reportCardv2Template1:`
    <section  class="pagebreak" *ngFor="let displayData of displayDataArray"> 
    <div style="color: black;" class="reportCard card container-fluid ">
        <div class="card-body" style="border: solid;" >
            <div style="font-size: large; font-weight: 400;" class="row">  
                <div class="col-2">
                <img class="widthInherit img-rounded" [src]="displayData.logo" alt="">
                </div>
                <div class="col-8 textCenter ">
               <h1 style="font-size: 35px;"> <strong>{{displayData.entityDisplayName}}</strong></h1>
                <strong>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </strong> <br>
                <strong>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </strong><br>
                <strong style="font-size: 25px;"> Report Card  (Session: {{displayData.session}} )</strong> 
                </div>
                <hr>
            </div>
            <div  style="font-size: large; font-weight: 400;" class="row">            
                <div class="col-12 textCenter">
                    
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <hr>
                    <hr>
                </div>
            </div>
            <div  style="font-size: large; font-weight: 400;" class="row m0 ">
                <div class="col-12 textCenter " >
                </div>
                <div class="col-7 ">
                    <div class="card-body p0">
                        <div class="row">
                            <div class="col-6 p0">
                            <strong>  Student's Name  </strong>
                            </div>
                            <div class="col-6 p0">
                            <span>  {{displayData.studentName}} </span>
                            </div> 
                        </div>
                        <div class="row">
                            <div class="col-6 p0">
                                <strong> Father's Name  </strong>
                            </div>
                            <div class="col-6 p0">
                                <span>  {{displayData.studentFatherName}} </span>
                            </div> 
                        </div>
                        <div class="row">
                            <div class="col-6 p0">
                                <strong> Mother's Name  </strong>
                            </div>
                            <div class="col-6 p0">
                                <span>  {{displayData.motherName}} </span>
                            </div> 
                        </div>
                        <div class="row">
                        <div class="col-6 p0">
                            <strong>D.O.B  </strong>
                        </div>
                        <div class="col-6 p0">
                            <span>  {{displayData.dob | date: 'dd/MM/yyyy'}} </span>
                        </div> 
                        </div>
                    </div>
                </div>
                <div class="col-5 ">
                    <div class="card-body p0">
                        <div class="row">
                            <div class="col-5 p0">
                                <strong>   Roll No.  </strong>
                            </div> 
                            <div class="col-7 p0">
                                {{displayData.studentRollNo}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-5 p0">
                                <strong>{{displayData.displayNamesCourse}}/Section</strong>
                            </div> 
                            <div class="col-7 p0">
                                {{displayData.studentCourse}} / {{displayData.studentSection}}
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col-5 p0">
                                <strong> {{displayData.displayNamesRegNo}} </strong>
                            </div> 
                            <div class="col-7 p0">
                                {{displayData.studentRegNo}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-5 p0">
                                <strong> Attendance  </strong>
                            </div> 
                            <div class="col-7 p0">
                                {{displayData.academicAttendance}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <hr>
                    <hr>
                </div>
            </div>
            <div class="row" style="font-size: small; font-weight: 400;">
                <div class="col-12">
                    <table style="padding: 0.5rem;" class="table textCenter table-bordered fontFamily mt3p">
                        <thead style="padding: 0.5rem;" class="borderS1P mt3p">
                            <tr class="buttonTheme">
                              
                            <th style="padding: 0.5rem;"  [attr.colspan]="3"  >
                               <strong> Scholastic Area</strong>
                            </th>
                            <ng-container *ngFor="let grp of displayData.scholasticTableHeads" >
                                <th style="padding: 0.5rem;" [attr.colspan]="grp.subHeads.length+4">
                                    <strong>{{grp.name}}</strong>
                                </th>
                            </ng-container>
                            </tr>
                            <tr>
                            <th style="padding: 0.5rem;">
                                <strong>Subject Group</strong>
                            </th>
                            <th style="padding: 0.5rem;"  >
                               <strong> Subjects</strong>
                            </th>
                            <th style="padding: 0.5rem;"  >
                               <strong> Attendance</strong>
                            </th>
                            <ng-container *ngFor="let grp of displayData.scholasticTableHeads">
                                <th style="padding: 0.5rem;"   *ngFor="let item of grp.subHeads">
                                <strong>{{item}}</strong>
                                </th>
                                <th style="padding: 0.5rem;" >Total</th>
                                <th style="padding: 0.5rem;" >Grade</th>
                                <th style="padding: 0.5rem;" >Group Total</th>
                                <th style="padding: 0.5rem;" >Group Grade</th>
                            </ng-container>
                            
                            </tr>
                        </thead>
                        <tbody style="padding: 0.5rem;">
                            <ng-container *ngFor="let subGrp of displayData.scholasticSubjectGroup">
                                
                                <tr *ngFor="let sub of subGrp.subjects; index as i" >
                                    <td style="padding: 0.5rem;" *ngIf="i == 0" [attr.rowspan]="subGrp.subjects.length" >
                                        <strong> {{subGrp.name}} </strong>
                                     </td>                                    
    
                                         <td style="padding: 0.5rem;" >
                                             <strong> {{sub.name}} </strong>
                                         </td>
                                         <td style="padding: 0.5rem;" >
                                             {{(sub.attendedLectures !== undefined && sub.attendedLectures !== null) ? sub.attendedLectures : '-'}} / {{(sub.totalLectures !== undefined && sub.totalLectures !== null) ? sub.totalLectures : '-'}}
                                         </td>
                                         <ng-container *ngFor="let grp of sub.assessmentGroups; index as j">
         
                                             <td style="padding: 0.5rem;"  *ngFor="let item of grp.assessments">
                                             
                                             <span *ngIf="item.attendance =='present'">
                                             {{item.obtainedMarks }}
                                             </span>
                                             <span *ngIf="item.attendance !='present'">
                                                 <strong>Ab</strong>
                                             </span>
                                             </td>
         
                                             <td style="padding: 0.5rem;" >{{grp.total }}</td>
                                             <td style="padding: 0.5rem;" >{{grp.grade}}</td>
                                             <td style="padding: 0.5rem;" *ngIf="i == 0" [attr.rowspan]="subGrp.subjects.length">{{subGrp.groupTotal[j]}}</td>
                                             <td style="padding: 0.5rem;" *ngIf="i == 0" [attr.rowspan]="subGrp.subjects.length">{{subGrp.groupGrade[j]}}</td>
                                         </ng-container>
                                   
                                     
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
                <div class="col-12">
                    <table style="padding: 0.5rem;" class="table textCenter table-bordered fontFamily mt3p">
                        <thead style="padding: 0.5rem;" class="borderS1P mt3p">
                            <tr class="buttonTheme">
                                <th style="padding: 0.5rem;" >
                                   <strong> Scholastic Area</strong>
                                </th>
                                    <th style="padding: 0.5rem;"  *ngFor="let grp of displayData.scholasticAssessmentGroupTotal">
                                        <strong>{{grp.groupName}}</strong>
                                    </th>
                                <th style="padding: 0.5rem;">
                                   <strong> Grand Total</strong>
                                </th>
                            </tr>
                        </thead>
                        <tbody style="padding: 0.5rem;">
                            <tr>
                                <td style="padding: 0.5rem;" >
                                    Grand Total
                                </td>
                                <td style="padding: 0.5rem;"  *ngFor="let grp of displayData.scholasticAssessmentGroupTotal">
                                    {{grp.totalObtained }} / {{grp.totalMaxMarks}}
                                </td>
                                <td style="padding: 0.5rem;">
                                    {{displayData.scholasticTotal }} / {{displayData.scholasticMaxTotalMarks}}
                                </td>
                            </tr>
                            <tr>
                                <td style="padding: 0.5rem;" >
                                    Percentage 
                                </td>
                                <td style="padding: 0.5rem;"  *ngFor="let grp of displayData.scholasticAssessmentGroupTotal">
                                    {{grp.percentage}}
                                </td>
                                <td style="padding: 0.5rem;">
                                    {{displayData.scholasticTotalPercentage }}
                                </td>
                            </tr>
                            
                        </tbody>
                    </table>
                </div>
                
                    
            </div> 
            <div class="row" style="font-size: small; font-weight: 400;">
                <div class="col-6">
                    <table style="padding: 0.5rem;" class="table textCenter table-bordered fontFamily mt3p">
                        <thead style="padding: 0.5rem;" class="borderS1P mt3p">
                            <tr class="buttonTheme">
                            <th style="padding: 0.5rem;"  [attr.colspan]="2"  >
                           <strong> Co-Scholastic Area</strong>
                            </th>
                            <ng-container *ngFor="let grp of displayData.coScholasticTableHeads" >
                                <th style="padding: 0.5rem;"   [attr.colspan]="grp.subHeads.length">
                                    <strong>{{grp.name}}</strong>
                                </th>
                            </ng-container>
                            </tr>
                        </thead>
                        <tbody style="padding: 0.5rem;">
                            <ng-container *ngFor="let subGrp of displayData.coScholasticSubjectGroup">
                                
                                <tr *ngFor="let sub of subGrp.subjects; index as i" >
                                    <td style="padding: 0.5rem;" *ngIf="i == 0" [attr.rowspan]="subGrp.subjects.length" >
                                        <strong> {{subGrp.name}} </strong>
                                     </td> 
                                <td style="padding: 0.5rem;" >
                                <strong> {{sub.name}}</strong>
                                </td>
                                <ng-container *ngFor="let grp of sub.assessmentGroups">
                                    <td style="padding: 0.5rem;"  *ngFor="let item of grp.assessments">
                                        {{item.grade}}
                                    </td>
                                </ng-container>
                            </tr>
                        </ng-container>
                        </tbody>
                    </table>
                </div>
                <div class="col-6">
                    <table style="padding: 0.5rem;" class="table textCenter table-bordered fontFamily mt3p">
                        <thead style="padding: 0.5rem;" class="borderS1P mt3p">
                            <tr class="buttonTheme">
                            <th style="padding: 0.5rem;"  [attr.colspan]="2"  >
                                <strong> Discipline</strong>
                            </th>
                            <ng-container *ngFor="let grp of displayData.disciplineTableHeads" >
                                <th style="padding: 0.5rem;"   [attr.colspan]="grp.subHeads.length">
                                  <strong>  {{grp.name}} </strong>
                                </th>
                            </ng-container>
                            </tr>
                        </thead>
                        <tbody style="padding: 0.5rem;">
                            <ng-container *ngFor="let sub of displayData.disciplineSubjectGroup">
                                <tr *ngFor="let sub of sub.subjects; index as i" >
                                    <td style="padding: 0.5rem;" *ngIf="i == 0" [attr.rowspan]="subGrp.subjects.length" >
                                        <strong> {{subGrp.name}} </strong>
                                     </td>
                                <td style="padding: 0.5rem;" >
                                   <strong> {{sub.name}}</strong>
                                </td>
                                <ng-container *ngFor="let grp of sub.assessmentGroups">
                                    <td style="padding: 0.5rem;"  *ngFor="let item of grp.assessments">
                                        {{item.grade}}
                                    </td>
                                    
                                </ng-container>
                                
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div> 
            <div class="kt-space-20"></div>
            <div class="row" style="font-size: large; font-weight: 400;">
               
                <div class="col-12">
                    <table style="padding: 0.5rem;" class="table table-bordered fontFamily mt3p">
                        <tbody>
                            <tr style="height: 100px;">
                                <td>
                                    <span style="padding: 0.5rem;">
                                        <strong>Remarks :- </strong> {{displayData.academicRemark}}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="kt-space-20"></div>
            <div class="row" style="font-size: large; font-weight: 400;">
                <div  class="col-12">
                    <span style="padding: 0.5rem;">
                       <strong> <span>Result : </span> {{displayData.academicResult}} </strong>
                    </span>
                </div>
            </div>
            <div class="kt-space-20"></div>
            <div class="row" style="font-size: small; font-weight: 400;">
                <div class="col-12">
                    <table style="padding: 0.5rem;" class="table textCenter table-bordered fontFamily mt3p">
                        <thead class="borderS1P mt3p">
                            <tr class="buttonTheme">
                                <th style="padding: 0.5rem;"  class="textCenter" [attr.colspan]="displayData.scholasticGradeConfig.length">
                                Grading Criteria
                                </th>
                            </tr>
                            <tr>
                                <th style="padding: 0.5rem;"  *ngFor=" let item of displayData.scholasticGradeConfig">
                                    {{item.grade}}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td style="padding: 0.5rem;"  *ngFor=" let item of displayData.scholasticGradeConfig">
                                {{item.minMarks}} -  {{item.maxMarks}}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                
            </div>
            <div class="kt-space-20"></div>

            <div class="row height100p" style="padding: 0.5rem; font-size: large; font-weight: 400;">
                <div  class="col-4 borderS1P textCenter">
                    <span style="left: 25%;" class="positionBottom">
                       <strong> Parent's Signature</strong>
                    </span>
                </div>
                <div class="col-4 borderS1P textCenter">
                    <span style="left: 12%;" class="positionBottom">
                       <strong> Class Teacher's Signature</strong>
                    </span>
                </div>
                <div class="col-4 borderS1P textCenter">
                    <span style="left: 25%;" class="positionBottom">
                       <strong> Principal's Signature</strong>
                    </span>
                </div>
            </div>
        </div>
    </div>
</section>
    `,
    invoiceTemplate1:`
    <section  class="pagebreak" *ngFor="let displayData of displayDataArray">
    <div style="color: black;" class="container-fluid ">
       <div class="card-body">
          <div class="row">
             <div class="col-3 borderLeftD1p">
                <div class="row">
                   <div class="col-12 textCenter">
                      STUDENT COPY
                   </div>
                </div>
                <div style="font-size: small; font-weight: 400;" class="row">
                   <div class="col-3">
                      <img style="height: 100%; width: 100%;" class="img-rounded" [src]="displayData.logo" alt="">
                   </div>
                   <div class="col-9">
                      <div class="row">
                         <div class="col-12">
                            <h5> <strong>{{displayData.entityDisplayName}}</strong></h5>
                         </div>
                         <div class="col-12 textRight">
                            <strong> {{displayData.entityCity}} </strong> 
                         </div>
                      </div>
                   </div>
                   <hr>
                </div>
                <div style="font-size: small; font-weight: 400; padding-top: 5px;" class="row borderS1P">
                   <div class="col-6 ">
                      Bank Name {{displayData.bankName}}
                   </div>
                   <div class="col-6">
                      Branch:_____
                   </div>
                   <div class="col-12">
                      Account Name : {{displayData.accountName}}
                   </div>
                   <div class="col-12">
                      Account Number : {{displayData.accountNumber}}
                   </div>
                </div>
                <div style="font-size: small; font-weight: 400;" class="row">
                   <div class="col-12">
                      Deposit Date:_____________
                   </div>
                   <div class="col-12">
                      Name of Student: {{displayData.studentName}}
                   </div>
                   <div class="col-12">
                      {{displayData.displayNamesRegNo}} / {{displayData.displayNamesCourse}} : {{displayData.studentRegNo}} / {{displayData.studentCourse}}
                   </div>
                   <div class="col-12">
                      Father Name :  {{displayData.studentFatherName}}
                   </div>
                   <div class="col-12">
                      <strong>Fee Period : </strong> {{displayData.installments}}
                   </div>
                   <div class="col-12">
                      <strong>Last Date : </strong> {{displayData.lastDate}}
                   </div>
                </div>
                <div style="font-size: small; font-weight: 400;" class="row">
                   <table class="table table-bordered fontFamily mt3p">
                      <thead>
                         <tr>
                            <th>
                               Type of Fee
                            </th>
                            <th>
                               Amount
                            </th>
                         </tr>
                      </thead>
                      <tbody>
                         <tr *ngFor="let abc of displayData.tableHead">
                            <td>
                               {{abc.name}}
                            </td>
                            <td >{{displayData.feeHeadsData[abc.value]}}</td>
                         </tr>
                         <tr>
                            <td>
                               <strong>Total Demand</strong>
                            </td>
                            <td>
                               {{displayData.demand}}
                            </td>
                         </tr>
                         <tr>
                            <td>
                               <strong>Total Concession</strong>
                            </td>
                            <td>
                               {{displayData.concession}}
                            </td>
                         </tr>
                         <tr>
                            <td>
                               <strong>Concession Applied</strong>
                            </td>
                            <td>
                               {{displayData.concessionGroupName}}
                            </td>
                         </tr>
                         <tr>
                            <td>
                               <strong>Total Payable</strong>
                            </td>
                            <td>
                               {{displayData.payable}}
                            </td>
                         </tr>
                         <tr>
                            <td>
                               <strong>Total Received</strong>
                            </td>
                            <td>
                               {{displayData.received}}
                            </td>
                         </tr>
                         <tr>
                            <td>
                               <strong>Total Due Amount</strong>
                            </td>
                            <td>
                               {{displayData.dueAmount}}
                            </td>
                         </tr>
                         <tr>
                            <td colspan="2">
                               <strong>Amount in Words :</strong> {{displayData.totalDueAmountWords}}
                            </td>
                         </tr>
                      </tbody>
                   </table>
                </div>
                <div style="font-size: small; font-weight: 400;" class="row">
                   <div class="col-12">
                      <strong>For Cheques Only:</strong>
                   </div>
                   <div class="col-6">
                      ChequeNo:____
                   </div>
                   <div class="col-6">
                      Dated:_____
                   </div>
                   <div class="col-12">
                      Drawn On:____________
                   </div>
                   <div class="col-12">
                      Depositor Signature:____________
                   </div>
                   <div class="col-12">
                      Phone No:____________
                   </div>
                   <div class="col-12 textCenter">
                      <strong>FOR BANK USE ONLY</strong>
                   </div>
                   <div class="col-12">
                      Bank Transaction No:________
                   </div>
                </div>
                <div class="kt-space-20"></div>
                <div style="font-size: x-small; font-weight: 400;" class="row">
                   <div class="col-6">
                      Note: If already paid kindly ignore.
                   </div>
                   <div class="col-6">
                      Cashier / Officer
                   </div>
                </div>
             </div>
             <div class="col-3 borderLeftD1p">
                <div class="row">
                   <div class="col-12 textCenter">
                      TEACHER COPY
                   </div>
                </div>
                <div style="font-size: small; font-weight: 400;" class="row">
                   <div class="col-3">
                      <img style="height: 100%; width: 100%;" class="img-rounded" [src]="displayData.logo" alt="">
                   </div>
                   <div class="col-9">
                      <div class="row">
                         <div class="col-12">
                            <h5> <strong>{{displayData.entityDisplayName}}</strong></h5>
                         </div>
                         <div class="col-12 textRight">
                            <strong> {{displayData.entityCity}} </strong> 
                         </div>
                      </div>
                   </div>
                   <hr>
                </div>
                <div style="font-size: small; font-weight: 400; padding-top: 5px;" class="row borderS1P">
                   <div class="col-6 ">
                      Bank Name {{displayData.bankName}}
                   </div>
                   <div class="col-6">
                      Branch:_____
                   </div>
                   <div class="col-12">
                      Account Name : {{displayData.accountName}}
                   </div>
                   <div class="col-12">
                      Account Number : {{displayData.accountNumber}}
                   </div>
                </div>
                <div style="font-size: small; font-weight: 400;" class="row">
                   <div class="col-12">
                      Deposit Date:_____________
                   </div>
                   <div class="col-12">
                      Name of Student: {{displayData.studentName}}
                   </div>
                   <div class="col-12">
                      {{displayData.displayNamesRegNo}} / {{displayData.displayNamesCourse}} : {{displayData.studentRegNo}} / {{displayData.studentCourse}}
                   </div>
                   <div class="col-12">
                      Father Name :  {{displayData.studentFatherName}}
                   </div>
                   <div class="col-12">
                      <strong>Fee Period : </strong> {{displayData.installments}}
                   </div>
                   <div class="col-12">
                      <strong>Last Date : </strong> {{displayData.lastDate}}
                   </div>
                </div>
                <div style="font-size: small; font-weight: 400;" class="row">
                   <table class="table table-bordered fontFamily mt3p">
                      <thead>
                         <tr>
                            <th>
                               Type of Fee
                            </th>
                            <th>
                               Amount
                            </th>
                         </tr>
                      </thead>
                      <tbody>
                         <tr *ngFor="let abc of displayData.tableHead">
                            <td>
                               {{abc.name}}
                            </td>
                            <td >{{displayData.feeHeadsData[abc.value]}}</td>
                         </tr>
                         <tr>
                            <td>
                               <strong>Total Demand</strong>
                            </td>
                            <td>
                               {{displayData.demand}}
                            </td>
                         </tr>
                         <tr>
                            <td>
                               <strong>Total Concession</strong>
                            </td>
                            <td>
                               {{displayData.concession}}
                            </td>
                         </tr>
                         <tr>
                            <td>
                               <strong>Concession Applied</strong>
                            </td>
                            <td>
                               {{displayData.concessionGroupName}}
                            </td>
                         </tr>
                         <tr>
                            <td>
                               <strong>Total Payable</strong>
                            </td>
                            <td>
                               {{displayData.payable}}
                            </td>
                         </tr>
                         <tr>
                            <td>
                               <strong>Total Received</strong>
                            </td>
                            <td>
                               {{displayData.received}}
                            </td>
                         </tr>
                         <tr>
                            <td>
                               <strong>Total Due Amount</strong>
                            </td>
                            <td>
                               {{displayData.dueAmount}}
                            </td>
                         </tr>
                         <tr>
                            <td colspan="2">
                               <strong>Amount in Words :</strong> {{displayData.totalDueAmountWords}}
                            </td>
                         </tr>
                      </tbody>
                   </table>
                </div>
                <div style="font-size: small; font-weight: 400;" class="row">
                   <div class="col-12">
                      <strong>For Cheques Only:</strong>
                   </div>
                   <div class="col-6">
                      ChequeNo:____
                   </div>
                   <div class="col-6">
                      Dated:_____
                   </div>
                   <div class="col-12">
                      Drawn On:____________
                   </div>
                   <div class="col-12">
                      Depositor Signature:____________
                   </div>
                   <div class="col-12">
                      Phone No:____________
                   </div>
                   <div class="col-12 textCenter">
                      <strong>FOR BANK USE ONLY</strong>
                   </div>
                   <div class="col-12">
                      Bank Transaction No:________
                   </div>
                </div>
                <div class="kt-space-20"></div>
                <div style="font-size: x-small; font-weight: 400;" class="row">
                   <div class="col-6">
                      Note: If already paid kindly ignore.
                   </div>
                   <div class="col-6">
                      Cashier / Officer
                   </div>
                </div>
             </div>
             <div class="col-3 borderLeftD1p">
                <div class="row">
                   <div class="col-12 textCenter">
                      BANK COPY
                   </div>
                </div>
                <div style="font-size: small; font-weight: 400;" class="row">
                   <div class="col-3">
                      <img style="height: 100%; width: 100%;" class="img-rounded" [src]="displayData.logo" alt="">
                   </div>
                   <div class="col-9">
                      <div class="row">
                         <div class="col-12">
                            <h5> <strong>{{displayData.entityDisplayName}}</strong></h5>
                         </div>
                         <div class="col-12 textRight">
                            <strong> {{displayData.entityCity}} </strong> 
                         </div>
                      </div>
                   </div>
                   <hr>
                </div>
                <div style="font-size: small; font-weight: 400; padding-top: 5px;" class="row borderS1P">
                   <div class="col-6 ">
                      Bank Name {{displayData.bankName}}
                   </div>
                   <div class="col-6">
                      Branch:_____
                   </div>
                   <div class="col-12">
                      Account Name : {{displayData.accountName}}
                   </div>
                   <div class="col-12">
                      Account Number : {{displayData.accountNumber}}
                   </div>
                </div>
                <div style="font-size: small; font-weight: 400;" class="row">
                   <div class="col-12">
                      Deposit Date:_____________
                   </div>
                   <div class="col-12">
                      Name of Student: {{displayData.studentName}}
                   </div>
                   <div class="col-12">
                      {{displayData.displayNamesRegNo}} / {{displayData.displayNamesCourse}} : {{displayData.studentRegNo}} / {{displayData.studentCourse}}
                   </div>
                   <div class="col-12">
                      Father Name :  {{displayData.studentFatherName}}
                   </div>
                   <div class="col-12">
                      <strong>Fee Period : </strong> {{displayData.installments}}
                   </div>
                   <div class="col-12">
                      <strong>Last Date : </strong> {{displayData.lastDate}}
                   </div>
                </div>
                <div style="font-size: small; font-weight: 400;" class="row">
                   <table class="table table-bordered fontFamily mt3p">
                      <thead>
                         <tr>
                            <th>
                               Type of Fee
                            </th>
                            <th>
                               Amount
                            </th>
                         </tr>
                      </thead>
                      <tbody>
                         <tr *ngFor="let abc of displayData.tableHead">
                            <td>
                               {{abc.name}}
                            </td>
                            <td >{{displayData.feeHeadsData[abc.value]}}</td>
                         </tr>
                         <tr>
                            <td>
                               <strong>Total Demand</strong>
                            </td>
                            <td>
                               {{displayData.demand}}
                            </td>
                         </tr>
                         <tr>
                            <td>
                               <strong>Total Concession</strong>
                            </td>
                            <td>
                               {{displayData.concession}}
                            </td>
                         </tr>
                         <tr>
                            <td>
                               <strong>Concession Applied</strong>
                            </td>
                            <td>
                               {{displayData.concessionGroupName}}
                            </td>
                         </tr>
                         <tr>
                            <td>
                               <strong>Total Payable</strong>
                            </td>
                            <td>
                               {{displayData.payable}}
                            </td>
                         </tr>
                         <tr>
                            <td>
                               <strong>Total Received</strong>
                            </td>
                            <td>
                               {{displayData.received}}
                            </td>
                         </tr>
                         <tr>
                            <td>
                               <strong>Total Due Amount</strong>
                            </td>
                            <td>
                               {{displayData.dueAmount}}
                            </td>
                         </tr>
                         <tr>
                            <td colspan="2">
                               <strong>Amount in Words :</strong> {{displayData.totalDueAmountWords}}
                            </td>
                         </tr>
                      </tbody>
                   </table>
                </div>
                <div style="font-size: small; font-weight: 400;" class="row">
                   <div class="col-12">
                      <strong>For Cheques Only:</strong>
                   </div>
                   <div class="col-6">
                      ChequeNo:____
                   </div>
                   <div class="col-6">
                      Dated:_____
                   </div>
                   <div class="col-12">
                      Drawn On:____________
                   </div>
                   <div class="col-12">
                      Depositor Signature:____________
                   </div>
                   <div class="col-12">
                      Phone No:____________
                   </div>
                   <div class="col-12 textCenter">
                      <strong>FOR BANK USE ONLY</strong>
                   </div>
                   <div class="col-12">
                      Bank Transaction No:________
                   </div>
                </div>
                <div class="kt-space-20"></div>
                <div style="font-size: x-small; font-weight: 400;" class="row">
                   <div class="col-6">
                      Note: If already paid kindly ignore.
                   </div>
                   <div class="col-6">
                      Cashier / Officer
                   </div>
                </div>
             </div>
             <div class="col-3 borderLeftD1p borderRightD1p">
                <div class="row">
                   <div class="col-12 textCenter">
                      SCHOOL COPY
                   </div>
                </div>
                <div style="font-size: small; font-weight: 400;" class="row">
                   <div class="col-3">
                      <img style="height: 100%; width: 100%;" class="img-rounded" [src]="displayData.logo" alt="">
                   </div>
                   <div class="col-9">
                      <div class="row">
                         <div class="col-12">
                            <h5> <strong>{{displayData.entityDisplayName}}</strong></h5>
                         </div>
                         <div class="col-12 textRight">
                            <strong> {{displayData.entityCity}} </strong> 
                         </div>
                      </div>
                   </div>
                   <hr>
                </div>
                <div style="font-size: small; font-weight: 400; padding-top: 5px;" class="row borderS1P">
                   <div class="col-6 ">
                      Bank Name {{displayData.bankName}}
                   </div>
                   <div class="col-6">
                      Branch:_____
                   </div>
                   <div class="col-12">
                      Account Name : {{displayData.accountName}}
                   </div>
                   <div class="col-12">
                      Account Number : {{displayData.accountNumber}}
                   </div>
                </div>
                <div style="font-size: small; font-weight: 400;" class="row">
                   <div class="col-12">
                      Deposit Date:_____________
                   </div>
                   <div class="col-12">
                      Name of Student: {{displayData.studentName}}
                   </div>
                   <div class="col-12">
                      {{displayData.displayNamesRegNo}} / {{displayData.displayNamesCourse}} : {{displayData.studentRegNo}} / {{displayData.studentCourse}}
                   </div>
                   <div class="col-12">
                      Father Name :  {{displayData.studentFatherName}}
                   </div>
                   <div class="col-12">
                      <strong>Fee Period : </strong> {{displayData.installments}}
                   </div>
                   <div class="col-12">
                      <strong>Last Date : </strong> {{displayData.lastDate}}
                   </div>
                </div>
                <div style="font-size: small; font-weight: 400;" class="row">
                   <table class="table table-bordered fontFamily mt3p">
                      <thead>
                         <tr>
                            <th>
                               Type of Fee
                            </th>
                            <th>
                               Amount
                            </th>
                         </tr>
                      </thead>
                      <tbody>
                         <tr *ngFor="let abc of displayData.tableHead">
                            <td>
                               {{abc.name}}
                            </td>
                            <td >{{displayData.feeHeadsData[abc.value]}}</td>
                         </tr>
                         <tr>
                            <td>
                               <strong>Total Demand</strong>
                            </td>
                            <td>
                               {{displayData.demand}}
                            </td>
                         </tr>
                         <tr>
                            <td>
                               <strong>Total Concession</strong>
                            </td>
                            <td>
                               {{displayData.concession}}
                            </td>
                         </tr>
                         <tr>
                            <td>
                               <strong>Concession Applied</strong>
                            </td>
                            <td>
                               {{displayData.concessionGroupName}}
                            </td>
                         </tr>
                         <tr>
                            <td>
                               <strong>Total Payable</strong>
                            </td>
                            <td>
                               {{displayData.payable}}
                            </td>
                         </tr>
                         <tr>
                            <td>
                               <strong>Total Received</strong>
                            </td>
                            <td>
                               {{displayData.received}}
                            </td>
                         </tr>
                         <tr>
                            <td>
                               <strong>Total Due Amount</strong>
                            </td>
                            <td>
                               {{displayData.dueAmount}}
                            </td>
                         </tr>
                         <tr>
                            <td colspan="2">
                               <strong>Amount in Words :</strong> {{displayData.totalDueAmountWords}}
                            </td>
                         </tr>
                      </tbody>
                   </table>
                </div>
                <div style="font-size: small; font-weight: 400;" class="row">
                   <div class="col-12">
                      <strong>For Cheques Only:</strong>
                   </div>
                   <div class="col-6">
                      ChequeNo:____
                   </div>
                   <div class="col-6">
                      Dated:_____
                   </div>
                   <div class="col-12">
                      Drawn On:____________
                   </div>
                   <div class="col-12">
                      Depositor Signature:____________
                   </div>
                   <div class="col-12">
                      Phone No:____________
                   </div>
                   <div class="col-12 textCenter">
                      <strong>FOR BANK USE ONLY</strong>
                   </div>
                   <div class="col-12">
                      Bank Transaction No:________
                   </div>
                </div>
                <div class="kt-space-20"></div>
                <div style="font-size: x-small; font-weight: 400;" class="row">
                   <div class="col-6">
                      Note: If already paid kindly ignore.
                   </div>
                   <div class="col-6">
                      Cashier / Officer
                   </div>
                </div>
             </div>
          </div>
       </div>
    </div>
 </section>
    `,
    studentLedgerTemplate: `
    <section style="font-weight: 800;" class="container">
   <div class="row mt10">
      <div class="col-2">
         <img style="height: 80%; width: 80%;" class="img-rounded" [src]="displayData.logo" alt="" />
      </div>
      <div class="col-8 textCenter  ">
         <strong>
            <h1>{{displayData.entityDisplayName}}</h1>
         </strong>
         <h3>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </h3>
         <h3>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </h3>
         <h2>Fee Ledger for {{displayData.studentName}} ( {{displayData.studentRegNo}} ) {{displayData.studentCourse}} - {{displayData.studentSection}} </h2>
      </div>
   </div>
   <div style="font-size: large; font-weight: 800;" class="row mt20">
      <table class="table table-bordered fontFamily mt3p">
         <thead>
            <tr>
               <th>
                  Date
               </th>
               <th>
                  Name/Narration
               </th>
               <th></th>
               <th>
                  Payment Mode
               </th>
               <th>
                  Debit
               </th>
               <th>Credit</th>
               <th>Balance</th>
               <th>Remarks</th>
            </tr>
         </thead>
         <tbody>
            <tr *ngFor="let row of displayData.studentLedger">
               <td>
                  {{row.date | date : 'dd/MMM/yyyy'}}
               </td>
               <td>
                  {{row.name}}
               </td>
               <td>
                  {{row.type}}
               </td>
               <td>
                  {{row.paymentMode || '-'}}
               </td>
               <td>
                  {{row.debit}}
               </td>
               <td>{{row.credit}}</td>
               <td>{{row.balance}}</td>
               <td></td>
            </tr>
         </tbody>
      </table>
   </div>
</section>
    `,
    gatePassTemplate1: `
    <section style="font-weight: 800; font-size: large;">
   <div class="card container-fluid">
      <div class="row">
         <div class="col-12">
            <div class="row">
               <div class="col-2">
                  <img style="height: 80%; width: 80%;" class="img-rounded" [src]="displayData.logo" alt="" />
               </div>
               <div class="col-8 textCenter">
                  <h1><strong>{{displayData.entityDisplayName}}</strong></h1>
                  <span>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </span> <br />
                  <span>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </span>
               </div>
            </div>
            <div class="row m0 borderSolid">
               <div class="col-4 borderBottom"><strong> Date </strong> : {{displayData.date | date : 'dd/MM/yyyy hh:mm:ss'}}</div>
               <div class="col-4 textCenter borderBottom"> 
                  <strong> Gate Pass</strong>
               </div>
               <div class="col-4 textEnd borderBottom">
                  <strong> GatePass ID :</strong> ________ 
               </div>
               <hr />
               <div class="col-8" *ngIf= "displayData.seekerType=='student'">
                  <div class="card-body">
                     <div class="row">
                        <div class="col-6 p0">
                           <strong> Student's Name </strong>
                        </div>
                        <div class="col-6 p0">
                           <span> : {{displayData.studentName}} </span>
                        </div>
                     </div>
                     <div class="row">
                        <div class="col-6 p0">
                           <strong> Adm. No. </strong>
                        </div>
                        <div class="col-6 p0">
                           <span> : {{displayData.studentRegNo}} </span>
                        </div>
                     </div>
                     <div class="row">
                        <div class="col-6 p0">
                           <strong> {{displayData.displayNamesCourse}} - Section </strong>
                        </div>
                        <div class="col-6 p0">
                           <span> : {{displayData.studentCourse}} - {{displayData.studentSection}} </span>
                        </div>
                     </div>
                     <div class="row">
                        <div class="col-6 p0">
                           <strong>Contact No.</strong>
                        </div>
                        <div class="col-6 p0">
                           <span> : {{displayData.mobile}} </span>
                        </div>
                     </div>
                     <div class="row">
                        <div class="col-6 p0">
                           <strong> Taker's Name </strong>
                        </div>
                        <div class="col-6 p0">
                           <span> : {{displayData.takerName}} </span>
                        </div>
                     </div>
                     <div class="row">
                        <div class="col-6 p0">
                           <strong> Relation </strong>
                        </div>
                        <div class="col-6 p0">
                           <span> : {{displayData.takerRelation}} </span>
                        </div>
                     </div>
                     <div class="row">
                        <div class="col-6 p0">
                           <strong> Reason </strong>
                        </div>
                        <div class="col-6 p0">
                           <span> : {{displayData.reason}} </span>
                        </div>
                     </div>
                     <div class="row">
                        <div class="col-6 p0">
                           <strong> Approved By </strong>
                        </div>
                        <div class="col-6 p0">
                           <span> : {{displayData.approvedBy}} </span>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-8" *ngIf= "displayData.seekerType=='employee'">
                  <div class="card-body">
                     <div class="row">
                        <div class="col-6 p0">
                           <strong> Employee Name </strong>
                        </div>
                        <div class="col-6 p0">
                           <span> : {{displayData.studentName}} </span>
                        </div>
                     </div>
                     <div class="row">
                        <div class="col-6 p0">
                           <strong>Contact No.</strong>
                        </div>
                        <div class="col-6 p0">
                           <span> : {{displayData.mobile}} </span>
                        </div>
                     </div>
                     <div class="row">
                        <div class="col-6 p0">
                           <strong> Reason </strong>
                        </div>
                        <div class="col-6 p0">
                           <span> : {{displayData.reason}} </span>
                        </div>
                     </div>
                     <div class="row">
                        <div class="col-6 p0">
                           <strong> Approved By </strong>
                        </div>
                        <div class="col-6 p0">
                           <span> : {{displayData.approvedBy}} </span>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-4 textCenter">
                  <br />
                  <img [src]="displayData.takerPhoto" width="80%;" height="80%" />
               </div>
            </div>
            <div class="row m0 borderSolid" style="padding-top: 30px;">
               <br />
               <br />
               <div class="col-3">
                  <strong>
                  Parent/Guardian Sign.
                  </strong>
               </div>
               <div class="col-3 textCenter">
                  <strong>
                  Security Officer
                  </strong>
               </div>
               <div class="col-3">
                  <strong>
                  Teacher's Sign.
                  </strong>
               </div>
               <div class="col-3 textEnd">
                  <strong>
                  Approver Signature
                  </strong>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>
    `,

    visitorGatePass: `
    <section style="font-weight: 500;">
    <div  class="container-fluid">
       <div class="row">
          <div class="col-6">
             <div class="row">
                <div class="col-2">
                   <img class="hW100px img-rounded" [src]="displayData.logo" alt="">
                </div>
                <div class="col-8 textCenter ">
                   <h4>{{displayData.entityDisplayName}}</h4>
                   <span>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}</span> <br>
                   <span>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </span>
                </div>
             </div>
             <div class="row m0 borderSolid">
                <div class="col-4 borderBottom">
                   <strong> Date </strong> : {{displayData.date | date: 'dd/MM/yyyy'}} 
                </div>
                <div class="col-4 textEnd borderBottom" >
                   <strong> Visitor Pass </strong> 
                </div>
                <div class="col-4 textEnd borderBottom">
                   <strong>Id :</strong> _______
                </div>
                <hr>
                <div class="col-12 row">
                   <div class="col-12 ">
                      <div class="card-body">
                         <div class="row">
                            <div class="col-6 p0">
                               <strong> Visitor's Name  </strong>
                            </div>
                            <div class="col-6 p0">
                               <span> : {{displayData.name}} </span>
                            </div>
                         </div>
                         <div class="row">
                            <div class="col-6 p0">
                               <strong> Whom To Meet</strong>
                            </div>
                            <div class="col-6 p0">
                               <span> : {{displayData.toMeet}} </span>
                            </div>
                         </div>
                         <div class="row">
                            <div class="col-6 p0">
                               <strong>Contact No.</strong>
                            </div>
                            <div class="col-6 p0">
                               <span> : {{displayData.mobile}} </span>
                            </div>
                         </div>
                         <div class="row">
                            <div class="col-6 p0">
                               <strong> Purpose </strong>
                            </div>
                            <div class="col-6 p0">
                               <span> : {{displayData.purpose}} </span>
                            </div>
                         </div>
                         <div class="row">
                            <div class="col-6 p0">
                               <strong> Visitor Address  </strong>
                            </div>
                            <div class="col-6 p0">
                               <span> : {{displayData.address}} </span>
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
                <div class="col-5 ">
                   <div class="card-body ">
                   </div>
                </div>
             </div>
             <div class="row m0 borderSolid" style="padding-top: 30px;">
                <div class="col-6">
                   <strong>
                   Reception (Name & Signature)
                   </strong>
                </div>
                <div class="col-6 textEnd">
                   <strong>
                   Approver's Signature
                   </strong>
                </div>
             </div>
          </div>
       </div>
    </div>
 </section>
    `,

    idCardTemplateHorizontal:`
    <style media="print"> 
   .pagebreak {page-break-before: always;} /* page-break-after works, as well */         
</style>
<section style="font-weight: 500;" >
   <div class="row mx-1">
      <div class="col-6 px-0" *ngFor="let displayData of displayDataArray">
         <div class=" borderSolid my-1 mr-1 " style="height: 355.5px !important" >
            <div class="main-div">
               <div class="row">
                  <div class="col-3">
                     <img style="height: 80%; width: 80%; padding-left:15px; padding-top:5px;" class="img-rounded" [src]="displayData.logo" alt="" />
                  </div>
                  <div class="col-9 textCenter">
                     <div class="textCenter" style="font-size: 23px; font-weight: 600; padding-right:5px;">
                        <strong> <span class="institute-name">{{displayData.entityDisplayName}}</span> </strong>
                     </div>
                     <div class="textCenter" style="font-size: 13px; font-weight: 500; padding-right:30px;">
                        <span>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}</span><br>
                        <span>Ph:{{displayData.entityReceptionNumber}}, Email:{{displayData.entityContactEmail}}</span>
                     </div>
                  </div>
               </div>
               <div class="row" style="background:red; color:white; font-weight:bold; font-size:medium; padding-left:200px;" >
                  <label >Student Id Card</label>
               </div>
               <div class="col-14 row">
                  <div class="col-3 textCenter" style="padding-top:10px;">
                     <div class="student-photo">
                        <img [src]= "displayData.takerPhoto" alt="" width="80px" height="80px">
                        <div class="d-flex flex-column align-items-center mt-2">
                           <img class="img"  style="width:100px;height:50px;" src="displayData.logo" />
                           <strong style="font-size: 17px; font-weight: 800;">
                           Principal
                           </strong>
                        </div>
                     </div>
                  </div>
                  <div class="col-9" style="font-size: 14px; font-weight: 800;">
                     <article class="mt5p">
                        <div class="row mt10">
                           <div class="col-4">
                              <strong><label>Student Name</label></strong>
                           </div>
                           <div class="col-8">
                              {{displayData.studentName}}
                           </div>
                        </div>
                        <div class="row mt10">
                           <div class="col-4">
                              <strong><label>Father Name</label></strong>
                           </div>
                           <div class="col-8">
                              {{displayData.fatherName}}
                           </div>
                        </div>
                        <div class="row mt10">
                           <div class="col-4">
                              <strong><label>Admission No.</label></strong>
                           </div>
                           <div class="col-8">
                              {{displayData.studentRegNo}}
                           </div>
                        </div>
                        <div class="row mt10">
                           <div class="col-4">
                              <strong><label>Class</label></strong>
                           </div>
                           <div class="col-8">
                              {{displayData.studentCourse}}-{{displayData.studentSection}}
                           </div>
                        </div>
                        <div class="row mt10">
                           <div class="col-4">
                              <strong><label>Contact No. </label></strong>
                           </div>
                           <div class="col-8">
                              {{displayData.studentPhone}}
                           </div>
                        </div>
                        <div class="row mt10">
                           <div class="col-4">
                              <strong><label>Address</label></strong>
                           </div>
                           <div class="col-8">
                              {{displayData.studentAddress}}
                           </div>
                        </div>
                     </article>
                  </div>
               </div>
            </div>
            <br>
            <br>
            <br>
         </div>
      </div>
      <br>
   </div>
</section>
    
    `,
    idCardTemplateVertical:
            ` 
    <section class="col-7" style="font-weight: 500;"  width="500px" *ngFor="let displayData of displayDataArray">
    <div class="col-8 borderSolid" style="padding:0px; border-radius: 20px;break-inside: avoid;" >
    <div class="main-div">
            <div class="row">
                <div class="textCenter "   style="font-size: large; font-weight: 400; padding-left:160px; ">
                   <strong> <span class="institute-name">{{displayData.entityDisplayName}}</span> </strong><br>
                </div>
            </div>    
            <div class="textCenter" style="background:red; color:white; font-weight:bold;" >
                 <label >Session:-{{displayData.session}}</label>
             </div>
             <div>
                <div class="student-photo textCenter" style="padding-top:10px">
                    <img [src]= "displayData.takerPhoto" alt="" width="100px" height="100px">
                </div>
             </div>
            <div class="col-10 row">
            <div class="col-10">    
            <article class="mt20p">
                 
                <div class="row mt10">
                        <div class="col-5">
                        <strong><label> Name </label></strong>
                        </div>

                        <div class="col-6">
                             {{displayData.studentName}}
                        </div>
                </div> 
                <div class="row mt10">
                        <div class="col-5">
                        <strong><label>F Name</label></strong>
                        </div>

                        <div class="col-6">
                              {{displayData.fatherName}}
                        </div>
                </div>
                 
                <div class="row mt10">
                        <div class="col-5 ">
                        <strong><label>  Reg No.</label></strong>
                        </div>

                        <div class="col-6">
                              {{displayData.studentRegNo}}
                        </div>
                </div>
                 
                <div class="row mt10">
                        <div class="col-5 ">
                        <strong><label>DOB</label></strong>
                        </div>
                        <div class="col-6">
                              {{displayData.dob | date: 'dd/MM/yyyy'}}
                        </div>
                </div>
                 
                <div class="row mt10">
                        <div class="col-5 ">
                        <strong><label> Class</label></strong>
                        </div>

                        <div class="col-6">
                              {{displayData.studentCourse}}
                        </div>
                </div>
                 
                <div class="row mt10">
                        <div class="col-5 ">
                        <strong><label>  Contact </label></strong>
                        </div>

                        <div class="col-6">
                              {{displayData.studentPhone}}
                        </div>
                </div>
                 
                <div class="row mt10">
                        <div class="col-5 ">
                        <strong><label> Address</label></strong>
                        </div>

                        <div class="col-6">
                              {{displayData.studentAddress}}
                        </div>
                </div>
            </article>
            </div>
            </div>

        </div>
        <div class="col-12 textRight">
        <strong>
        Sign. of Principal
        </strong>
        </div>
        <div class="textCenter" style="background:red; color:white; font-weight:bold;" >
            <label >Student Id Card</label>
        </div>
       </div> 
       <br>
    </section>
            `
    ,
    admitCardTemplate:`
    <section class="pagebreak" *ngFor="let displayData of displayDataArray">   
    <div style="font-size: large; font-weight: 900;" class="card container-fluid"> 
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-2">
                        <img style="height: 60%; width: 90%;" class="img-rounded" [src]="displayData.logo" alt="">
                    </div>
                    <div class="col-8 textCenter ">
                        <h1 style="font-size: 45px;"> <strong>{{displayData.entityDisplayName}}</strong></h1>
                        <strong>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </strong> <br>
<strong>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </strong><br>
                        <br>
                        <u><strong style="font-size: 35px;">ADMIT CARD</strong></u> <br>
                        <u><strong style="font-size: 25px;">Examination ({{displayData.session}})</strong></u>
                        <hr>
                    </div>
                </div>
                <div class="row m0 borderSolid">
<div class="col-4 textCenter" style="padding-top:20px;">
            <div class="student-photo">
            <img [src]= "displayData.takerPhoto" alt="" width="160px" height="160px">
            </div>
            </div>
                    <div class="col-8 ">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-3 p0">
                                    <strong> Student's Name  </strong>
                                </div>
                                <div class="col-1 p0">
                                    :
                                </div>
                                <div class="col-6 p0">
                                    <span>  {{displayData.studentName}} </span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-3 p0">
                                    <strong> Father's Name  </strong>
                                </div>
                                <div class="col-1 p0">
                                    :
                                </div>
                                <div class="col-6 p0">
                                    <span>  {{displayData.studentFatherName}} </span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-3 p0">
                                    <strong> {{displayData.displayNamesRegNo}} </strong>
                                </div>
                                <div class="col-1 p0">
                                    :
                                </div>
                                <div class="col-6 p0">
                                    <span>  {{displayData.studentRegNo}} </span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-3 p0">
                                    <strong> Class</strong>
                                </div>
                                <div class="col-1 p0">
                                    :
                                </div>
                                <div class="col-6 p0">
                                    <span>  {{displayData.studentCourse}} - {{displayData.studentSection}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-3 p0">
                                    <strong>D.O.B.</strong>
                                </div>
                                <div class="col-1 p0">
                                    :
                                </div>
                                <div class="col-6 p0">
                                    <span>  {{displayData.dob | date: 'dd/MM/yyyy'}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-3 p0">
                                    <strong> Exam Centre</strong> 
                                </div>
                                <div class="col-1 p0">
                                    :
                                </div>
                                <div class="col-6 p0">
                                    <span>{{displayData.entityDisplayName}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row m0 borderSolid" style="padding-top: 20px;">
                    <div class="col-12">
                        <u><strong style="font-size: 25px;">Instructions For Examination:-</strong><br></u>
                        <strong>
                        1. You should carry Admit Card, & pen, pencil etc. in a transparent pouch.<br>
                        2. Mobile & other electronic items are not allowed inside examination centre.
                        <br>
                        <br>
                      
                        </strong>
                    </div>
                    <div class="col-12 textEnd">
                        Principal
                        <br>
                        <br>
                        <br>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
    
    `,
   attendanceSheetTemplate:`
           <section class="pagebreak" *ngFor="let displayData of displayDataArray">   
    <div style="font-size: large; font-weight: 900;" class="card container-fluid"> 
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-2">
                        <img style="height: 60%; width: 90%;" class="img-rounded" [src]="displayData.logo" alt="">
                    </div>
                    <div class="col-8 textCenter ">
                        <h1 style="font-size: 45px;"> <strong>{{displayData.entityDisplayName}}</strong></h1>
                        <strong>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </strong> <br>
<strong>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </strong><br>
                        <br>
                        <u><strong style="font-size: 35px;">Attendance Sheet</strong></u> <br>
                        <u><strong style="font-size: 25px;">Examination ({{displayData.session}})</strong></u>
                    </div>
                        <hr>
                </div>
                <div class="row m0 borderSolid">
<div class="col-4 textCenter" style="padding-top:20px;">
            <div class="student-photo">
            <img [src]= "displayData.takerPhoto" alt="" width="160px" height="160px">
            </div>
            </div>
                    <div class="col-8 ">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-3 p0">
                                    <strong> Student's Name  </strong>
                                </div>
                                <div class="col-1 p0">
                                    :
                                </div>
                                <div class="col-6 p0">
                                    <span>  {{displayData.studentName}} </span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-3 p0">
                                    <strong> Father's Name  </strong>
                                </div>
                                <div class="col-1 p0">
                                    :
                                </div>
                                <div class="col-6 p0">
                                    <span>  {{displayData.studentFatherName}} </span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-3 p0">
                                    <strong> {{displayData.displayNamesRegNo}} </strong>
                                </div>
                                <div class="col-1 p0">
                                    :
                                </div>
                                <div class="col-6 p0">
                                    <span>  {{displayData.studentRegNo}} </span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-3 p0">
                                    <strong> Class</strong>
                                </div>
                                <div class="col-1 p0">
                                    :
                                </div>
                                <div class="col-6 p0">
                                    <span>  {{displayData.studentCourse}} - {{displayData.studentSection}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-3 p0">
                                    <strong>D.O.B.</strong>
                                </div>
                                <div class="col-1 p0">
                                    :
                                </div>
                                <div class="col-6 p0">
                                    <span>  {{displayData.dob | date: 'dd/MM/yyyy'}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-3 p0">
                                    <strong> Exam Centre</strong> 
                                </div>
                                <div class="col-1 p0">
                                    :
                                </div>
                                <div class="col-6 p0">
                                    <span>{{displayData.entityDisplayName}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row m0 borderSolid" style="padding-top: 20px;">
                    <div class="col-12">
                        <u><strong style="font-size: 25px;">Instructions For Examination:-</strong><br></u>
                        <strong>
                        1. You should carry Admit Card, & pen, pencil etc. in a transparent pouch.<br>
                        2. Mobile & other electronic items are not allowed inside examination centre.
                        <br>
                        <br>
                      
                        </strong>
                    </div>
                    <div class="col-12 textEnd">
                        Principal
                        <br>
                        <br>
                        <br>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
   `,
    refundReceiptTemp1:
                ` 
                <div class="container-fluid">
                <div style="font-size: large; font-weight: 700;" class="row">
                   <div class="col-12">
                      <div class="row">
                         <div class="col-2">
                            <img class="hW100px img-rounded" [src]="displayData.logo" alt="">
                         </div>
                         <div class="col-8 textCenter ">
                            <h1>{{displayData.entityDisplayName}}</h1>
                            <span>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </span> <br>
                            <span>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </span>
                         </div>
                      </div>
                      <div class="row m0 borderSolid">
                         <div class="col-12 textCenter borderBottom" >
                            <mat-label> <strong> Refund Receipt ({{displayData.session}}) </strong> </mat-label>
                         </div>
                         <div class="col-7 ">
                            <div class="card-body">
                               <div class="row">
                                  <div class="col-6 p0">
                                     <strong> Receipt No  </strong>
                                  </div>
                                  <div class="col-6 p0">
                                     <span> : {{displayData.receiptId}} </span>
                                  </div>
                               </div>
                               <div class="row">
                                  <div class="col-6 p0">
                                     <strong> {{displayData.displayNamesRegNo}} </strong>
                                  </div>
                                  <div class="col-6 p0">
                                     <span> : {{displayData.studentRegNo}} </span>
                                  </div>
                               </div>
                               <div class="row">
                                  <div class="col-6 p0">
                                     <strong> Student's Name  </strong>
                                  </div>
                                  <div class="col-6 p0">
                                     <span> : {{displayData.studentName}} </span>
                                  </div>
                               </div>
                               <div class="row">
                                  <div class="col-6 p0">
                                     <strong> Father's Name  </strong>
                                  </div>
                                  <div class="col-6 p0">
                                     <span> : {{displayData.studentFatherName}} </span>
                                  </div>
                               </div>
                            </div>
                         </div>
                         <div class="col-5 ">
                            <div class="card-body ">
                               <div class="row">
                                  <div class="col-5 p0">
                                     <strong>Date</strong>
                                  </div>
                                  <div class="col-7 p0">
                                     :  {{displayData.date | date: 'dd/MM/yyyy'}}
                                  </div>
                               </div>
                               <div class="row">
                                  <div class="col-5 p0">
                                     <strong>  Contact  </strong>
                                  </div>
                                  <div class="col-7 p0">
                                     :  {{displayData.studentPhone}}
                                  </div>
                               </div>
                               <div class="row">
                                  <div class="col-5 p0">
                                     <strong>  {{displayData.displayNamesCourse}}  </strong>
                                  </div>
                                  <div class="col-7 p0">
                                     :  {{displayData.studentCourse}}
                                  </div>
                               </div>
                               <div class="row">
                                  <div class="col-5 p0">
                                     <strong> Section</strong>
                                  </div>
                                  <div class="col-7 p0">
                                     :  {{displayData.studentSection}}
                                  </div>
                               </div>
                            </div>
                         </div>
                      </div>
                      <div *ngIf="!hasError" class="">
                         <table class="table fontFamily mt3p">
                            <thead class="borderS1P mt3p">
                               <th style="font-size:17px;font-weight:700;">
                                  S.No
                               </th>
                               <th  style="font-size:17px;font-weight:700;">
                                  Fee Head
                               </th>
                               <th  style="font-size:17px;font-weight:700;">
                                  Refund Amount
                               </th>
                            </thead>
                            <tbody>
                               <tr *ngFor="let row of displayData.dataSource.data; let i = index" >
                                  <td>
                                     {{i+1}}
                                  </td>
                                  <td>
                                     {{row.feeHead}}
                                  </td>
                                  <td>
                                     {{row.paidAmount | number : '1.2-2'}}
                                  </td>
                               </tr>
                            </tbody>
                         </table>
                         <div class="colorBlackDark">
                            <div class="row">
                               <div class="col-7 ">
                                  Payment Mode
                               </div>
                               <div class="col-1 ">
                                  :
                               </div>
                               <div class="col-4 textEnd ">
                                  {{displayData.paymentDetailsPaymentMode}}
                               </div>
                            </div>
                            <!-- <div class="row">
                               <div class="col-7 ">
                                 Instrument Date
                               </div>
                               <div class="col-1 ">
                                 :
                               </div>
                               <div class="col-4 textEnd ">
                                 {{displayData.paymentDetailsDate | date: 'dd/MM/yyyy'}}
                               </div>
                               </div>-->
                            <div class="row">
                               <div class="col-7 ">
                                  Ref/Chq. Number
                               </div>
                               <div class="col-1 ">
                                  :
                               </div>
                               <div class="col-4 textEnd ">
                                  {{displayData.paymentDetailsRefId}}
                               </div>
                            </div>
                            <div class="row">
                               <div class="col-7 ">
                                  Total Invoice
                               </div>
                               <div class="col-1 ">
                                  :
                               </div>
                               <div class="col-4 textEnd ">
                                  {{displayData.totalPaybleAmount | number : '1.2-2' }}
                               </div>
                            </div>
                            <div class="row">
                               <div class="col-7 ">
                                  Net Refund Amount
                               </div>
                               <div class="col-1 ">
                                  :
                               </div>
                               <div class="col-4 textEnd">
                                  {{displayData.totalPaidAmount | number : '1.2-2' }}
                               </div>
                            </div>
                            <!--<div class="row">
                               <div class="col-7">
                                  Balance Due
                               </div>
                               <div class="col-1 ">
                                  :
                               </div>
                               <div class="col-4 textEnd  ">
                                  {{displayData.balance | number : '1.2-2' }}
                               </div>
                            </div>-->
                         </div>
                         <div class="kt-space-20"></div>
                         <div class="kt-space-20"></div>
                         <div class="row justifyFlexEnd m0">
                            <div class="col-12">
                               <strong>Remarks :</strong>
                               {{displayData.remark}}
                            </div>
                            <div class="col-8">
                               <strong> Amount in Words: </strong>
                               Rs {{displayData.totalPaidAmountWords.toUpperCase()}} ONLY
                            </div>
                            <div class="col-4 p0"> 
                               <label>Fees Clerk/Accountant</label>
                            </div>
                         </div>
                         <div class="kt-space-20"></div>
                         <div class="kt-space-20"></div>
                      </div>
                   </div>
                </div>
             </div>
                `,


  
  attendanceShortageTemplate:
  `
  <div class="landscape container-fluid p4Rem">
<div style="font-size: large; font-weight: 400;" class="row">
    <div class="col-3">
        <img class="widthInherit img-rounded" [src]="displayData.logo" alt="" />
    </div>
    <div class="col-9 textCenter">
        <h1 style="font-size: 40px;"><strong>{{displayData.entityDisplayName}}</strong></h1>
        <strong>{{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </strong> <br />
        <strong>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </strong><br />
        <br>
        <strong style="font-size: 25px;"> Attendance Shortage Letter</strong>
    </div>
    <hr />
</div>
<br>
<div style="font-size: large; font-weight: 400;" class="row m0">
    <div class="col-12"></div>
<div class="col-6">
        <strong>ODP/2023/________</strong> 
    </div>
    <div class="col-6 textEnd">
        <strong>Date:</strong> {{displayData.date | date}} 
    </div>
</div>
<br>
<div style="font-size: large; font-weight: 400;" class="row m0">
    <div class="col-12 textCenter"></div>
    <div class="col-7">
        <div class="card-body p0">
            <div class="row">
                <div class="col-7 p0">
                    <strong>{{displayData.fatherName}}</strong>
                </div>
            </div>
            <div class="row">
                <div class="col-7 p0">
                    <strong>F/O  {{displayData.studentName}}({{displayData.rollNo}})</strong>
                </div>
            </div>
            <div class="row">
                <div class="col-7 p0">
                    <strong>{{displayData.address}}</strong>
                </div>
            </div>
            <div class="row">
                <div class="col-7 p0">
                    <strong>{{displayData.city}}, {{displayData.state}}</strong>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row m0">
<div class="col-12">
    <br><br>
    <div style="font-size: medium; font-weight: 400;" class="row">
        <div>
            <h4><strong>Dear Parent,</strong></h4>
            <p>It has been brought to my notice that your ward is not attending classes regularly and failing deficient in his/her attendance. As per rules 75% attendance is must to appear in the final examinations of University, failing which your ward will not be eligible for appearing in the final examinations.
                The details of the attendance up {{displayData.date | date}} to is given below:-
            </p>
        </div>
        <div [hidden]="hasError" class="" class="col-12">
            <table class="table textCenter table-bordered fontFamily mt3p">
                <thead class="">
                    <th >
                        S.No
                    </th>
                    <th  >
                        Subject Code
                    </th>
                    <th  >
                        Subject Name
                    </th>
                    <th  >
                        Lecture Delivered
                    </th>
                    <th >
                        Lecture Attended
                    </th>
                    <th  >
                        % of Attendance
                    </th>
                    <th  >
                        % of Attendance Short
                    </th>
                </thead>
                <tbody>
                    <tr *ngFor="let row of displayData.dataSource; let i = index" >
                        <td>
                            {{i+1}}
                        </td>
                        <td>
                            {{row.subject}}
                        </td>
                        <td>
                            {{row.subjectName}}
                        </td>
                        <td>
                            {{row.working}}
                        </td>
                        <td>
                            {{row.present}}
                        </td>
                        <td>
                            {{row.percentage}}
                        </td>
                        <td >
                            <span *ngIf="row.percentage<=75">{{(75-row.percentage).toFixed(2)}}%</span> <span *ngIf="row.percentage>75">0.00%</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="kt-space-20"></div>
        <div style="font-size: medium; font-weight: 400;"class="col-md-12">
            You are requested to advice your ward to be regular to make up the required attendance.
        </div>
        <br><br><br><br><br>
        <div class="col-12">
           <h5><strong>Director</strong></h5>
        </div>
        <div class="col-12">
            <h5><strong>{{displayData.entityDisplayName}}</strong></h5>
        </div>
    </div>
</div>
  `
,

  idCardEmployeeTemplate:
  `
  <div class="container" style=" border:1px solid black;width:50%; margin-bottom:40px;">


  <div class="col-md-12 " style="display:flex;margin-bottom:px">
  <div class="col-4" >
  <img style="height:100px; width:100px;border-radius:50%;" [src]="displayData.logo" />
  </div>
  
  <div class="col-8 text-center" >
  <h5>{{displayData.entityDisplayName}}</h5> 
  <h6 >{{displayData.entityAddress}}, ( {{displayData.entityCity}} , {{displayData.entityState}} ) - {{displayData.entityPin}}
  </h6>
  <p > Affilicated to CBSE, New Delhi
  
  </p>  <p> {{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </p>


  
  </div>
  

  
  

  </div>
  
      <div class="text-center" style="padding-bottom:10px;">
  <img  style="height:150px; width:150px;border-radius:50%;" [src]="displayData.photo"/>
 
  </div>
  
<div style="margin: 0 auto;width: 90%;" >
  <div class="col-12 " style="display:flex;border:2px solid black;  ">
  <div class="col-6" style="border-right:1px solid black; font-weight:bold;font-size:15px;">
  Name
  </div>
     <div class="col-6"style="">{{displayData.name}}</div>
  </div>
  <div class="col-12 " style="display:flex;border-bottom:2px solid black;border-right:2px solid black;border-left:2px solid black;   ">
    <div class="col-6" style="border-right:1px solid black; font-weight:bold;font-size:15px;">
    Designation
    </div>
       <div class="col-6"style="">{{displayData.designation}}</div>
    </div>
    <div class="col-12 " style="display:flex;border-bottom:2px solid black;border-right:2px solid black;border-left:2px solid black;  ">
      <div class="col-6" style="border-right:1px solid black; font-weight:bold;font-size:15px;">
      Department
      </div>
         <div class="col-6"style="">{{displayData.department}}</div>
      </div>
      <div class="col-12 " style="display:flex;border-bottom:2px solid black;border-right:2px solid black;border-left:2px solid black;  ">
        <div class="col-6" style="border-right:1px solid black; font-weight:bold;font-size:15px;">
        ID No.
        </div>
           <div class="col-6"style="">{{displayData.employeeId}}</div>
        </div>
        <div class="col-12 " style="display:flex;border-bottom:2px solid black;border-right:2px solid black;border-left:2px solid black;  ">
          <div class="col-6" style="border-right:1px solid black; font-weight:bold;font-size:15px;">
          Mobile No.
          </div>
             <div class="col-6"style="">{{displayData.mobile}}</div>
          </div>
  

  

  
        </div>

        <div class="col-12 container row "style="padding-top:7px">
          <div class="col-8 text-center">
              <h1>{{displayData.designation}}</h1>
          </div>
          <div class="col-4 d-flex flex-column " style="align-items: end;">
            <img style="width: 20px;height:20px;padding-bottom: 3px;" src="" alt="">
            <label for="">Principal</label>
          </div>

        </div>
  
   



 

  
</div>
  `,
  employeeExperienceCertificateTemplate:
    `
    <div class="container" style="width: 80%;">
    
      <div class="text-center d-flex flex-row">
        <img style="width: 60px;height:60px;margin-top:12px; " [src]="displayData.logo" alt="">
        <h1 style="color:blue;display:block;font-size:4rem">{{displayData.entityDisplayName}}</h1>
      </div>
      <hr>
      <div class="d-flex flex-row justify-content-between">
        <h5><strong>School Afflication No-  </strong> </h5> <h5> <strong>{{displayData.entityAddress}}, ( {{displayData.entityCity}} , {{displayData.entityState}} ) - {{displayData.entityPin}} </strong> </h5>     <h5> <strong>SCHOOL Code - </strong></h5> 
      </div>
      
      <h5> <strong>E-mail Id: {{displayData.entityContactEmail}} </strong></h5>
    
      <div class="d-flex flex-row justify-content-between">
        <h5><strong>   </strong></h5>
        <h5> <strong>Date</strong>  - </h5>
      </div>
      
    
      <div class="text-center">
        <h3 style="font-weight:900;"> To Whom It May Concern</h3>
      </div>
    
      <br>
      <br>
    
      <div>
        <h5><strong>It is certified that {{displayData.name}} Sharma D/O  {{displayData.fatherName}} has worked as a TGT Maths Teacher 
          in our school. She joined the school on {{displayData.joiningDate | date:'dd:MMM:YY'}}.</strong>
        </h5>
        <br>
        <h5> <strong> She left from job on {{displayData.terminationDate | date:'dd:MM:YY'}} for her personal reasons.</strong></h5>
        <br>
        <h5> <strong>She is intelligent, sincere and discipline teacher.</strong></h5>
        <br>
        <h5> <strong>During the above said period her work and conduct was found appreciable and excellent.</strong> </h5>
        <br>
        <h5><strong>We wish her all the success in future life. </strong></h5>
        <br><br><br>
        <br>
        <h5> <strong>Principal </strong></h5>
    
        <br><br><br><br>
        <div class="d-flex flex-column">
        <h5> <strong>  </strong>
      </h5>
          <h5><strong> {{displayData.entityDisplayName}} </strong></h5>
          </div>
      </div>
    
    </div>
    `
    ,
    cbseEmployeeTemplate:
    `<div class="container" style="margin:0 auto; border:5px solid black;padding:30px;">
    
    <h2 class="text-center "style="padding-bottom:40px;">{{displayData.entityDisplayName}}</h2>
    
    <div class="col-md-12 d-flex flex-row" >
          <div class="col-md-6 " style="margin-top:100px;">
            <div class="d-flex flex-row">
          <h4><strong>Teacher Code :  </strong></h4>
         <h4> {{displayData.employeeCode}}</h4>
            </div>
            
              <div class="d-flex flex-row">
          <h4><strong>Teacher Name :  </strong></h4>
         <h4> {{displayData.name}}</h4>
            </div>
            
            <div class="d-flex flex-row">
          <h4><strong>Date of Birth :  </strong></h4>
         <h4> {{displayData.dob}}</h4>
            </div>
            
           <div class="d-flex flex-row">
          <h4><strong>Gender :  </strong></h4>
         <h4> {{displayData.gender}}</h4>
            </div>
            
            
           <div class="d-flex flex-row">
          <h4><strong>Phone Number : </strong></h4>
         <h4> {{displayData.mobile}}</h4>
            </div>
            
            
            
           <div class="d-flex flex-row">
          <h4><strong>EmailId  :  </strong></h4>
         <h4> {{displayData.email}}</h4>
            </div>
            
            
            
           <div class="d-flex flex-row">
          <h4><strong>Social Category :  </strong></h4>
         <h4> {{displayData.socialCategory}}</h4>
            </div>
            
            
            
            <div class="d-flex flex-row">
          <h4><strong>Father Name :  </strong></h4>
         <h4> {{displayData.fatherName}}</h4>
            </div>
            
            
            <div class="d-flex flex-row">
          <h4><strong>Aadhar Number :  </strong></h4>
         <h4>  {{displayData.uin}}</h4>
            </div>
            
            
   
  
      </div>
        
      <div class="col-md-6">
             <img style="width:200px; height:250px;" [src]="displayData.photo" alt=""/> 
      </div>
  
      
   
  
    </div>
    
       <div class="col-md-12">
                <div class=" d-flex flex-row">
          <h4 class="col-md-6"><strong>Aadhar Front :  </strong></h4>
           <img style="height:400px;margin-top:60px;" [src]="displayData.aadhaarCardFront" alt="">
            </div>
         
         
         <div class=" d-flex flex-row">
          <h4 class="col-md-6"><strong>Aadhar Back :  </strong></h4>
           <img style="height:400px; margin-top:60px;" [src]="displayData.aadhaarCardBack" alt="">
            </div>
         
         
          <div class="d-flex flex-row">
          <h4><strong>Addess :  </strong></h4>
         <h4> {{displayData.address}} </h4>
          </div>
         
         
        <div class="d-flex flex-row">
          <h4><strong>City :  </strong></h4>
         <h4> {{displayData.city}}</h4>
       </div>
         
         <div class="d-flex flex-row">
          <h4><strong>State :  </strong></h4>
         <h4> {{displayData.state}}</h4>
            </div>
       </div>
  
    
           <div class="d-flex flex-row">
          <h4><strong>Postal/Zip-Code :  </strong></h4>
         <h4> {{displayData.pin}}</h4>
            </div>
     
  
           <div class="d-flex flex-row">
          <h4><strong>Country :  </strong></h4>
         <h4> {{displayData.country}}</h4>
            </div>
     
           <div class="d-flex flex-row">
          <h4><strong>Designation:  </strong></h4>
         <h4> {{displayData.designation}}</h4>
            </div>
    
       
           <div class="d-flex flex-row">
          <h4><strong>Type Of Teacher:  </strong></h4>
         <h4>  </h4>
            </div>
       
           <div class="d-flex flex-row">
          <h4><strong>Nature Of Appointment:  </strong></h4>
         <h4>  </h4>
            </div>
       
           <div class="d-flex flex-row">
          <h4><strong>Year of Joining In Service:  </strong></h4>
         <h4> {{displayData.yearOfJoiningService}}</h4>
            </div>
       
           <div class="d-flex flex-row">
          <h4><strong>Highest Qualification (Academic):  </strong></h4>
         <h4> {{displayData.highestAcademicQualification}}</h4>
            </div>
       
           <div class="d-flex flex-row">
          <h4><strong>Highest Qualification (Professional):  </strong></h4>
         <h4> {{displayData.highestProfessionalQualification}}</h4>
            </div>
       
           <div class="d-flex flex-row">
          <h4><strong>Appointment For Subject:  </strong></h4>
         <h4> {{displayData.appointedForSubject}} </h4>
            </div>
       
           <div class="d-flex flex-row">
          <h4><strong>Main Subject Taught:  </strong></h4>
         <h4> {{displayData.mainSubjectTaught}}</h4>
            </div>
       
           <div class="d-flex flex-row">
          <h4><strong>Additional Subject Taught:  </strong></h4>
         <h4> {{displayData.additionalSubjectTaught}}</h4>
            </div>
       
           <div class="d-flex flex-row">
          <h4><strong>Maths/Science Studied Upto:  </strong></h4>
         <h4> {{displayData.mathsScienceStudiedUpto}}</h4>
            </div>
       
           <div class="d-flex flex-row">
          <h4><strong>English Studied Upto:  </strong></h4>
         <h4> {{displayData.englishStudiedUpto}}</h4>
            </div>
       
           <div class="d-flex flex-row">
          <h4><strong>Social Studies Studied Upto:  </strong></h4>
         <h4> {{displayData.socialStudiesStudiedUpto}}</h4>
            </div>
       
           <div class="d-flex flex-row">
          <h4><strong>Trained in use of Computer/Teaching Throoght Computer:  </strong></h4>
         <h4> {{displayData.computerTrained}}</h4>
            </div>
       
           <div class="d-flex flex-row">
          <h4><strong>Disability:  </strong></h4>
         <h4> {{displayData.disability}}</h4>
            </div>
       
           <div class="d-flex flex-row">
          <h4><strong>Bank Name:  </strong></h4>
         <h4> {{displayData.bankName}}</h4>
            </div>
       
           <div class="d-flex flex-row">
          <h4><strong>Account Number:  </strong></h4>
         <h4> {{displayData.accountNumber}}</h4>
            </div>
    
             <div class="d-flex flex-row">
          <h4><strong>IFSC:  </strong></h4>
         <h4> {{displayData.ifsc}}</h4>
            </div>
    
    
    
        <div class=" d-flex flex-row">
          <h4 class="col-md-6"><strong>PassBook/Cancel Cheque :  </strong></h4>
           <img style="height:400px; margin-top:60px;" [src]="displayData.passbook" alt="">
            </div>
    
       
               <div class="d-flex flex-row">
          <h4><strong>PAN Number : </strong></h4>
         <h4> SBIN0 012205</h4>
            </div>
            
            <br>
          <div class=" d-flex flex-row">
          <h4 class="col-md-6"><strong>PAN Card Photo :  </strong></h4>
           <img style="height:80%; margin-top:60px;" [src]="displayData.panCard" alt="">
            </div>
    
    
    
      
               <div class="d-flex flex-row">
          <h4><strong>Work In Present School Since (Year) : </strong></h4>
         <h4> {{displayData.yearOfJoiningService}}</h4>
            </div>
    
    
      
               <div class="d-flex flex-row">
          <h4><strong>Joining Date : </strong></h4>
         <h4> {{displayData.joiningDate | date:'dd:MMM:YY'}}</h4>
            </div>
    
    
      
               <div class="d-flex flex-row">
          <h4><strong>Trained to Teach CWSN : </strong></h4>
         <h4> {{displayData.cwsnTrained}}</h4>
            </div>
    
    
    
      
               <div class="d-flex flex-row">
          <h4><strong>Evaluation Medium : </strong></h4>
         <h4> {{displayData.evaluationMedium}}</h4>
            </div>
    
    
    
      
               <div class="d-flex flex-row">
          <h4><strong>Select Classes Taught : </strong></h4>
         <h4> {{displayData.classesTaught}} </h4>
            </div>
    
    
    
      
               <div class="d-flex flex-row">
          <h4><strong>Secondary Education : </strong></h4>
         <h4> {{displayData.secondaryEducation}}</h4>
            </div>
    
    
      
       

    
    
    
      
               <div class="d-flex flex-row">
          <h4><strong>Ward Appearing in Class Subject-10 Above : </strong></h4>
         <h4> {{displayData.wardAppearingInClass10}}</h4>
            </div>
    
    
      
               <div class="d-flex flex-row">
          <h4><strong>Trained or Untrained : </strong></h4>
         <h4> {{displayData.trained}}</h4>
            </div>
    
    
      
               <div class="d-flex flex-row">
          <h4><strong>Qualified : </strong></h4>
         <h4> {{displayData.qualified}}</h4>
            </div>
    
                <div class="d-flex flex-row">
          <h4><strong>Name of Training Courses Atteneded : </strong></h4>
         <h4> {{displayData.trainingCoursesAttended}}</h4>
            </div>
    
                <div class="d-flex flex-row">
          <h4><strong>Training Program Organised By : </strong></h4>
         <h4> {{displayData.trainingProgramOrganisedBy}}</h4>
            </div>
    

    
    <br><br><br><br>
    
      <h6>I hereby declare that all the statement made in this application is true and completed to the best of my knowledge and belief. I understand that action can to take against ne by the School, if I am declared by them to be guilty of any type of misconduct. I hereby agree to abide by the rules and regulations of this School. </h6>
    
    
    <br><br><br>
    <div class="d-flex flex-row justify-content-between">
      <h6>Place</h6>
      <h6>Date:22/0816</h6>
    </div>
    
    
          <div>
          <h4 class="col-md-12"><strong>Qualification Certificate :  </strong></h4>
           <img style="height:100%; width:100%; margin-top:20px;" [src]="displayData.qualificationCertificates" alt="">
            </div>
    
            <div>
          <h4 class="col-md-12"><strong>Matric Certificate :  </strong></h4>
           <img style="height:100%; width:100%; margin-top:20px;" [src]="displayData.metricCertificate" alt="">
            </div>
            <div>
          <h4 class="col-md-12"><strong>12th Passing Certificate :  </strong></h4>
           <img style="height:100%; width:100%; margin-top:20px;" [src]="displayData.passingCertificate12th" alt="">
            </div>
            <div>
          <h4 class="col-md-12"><strong>Highest Qualification(Academic) Certificate :  </strong></h4>
           <img style="height:100%; width:100%; margin-top:20px;" [src]="displayData.highestAcademicQualificationCertificates" alt="">
            </div>
    
              <div>
          <h4 class="col-md-12"><strong>Highest Qualification(Professional) Certificate :  </strong></h4>
           <img style="height:100%; width:100%; margin-top:20px;" [src]="displayData.highestProfessionalQualificationCertificates" alt="">
            </div>
    
    
       </div>
  
  
  
  
  
    
  `,
  appreciationCertificateStudentTemplate:
  `
  <style>
  
  .container {
   font-family: Arial, sans-serif;
    margin-top: 50px;
    text-align: center;
  }
  
  h3, h4 {
    margin: 10px 0;
  }
  
  .student-image {
    border-radius: 50%;
    width: 150px;
    height: 150px;
    margin: 20px auto;
    background: #e9e9e9 url(student-image.jpg) no-repeat center;
    background-size: cover;
  }
  
  .school-logo {
    border-radius: 50%;
    width: 100px;
    height: 100px;
    margin: 20px auto;
    background: #e9e9e9 url(school-logo.jpg) no-repeat center;
    background-size: cover;
  }
  
  .border {
    border: 1px solid #ccc;
    margin-top: 50px;
    padding: 10px;
  }
  
  .powered-by {
    margin-top: 20px;
    font-size: 12px;
  }
</style>


<div class="container">
  <h1>Congratulations!</h1>
  <h3>To the achiever</h3>
  
  <div class="student-image">
  <img style="width: 60px;height:60px;margin-top:12px; " [src]="displayData.takerPhoto" alt=""></div>
  
  <h4>{{displayData.studentName}}</h4>
  <h4> Grade - {{displayData.studentCourse}}</h4>
  <h4>Show and Tell Competition</h4>
  <h4>Your ward has won consolation in the Show and Tell Competition</h4>
  
  <div class="school-logo">
  <img style="width: 60px;height:60px;margin-top:12px; " [src]="displayData.logo" alt="">
   </div>
  
  <h4>{{displayData.entityDisplayName}}</h4>
  
  <div class="border">
    <p>Powered by Company Name</p>
  </div>
</div>

 `,
 appreciationCertificateEmployeeTemplate:
 `
 <style>
 
 .container {
  font-family: Arial, sans-serif;
   margin-top: 50px;
   text-align: center;
 }
 
 h3, h4 {
   margin: 10px 0;
 }
 
 .student-image {
   border-radius: 50%;
   width: 150px;
   height: 150px;
   margin: 20px auto;
   background: #e9e9e9 url(student-image.jpg) no-repeat center;
   background-size: cover;
 }
 
 .school-logo {
   border-radius: 50%;
   width: 100px;
   height: 100px;
   margin: 20px auto;
   background: #e9e9e9 url(school-logo.jpg) no-repeat center;
   background-size: cover;
 }
 
 .border {
   border: 1px solid #ccc;
   margin-top: 50px;
   padding: 10px;
 }
 
 .powered-by {
   margin-top: 20px;
   font-size: 12px;
 }
</style>


<div class="container">
 <h1>Congratulations!</h1>
 <h3>To the achiever</h3>
 
 <div class="student-image">
 <img style="width: 60px;height:60px;margin-top:12px; " [src]="displayData.photo" alt=""></div>
 
 <h4>{{displayData.name}}</h4>
 <h4> Department - {{displayData.department}}</h4>
 <h4>Show and Tell Competition</h4>
 <h4>Your ward has won consolation in the Show and Tell Competition</h4>
 
 <div class="school-logo">
 <img style="width: 60px;height:60px;margin-top:12px; " [src]="displayData.logo" alt="">
  </div>
 
 <h4>{{displayData.entityDisplayName}}</h4>
 
 <div class="border">
   <p>Powered by Company Name</p>
 </div>
</div>

`
,
birthdayCardTemplate:
`
<style>

.container {
 font-family: Arial, sans-serif;
  margin-top: 50px;
  text-align: center;
}

h3, h4 {
  margin: 10px 0;
}

.student-image {
  border-radius: 50%;
  width: 150px;
  height: 150px;
  margin: 20px auto;
  background: #e9e9e9 url(student-image.jpg) no-repeat center;
  background-size: cover;
}

.school-logo {
  border-radius: 50%;
  width: 100px;
  height: 100px;
  margin: 20px auto;
  background: #e9e9e9 url(school-logo.jpg) no-repeat center;
  background-size: cover;
}

.border {
  border: 1px solid #ccc;
  margin-top: 50px;
  padding: 10px;
}

.powered-by {
  margin-top: 20px;
  font-size: 12px;
}
</style>


<div class="container">
<h1>Congratulations!</h1>
<h3>To the achiever</h3>

<div class="student-image">
<img style="width: 60px;height:60px;margin-top:12px; " [src]="displayData.photo" alt=""></div>

<h4>{{displayData.name}}</h4>
<h4> Department - {{displayData.department}}</h4>
<h4>Show and Tell Competition</h4>
<h4>Your ward has won consolation in the Show and Tell Competition</h4>

<div class="school-logo">
<img style="width: 60px;height:60px;margin-top:12px; " [src]="displayData.logo" alt="">
 </div>

<h4>{{displayData.entityDisplayName}}</h4>

<div class="border">
  <p>Powered by Company Name</p>
</div>
</div>

`
,

lorTemplate:
`
<style>

.container {
 font-family: Arial, sans-serif;
  margin-top: 50px;
  text-align: center;
}

h3, h4 {
  margin: 10px 0;
}

.student-image {
  border-radius: 50%;
  width: 150px;
  height: 150px;
  margin: 20px auto;
  background: #e9e9e9 url(student-image.jpg) no-repeat center;
  background-size: cover;
}

.school-logo {
  border-radius: 50%;
  width: 100px;
  height: 100px;
  margin: 20px auto;
  background: #e9e9e9 url(school-logo.jpg) no-repeat center;
  background-size: cover;
}

.border {
  border: 1px solid #ccc;
  margin-top: 50px;
  padding: 10px;
}

.powered-by {
  margin-top: 20px;
  font-size: 12px;
}
</style>


<div class="container">
<h1>Congratulations!</h1>
<h3>To the achiever</h3>

<div class="student-image">
<img style="width: 60px;height:60px;margin-top:12px; " [src]="displayData.photo" alt=""></div>

<h4>{{displayData.name}}</h4>
<h4> Department - {{displayData.department}}</h4>
<h4>Show and Tell Competition</h4>
<h4>Your ward has won consolation in the Show and Tell Competition</h4>

<div class="school-logo">
<img style="width: 60px;height:60px;margin-top:12px; " [src]="displayData.logo" alt="">
 </div>

<h4>{{displayData.entityDisplayName}}</h4>

<div class="border">
  <p>Powered by Company Name</p>
</div>
</div>

`


,
noDuesTemplate: `
    
<section style="font-weight: 800; font-size: 150%">
<div  class="container-fluid">  
    <div class="row">  
        <div class="col-12"> 
            <div class="row">   
                <div class="col-3"> 
            <img style="height: 80%; width: 80%;" class="img-rounded" [src]="displayData.logo" alt="">
            </div> 
                <div class="col-6 textCenter ">
                    <strong><h1>{{displayData.entityDisplayName}}</h1></strong>
                    <span>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </span> <br>
                    <span>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </span><br>
<br>
                    <span>Fee Certificate</span><br>
                    <span>FOR THE FINANCIAL YEAR ({{displayData.session}})</span>
                </div>
            </div>
            <div class="row m0 borderSolid">
                <div class="col-12 textCenter borderBottom" >
                    <mat-label> <strong> To Whomsoever It May Concern </strong> </mat-label>
                </div>
                <div class="col-12 ">
        
                    <div class="card-body">
                        <div class="row">
                            <div class="col-6 p0">
                            <strong> Ref No. :  </strong>
                            </div>
                            <div class="col-6 textEnd">
                            <span> Date: {{displayData.dateNow | date: 'dd/MM/yyyy'}} </span>
                            </div> 
                        </div>
                        <div class="row">
                            <div class="col-3 p0">
                            <strong> Student's Name  </strong>
                            </div>
                            <div class="col-1 p0">
                                :
                            </div>
                            <div class="col-6 p0">
                            <span>  {{displayData.studentName}} </span>
                            </div> 
                        </div>
                        <div class="row">
                            <div class="col-3 p0">
                            <strong> {{displayData.displayNamesRegNo}} </strong>
                            </div>
                            <div class="col-1 p0">
                                :
                            </div>
                            <div class="col-6 p0">
                            <span>  {{displayData.studentRegNo}} </span>
                            </div> 
                        </div>
                        <div class="row">
                            <div class="col-3 p0">
                            <strong> Class</strong>
                            </div>
                            <div class="col-1 p0">
                                :
                            </div>
                            <div class="col-6 p0">
                            <span>  {{displayData.studentCourse}} </span>
                            </div> 
                        </div>

                        <div class="row">
                            <div class="col-3 p0">
                            <strong> Father's Name  </strong>
                            </div>
                            <div class="col-1 p0">
                                :
                            </div>
                            <div class="col-6 p0">
                            <span>  {{displayData.studentFatherName}} </span>
                            </div> 
                        </div>
                       <div class="row">
                            <div class="col-3 p0">
                            <strong> Mother's Name  </strong>
                            </div>
                            <div class="col-1 p0">
                                :
                            </div>
                            <div class="col-6 p0">
                            <span>  {{displayData.studentMotherName}} </span>
                            </div> 
                        </div>
                        <div class="row">
                            <div class="col-3 p0">
                            <strong> Demand  </strong>
                            </div>
                            <div class="col-1 p0">
                                :
                            </div> 
                            <div class="col-6 p0">
                            <span>  {{displayData.studentTuitionCertificate.demand}} </span>
                            </div> 
                        </div>
                        
                        <div class="row">
                            <div class="col-3 p0">
                            <strong> Concession  </strong>
                            </div>
                            <div class="col-1 p0">
                                :
                            </div>
                            <div class="col-6 p0">
                            <span>  {{displayData.studentTuitionCertificate.concession}} </span>
                            </div> 
                        </div>
<div class="row">
                            <div class="col-3 p0">
                            <strong>Payable  </strong>
                            </div>
                            <div class="col-1 p0">
                                :
                            </div>
                            <div class="col-6 p0">
                            <span>  {{displayData.studentTuitionCertificate.payable}} </span>
                            </div> 
                        </div><div class="row">
                            <div class="col-3 p0">
                            <strong>Received  </strong>
                            </div>
                            <div class="col-1 p0">
                                :
                            </div>
                            <div class="col-6 p0">
                            <span>  {{displayData.studentTuitionCertificate.received}} </span>
                            </div> 
                        </div>
<div class="row">
                            <div class="col-3 p0">
                            <strong> Due Amount  </strong>
                            </div>
                            <div class="col-1 p0">
                                :
                            </div>
                            <div class="col-6 p0">
                            <span>  {{displayData.studentTuitionCertificate.dueAmount}} </span>
                            </div> 
                        </div>
                        <div class="row">
                            <div class="col-3 p0">
                            <strong> Installements  </strong>
                            </div>
                            <div class="col-1 p0">
                                :
                            </div>
                            <div class="col-7 p0">
                            <span>  {{displayData. studentTuitionCertificate.installments}} </span>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
            <div class="row m0 borderSolid" style="padding-top: 50px;">
                <div class="col-12">
                    <strong>
                        This Certificate is being issued for the purpose of Income Tax/Reimbursement only.
                    </strong>
                </div>
                <div class="col-12 textEnd">
                    Authorised Signatory
                </div>
            </div>
        </div>
    </div>
</div>
</section>
`,
questionPaperTemplate: `
<style>
body {
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
  background-color: #f2f2f2;
}

.question-paper {
  max-width: 800px;
  margin: 20px auto;
  border: 1px solid #ccc;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.header, .footer {
  text-align: center;
  padding: 20px 0;
  background-color: #f2f2f2;
  border-bottom: 1px solid #ccc;
}

.header h1, .footer p {
  margin: 0;
}

.question-section {
  padding: 20px;
}

.question {
  margin-bottom: 20px;
}

.question h3 {
  margin: 0;
}

.question p {
  margin: 5px 0;
}
</style>
<section style="font-weight: 800; font-size: 150%">
<div  class="container-fluid">  
    <div class="row">  
        <div class="col-12"> 
            <div class="row">   
                <div class="col-3"> 
            <img style="height: 80%; width: 80%;" class="img-rounded" [src]="displayData.logo" alt="">
            </div> 
                <div class="col-6 textCenter ">
                    <strong><h1>{{displayData.entityDisplayName}}</h1></strong>
                    <span>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </span> <br>
                    <span>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </span><br>
<br>
                    <span>Fee Certificate</span><br>
                    <span>FOR THE FINANCIAL YEAR ({{displayData.session}})</span>
                </div>
            </div>

            <div class="question-paper">
                <div class="header">
                  <h1>Sample Question Paper</h1>
                </div>
                <div class="question-section">


                  <div class="question" *ngFor="let item of displayData.questionList">
                  <p class="text-dark-75 font-size-lg font-weight-normal" [innerHTML]="item.questionText"></p>
                  <p>{{item.marks}}</p>
                  
                  </div>

                </div>
                <div class="footer">
                  <p>&copy; 2024 Your Institution</p>
                </div>
              </div>
        </div>
    </div>
</div>
</section>

`,
salarySlipTemplate:`
<section style="font-weight: 800; font-size: 150%">
<div class="container">
<div class="col-12"> 
<div class="row">   
    <div class="col-3"> 
<img style="height: 80%; width: 80%;" class="img-rounded" [src]="displayData.logo" alt="">
</div> 
    <div class="col-6 textCenter ">
        <strong><h1>{{displayData.entityDisplayName}}</h1></strong>
        <span>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </span> <br>
        <span>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </span><br>
<br>
        <span>Fee Certificate</span><br>
        <span>FOR THE FINANCIAL YEAR ({{displayData.session}})</span>
    </div>
</div>
  <div class="middle">
    <p class="heading">PAY SLIP FOR THE MONTH JANUARY, 2024</p>
    <hr>
    <div class="employee-info">
      <p>Employee Name: {{displayData.name}}</p>
      <p>Employee ID: {{displayData.employeeId}}</p>
      <p>Department: {{displayData.department}}</p>
      <p>Designation: {{displayData.designation}}</p>
      <p>Pay Period: {{displayData.startDate| date:'dd/MMM/yyyy'}} to {{displayData.endDate | date:'dd/MMM/yyyy'}}</p>
      <p>Payable Days: {{displayData.payableDays}}</p>
    </div>
    <div class="col-md-12" style="display: flex;">
    <div class="table col-md-6" >
    <table class=" fontFamily mt3p">
    <thead class="borderS1P mt3p">
        <th  class=" fwBoldvw" >
           S.No
        </th>
        <th  class=" fwBoldvw">
          Earnings
         </th>
         <th  class=" fwBoldvw" >
          Amount(₹⟩
       </th>
    </thead>
    <tbody>
        <tr *ngFor="let row of displayData.earningHeads; let i = index" >
          <td>
            {{i+1}}
          </td>
          <td>
              {{row.headName}}
          </td>
          <td>
              {{row.value}}
          </td>
        </tr>
    </tbody>
  </table>
  </div>

  <div class=" col-md-6" >
    <table class="table fontFamily mt3p">
    <thead class="borderS1P mt3p">

        <th  class=" fwBoldvw">
          Deduction
         </th>
         <th  class=" fwBoldvw" >
          Amount(₹⟩
       </th>
    </thead>
    <tbody>
        <tr *ngFor="let row of displayData.deductionHeads; let i = index" >

          <td>
              {{row.headName}}
          </td>
          <td>
              {{row.value}}
          </td>
        </tr>
    </tbody>
  </table>
  </div>

    </div>
    <p>Net Paid Amount: {{displayData.netPaidAmount}}</p>
    <p> In Words: {{displayData.inWords}} </p>
    <div class="payment-details">
      <p><strong>Payment Details:</strong></p>
      <p>Mode of Payment: {{displayData.modeOfPayment}}</p>
      <p>Bank Account Number: {{displayData.bankAccount}}</p>
      <p>Bank Name: {{displayData.bankName}}</p>
      <p>Branch: {{displayData.branch}}</p>
    </div>
    <div class="remarks">
      <p><strong>Remarks:</strong></p>
      <p *ngFor="let remark of displayData.remark">{{remark}}</p>
    </div>
  </div>
</div>
</div>

</section>
`,
salaryReportTemplate:`
<section style="font-weight: 800; font-size: 150%">
<div class="">
<div class="col-12"> 
<div class="row" *ngIf="!displayData.showVerticalTableFlag">    
  <div class="row textCenter">
    <div class="col-12 textCenter"> 
     <p>Employee Salary Report   </p>
 </div>
 </div>

  <table class="table table-bordered">
    <thead>
      <tr>
        <th rowspan="2">S.NO</th>
        <ng-container *ngFor="let item of displayData.tableHead">
          <th *ngIf="!['earningHeads', 'deductionHeads', 'employerContributionHeads', 'templateEarningHeads', 'templateDeductionHeads', 'templateEmployerContributionHeads'].includes(item.value)" rowspan="2">
            <strong> {{item.name.toUpperCase()}} </strong>
          </th>
          <th *ngIf="item.value == 'earningHeads' && displayData.earningHeads && displayData.earningHeads.length > 0" [attr.colspan]="displayData.earningHeads.length">
            <strong> EARNING HEADS </strong>
          </th>
          <th *ngIf="item.value == 'deductionHeads' && displayData.deductionHeads && displayData.deductionHeads.length > 0" [attr.colspan]="displayData.deductionHeads.length">
            <strong> DEDUCTION HEADS </strong>
          </th>
          <th *ngIf="item.value == 'employerContributionHeads' && displayData.employerContributionHeads && displayData.employerContributionHeads.length > 0" [attr.colspan]="displayData.employerContributionHeads.length">
            <strong> EMPLOYER CONTRIBUTION HEADS </strong>
          </th>
        </ng-container>
      </tr>
      <tr>
        <ng-container *ngFor="let item of displayData.tableHead">
          <ng-container *ngIf="item.value == 'earningHeads' && displayData.earningHeads && displayData.earningHeads.length > 0">
            <th *ngFor="let h of displayData.earningHeads"><strong>{{h.toUpperCase()}}</strong></th>
          </ng-container>
          <ng-container *ngIf="item.value == 'deductionHeads' && displayData.deductionHeads && displayData.deductionHeads.length > 0">
            <th *ngFor="let h of displayData.deductionHeads"><strong>{{h.toUpperCase()}}</strong></th>
          </ng-container>
          <ng-container *ngIf="item.value == 'employerContributionHeads' && displayData.employerContributionHeads && displayData.employerContributionHeads.length > 0">
            <th *ngFor="let h of displayData.employerContributionHeads"><strong>{{h.toUpperCase()}}</strong></th>
          </ng-container>
        </ng-container>
      </tr>
    </thead>
      <tbody class="verticalMiddle">
      <ng-container *ngFor="let item of displayData.dataSource; let index = index">
        <ng-container *ngIf="item.employeeName != 'Total'; else totalTd">
          
          <!-- MODE 1: Monthly Data Shown ON -->
          <ng-container *ngIf="displayData.monthlyDataShown">
            <tr *ngFor="let month of item.monthWiseArrear; let monthIndex = index">
              <!-- S.No -->
              <td *ngIf="monthIndex == 0" [attr.rowspan]="item.monthWiseArrear.length">{{ index + 1 }}</td>

              <!-- Normal columns -->
              <ng-container *ngFor="let head of displayData.tableHead">
                <ng-container *ngIf="!['deductionHeads', 'earningHeads', 'employerContributionHeads', 'templateEarningHeads', 'templateDeductionHeads', 'templateEmployerContributionHeads'].includes(head.value) && head.value != 'months'">
                  <ng-container *ngIf="getValueOfTD(head, month, item) as data">
                    <td *ngIf="data.rowSpan && monthIndex == 0" [attr.rowspan]="item.monthWiseArrear.length">
                      {{ data.name }}
                    </td>
                    <td *ngIf="!data.rowSpan">
                      {{ data.name }}
                    </td>
                  </ng-container>
                </ng-container>

                <!-- Months column -->
                <td *ngIf="head.value == 'months'">{{ month.month }}</td>

                <!-- Earning Heads columns (Salary Contract, DUE, PAID, Net Payable) -->
                <ng-container *ngIf="head.value == 'earningHeads'">
                  <!-- Salary Contract values -->
                  <td *ngFor="let val of displayData.earningHeads">
                    {{ getTemplateEarningHeadValue(month, val) }}
                  </td>
                  <!-- DUE values (newValue) -->
                  <td *ngFor="let val of displayData.earningHeads">
                    {{ getEarningHeadValue(month, val, 'newValue') }}
                  </td>
                  <!-- PAID values (oldValue) -->
                  <td *ngFor="let val of displayData.earningHeads">
                    {{ getEarningHeadValue(month, val, 'oldValue') }}
                  </td>
                  <!-- Net Payable value -->
                  <td>{{ month.netPayable || month.totalEarning || '0.00' }}</td>
                </ng-container>

                <!-- Deduction Heads columns (DUE, PAID, Net Deduction) -->
                <ng-container *ngIf="head.value == 'deductionHeads'">
                  <!-- DUE values (newValue) -->
                  <td *ngFor="let val of displayData.deductionHeads">
                    {{ getDeductionHeadValue(month, val, 'newValue') }}
                  </td>
                  <!-- PAID values (oldValue) -->
                  <td *ngFor="let val of displayData.deductionHeads">
                    {{ getDeductionHeadValue(month, val, 'oldValue') }}
                  </td>
                  <!-- Net Deduction value -->
                  <td>{{ month.netDeduction || month.totalDeduction || '0.00' }}</td>
                </ng-container>

                <!-- Employer Contribution Heads -->
                <ng-container *ngIf="head.value == 'employerContributionHeads'">
                  <td *ngFor="let val of displayData.employerContributionHeads">
                    {{ getTableDataValueMonthly(val, head, month) }}
                  </td>
                </ng-container>
              </ng-container>
            </tr>

            <!-- Employee Summary Total Row (When Monthly Data Shown ON) -->
            <tr style="font-weight: bold;">
              <td></td>
              <ng-container *ngFor="let head of displayData.tableHead">
                <ng-container *ngIf="!['deductionHeads', 'earningHeads', 'employerContributionHeads', 'templateEarningHeads', 'templateDeductionHeads', 'templateEmployerContributionHeads'].includes(head.value) && head.value != 'months'">
                  <td>{{ getValue(head, item) }}</td>
                </ng-container>
                <td *ngIf="head.value == 'months'"></td>

                <ng-container *ngIf="head.value == 'earningHeads'">
                  <td *ngFor="let val of displayData.earningHeads">
                    {{ getTemplateEarningHeadTotalValue(item, val) }}
                  </td>
                  <td *ngFor="let val of displayData.earningHeads">
                    {{ getEarningHeadTotalValue(item, val, 'newValue') }}
                  </td>
                  <td *ngFor="let val of displayData.earningHeads">
                    {{ getEarningHeadTotalValue(item, val, 'oldValue') }}
                  </td>
                  <td>{{ (item.totalArrear && item.totalArrear.totalEarning !== undefined) ? item.totalArrear.totalEarning : (item.totalEarning || '0.00') }}</td>
                </ng-container>

                <ng-container *ngIf="head.value == 'deductionHeads'">
                  <td *ngFor="let val of displayData.deductionHeads">
                    {{ getDeductionHeadTotalValue(item, val, 'newValue') }}
                  </td>
                  <td *ngFor="let val of displayData.deductionHeads">
                    {{ getDeductionHeadTotalValue(item, val, 'oldValue') }}
                  </td>
                  <td>{{ (item.totalArrear && item.totalArrear.totalDeduction !== undefined) ? item.totalArrear.totalDeduction : (item.totalDeduction || '0.00') }}</td>
                </ng-container>

                <ng-container *ngIf="head.value == 'employerContributionHeads'">
                  <td *ngFor="let val of displayData.employerContributionHeads">
                    {{ getTableDataValue(val, head, item) }}
                  </td>
                </ng-container>
              </ng-container>
            </tr>
          </ng-container>

          <!-- MODE 2: Monthly Data Shown OFF -->
          <ng-container *ngIf="!displayData.monthlyDataShown">
            <tr>
              <td>{{ index + 1 }}</td>
              <ng-container *ngFor="let head of displayData.tableHead">
                <ng-container *ngIf="!['deductionHeads', 'earningHeads', 'employerContributionHeads', 'templateEarningHeads', 'templateDeductionHeads', 'templateEmployerContributionHeads'].includes(head.value) && head.value != 'months'">
                  <td>{{ getValue(head, item) }}</td>
                </ng-container>

                <td *ngIf="head.value == 'months'">-</td>

                <ng-container *ngIf="head.value == 'earningHeads'">
                  <td *ngFor="let val of displayData.earningHeads">
                    {{ getTemplateEarningHeadTotalValue(item, val) }}
                  </td>
                  <td *ngFor="let val of displayData.earningHeads">
                    {{ getEarningHeadTotalValue(item, val, 'newValue') }}
                  </td>
                  <td *ngFor="let val of displayData.earningHeads">
                    {{ getEarningHeadTotalValue(item, val, 'oldValue') }}
                  </td>
                  <td>{{ (item.totalArrear && item.totalArrear.totalEarning !== undefined) ? item.totalArrear.totalEarning : (item.totalEarning || '0.00') }}</td>
                </ng-container>

                <ng-container *ngIf="head.value == 'deductionHeads'">
                  <td *ngFor="let val of displayData.deductionHeads">
                    {{ getDeductionHeadTotalValue(item, val, 'newValue') }}
                  </td>
                  <td *ngFor="let val of displayData.deductionHeads">
                    {{ getDeductionHeadTotalValue(item, val, 'oldValue') }}
                  </td>
                  <td>{{ (item.totalArrear && item.totalArrear.totalDeduction !== undefined) ? item.totalArrear.totalDeduction : (item.totalDeduction || '0.00') }}</td>
                </ng-container>

                <ng-container *ngIf="head.value == 'employerContributionHeads'">
                  <td *ngFor="let val of displayData.employerContributionHeads">
                    {{ getTableDataValue(val, head, item) }}
                  </td>
                </ng-container>
              </ng-container>
            </tr>
          </ng-container>

        </ng-container>

        <!-- Grand Total Row -->
        <ng-template #totalTd>
          <tr style="font-weight: bold;">
            <td>{{ index + 1 }}</td>
            <ng-container *ngFor="let head of displayData.tableHead">
              <ng-container *ngIf="!['deductionHeads', 'earningHeads', 'employerContributionHeads', 'templateEarningHeads', 'templateDeductionHeads', 'templateEmployerContributionHeads'].includes(head.value) && head.value != 'months'">
                <td>{{ item[head.value] || '' }}</td>
              </ng-container>

              <td *ngIf="head.value == 'months'"></td>

              <ng-container *ngIf="head.value == 'earningHeads'">
                <td *ngFor="let val of displayData.earningHeads">
                  {{ getTemplateEarningHeadTotalValue(item, val) }}
                </td>
                <td *ngFor="let val of displayData.earningHeads">
                  {{ getEarningHeadTotalValue(item, val, 'newValue') }}
                </td>
                <td *ngFor="let val of displayData.earningHeads">
                  {{ getEarningHeadTotalValue(item, val, 'oldValue') }}
                </td>
                <td>{{ (item.totalArrear && item.totalArrear.totalEarning !== undefined) ? item.totalArrear.totalEarning : (item.totalEarning || '0.00') }}</td>
              </ng-container>

              <ng-container *ngIf="head.value == 'deductionHeads'">
                <td *ngFor="let val of displayData.deductionHeads">
                  {{ getDeductionHeadTotalValue(item, val, 'newValue') }}
                </td>
                <td *ngFor="let val of displayData.deductionHeads">
                  {{ getDeductionHeadTotalValue(item, val, 'oldValue') }}
                </td>
                <td>{{ (item.totalArrear && item.totalArrear.totalDeduction !== undefined) ? item.totalArrear.totalDeduction : (item.totalDeduction || '0.00') }}</td>
              </ng-container>

              <ng-container *ngIf="head.value == 'employerContributionHeads'">
                <td *ngFor="let val of displayData.employerContributionHeads">
                  {{ getTableDataValue(val, head, item) }}
                </td>
              </ng-container>
            </ng-container>
          </tr>
        </ng-template>
      </ng-container>
   <tr>
     <td>PREPARED By:-</td>
     <td></td>
     <td></td>
     <td></td>
     <td></td>
     <td></td>
     <td>CHECKED By:-</td>
     <td></td>
     <td></td>
     <td></td>
     <td></td>
     <td></td>
     <td>DIRECTOR/PRINCIPAL</td>
   </tr>  
   <tr>
     <td>CLEARK</td>
     <td></td>
     <td></td>
     <td></td>
     <td></td>
     <td></td>
     <td>ACCOUNTANT</td>
     <td></td>
     <td></td>
   </tr>   
  </tbody>
</table>
 <div class="row pt30">
     <div class="col-4">
         Principal's Singature
     </div>
     <div class="col-3 offset-5">
         Authorised Singature
     </div>
 </div>

</div>

<div  class="" *ngIf="displayData.showVerticalTableFlag ">
  <div id="tablePrint" style="overflow-x:auto;" class="bgColorWhite tablePrint scrollbar bRadius10P">
      
      <table class="table textCenter verticalMiddle ">
          <thead class="buttonTheme">
            <tr>

              <th  style="border: 1px solid;"rowspan="2" class="colorWhite"> S.No</th>
              <ng-container *ngFor="let head of displayData.tableHead">
                  <th style="border: 1px solid;" [ngStyle]="getStyleConditionally(head.value)"  [attr.rowspan]="getRowSpan(head.value)" [attr.colspan]="getColSpan(head.value)" class="colorWhite">{{head.name}}</th>
              </ng-container>
              </tr>
              <tr>
              

             
              <ng-container *ngFor="let head of displayData.tableHead">
                  <ng-container *ngIf="canItrate(head)">
                      <th  *ngFor="let item of getHeadName(head)" style="font-weight: 700;    writing-mode: vertical-lr !important;
                      -webkit-writing-mode: vertical-lr;
                      -ms-writing-mode: vertical-lr;
                      transform: rotate(180deg);
                      margin: 0 auto; border: 1px solid;"   class="colorWhite">{{item}}</th>
                  </ng-container>
              </ng-container>
                            
          
            </tr>   
            
          </thead>
          <tbody class="verticalMiddle">  
              <tr *ngFor="let item of displayData.dataSource;let index=index">
                      <td >
                          {{index+1}}
                      </td>
                      <ng-container *ngFor="let head of displayData.tableHead">
                          <ng-container *ngIf="['deductionHeads', 'earningHeads', 'employerContributionHeads','templateEarningHeads','templateDeductionHeads','templateEmployerContributionHeads'].includes(head.value)">
                              <td *ngFor="let val of getHeadName(head)">
                                  {{getTableDataValue(val,head,item)}}
                              </td>
                          </ng-container>
                      <ng-container *ngIf="!['deductionHeads', 'earningHeads', 'employerContributionHeads','templateEarningHeads','templateDeductionHeads','templateEmployerContributionHeads'].includes(head.value)">
                          <td >
                            <ng-container *ngIf="head.value!='joiningDate'">{{item[head.value]}}</ng-container> 
                            <ng-container *ngIf="head.value=='joiningDate'">{{item[head.value] | date:'dd/MMM/yyyy'}}</ng-container> 
                          </td>
                          </ng-container>

                      </ng-container>
             
                 
              </tr>   
              <tr >
                <td>PREPARED By:-</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>CHECKED By:-</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>DIRECTOR/PRINCIPAL</td>
              </tr>  
              <tr >
                <td>CLEARK</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>ACCOUNTANT</td>
                <td></td>
                <td></td>
              </tr>  


          </tbody>

      </table>        

  </div>
</div>



</div>
</div>

</section>
`,
salaryReportMonthTemplate:`
<script>
.printReceipt, #tablePrint {
   font-family: 'Open Sans', sans-serif;
}

table {
   width: 100%;
   border-collapse: collapse;
   table-layout: auto; /* Ensures automatic layout for adjusting column widths */
}

th, td {
   border: 1px solid #000;
   text-align: left;
}

/* Ensure columns are not too wide */
th, td {
   max-width: 150px; /* Adjust as needed */
   word-wrap: break-word; /* Breaks long words */
   overflow: hidden; /* Ensures text overflow is handled */
   text-overflow: ellipsis; /* Adds ellipsis for overflowed text */
}

/* CSS for print */
@media print {
   .borderBold{
       border: 1px solid black;
   }
   .tablePrint {
       max-height: none; /* Disable the fixed height */
       overflow-y: visible; /* Show full table without scrolling */
       padding: 20px;
       background-color: #fff !important;
   }
 .headerPage{
   border-color: #000;
   border-top: 1px solid black;
   border-right: 1px solid black;
   border-left: 1px solid black;
   border-bottom: 0;
   padding-top: 10px;
   th span{
       font-weight: 800;
   }
 }
   .table thead th {
       border-bottom:  1px solid #000;
   }
   .thead-dark{
       th{
             border: 1px solid #000 !important;
       }
   }
   table {
       width: 100%;
       table-layout: fixed; /* Fix the table layout */
   }

   th, td {
       border: 1px solid #000 !important;
       text-align: left;
   }

   /* Ensure columns are not too wide */
   th, td {
       max-width: 100px; /* Adjust as needed */
       word-wrap: break-word; /* Breaks long words */
       // white-space: nowrap; /* Prevent text wrapping */
       // overflow: hidden; /* Ensure text overflow is handled */
       // text-overflow:clip; /* Adds ellipsis for overflowed text */
       font-size: 8px; /* Make the text smaller to fit more content */
   }

   /* Force the table to fit within the print area */
   body {
       -webkit-print-color-adjust: exact; /* Print colors correctly */
   }
}

</script>
<section style="font-weight: 800; font-size: 150%">
<div class="">
<div class="col-12"> 

<div  class="" >
  <div id="tablePrint" style="overflow-x:auto;" class="bgColorWhite tablePrint scrollbar bRadius10P">
      
    <table class="table textCenter verticalMiddle">
      <thead class="buttonTheme">
        <!-- First header row for months -->


        <tr>
          <th></th>
          <th [attr.colspan]="getColSpanLengthOfTableHead()" ></th>
          <ng-container *ngFor="let mnth of displayData.monthArr;let ind=index">
            <th style="border: 1px solid;" [attr.colspan]="getLength()" class="colorWhite">{{mnth}}</th>
          </ng-container>
         
        </tr>
        
    
        <!-- Second header row for main headers -->
        <tr>
          <th style="border: 1px solid;" rowspan="2" class="colorWhite">S.No</th>
          <ng-container *ngFor="let mnth of displayData.monthArr;let ind=index">
            <ng-container *ngFor="let head of displayData.tableHead">
              <ng-container *ngIf="getColSpan(head.value) > 1; else simpleHeads">
                <th style="border: 1px solid;" [ngStyle]="getStyleConditionally(head.value)" [attr.rowspan]="getRowSpan(head.value)" [attr.colspan]="getColSpan(head.value)" class="colorWhite">
                  {{head.name}} 
                </th>
              </ng-container>
              <ng-template #simpleHeads>
                <ng-container *ngIf="ind==0">
                <th style="border: 1px solid;" [ngStyle]="getStyleConditionally(head.value)" [attr.rowspan]="getRowSpan(head.value)" [attr.colspan]="getColSpan(head.value)" class="colorWhite">
                  {{head.name}} 
                </th>
              </ng-container>
              <ng-container *ngIf="ind>0 && head.key =='monthlyType' "> <!-- to get monthy head twice -->
                <th style="border: 1px solid;" [ngStyle]="getStyleConditionally(head.value)" [attr.rowspan]="getRowSpan(head.value)" [attr.colspan]="getColSpan(head.value)" class="colorWhite">
                  {{head.name}} 
                </th>
              </ng-container>
              </ng-template>
            </ng-container>
          </ng-container>
        </tr>
    
        <!-- Third header row for subheaders -->
        <tr>
          <ng-container *ngFor="let mnth of displayData.monthArr">
            <ng-container *ngFor="let head of displayData.tableHead">
              <ng-container *ngIf="canItrate(head)">
                <th *ngFor="let item of getHeadName(head)" style="font-weight: 700; writing-mode: vertical-lr !important; -webkit-writing-mode: vertical-lr; -ms-writing-mode: vertical-lr; transform: rotate(180deg); margin: 0 auto; border: 1px solid;" class="colorWhite">
                  {{item}}
                </th>
              </ng-container>
            </ng-container>
          </ng-container>
        </tr>
      </thead>
      
      <tbody class="verticalMiddle">
        <tr *ngFor="let item of displayData.dataSource; let index = index">
          <td>{{index + 1}}</td>
          <ng-container *ngFor="let mnth of displayData.monthArr;let ind=index">
            <ng-container *ngFor="let head of displayData.tableHead">
              <ng-container *ngIf="['deductionHeads', 'earningHeads', 'employerContributionHeads', 'templateEarningHeads', 'templateDeductionHeads', 'templateEmployerContributionHeads'].includes(head.value)">
                <td *ngFor="let val of getHeadName(head)">
                  {{getTableDataValue(val, head, item, mnth)}} 
                </td>
              </ng-container>
              <ng-container *ngIf="!['deductionHeads', 'earningHeads', 'employerContributionHeads', 'templateEarningHeads', 'templateDeductionHeads', 'templateEmployerContributionHeads'].includes(head.value)">
                <td *ngIf="ind== 0 && head.key == 'employeeType'">
                  <ng-container *ngIf="head.value != 'joiningDate'">{{item[head.value]}}</ng-container>
                  <ng-container *ngIf="head.value == 'joiningDate'">{{item[head.value] | date: 'dd/MMM/yyyy'}}</ng-container>
                </td>
                <td *ngIf="head.key=='monthlyType'">
                  <ng-container >{{ getItemOfMonthlyType(item,head,mnth)}}</ng-container>
                </td>
              </ng-container>
            </ng-container>
          </ng-container>
        </tr>
        <tr >
          <td>PREPARED By:-</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>CHECKED By:-</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>DIRECTOR/PRINCIPAL</td>
        </tr>
        <tr>
          <td>CLERK</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>ACCOUNTANT</td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>     

  </div>
</div>



</div>
</div>

</section>
`,
studentAllValuesCertificate: `
    
<div style="font-weight: 500;  font-size: large;" class="container card">
<div class="row mt10">
   <br>
   <br>
   <div class="col-3">
      <img style="height: 100%; width: 100%;" class="img-rounded" [src]="displayData.logo" alt="">
   </div>
   <div class="col-9 textCenter ">
      <strong>
         <h1>{{displayData.entityDisplayName}}</h1>
      </strong>
      <h4>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </h4>
      <h4>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </h4>
   </div>
</div>
<article class="mt20p">
   <div class="row mt10">
      <div class="col-7">
         <div class="row mt10">
            <div class="col-5 offset-1">
               <strong>
               Course
               </strong> 
            </div>
            <div class="col-1">
               :
            </div>
            <div class="col-5">
               {{displayData.course}}
            </div>
         </div>
         <div class="row mt10" *ngIf="displayData.applicationNumber">
            <div class="col-5 offset-1">
               <strong>
               Application No.
               </strong> 
            </div>
            <div class="col-1">
               :
            </div>
            <div class="col-5">
               {{displayData.applicationNumber}}
            </div>
         </div>
         <div class="row mt10" *ngIf="displayData.date">
            <div class="col-5 offset-1">
               <strong>
               Date of Application
               </strong> 
            </div>
            <div class="col-1">
               :
            </div>
            <div class="col-5">
               {{displayData.date | date : 'dd/MM/yyyy'}}
            </div>
         </div>
         <div class="row mt10" *ngIf="displayData.batch">
            <div class="col-5 offset-1">
               <strong>
               Batch
               </strong> 
            </div>
            <div class="col-1">
               :
            </div>
            <div class="col-5">
               {{displayData.batch}}
            </div>
         </div>
         <div class="row mt10" *ngIf="displayData.section">
            <div class="col-5 offset-1">
               <strong>
               Section
               </strong> 
            </div>
            <div class="col-1">
               :
            </div>
            <div class="col-5">
               {{displayData.section}}
            </div>
         </div>
         <div class="row mt10" *ngIf="displayData.oldNew">
            <div class="col-5 offset-1">
               <strong>
               Old/New
               </strong> 
            </div>
            <div class="col-1">
               :
            </div>
            <div class="col-5">
               {{displayData.oldNew}}
            </div>
         </div>
         <div class="row mt10" *ngIf="displayData.category">
            <div class="col-5 offset-1">
               <strong>
               Category
               </strong> 
            </div>
            <div class="col-1">
               :
            </div>
            <div class="col-5">
               {{displayData.category}}
            </div>
         </div>
         <div class="row mt10" *ngIf="displayData.totalPaybleAmount">
            <div class="col-5 offset-1">
               <strong>
               Total Payable Amount
               </strong> 
            </div>
            <div class="col-1">
               :
            </div>
            <div class="col-5">
               {{displayData.totalPaybleAmount}}
            </div>
         </div>
         <div class="row mt10" *ngIf="displayData.totalPaidAmount">
            <div class="col-5 offset-1">
               <strong>
               Total Paid Amount
               </strong> 
            </div>
            <div class="col-1">
               :
            </div>
            <div class="col-5">
               {{displayData.totalPaidAmount}}
            </div>
         </div>
      </div>
      <div class="col-5 textCenter">
         <img style="height: 150px;" class="img" [src]="displayData.photo" />
      </div>
   </div>
</article>
<article class="mt20p">
   <div class="row mt10">
      <div class="col-10 offset-1">
         <h4>
            Applicant Details:
         </h4>
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.name">
      <div class="col-4 offset-2">
         <strong>
         Name of the Applicant
         </strong>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.name}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.dob">
      <div class="col-4 offset-2">
         <strong>
         Date of Birth
         </strong>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.dob | date : 'dd/MM/yyyy'}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.gender">
      <div class="col-4 offset-2">
         <strong>
         Gender
         </strong>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.gender}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.doa">
      <div class="col-4 offset-2">
         <strong>
         Date of Admission
         </strong>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.doa | date : 'dd/MM/yyyy'}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.uid">
      <div class="col-4 offset-2">
         <strong>
         Aadhar card no.
         </strong>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.uid}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.phone">
      <div class="col-4 offset-2">
         <strong>
         Contact No. for SMS
         </strong>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.phone}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.email">
      <div class="col-4 offset-2">
         <strong>
         Email
         </strong>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.email}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.fatherName">
      <div class="col-4 offset-2">
         <strong>
         Father's Name
         </strong>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.fatherName}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.motherName">
      <div class="col-4 offset-2">
         <strong>
         Mother's Name
         </strong>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.motherName}}
      </div>
   </div>
</article>
<article class="mt20p">
   <div class="row mt10">
      <div class="col-10 offset-1">
         <h4>
            Address Details:
         </h4>
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.address">
      <div class="col-4 offset-2">
         <strong>
         Home Address
         </strong>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.address}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.city">
      <div class="col-4 offset-2">
         <strong>
         City
         </strong>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.city}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.state">
      <div class="col-4 offset-2">
         <strong>
         State
         </strong>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.state}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.country">
      <div class="col-4 offset-2">
         <strong>
         Country
         </strong>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.country}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.pinCode">
      <div class="col-4 offset-2">
         <strong>
         Pin Code
         </strong>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.pinCode}}
      </div>
   </div>
</article>
<article class="mt20p">
   <div class="row mt10">
      <div class="col-10 offset-1">
         <h4>
            Other Details:
         </h4>
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.fatherMobile">
      <div class="col-4 offset-2">
         <strong>
         Father's Mobile
         </strong>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.fatherMobile}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.fatherEmail">
      <div class="col-4 offset-2">
         <strong>
         Father Email 
         </strong>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.fatherEmail}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.fatherDOB">
      <div class="col-4 offset-2">
         <strong>
         Father DOB 
         </strong>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.fatherDOB}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.fatherUID">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Father UID 
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.fatherUID}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.fatherQualification">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Father Qualification 
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.fatherQualification}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.fatherOccupation">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Father Occupation 
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.fatherOccupation}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.fatherOrganisation">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Father Organisation
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.fatherOrganisation}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.fatherDesignation">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Father Designation 
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.fatherDesignation}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.fatherAnnualIncome">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Father Annual Income 
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.fatherAnnualIncome}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.fatherAddress">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Father Address 
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.fatherAddress}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.fatherCity">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Father City
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.fatherCity}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.fatherState">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Father State
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.fatherState}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.fatherCountry">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Father Country
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.fatherCountry}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.fatherPinCode">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Father Pin Code
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.fatherPinCode}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.fatherEmployeeOfInstitute">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Father Employee Of Institute
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.fatherEmployeeOfInstitute}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.motherMobile">
      <div class="col-4 offset-2">
         <strong>
         Mother's Mobile
         </strong>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.motherMobile}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.motherEmail">
      <div class="col-4 offset-2">
         <strong>
         Mother Email 
         </strong>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.motherEmail}}
      </div>
   </div>
   <div class="row mt10"  *ngIf="displayData.motherDOB">
      <div class="col-4 offset-2">
         <strong>
         Mother DOB 
         </strong>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.motherDOB}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.motherUID">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Mother UID 
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.motherUID}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.motherQualification">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Mother Qualification 
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.motherQualification}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.motherOccupation">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Mother Occupation 
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.motherOccupation}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.motherOrganisation">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Mother Organisation
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.motherOrganisation}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.motherDesignation">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Mother Designation 
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.motherDesignation}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.motherAnnualIncome">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Mother Annual Income 
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.motherAnnualIncome}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.motherAddress">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Mother Address 
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.motherAddress}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.motherCity">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Mother City
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.motherCity}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.motherState">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Mother State
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.motherState}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.motherCountry">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Mother Country
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.motherCountry}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.motherPinCode">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Mother Pin Code
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.motherPinCode}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.motherEmployeeOfInstitute">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Mother Employee Of Institute
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.motherEmployeeOfInstitute}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.guardianName">
      <div class="col-4 offset-2">
         <strong>
         Guardian name
         </strong>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.guardianName}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.relationWithGuardian">
      <div class="col-4 offset-2">
         <strong>
         Relation with Guardian
         </strong>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.relationWithGuardian}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.guardianMobile">
      <div class="col-4 offset-2">
         <strong>
         Guardian's Mobile
         </strong>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.guardianMobile}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.guardianEmail">
      <div class="col-4 offset-2">
         <strong>
         Guardian Email 
         </strong>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.guardianEmail}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.guardianDOB">
      <div class="col-4 offset-2">
         <strong>
         Guardian DOB 
         </strong>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.guardianDOB}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.guardianUID">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Guardian UID 
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.guardianUID}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.guardianQualification">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Guardian Qualification 
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.guardianQualification}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.guardianOccupation">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Guardian Occupation 
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.guardianOccupation}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.guardianOrganisation">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Guardian Organisation
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.guardianOrganisation}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.guardianDesignation">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Guardian Designation 
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.guardianDesignation}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.guardianAnnualIncome">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Guardian Annual Income 
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.guardianAnnualIncome}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.guardianAddress">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Guardian Address 
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.guardianAddress}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.guardianCity">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Guardian City
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.guardianCity}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.guardianState">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Guardian State
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.guardianState}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.guardianCountry">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Guardian Country
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.guardianCountry}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.guardianPinCode">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Guardian Pin Code
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.guardianPinCode}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.guardianEmployeeOfInstitute">
      <div class="col-4 offset-2">
         <span>
         <strong>
         Guardian Employee Of Institute
         </strong>
         </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.guardianEmployeeOfInstitute}}
      </div>
   </div>
</article>
<article class="mt20p">
   <div class="row mt10">
      <div class="col-10 offset-1">
         <h4>
            Education Details:
         </h4>
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.bloodGroup">
      <div class="col-4 offset-2">
         <span><strong>
         Blood Group
         </strong> </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.bloodGroup}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.height">
      <div class="col-4 offset-2">
         <span><strong>
         Height
         </strong> </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.height}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.weight">
      <div class="col-4 offset-2">
         <span><strong>
         Weight
         </strong> </span>
      </div>
      <div class="col-1">
         :
      </div>
      <div class="col-4">
         {{displayData.weight}}
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.educationDetails1Class">
      <div class="col-4 offset-2">
         <span><strong>
         Class Passed
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.educationDetails1Class}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.educationDetails1School">
      <div class="col-4 offset-2">
         <span><strong>
         10th School Name
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.educationDetails1School}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.educationDetails1University">
      <div class="col-4 offset-2">
         <span><strong>
         10th Board
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.educationDetails1University}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.educationDetails1PassingYear">
      <div class="col-4 offset-2">
         <span><strong>
         10th Passing Year
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.educationDetails1PassingYear}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.educationDetails1RollNo">
      <div class="col-4 offset-2">
         <span><strong>
         10th Roll No.
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.educationDetails1RollNo}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.educationDetails1MaxMarks">
      <div class="col-4 offset-2">
         <span><strong>
         Maximum Marks 10th
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.educationDetails1MaxMarks}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.educationDetails1ObtainedMarks">
      <div class="col-4 offset-2">
         <span><strong>
         Obtained Marks 10th
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.educationDetails1ObtainedMarks}}  
      </div>
   </div>
   <!--new-->
   <div class="row mt10" *ngIf="displayData.educationDetails1Result">
      <div class="col-4 offset-2">
         <span><strong>
         Result 10th
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.educationDetails1Result}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.educationDetails1Percentage">
      <div class="col-4 offset-2">
         <span><strong>
         10th Percentage
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.educationDetails1Percentage}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.educationDetails1Remark">
      <div class="col-4 offset-2">
         <span><strong>
         10th Remark
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.educationDetails1Remark}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.educationDetails1SchoolCity">
      <div class="col-4 offset-2">
         <span><strong>
         10th School City
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.educationDetails1SchoolCity}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.educationDetails1SchoolState">
      <div class="col-4 offset-2">
         <span><strong>
         10th School State
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.educationDetails1SchoolState}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.educationDetails2Class">
      <div class="col-4 offset-2">
         <span><strong>
         Class Passed
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.educationDetails2Class}}  
      </div>
   </div>
   <!--new-->
   <div class="row mt10" *ngIf="displayData.educationDetails2University">
      <div class="col-4 offset-2">
         <span><strong>
         ITI/12th University
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.educationDetails2University}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.educationDetails2PassingYear">
      <div class="col-4 offset-2">
         <span><strong>
         ITI/12th Passing Year
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.educationDetails2PassingYear}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.educationDetails2School">
      <div class="col-4 offset-2">
         <span><strong>
         ITI/12th School
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.educationDetails2School}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.educationDetails2RollNo">
      <div class="col-4 offset-2">
         <span><strong>
         ITI/12th Roll No.
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.educationDetails2RollNo}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.educationDetails2MaxMarks">
      <div class="col-4 offset-2">
         <span><strong>
         Maximum Marks ITI/12th
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.educationDetails2MaxMarks}}  
      </div>
   </div>
   <!--new-->
   <div class="row mt10" *ngIf="displayData.educationDetails2ObtainedMarks">
      <div class="col-4 offset-2">
         <span><strong>
         Obtained Marks ITI/12th
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.educationDetails2ObtainedMarks}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.educationDetails2Result">
      <div class="col-4 offset-2">
         <span><strong>
         ITI/12th Result
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.educationDetails2Result}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.educationDetails2Percentage">
      <div class="col-4 offset-2">
         <span><strong>
         ITI/12th Percentage
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.educationDetails2Percentage}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.educationDetails2Remark">
      <div class="col-4 offset-2">
         <span><strong>
         ITI/12th Remark
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.educationDetails2Remark}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.educationDetails2SchoolCity">
      <div class="col-4 offset-2">
         <span><strong>
         ITI/12th School City
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.educationDetails2SchoolCity}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.educationDetails2SchoolState">
      <div class="col-4 offset-2">
         <span><strong>
         ITI/12th School State
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.educationDetails2SchoolState}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.actualGraduationYear">
      <div class="col-4 offset-2">
         <span><strong>
         Actual Graduation Year
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.actualGraduationYear}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.qualifyingExamName">
      <div class="col-4 offset-2">
         <span><strong>
         Qualifying Exam Name
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.qualifyingExamName}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.currentStage">
      <div class="col-4 offset-2">
         <span><strong>
         Current Stage
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.currentStage}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.qualifyingExamRollNo">
      <div class="col-4 offset-2">
         <span><strong>
         Qualifying Exam Roll No
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.qualifyingExamRollNo}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.qualifyingExamRank1">
      <div class="col-4 offset-2">
         <span><strong>
         Qualifying Exam Rank1
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.qualifyingExamRank1}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.qualifyingExamRank2">
      <div class="col-4 offset-2">
         <span><strong>
         Qualifying Exam Rank2
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.qualifyingExamRank2}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.utmSource">
      <div class="col-4 offset-2">
         <span><strong>
         Utm Source
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.utmSource}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.utmMedium">
      <div class="col-4 offset-2">
         <span><strong>
         Utm Medium
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.utmMedium}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.utmCampaign">
      <div class="col-4 offset-2">
         <span><strong>
         Utm Campaign
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.utmCampaign}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.customField2">
      <div class="col-4 offset-2">
         <span><strong>
         Custom Field 2
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.customField2}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.customField3">
      <div class="col-4 offset-2">
         <span><strong>
         Password
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.customField3}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.customField4">
      <div class="col-4 offset-2">
         <span><strong>
         Rank
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.customField4}}  
      </div>
   </div>
   <div class="row mt10" *ngIf="displayData.customField5">
      <div class="col-4 offset-2">
         <span><strong>
         Custom Field 5
         </strong> </span>
      </div>
      <div class="col-1">
         :     
      </div>
      <div class="col-4">
         {{displayData.customField5}}  
      </div>
   </div>
</article>
<article class="mt20p">
   <div class="row mt10">
   </div>
   <div class="row mt10">
      <div class="col-12">
         <p>
            <strong>Declaration: </strong>  I, verify that I have applied for {{displayData.course}}. The photo pasted above and all the particulars given are correct to the best of my knowledge. I have no objection, if my admission is cancelled at any stage due to false information given by me.
         </p>
         <br>
         <br>
      </div>
      <div class="col-6">
         <strong>Parent/Guardian Signature</strong>
      </div>
      <div class="col-6 textEnd">
         <strong>Candidate Signature</strong>
      </div>
   </div>
   <div class="row mt10">
      <div class="col-12">
         <hr>
      </div>
      <div class="col-12">
         <strong>Documents Attached:</strong>
      </div>
      <div class="col-3">
         <input type=checkbox> Aadhar Card
      </div>
      <div class="col-3">
         <input type=checkbox> Matric Certificate
      </div>
      <div class="col-3">
         <input type=checkbox> 12th Certificate
      </div>
      <div class="col-3">
         <input type=checkbox> Character Certificate
      </div>
      <p>
      <div class="col-3">
         <input type=checkbox> Gap Year Certificate
      </div>
      <div class="col-3">
         <input type=checkbox> Medical Certificate
      </div>
      <div class="col-3">
         <input type=checkbox> Income Certificate
      </div>
      <div class="col-3">
         <input type=checkbox> Counselling Receipt
      </div>
      <p>
   </div>
</article>
</div>

`,
studentLedgerMultipleSessionTemplate:
` 
    <section style="font-weight: 500;" class="container card">
<ng-container *ngFor='let displayData of displayDataArray'>
        <div class="row mt10">  
            <div class="col-8 textCenter  ">
            <h2>{{displayData.entityDisplayName}}</h2>
            <h4>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </h4> <br>
            <h4>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </h4>
            <h4>Ledger for {{displayData.studentName}} ( {{displayData.studentRegNo}} ) {{displayData.studentCourse}} - {{displayData.studentStream}} </h4>
            </div>
        </div>
        <div style="font-size: large; font-weight: 400;" class="row mt20" *ngFor="let row of displayData.studentLedger">
          Session :{{row.session}}
            <table class="table table-bordered fontFamily mt3p">
                <thead>
                    <tr>
                        <th>
                            Date
                        </th>
                        <th>
                        Name/Narration
                        </th>
                        <th></th>
                        <th>
                        Payment Mode
                        </th>
                        <th>
                            Debit
                        </th>
                        <th>Credit</th>
                        <th>Balance</th>
                        <th>Remarks</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of row.ledgerData">
                        <td>
                            {{data.date | date : 'dd/MMM/yyyy'}}
                        </td>
                        <td>
                        {{data.name}}
                        </td>
                        <td>
                            {{data.type}}
                        </td>
                        <td>
                        {{data.paymentMode || '-'}}
                        </td>
                        <td>
                        {{data.debit}}
                        </td>
                        <td>{{data.credit}}</td>
                        <td>{{data.balance}}</td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>      
</ng-container>  
    </section>
    
    `,
    studentLedgerMultipleSessionHeadWiseTemplate:
` 
    <section style="font-weight: 500;" class="container card">
<ng-container *ngFor='let displayData of displayDataArray'>
        <div class="row mt10">  
            <div class="col-8 textCenter  ">
            <h2>{{displayData.entityDisplayName}}  </h2>
            <h4>{{displayData.entityAddress}}, {{displayData.entityCity}}, {{displayData.entityState}}, {{displayData.entityPin}} </h4> <br>
            <h4>{{displayData.entityReceptionNumber}}, {{displayData.entityContactEmail}} </h4>
            <h4>Ledger for {{displayData.studentName}} ( {{displayData.studentRegNo}} ) {{displayData.studentCourse}} - {{displayData.studentStream}} </h4>
            </div>
        </div>
        <div style="font-size: large; font-weight: 400;" class="row mt20" *ngFor="let row of displayData.studentLedger">
          Session :{{row.session}}
            <table class="table table-bordered fontFamily mt3p">
                <thead>
                    <tr>
                        <th>
                            Date
                        </th>
                        <th>
                        Name/Narration
                        </th>
                        <th></th>
                        <th>
                        Payment Mode
                        </th>
                        <th>
                            Debit
                        </th>
                        <th>Credit</th>
                        <th>Balance</th>
                        <th>Remarks</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of row.ledgerData">
                        <td>
                            {{data.date | date : 'dd/MMM/yyyy'}}
                        </td>
                        <td>
                        {{data.headName}}
                        </td>
                        <td>
                            {{data.type}}
                        </td>
                        <td>
                        {{data.paymentMode || '-'}}
                        </td>
                        <td>
                        {{data.debit}}
                        </td>
                        <td>{{data.credit}}</td>
                        <td>{{data.balance}}</td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>      
</ng-container>  
    </section>
    
    `,
    eventActivity:`
    <style>
.report-container {
            width: 80%;
            margin: auto;
            border: 2px solid black;
            padding: 20px;
        }
        .dotted-line {
            border-bottom: 1px dotted black;
            display: inline-block;
            width: 100%;
            min-height: 20px;
        }
        .row .dotted-line {
            width: 48%;
        }
        h2 {
            text-align: center;
            font-weight: bold;
        }
</style>
<section>
<div class="report-container">
        <h2>Teacher’s <strong>Activity Report 2021-2022</strong></h2>
        <strong>user:{{displayData.userName}}</strong>

        <p><strong>Faculty (Name of Department/Committee/Club):</strong> <span class="dotted-line"></span></p>

        <p><strong>Name of the Activity:{{displayData.name}}</strong> <span class="dotted-line"></span></p>

        <div class="row">
            <div class="col-md-6">
                <p><strong>Name of the Coordinator:</strong> <span class="dotted-line"></span></p>
            </div>
            <div class="col-md-6">
                <p><strong>Date & Time:</strong> <span class="dotted-line"></span></p>
            </div>
        </div>

        <p><strong>Name and Designation of the Resource Person:</strong> <span class="dotted-line"></span></p>

        <div class="row">
            <div class="col-md-6">
                <p><strong>Venue: {{displayData.venue}}</strong> <span class="dotted-line"></span></p>
            </div>
            <div class="col-md-6">
                <p><strong>Nature (Indoor/Outdoor):</strong> <span class="dotted-line"></span></p>
            </div>
        </div>

        <p><strong>Support/Assistance:</strong> <span class="dotted-line"></span></p>
    </div>
    </section>
    `
    ,
    leaveApplicationCertificate:`
      <section>
      <div class="certificate">
        <h2>Leave Application Certificate</h2>
        <p>This is to certify that</p>
        <h3>[Employee/Student Name]</h3>
        <p>has been granted leave from</p>
        <h3>[Start Date] to [End Date]</h3>
        <p>for the reason:</p>
        <h3>[Reason for Leave]</h3>
        
        <div class="signature">
            <p>Authorized By</p>
            <p><strong>[Authority Name]</strong></p>
            <p><em>[Designation]</em></p>
        </div>
    </div>
      </section>

    `,
    arrearSalaryTemplate:`
            <section style="font-weight: 800; font-size: 150%">
       <div class="">
       <div class="col-12"> 
       
       
       <div  class="" >
         <div id="tablePrint" style="overflow-x:auto;" class="bgColorWhite tablePrint scrollbar bRadius10P">
                  <table class="table textCenter verticalMiddle ">
                 <thead class="buttonTheme">
                  <!-- Row 1 -->
                  <tr>
                    <th style="border: 1px solid;" rowspan="3" class="colorWhite"> S.No</th>
                    <ng-container *ngFor="let head of displayData.tableHead">
                      <!-- Normal headers span all 3 rows -->
                      <th *ngIf="!['earningHeads', 'deductionHeads', 'employerContributionHeads'].includes(head.value) && head.value != 'months'"
                          style="border: 1px solid;" [ngStyle]="getStyleConditionally(head.value)" rowspan="3" class="colorWhite">
                        {{head.name}}
                      </th>
                      <!-- Months column spans 3 rows -->
                      <th *ngIf="head.value == 'months'" style="border: 1px solid;" rowspan="3" class="colorWhite">Months</th>

                      <!-- Salary Contract main header spans 2 rows and earningHeads.length columns -->
                      <th *ngIf="head.value == 'earningHeads'" style="border: 1px solid; font-weight: 700; text-align: center;" 
                          [attr.colspan]="displayData.earningHeads.length" rowspan="2" class="colorWhite">
                        Salary Contract
                      </th>

                      <!-- Earning Heads main header spans 1 row and multiple columns (DUE + PAID + NET PAYABLE) -->
                      <th *ngIf="head.value == 'earningHeads'" style="border: 1px solid; font-weight: 700; text-align: center;" 
                          [attr.colspan]="displayData.earningHeads.length * 2 + 1" rowspan="1" class="colorWhite">
                        Earning Head
                      </th>

                      <!-- Deduction Head main header spans 1 row and multiple columns (DUE + PAID + NET DEDUCTION) -->
                      <th *ngIf="head.value == 'deductionHeads'" style="border: 1px solid; font-weight: 700; text-align: center;" 
                          [attr.colspan]="displayData.deductionHeads.length * 2 + 1" rowspan="1" class="colorWhite">
                        Deduction Head
                      </th>
                      <th *ngIf="head.value == 'employerContributionHeads'" style="border: 1px solid;" [attr.colspan]="displayData.employerContributionHeads.length" rowspan="2" class="colorWhite">
                        Employer Contribution Heads
                      </th>
                    </ng-container>
                  </tr>

                  <!-- Row 2 -->
                  <tr>
                    <!-- Under Earning Head -->
                    <th style="border: 1px solid; text-align: center; font-weight: 700;" [attr.colspan]="displayData.earningHeads.length" class="colorWhite">DUE</th>
                    <th style="border: 1px solid; text-align: center; font-weight: 700;" [attr.colspan]="displayData.earningHeads.length" class="colorWhite">PAID</th>
                    <th style="border: 1px solid; text-align: center; font-weight: 700; vertical-align: middle;" rowspan="2" class="colorWhite">NET PAYABLE</th>

                    <!-- Under Deduction Head -->
                    <th style="border: 1px solid; text-align: center; font-weight: 700;" [attr.colspan]="displayData.deductionHeads.length" class="colorWhite">DUE</th>
                    <th style="border: 1px solid; text-align: center; font-weight: 700;" [attr.colspan]="displayData.deductionHeads.length" class="colorWhite">PAID</th>
                    <th style="border: 1px solid; text-align: center; font-weight: 700; vertical-align: middle;" rowspan="2" class="colorWhite">NET Deduction</th>
                  </tr>

                  <!-- Row 3 -->
                  <tr>
                    <!-- Under Salary Contract -->
                    <th *ngFor="let val of displayData.earningHeads" style="border: 1px solid; font-weight: 700; text-align: center;" class="colorWhite">{{val}}</th>

                    <!-- Under DUE -->
                    <th *ngFor="let val of displayData.earningHeads" style="border: 1px solid; font-weight: 700; text-align: center;" class="colorWhite">{{val}}</th>
                    <!-- Under PAID -->
                    <th *ngFor="let val of displayData.earningHeads" style="border: 1px solid; font-weight: 700; text-align: center;" class="colorWhite">{{val}}</th>

                    <!-- Under DUE -->
                    <th *ngFor="let val of displayData.deductionHeads" style="border: 1px solid; font-weight: 700; text-align: center;" class="colorWhite">{{val}}</th>
                    <!-- Under PAID -->
                    <th *ngFor="let val of displayData.deductionHeads" style="border: 1px solid; font-weight: 700; text-align: center;" class="colorWhite">{{val}}</th>

                    <!-- For Employer Contribution Heads, their sub-headers are here (Row 3) -->
                    <ng-container *ngFor="let head of displayData.tableHead">
                      <ng-container *ngIf="['employerContributionHeads'].includes(head.value)">
                        <th *ngFor="let item of getHeadName(head)" style="font-weight: 700;    writing-mode: vertical-lr !important;
                            -webkit-writing-mode: vertical-lr;
                            -ms-writing-mode: vertical-lr;
                            transform: rotate(180deg);
                            margin: 0 auto; border: 1px solid;" class="colorWhite">
                          {{item}}
                        </th>
                      </ng-container>
                    </ng-container>
                  </tr>
                </thead>
                <tbody class="verticalMiddle">
                  <ng-container *ngFor="let item of displayData.dataSource; let index = index">
                    <ng-container *ngIf="item.employeeName!='Total';else totalTd">
                    <ng-container *ngIf="displayData.monthlyDataShown">
                    <tr *ngFor="let month of item.monthWiseArrear; let monthIndex = index">
                      <!-- S.No -->
                      <td *ngIf="monthIndex == 0" [attr.rowspan]="item.monthWiseArrear.length">
                       {{ index + 1 }}
                      </td>
                  
                      <!-- Other columns -->
                      <ng-container *ngFor="let head of displayData.tableHead">
                        <!-- Normal columns (Employee name, code, dept, etc.) -->
                        <ng-container *ngIf="!['deductionHeads', 'earningHeads', 'employerContributionHeads'].includes(head.value) && head.value != 'months'">
                          <ng-container *ngIf="getValueOfTD(head, month, item) as data">
                            <td *ngIf="data.rowSpan && monthIndex == 0" [attr.rowspan]="item.monthWiseArrear.length">
                              {{ data.name }}
                            </td>
                            <td *ngIf="!data.rowSpan">
                              {{ data.name }}
                            </td>
                          </ng-container>
                        </ng-container>

                        <!-- Months column -->
                        <td *ngIf="head.value == 'months'">{{ month.month }}</td>

                        <!-- Earning Heads columns (Salary Contract, DUE, PAID, NET PAYABLE) -->
                        <ng-container *ngIf="head.value == 'earningHeads'">
                          <!-- Salary Contract values -->
                          <td *ngFor="let val of displayData.earningHeads">
                            {{ getTemplateEarningHeadValue(month, val) }}
                          </td>
                          <!-- DUE values (newValue) -->
                          <td *ngFor="let val of displayData.earningHeads">
                            {{ getEarningHeadValue(month, val, 'newValue') }}
                          </td>
                          <!-- PAID values (oldValue) -->
                          <td *ngFor="let val of displayData.earningHeads">
                            {{ getEarningHeadValue(month, val, 'oldValue') }}
                          </td>
                          <!-- NET PAYABLE value (totalEarning for this month) -->
                          <td>{{ month.totalEarning }}</td>
                        </ng-container>

                        <!-- Deduction Heads columns (DUE, PAID, NET DEDUCTION) -->
                        <ng-container *ngIf="head.value == 'deductionHeads'">
                          <!-- DUE values (newValue) -->
                          <td *ngFor="let val of displayData.deductionHeads">
                            {{ getDeductionHeadValue(month, val, 'newValue') }}
                          </td>
                          <!-- PAID values (oldValue) -->
                          <td *ngFor="let val of displayData.deductionHeads">
                            {{ getDeductionHeadValue(month, val, 'oldValue') }}
                          </td>
                          <!-- NET DEDUCTION value (totalDeduction for this month) -->
                          <td>{{ month.totalDeduction }}</td>
                        </ng-container>

                        <!-- Employer Contribution Heads columns (standard single value) -->
                        <ng-container *ngIf="head.value == 'employerContributionHeads'">
                          <td *ngFor="let val of displayData.employerContributionHeads">
                            {{ getTableDataValueMonthly(val, head, month) }}
                          </td>
                        </ng-container>
                      </ng-container>
                    </tr>
                  </ng-container>
                    <tr>   
                      <td *ngIf="!displayData.monthlyDataShown">
                        {{ index + 1 }}
                       </td>  
                       <td *ngIf="displayData.monthlyDataShown"></td>   <!--sno-->
                      <ng-container *ngFor="let head of displayData.tableHead">
                        <!-- Normal columns -->
                        <ng-container *ngIf="!['deductionHeads', 'earningHeads', 'employerContributionHeads'].includes(head.value) && head.value != 'months'">
                          <td>
                            {{ getValue(head, item) }}
                          </td>
                        </ng-container>

                        <!-- Months column -->
                        <td *ngIf="head.value == 'months'"></td>

                        <!-- Earning Heads (Salary Contract, DUE, PAID, NET PAYABLE) -->
                        <ng-container *ngIf="head.value == 'earningHeads'">
                          <!-- Salary Contract values -->
                          <td *ngFor="let val of displayData.earningHeads">
                            {{ getTemplateEarningHeadTotalValue(item, val) }}
                          </td>
                          <!-- DUE values (newValue) -->
                          <td *ngFor="let val of displayData.earningHeads">
                            {{ getEarningHeadTotalValue(item, val, 'newValue') }}
                          </td>
                          <!-- PAID values (oldValue) -->
                          <td *ngFor="let val of displayData.earningHeads">
                            {{ getEarningHeadTotalValue(item, val, 'oldValue') }}
                          </td>
                          <!-- NET PAYABLE value (totalArrear.totalEarning) -->
                          <td>{{ item.totalArrear.totalEarning }}</td>
                        </ng-container>

                        <!-- Deduction Heads (DUE, PAID, NET DEDUCTION) -->
                        <ng-container *ngIf="head.value == 'deductionHeads'">
                          <!-- DUE values (newValue) -->
                          <td *ngFor="let val of displayData.deductionHeads">
                            {{ getDeductionHeadTotalValue(item, val, 'newValue') }}
                          </td>
                          <!-- PAID values (oldValue) -->
                          <td *ngFor="let val of displayData.deductionHeads">
                            {{ getDeductionHeadTotalValue(item, val, 'oldValue') }}
                          </td>
                          <!-- NET DEDUCTION value (totalArrear.totalDeduction) -->
                          <td>{{ item.totalArrear.totalDeduction }}</td>
                        </ng-container>

                        <!-- Employer Contribution Heads -->
                        <ng-container *ngIf="head.value == 'employerContributionHeads'">
                          <td *ngFor="let val of displayData.employerContributionHeads">
                            {{ getTableDataValue(val, head, item) }}
                          </td>
                        </ng-container>
                      </ng-container>
                    </tr>
                  </ng-container>
                  <ng-template #totalTd>
                    <td>{{index+1}}</td>
                    <ng-container *ngFor="let head of displayData.tableHead">
                      <!-- normal columns -->
                      <ng-container *ngIf="!['deductionHeads', 'earningHeads', 'employerContributionHeads'].includes(head.value) && head.value != 'months'">
                        <td>
                          {{ item[head.value] }}
                        </td>
                      </ng-container>

                      <!-- Months -->
                      <td *ngIf="head.value == 'months'"></td>

                      <!-- Earning Heads (Salary Contract, DUE, PAID, NET PAYABLE) -->
                      <ng-container *ngIf="head.value == 'earningHeads'">
                        <!-- Salary Contract values -->
                        <td *ngFor="let val of displayData.earningHeads">
                          {{ getTemplateEarningHeadTotalValue(item, val) }}
                        </td>
                        <!-- DUE values -->
                        <td *ngFor="let val of displayData.earningHeads">
                          {{ getEarningHeadTotalValue(item, val, 'newValue') }}
                        </td>
                        <!-- PAID values -->
                        <td *ngFor="let val of displayData.earningHeads">
                          {{ getEarningHeadTotalValue(item, val, 'oldValue') }}
                        </td>
                        <!-- NET PAYABLE value -->
                        <td>{{ item.totalArrear.totalEarning }}</td>
                      </ng-container>

                      <!-- Deduction Heads (DUE, PAID, NET DEDUCTION) -->
                      <ng-container *ngIf="head.value == 'deductionHeads'">
                        <!-- DUE values -->
                        <td *ngFor="let val of displayData.deductionHeads">
                          {{ getDeductionHeadTotalValue(item, val, 'newValue') }}
                        </td>
                        <!-- PAID values -->
                        <td *ngFor="let val of displayData.deductionHeads">
                          {{ getDeductionHeadTotalValue(item, val, 'oldValue') }}
                        </td>
                        <!-- NET DEDUCTION value -->
                        <td>{{ item.totalArrear.totalDeduction }}</td>
                      </ng-container>

                      <!-- Employer Contribution Heads -->
                      <ng-container *ngIf="head.value == 'employerContributionHeads'">
                        <td *ngFor="let val of displayData.employerContributionHeads">
                          {{ getTableDataValue(val, head, item) }}
                        </td>
                      </ng-container>
                    </ng-container>
                  </ng-template>
          </ng-container>
            <tr >
              <td>PREPARED By:-</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>CHECKED By:-</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>DIRECTOR/PRINCIPAL</td>
            </tr>  
            <tr >
              <td>CLEARK</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>ACCOUNTANT</td>
              <td></td>
              <td></td>
            </tr>  


        </tbody>
       
             </table>        
       
         </div>
       </div>
       
       
       
       </div>
       </div>
       
       </section>
    `,
    admitCardTemplate2:`

<style>
  .container {
      width: 800px;
      border: 1px solid #000;
      padding: 20px;
  }
  .header {
      text-align: center;
      margin-bottom: 20px;
  }
  .header img {
      height: 80px;
  }
  .photo {
      width: 120px;
      height: 140px;
      border: 1px solid #000;
  }
  .details {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
  }
  .details p {
      margin: 5px 0;
  }
  .barcode {
      text-align: center;
      margin: 10px 0;
  }
  .barcode img {
      width: 250px;
      height: 50px;
  }
  table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 20px;
  }
  th, td {
      border: 1px solid #000;
      padding: 8px;
      text-align: center;
  }
  .signature {
      text-align: right;
      margin-top: 30px;
  }
</style>

<ng-container *ngFor="let displayData of displayDataArray">
<div class="container">
    <div class="header">
      <img [src]="displayData.logo" alt="SGU Logo" />
      <h1>{{ displayData.entityDisplayName }}</h1>
      <p>{{ displayData.entityAddress }}</p>
      <p>Under the Aegis of {{ displayData.entityDisplayName }}</p>
      <h2>Admit Card, Session {{ displayData.session }}</h2>
    </div>
    <div class="details">
      <div>
        <p>
          <strong>University ID:</strong> {{ displayData.entityReceptionNumber }}
        </p>
        <p><strong>Name of Candidate:</strong> {{ displayData.name }}</p>
        <p><strong>Gender:</strong> {{ displayData.gender }}</p>
        <p><strong>Father’s Name:</strong> {{ displayData.fatherName }}</p>
        <p>
          <strong>Course:</strong> {{ displayData.examRegistrations[0].course }}
        </p>
        <p>
          <strong>Semester:</strong>{{ displayData.examRegistrations[0].stream }}
        </p>
        <p>
          <strong>Examination Center:</strong> {{ displayData.entityDisplayName }}
        </p>
      </div>
      <!-- <div>
              <img class="photo" src="profile.jpg" alt="Candidate Photo">
          </div> -->
    </div>
    <div class="barcode">
      <ngx-barcode 
      [bc-value]="displayData.barcodeValue" 
      [bc-format]="'CODE128'" 
      [bc-width]="2" 
      [bc-height]="50" 
      [bc-display-value]="true">
  </ngx-barcode>
    </div>
  
    <table
      *ngIf="
        displayData.examRegistrations && displayData.examRegistrations.length > 0
      "
    >
      <thead>
        <tr>
          <th>S.No</th>
          <th>Subject Code</th>
          <th>Subject Name</th>
          <th>Date of Examination</th>
          <th>Exam Shift</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of displayData.examRegistrations; let ind = index">
          <td>{{ ind + 1 }}</td>
          <td>{{ item.subjectCode }}</td>
          <td>{{ item.subjectName }}</td>
          <td *ngIf="item.examDate; else emptyTd">
            {{ item.examDate | date : 'dd/MMM/yyyy' }}
          </td>
          <td *ngIf="item.shiftName; else emptyTd">
            {{ item.shiftName }}
          </td>
        </tr>
      </tbody>
    </table>
    <div class="signature">
      <p><strong>Principal</strong></p>
    </div>
  </div>
</ng-container>
<ng-template #emptyTd>
  <td></td>
</ng-template>

    `,
    libraryReceiptTemp1 : `
    <div class="card container-fluid p4Rem" *ngFor="let displayData of displayDataArray">
  <div class="row">
    <div class="col-2">
      <img class="hW100px" [src]="displayData?.logo" alt="Logo" />
    </div>
    <div class="col-7 textCenter">
      <h3>{{displayData?.entityDisplayName || 'School Name'}}</h3>
      <p>
        {{displayData?.entityAddress}}, {{displayData?.entityCity}},
        {{displayData?.entityState}}, {{displayData?.entityPin}}
      </p>
      <p>
        {{displayData?.entityReceptionNumber}},
        {{displayData?.entityContactEmail}}
      </p>
    </div>
    <div class="col-3 textEnd">
      <h4>Parent Copy</h4>
      <h3 class="pt30">Library Receipt</h3>
    </div>
  </div>

  <!-- Student Details -->
  <div class="row m0">
    <div class="col-8 borderSolid">
      <div class="row">
        <div class="col-12 textCenter borderBottom">
          <mat-label>Student Details</mat-label>
        </div>
        <div class="card-body row">
          <div class="col-6">
            <div class="row">
              {{displayData?.displayNamesRegNo}} :
              {{displayData?.receiverId || 'N/A'}}
            </div>
            <div class="row">
              Receiver's Name : {{displayData?.receiverName || 'N/A'}}
            </div>
            <div class="row">
              Receiver's Id : {{displayData?.receiverId || 'N/A'}}
            </div>
          </div>
          <div class="col-6">
            <div class="row">
              {{displayData?.displayNamesCourse}} :
              {{displayData?.receiverCode || 'N/A'}}
            </div>
            <div class="row">Section : N/A</div>
            <div class="row">Stream : N/A</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Payment Details -->
    <div class="col-4 borderSolid">
      <div class="row">
        <div class="col-12 textCenter borderBottom">
          <mat-label>Payment Details</mat-label>
        </div>
        <div class="card-body row">
          <div class="col-12">
            <div class="row">
              <div class="col-6">Receipt No</div>
              <div class="col-2">:</div>
              <div class="col-4 textEnd">{{displayData?.receiptId}}</div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-6">Receipt Date</div>
              <div class="col-2">:</div>
              <div class="col-4 textEnd">
                {{displayData?.date | date: 'dd/MM/yyyy'}}
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-6">Academic Year</div>
              <div class="col-2">:</div>
              <div class="col-4 textEnd">{{displayData?.session || 'N/A'}}</div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-6">Total Paid Amount</div>
              <div class="col-2">:</div>
              <div class="col-4 textEnd">
                {{displayData?.totalPaidAmount | number : '1.2-2'}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Payment Mode & Totals -->
  <div class="row mt-3">
    <div class="col-6 textEnd">Total Invoice</div>
    <div class="col-4 textEnd">
      {{displayData?.totalPaybleAmount | number : '1.2-2'}}
    </div>
  </div>
  <div class="row">
    <div class="col-6 textEnd">Net Paid Amount</div>
    <div class="col-4 textEnd">
      {{displayData?.totalPaidAmount | number : '1.2-2'}}
    </div>
  </div>
  <div class="row">
    <div class="col-6 textEnd">Balance Due</div>
    <div class="col-4 textEnd">
      {{
        (displayData?.totalPaybleAmount - displayData?.totalPaidAmount)
          | number : '1.2-2'
      }}
    </div>
  </div>

  <!-- Payment Method -->
  <div class="row mt-3">
    <div class="col-3 borderSolid textCenter">
      <mat-label>Payment Mode</mat-label>
      <div>{{displayData?.paymentMode}}</div>
    </div>
    <div class="col-3 borderSolid textCenter" *ngIf="!displayData?.cash">
      <mat-label>Bank Name</mat-label>
      <div>{{displayData?.bankAccount}}</div>
    </div>
    <div class="col-3 borderSolid textCenter">
      <mat-label>Net Paid Amount</mat-label>
      <div>{{displayData?.totalPaidAmount | number : '1.2-2'}}</div>
    </div>
  </div>

  <!-- Footer -->
  <div class="row justifyFlexEnd mt-4">
    <div>
      <label>Fees Clerk/Accountant</label>
    </div>
  </div>
</div>
`,
    lessonPlanTemplate:`
    
    <style>
    .container {
      font-family: Arial, sans-serif;
      font-size: 13px;
      margin: 30px;
    }

    .header {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      margin-bottom: 20px;
   }
   .header img {
         height: 80px;
         margin-right: 10px;
   }

    table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 15px;
    }

    table, th, td {
      border: 1px solid black;
    }

    th, td {
      padding: 6px;
      vertical-align: middle;
      text-align: center;
    }

    .nowrap {
      white-space: nowrap;
    }
  </style>

  <div class="container">
  <div class="header">
    <img [src]="displayData.logo" alt="Entity Logo" />
    <h1>{{ displayData.entityDisplayName }}</h1>
  </div>

  <table>
    <tr>
      <td><strong>Program Name:</strong></td>
      <td>{{ displayData.course }}</td>
      <td><strong>AY:</strong></td>
      <td>{{ displayData.session }} </td>
    </tr>
    <tr>
      <td><strong>Course Name:</strong></td>
      <td>{{ displayData.course }}</td>
      <td><strong>Year/Sem:</strong></td>
      <td>{{ displayData.batch }}</td>
    </tr>
    <tr>
      <td><strong>Faculty Name:</strong></td>
      <td>{{ displayData.teacher }}</td>
      <td><strong>Course Code:</strong></td>
      <td>{{ displayData.subject }}</td>
    </tr>
  </table>

  <table>
    <thead>
      <tr>
        <th>Unit</th>
        <th>Lecture No</th>
        <th>Topic</th>
        <th>Book / Web Reference</th>
        <th>Date of Lecture</th>
        <th>Teaching Method(s)</th>
      </tr>
    </thead>
   
    <tbody>
  <tr *ngFor="let topic of displayData.topics">
    <td>{{ topic.sequence }}</td>
    <td>{{ topic.lecture }}</td>
    <td>{{ topic.name }}</td>
    <td>{{ topic.reference }}</td>
    <td>
      {{ topic.startDate | date: 'dd/MM/yy' }}
      <ng-container *ngIf="topic.endDate"> & <br>
      {{ topic.endDate | date: 'dd/MM/yy' }}
      </ng-container>
    </td>
    <td>{{ topic.teachingMethod }}</td>
  </tr>
</tbody>

  </table>
</div>
    `,
    assessmentWiseTemplate:`
      <div class="container-fluid">
      <div class="row textCenter">
            <div class="col-12 textCenter">
                <h3>{{displayData.entityDisplayName}}</h3>
                <p>Assessment Wise Report( {{displayData.session}} ) </p>
            </div>
<div class="col-12 textCenter">
                <p>
                    <span> {{displayData.course}} - {{displayData.stream}} - </span>
                    <span> {{displayData.batch}} - </span>
                    <span> {{displayData.section}}</span>
                </p>
                <p> {{displayData.assessmentName}}</p>
            </div>
        </div>
<table class="table table-bordered">
            <thead>
                <tr>
                    <th>
                        S.NO
                    </th>
                    <th>
                        {{displayData.displayNamesRegNo}}
                    </th>
                    <th>
                        {{displayData.displayNamesRollNo}}
                    </th>
                    <th>
                        Student Name
                    </th>

                    <th *ngFor="let item of displayData.tableHead">
                        <strong *ngIf="item.value !='total'">
                            {{item.name.toUpperCase()}}
                        </strong>
                        <strong
                            *ngIf="item.value=='total' && displayData.selectedMarksType =='obtainedMarks'">{{item.name.toUpperCase()}}
                        </strong>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of displayData.assessmentWiseData; let i = index">
                    <td>
                        {{i+1}}
                    </td>
                    <td>
                        {{item.studentRegNo}}
                    </td>
                    <td>
                        {{item.studentRollNo}}
                    </td>
                    <td>
                        {{item.studentName}}
                    </td>
                    <td *ngFor="let abc of displayData.tableHead">
                        <span
                            *ngIf="displayData.selectedMarksType=='obtainedMarks' && abc.value!='total'">{{ item[abc.value + 'marks'] }}</span>
                        <span *ngIf="displayData.selectedMarksType=='grade' && abc.value!='total'">{{ item[abc.value + 'grade'] }}</span>
                        <span
                            *ngIf="displayData.selectedMarksType=='gradeRemark' && abc.value!='total'">{{ item[abc.value + 'gradeRemark'] }}</span>
                        <span
                            *ngIf="abc.value=='total' && displayData.selectedMarksType =='obtainedMarks'">{{ item[abc.value] }}</span>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="row pt30">
            <div class="col-4">
                Authorised Signature
            </div>
            <div class="col-3 offset-5">
                Principal's Signature
            </div>

        </div>
      </div>
    `,
    greenSheetTemplate:`
   <table class="table textCenter verticalMiddle">
        <thead class="buttonTheme">
          <tr>
            <th style="font-weight: 700;" rowspan="2" class="textHorizontal" > <p>S No.</p>  </th>
            <th style="font-weight: 700;"  rowspan="2" class="textHorizontal" > <p> Student Name</p></th>
            <th style="font-weight: 700;"  rowspan="2" class="textHorizontal" ><p>{{displayData.displayNames.regNo}}</p> </th>
            <th style="font-weight: 700;"  rowspan="2" class="textHorizontal" > <p>{{displayData.displayNames.rollNo}}.</p></th>
            <th *ngIf="displayData.showCategory && (displayData.entityType=='college'  || displayData.entityType === 'university' || displayData.entityType === 'degreeCollege' || displayData.entityType === 'academy')" style="font-weight: 700;"  rowspan="2" class="textHorizontal"><p>Social Category</p></th>
            <ng-container *ngFor="let subject of displayData.tableHeads" >
                <th style="font-weight: 700; border-bottom: 1px solid black;  "  *ngIf="displayData.hideTotal && displayData.displayGrade"  [attr.colspan]="subject.subHeads.length+1"> {{subject.displayName}} <span *ngIf="displayData.displaySubjectCode">({{subject.code}})</span> </th>
                <th style="font-weight: 700; border-bottom: 1px solid black; ; "   *ngIf="displayData.hideTotal && !displayData.displayGrade  "  [attr.colspan]="subject.subHeads.length"> {{subject.displayName}} <span *ngIf="displayData.displaySubjectCode">({{subject.code}})</span></th>
                <th style="font-weight: 700; border-bottom: 1px solid black; "   *ngIf="!displayData.hideTotal && displayData.displayGrade"  [attr.colspan]="subject.subHeads.length+2"> {{subject.displayName}} <span *ngIf="displayData.displaySubjectCode">({{subject.code}})</span></th>
                <th style="font-weight: 700; border-bottom: 1px solid black; "   *ngIf="!displayData.hideTotal && !displayData.displayGrade"  [attr.colspan]="subject.subHeads.length+1"> {{subject.displayName}} <span *ngIf="displayData.displaySubjectCode">({{subject.code}})</span></th>
                <!-- <th rowspan="2"></th> -->
            </ng-container>
            <!-- <th rowspan="1"></th> -->
            <th style="font-weight: 700;" class="textHorizontal" rowspan="2" *ngIf="displayData.selectedMarksType!='grade'"><p>Total</p>  </th>
            <th style="font-weight: 700;" class="textHorizontal" rowspan="2" *ngIf="displayData.selectedMarksType!='grade'"><p>Percentage</p>  </th>
            <th style="font-weight: 700;" class="textHorizontal" rowspan="2" ><p>Grade</p>  </th>
            <th style="font-weight: 700;" class="textHorizontal" rowspan="2" *ngIf="displayData.showRemarkReport" >Present Days</th>
            <th style="font-weight: 700;" class="textHorizontal" rowspan="2" *ngIf="displayData.showRemarkReport" > WorkingDays </th>
            <th style="font-weight: 700;" class="textHorizontal" rowspan="2" *ngIf="displayData.showRemarkReportPercentage" > Attendance Percentage </th>
            <th style="font-weight: 700;" class="textHorizontal" rowspan="2" *ngIf="displayData.showRemarkReport" > Remark</th>
            <th style="font-weight: 700;" class="textHorizontal" rowspan="2" *ngIf="displayData.showRemarkReport" >Result</th>
          </tr>
          <tr *ngIf="displayData.selectedMarksType == 'weightage'">
                <ng-container *ngFor="let subject of displayData.tableHeads"  >
                  <th style="font-weight: 700; " class="textHorizontal"  *ngFor="let assmnt of subject.subHeads"> <p>{{assmnt.displayName}}</p> 
                    <!--<span *ngIf="!assmnt.isFormula">({{assmnt.totalWeightage}})</span> --></th>
                  <th style="font-weight: 700; " class="textHorizontal" [hidden]="displayData.hideTotal" ><p>Total</p>  </th>
                  <th style="font-weight: 700; " class="textHorizontal" *ngIf="displayData.displayGrade"  ><p>Grade</p></th>
                </ng-container>
          </tr>
          <tr *ngIf="displayData.selectedMarksType == 'marks'">
            <ng-container *ngFor="let subject of displayData.tableHeads"  >
              <th style="font-weight: 700;"  class="textHorizontal" *ngFor="let assmnt of subject.subHeads"> <p>{{assmnt.displayName}}</p>  <!--<span *ngIf="!assmnt.isFormula">({{assmnt.totalMarks}})</span> --></th> <!-- width: 0px;  writing-mode: vertical-lr;text-orientation: upright; border-right: 3px solid; border-left: 3px solid;-->
              <th style="font-weight: 700; " class="textHorizontal" [hidden]="displayData.hideTotal" ><p>Total</p>  </th>
              <th style="font-weight: 700; " class="textHorizontal"   *ngIf="displayData.displayGrade" ><p>Grade</p>  </th>
            </ng-container>
      </tr>
      <tr *ngIf="displayData.selectedMarksType == 'grade'">
        <ng-container *ngFor="let subject of displayData.tableHeads"  >
          <th style="font-weight: 700; " class="textHorizontal"  *ngFor="let assmnt of subject.subHeads"> <p>{{assmnt.displayName}}</p> </th>
          <th style="font-weight: 700; " class="textHorizontal"  [hidden]="displayData.hideTotal" ><p></p>  </th>
          <th style="font-weight: 700;" class="textHorizontal" *ngIf="displayData.displayGrade" ><p>Grade</p>  </th>
        </ng-container>
  </tr>
          
        </thead>
        <tbody class="verticalMiddle">               
            <tr *ngFor="let row of displayData.greenSheetData  let i = index">
                <td>
                    {{i+1}}
                </td>
                <td>
                    {{row.studentName}}
                </td>
                <td>
                    {{row.studentRegNo}}
                </td>
                <td>
                    {{row.studentRollNo}}
                </td>
                <td *ngIf="displayData.showCategory && displayData.entityType=='college'  || displayData.entityType === 'university' || displayData.entityType === 'degreeCollege' || displayData.entityType === 'academy'">
                    {{row.socialCategory}}
                </td>
                <ng-container *ngFor="let subject of displayData.tableHeads">
                  <td *ngFor="let item of subject.subHeads">
                    <ng-container *ngFor="let studentSub of row.subjects">
                        <span *ngIf="studentSub.code == subject.code && studentSub.name == subject.name && studentSub[item.name] &&studentSub[item.name].attendance =='present' && displayData.selectedMarksType =='marks'">
                            {{studentSub[item.name] ? showValue(studentSub[item.name].obtainedMarks) : 0}} 
                        </span>
                        <span *ngIf="studentSub.code == subject.code && studentSub.name == subject.name && studentSub[item.name] &&studentSub[item.name].attendance =='present' && displayData.selectedMarksType =='grade'">
                            {{studentSub[item.name] ? studentSub[item.name].grade : ''}} 
                        </span>
                        <span *ngIf="studentSub.code == subject.code && studentSub.name == subject.name && studentSub[item.name] &&studentSub[item.name].attendance =='present' && displayData.selectedMarksType =='weightage'">
                            {{studentSub[item.name] ? showValue(studentSub[item.name].weightageMarks) : 0}} 
                        </span>
                        <span *ngIf="studentSub.code == subject.code && studentSub.name == subject.name && studentSub[item.name] &&studentSub[item.name].attendance !='present'">
                            Ab <span *ngIf="studentSub[item.name].attendance =='excludeAbsent'"> - E </span>
                        </span>

                    </ng-container>
                </td>

                    <td *ngIf="displayData.selectedMarksType == 'marks' && !displayData.hideTotal">
                        <ng-container *ngFor="let studentSub of row.subjects">
                            <span *ngIf="studentSub.code == subject.code && studentSub.name == subject.name">
                                {{showValue(studentSub.total)}}
                            </span>
                        </ng-container>
                    </td>
                    <td  *ngIf="displayData.selectedMarksType =='weightage' && !displayData.hideTotal">
                        <ng-container *ngFor="let studentSub of row.subjects">
                            <span *ngIf="studentSub.code == subject.code && studentSub.name == subject.name">
                                {{showValue(studentSub.totalWeightage)}}
                            </span>
                        </ng-container>
                    </td>
                    <td  *ngIf="displayData.displayGrade" >
                        <ng-container *ngFor="let studentSub of row.subjects">
                            <span *ngIf="studentSub.code == subject.code && studentSub.name == subject.name && displayData.selectedMarksType =='marks'">
                                {{studentSub.totalGrade}}
                            </span>
                            <span *ngIf="studentSub.code == subject.code && studentSub.name == subject.name && displayData.selectedMarksType =='weightage'">
                                {{studentSub.weightageGrade}} 
                            </span>
                            <span *ngIf="studentSub.code == subject.code && studentSub.name == subject.name && displayData.selectedMarksType =='grade'">
                                {{studentSub.totalGrade}}
                            </span>
                        </ng-container>

                    </td>

                <!-- <td></td> -->
                </ng-container>

                    <td *ngIf="displayData.selectedMarksType == 'marks'" > 
                        {{showValue(row.total)}}/{{row.totalMarks}}
                    </td>
                    <td *ngIf="displayData.selectedMarksType == 'weightage'" >         
                        {{showValue(row.totalWeightage)}}/{{row.weightage}}
                    </td>
                    <td *ngIf="displayData.selectedMarksType == 'marks'">
                        {{showValue(row.percentage)}}
                    </td>
                    <td *ngIf="displayData.selectedMarksType == 'weightage'">
                        {{showValue(row.weightagePercentage)}}
                    </td>


                    <td *ngIf="displayData.selectedMarksType =='marks'|| displayData.selectedMarksType =='grade'">
                        {{row.grade}}
                    </td>
                    <td *ngIf="displayData.selectedMarksType =='weightage'">
                        {{row.weightageGrade}}
                    </td>
                    <td *ngIf="displayData.showRemarkReport">{{getDataOfAcademicResult( row,'presentDays')}}</td>
                    <td *ngIf="displayData.showRemarkReport">{{getDataOfAcademicResult(row,'workingDays')}}</td>
                    <td *ngIf="displayData.showRemarkReportPercentage">{{getDataOfAcademicResult(row,'attendancePercentage')}}</td>
                    <td *ngIf="displayData.showRemarkReport">{{getDataOfAcademicResult(row,'remark')}}</td>
                    <td *ngIf="displayData.showRemarkReport">{{getDataOfAcademicResult(row,'result')}}</td>
            </tr>               
        </tbody>

    </table>
    `,
    attendanceSummaryTemplate:`
      <div class="container-fluid">
         <div class="row textCenter">
            <div class="col-12 textCenter">
                  <h3>{{displayData.entityName}}</h3>
                  <p>Attendance Summary from {{displayData.startDate | date: 'dd/MMM/yyyy' }} to {{displayData.endDate | date:
                     'dd/MMM/yyyy'}} </p>
            </div>
            <div class="col-12 textCenter">
                  <p>
                     <span>Class: </span>
                     <span> {{displayData.course}} - {{displayData.stream}} - </span>
                     <span> {{displayData.batch}} - </span>
                     <span> {{displayData.section}}</span>
                  </p>
                  <p>
                     <span>Subject:</span>
                     <span>{{displayData.subject}}</span>
                  </p>
            </div>
         </div>
         <table class="table table-bordered">
            <thead>
                  <tr>
                     <th> S.NO </th>
                     <th> {{displayData.displayNamesRegNo}} </th>
                     <th> Student Name </th>
                     <th> Father Name</th>
                     <th> Total Days </th>
                     <th> Total Working </th>
                     <th *ngFor="let val of displayData.tableHead">{{val.name}}</th>
                     <th> Total Holiday</th>
                     <th> Total Not Marked </th>
                     <th> Percentage </th>
                  </tr>
            </thead>
            <tbody>
                  <tr *ngFor="let item of displayData.attendanceSummaryData; let i = index">
                     <td> {{i+1}} </td>
                     <td> {{item.regNo}}</td>
                     <td> {{item.name}} </td>
                     <td> {{item.fatherName}} </td>
                     <td> {{item.totalDays}} </td>
                     <td> {{item.totalWorking}} </td>
                     <td *ngFor="let abc of displayData.tableHead"> {{item[abc.value]}}</td>
                     <td> {{item.totalHoliday}}</td>
                     <td> {{item.totalNotMarked}} </td>
                     <td> {{item.percentage}} </td>
                  </tr>
            </tbody>
         </table>
         <div class="row pt30">
            <div class="col-4">
                  Authorised Signature
            </div>
            <div class="col-3 offset-5">
                  Principal's Signature
            </div>

         </div>
      </div>
    `,
    universityGreenSheetTemplate:`
 <table class="table textCenter verticalMiddle">
        <thead class="buttonTheme">
          <tr>
            <th style="font-weight: 700;" rowspan="2" class="textHorizontal" > <p>S No.</p>  </th>
            <th style="font-weight: 700;"  rowspan="2" class="textHorizontal" > <p> Student Name</p></th>
            <th style="font-weight: 700;"  rowspan="2" class="textHorizontal" ><p>{{displayData.displayNames.regNo}}</p> </th>
            <th style="font-weight: 700;"  rowspan="2" class="textHorizontal" > <p>{{displayData.displayNames.rollNo}}.</p></th>

            <ng-container *ngFor="let subject of displayData.tableHeads" >
                <th style="font-weight: 700; border-bottom: 1px solid black;  "  *ngIf="displayData.hideTotal && displayData.displayGrade"  [attr.colspan]="subject.subHeads.length+2"> {{subject.displayName}} <span *ngIf="displayData.displaySubjectCode">({{subject.code}})</span> </th>
                <th style="font-weight: 700; border-bottom: 1px solid black; ; "   *ngIf="displayData.hideTotal && !displayData.displayGrade  "  [attr.colspan]="subject.subHeads.length"> {{subject.displayName}} <span *ngIf="displayData.displaySubjectCode">({{subject.code}})</span></th>
                <th style="font-weight: 700; border-bottom: 1px solid black; "   *ngIf="!displayData.hideTotal && displayData.displayGrade"  [attr.colspan]="subject.subHeads.length+3"> {{subject.displayName}} <span *ngIf="displayData.displaySubjectCode">({{subject.code}})</span></th>
                <th style="font-weight: 700; border-bottom: 1px solid black; "   *ngIf="!displayData.hideTotal && !displayData.displayGrade"  [attr.colspan]="subject.subHeads.length+1"> {{subject.displayName}} <span *ngIf="displayData.displaySubjectCode">({{subject.code}})</span></th>
                <!-- <th rowspan="2"></th> -->
                 <th rowspan="2"></th>
            </ng-container>
            <!-- <th rowspan="1"></th> -->
            <th style="font-weight: 700;" class="textHorizontal" rowspan="2" *ngIf="displayData.selectedMarksType!='grade'"><p>Total</p>  </th>
            <th style="font-weight: 700;" class="textHorizontal" rowspan="2" *ngIf="displayData.selectedMarksType!='grade'"><p>Percentage</p>  </th>
            <th style="font-weight: 700;" class="textHorizontal" rowspan="2" ><p>Grade</p>  </th>
                        <th style="font-weight: 700;" class="textHorizontal" rowspan="2">SGPA </th>
            <th style="font-weight: 700;" class="textHorizontal" rowspan="2" *ngIf="displayData.showRemarkReport" >Present Days</th>
            <th style="font-weight: 700;" class="textHorizontal" rowspan="2" *ngIf="displayData.showRemarkReport" > WorkingDays </th>
            <th style="font-weight: 700;" class="textHorizontal" rowspan="2" *ngIf="displayData.showRemarkReport" > Remark</th>
            <th style="font-weight: 700;" class="textHorizontal" rowspan="2" *ngIf="displayData.showRemarkReport" >Result</th>
          </tr>
          <tr *ngIf="displayData.selectedMarksType == 'weightage'">
                <ng-container *ngFor="let subject of displayData.tableHeads"  >
                  <th style="font-weight: 700; " class="textHorizontal"  *ngFor="let assmnt of subject.subHeads"> <p>{{assmnt.displayName}}</p> 
                    <!--<span *ngIf="!assmnt.isFormula">({{assmnt.totalWeightage}})</span> --></th>
                  <th style="font-weight: 700; " class="textHorizontal" [hidden]="displayData.hideTotal" ><p>Total</p>  </th>
                  <th style="font-weight: 700; " class="textHorizontal" *ngIf="displayData.displayGrade"  ><p>Grade</p></th>
                                    <th  *ngIf="displayGrade" style="font-weight: 700; " class="textHorizontal">Grade Score</th>
                </ng-container>
          </tr>
          <tr *ngIf="displayData.selectedMarksType == 'marks'">
            <ng-container *ngFor="let subject of displayData.tableHeads"  >
              <th style="font-weight: 700;"  class="textHorizontal" *ngFor="let assmnt of subject.subHeads"> <p>{{assmnt.displayName}}</p>  <!--<span *ngIf="!assmnt.isFormula">({{assmnt.totalMarks}})</span> --></th> <!-- width: 0px;  writing-mode: vertical-lr;text-orientation: upright; border-right: 3px solid; border-left: 3px solid;-->
              <th style="font-weight: 700; " class="textHorizontal" [hidden]="displayData.hideTotal" ><p>Total</p>  </th>
              <th style="font-weight: 700; " class="textHorizontal"   *ngIf="displayData.displayGrade" ><p>Grade</p>  </th>
                            <th  *ngIf="displayGrade" style="font-weight: 700; " class="textHorizontal">Grade Score</th>
            </ng-container>
      </tr>
      <tr *ngIf="displayData.selectedMarksType == 'grade'">
        <ng-container *ngFor="let subject of displayData.tableHeads"  >
          <th style="font-weight: 700; " class="textHorizontal"  *ngFor="let assmnt of subject.subHeads"> <p>{{assmnt.displayName}}</p> </th>
          <th style="font-weight: 700; " class="textHorizontal"  [hidden]="displayData.hideTotal" ><p></p>  </th>
          <th style="font-weight: 700;" class="textHorizontal" *ngIf="displayData.displayGrade" ><p>Grade</p>  </th>
                    <th  *ngIf="displayGrade" style="font-weight: 700; " class="textHorizontal">Grade Score</th>
        </ng-container>
  </tr>
          
        </thead>
        <tbody class="verticalMiddle">               
            <tr *ngFor="let row of displayData.greenSheetData  let i = index">
                <td>
                    {{i+1}}
                </td>
                <td>
                    {{row.studentName}}
                </td>
                <td>
                    {{row.studentRegNo}}
                </td>
                <td>
                    {{row.studentRollNo}}
                </td>

                <ng-container *ngFor="let subject of displayData.tableHeads">
                  <td *ngFor="let item of subject.subHeads">
                    <ng-container *ngFor="let studentSub of row.subjects">
                        <span *ngIf="studentSub.code == subject.code && studentSub.name == subject.name && studentSub[item.name] &&studentSub[item.name].attendance =='present' && displayData.selectedMarksType =='marks'">
                            {{studentSub[item.name] ? showValue(studentSub[item.name].obtainedMarks) : 0}} 
                        </span>
                        <span *ngIf="studentSub.code == subject.code && studentSub.name == subject.name && studentSub[item.name] &&studentSub[item.name].attendance =='present' && displayData.selectedMarksType =='grade'">
                            {{studentSub[item.name] ? studentSub[item.name].grade : ''}} 
                        </span>
                        <span *ngIf="studentSub.code == subject.code && studentSub.name == subject.name && studentSub[item.name] &&studentSub[item.name].attendance =='present' && displayData.selectedMarksType =='weightage'">
                            {{studentSub[item.name] ? showValue(studentSub[item.name].weightageMarks) : 0}} 
                        </span>
                        <span *ngIf="studentSub.code == subject.code && studentSub.name == subject.name && studentSub[item.name] &&studentSub[item.name].attendance !='present'">
                            Ab <span *ngIf="studentSub[item.name].attendance =='excludeAbsent'"> - E </span>
                        </span>

                    </ng-container>
                </td>

                    <td *ngIf="displayData.selectedMarksType == 'marks' && !displayData.hideTotal">
                        <ng-container *ngFor="let studentSub of row.subjects">
                            <span *ngIf="studentSub.code == subject.code && studentSub.name == subject.name">
                                {{showValue(studentSub.total)}}
                            </span>
                        </ng-container>
                    </td>
                    <td  *ngIf="displayData.selectedMarksType =='weightage' && !displayData.hideTotal">
                        <ng-container *ngFor="let studentSub of row.subjects">
                            <span *ngIf="studentSub.code == subject.code && studentSub.name == subject.name">
                                {{showValue(studentSub.totalWeightage)}}
                            </span>
                        </ng-container>
                    </td>
                    <td  *ngIf="displayData.displayGrade" >
                        <ng-container *ngFor="let studentSub of row.subjects">
                            <span *ngIf="studentSub.code == subject.code && studentSub.name == subject.name && displayData.selectedMarksType =='marks'">
                                {{studentSub.totalGrade}}
                            </span>
                            <span *ngIf="studentSub.code == subject.code && studentSub.name == subject.name && displayData.selectedMarksType =='weightage'">
                                {{studentSub.weightageGrade}} 
                            </span>
                            <span *ngIf="studentSub.code == subject.code && studentSub.name == subject.name && displayData.selectedMarksType =='grade'">
                                {{studentSub.totalGrade}}
                            </span>
                        </ng-container>

                    </td>
                    <ng-container *ngIf="displayData.displayGrade"> 
                        <td>
                            <ng-container *ngFor="let studentSub of row.subjects">
                                <span *ngIf="studentSub.code == subject.code && studentSub.name == subject.name">
                                    {{studentSub.totalGradeScore}}
                                </span>            
                            </ng-container>
                        </td>
                    </ng-container>
                <td></td>
                </ng-container>

                    <td *ngIf="displayData.selectedMarksType == 'marks'" > 
                        {{showValue(row.total)}}/{{row.totalMarks}}
                    </td>
                    <td *ngIf="displayData.selectedMarksType == 'weightage'" >         
                        {{showValue(row.totalWeightage)}}/{{row.weightage}}
                    </td>
                    <td *ngIf="displayData.selectedMarksType == 'marks'">
                        {{showValue(row.percentage)}}
                    </td>
                    <td *ngIf="displayData.selectedMarksType == 'weightage'">
                        {{showValue(row.weightagePercentage)}}
                    </td>


                    <td *ngIf="displayData.selectedMarksType =='marks'|| displayData.selectedMarksType =='grade'">
                        {{row.grade}}
                    </td>
                    <td *ngIf="displayData.selectedMarksType =='weightage'">
                        {{row.weightageGrade}}
                    </td>
                    <td >
                        {{row.sgpa}}
                    </td>
                    <td *ngIf="displayData.showRemarkReport">{{getDataOfAcademicResult( row,'presentDays')}}</td>
                    <td *ngIf="displayData.showRemarkReport">{{getDataOfAcademicResult(row,'workingDays')}}</td>

                    <td *ngIf="displayData.showRemarkReport">{{getDataOfAcademicResult(row,'remark')}}</td>
                    <td *ngIf="displayData.showRemarkReport">{{getDataOfAcademicResult(row,'result')}}</td>
            </tr>               
        </tbody>

    </table>`,
    departmentTeacherLectureReportTemplate:`
      <div class="bgColorWhite tablePrint scrollbar bRadius10P" id="tablePrint">
         <div class="p-2">
            <div class="report-header-section textCenter mb-3">
               <h3 class="entity-title">{{ displayData.entityName }}</h3>
               <h4 class="report-title">Department Teacher Lecture Report</h4>
               <p class="report-meta">
                  <strong>Department:</strong> {{ displayData.department }} &nbsp;|&nbsp;
                  <strong>Date:</strong> {{ displayData.selectedDate | date: 'dd-MM-yyyy' }} &nbsp;|&nbsp;
                  <strong>Session:</strong> {{ displayData.session }}
               </p>
            </div>

            <table *ngIf="displayData.faculty" class="table textCenter verticalMiddle report-table" [ngClass]="displayData.scaleClass">
               <thead>
                  <tr>
                     <th class="srno-th">SR.NO</th>
                     <th class="faculty-th">FACULTY NAME</th>
                     <th *ngFor="let lecKey of displayData.lectureKeys" class="lecture-th">
                        {{ lecKey.header }}
                     </th>
                     <th class="summary-th">TAKEN</th>
                     <th class="summary-th">NOT TAKEN</th>
                     <th class="summary-th">TOTAL</th>
                  </tr>
               </thead>
               <tbody>
                  <tr *ngFor="let fac of displayData.faculty; let i = index">
                     <td class="text-center align-middle srno-cell">{{ i + 1 }}</td>
                     <td class="align-middle text-left faculty-name-cell">
                        <div class="fac-name"><strong>{{ fac.employeeName }}</strong></div>
                        <small class="fac-id text-muted" *ngIf="fac.employeeId">({{ fac.employeeId }})</small>
                     </td>
                     <td *ngFor="let lecKey of displayData.lectureKeys" class="lecture-cell align-top text-left">
                        <ng-container *ngIf="fac.lectures && fac.lectures[lecKey.key]">
                           <div *ngIf="fac.lectures[lecKey.key].status === 'Taken'"
                              class="taken-box position-relative bRadius5P"
                              [class.has-lm]="fac.lectures[lecKey.key].isLateMarked">
                              <span *ngIf="fac.lectures[lecKey.key].isLateMarked" class="late-marked-label" title="Attendance marked more than 10 minutes after lecture end time"><strong>LM</strong></span>
                              <div class="status-badge"><strong>✓ TAKEN</strong></div>
                              <div *ngIf="fac.lectures[lecKey.key].semester || fac.lectures[lecKey.key].stream || fac.lectures[lecKey.key].streamName" class="cell-detail">{{ fac.lectures[lecKey.key].semester || fac.lectures[lecKey.key].stream || fac.lectures[lecKey.key].streamName }}</div>
                              <div class="cell-detail">Sem: {{ fac.lectures[lecKey.key].batch }}<ng-container *ngIf="fac.lectures[lecKey.key].section || fac.lectures[lecKey.key].sectionName"> - {{ fac.lectures[lecKey.key].section || fac.lectures[lecKey.key].sectionName }}</ng-container></div>
                              <div class="cell-detail subject-line">Sub: {{ fac.lectures[lecKey.key].subjectCode }}</div>
                              <div class="cell-detail">Strength: {{ fac.lectures[lecKey.key].classStrength && fac.lectures[lecKey.key].classStrength.present }}/{{ fac.lectures[lecKey.key].classStrength && fac.lectures[lecKey.key].classStrength.total }}</div>
                              <div class="cell-detail">Time: {{ fac.lectures[lecKey.key].attendanceMarkedAt | date:'HH:mm:ss' }}</div>
                           </div>
                           <div *ngIf="fac.lectures[lecKey.key].status && fac.lectures[lecKey.key].status !== 'Taken'" class="not-taken-box position-relative bg-red bRadius5P colorWhite">
                              <div class="status-badge"><strong>X NOT TAKEN</strong></div>
                              <div class="small-text">(Scheduled)</div>
                           </div>
                        </ng-container>
                        <span *ngIf="!(fac.lectures && fac.lectures[lecKey.key])" class="empty-dash text-muted">-</span>
                     </td>
                     <td class="text-center align-middle summary-cell"><strong>{{ fac.summary?.totalLecturesTaken || 0 }}</strong></td>
                     <td class="text-center align-middle summary-cell"><strong>{{ fac.summary?.totalLecturesNotTaken || 0 }}</strong></td>
                     <td class="text-center align-middle summary-cell"><strong>{{ fac.summary?.totalLecturesScheduled || 0 }}</strong></td>
                  </tr>
               </tbody>
            </table>

            <div *ngIf="displayData.summary" class="dept-summary-wrapper mt-4">
               <h5 class="summary-title text-uppercase font-weight-bold text-left mb-2">
                  OVERALL DEPARTMENT SUMMARY
               </h5>
               <table class="table textCenter verticalMiddle report-table summary-table">
                  <thead>
                     <tr>
                        <th class="text-left">DESCRIPTION</th>
                        <th class="text-center" style="width: 120px;">COUNT</th>
                     </tr>
                  </thead>
                  <tbody>
                     <tr>
                        <td class="font-weight-bold text-left">Department Capacity (Batches × Lectures/Day)</td>
                        <td class="text-center font-weight-bold">{{ displayData.summary?.departmentCapacity }}</td>
                     </tr>
                     <tr>
                        <td class="font-weight-bold text-left">Total Lectures Scheduled (Assigned to Faculty)</td>
                        <td class="text-center font-weight-bold">{{ displayData.summary?.totalLecturesScheduled }}</td>
                     </tr>
                     <tr>
                        <td class="font-weight-bold text-left">Total Lectures Actually Taken</td>
                        <td class="text-center font-weight-bold">{{ displayData.summary?.totalLecturesTaken }}</td>
                     </tr>
                     <tr>
                        <td class="font-weight-bold text-left">Total Lectures NOT TAKEN (Scheduled but Missed)</td>
                        <td class="text-center font-weight-bold">{{ displayData.summary?.totalLecturesNotTaken }}</td>
                     </tr>
                     <tr class="summary-percentage-row">
                        <td class="font-weight-bold text-left">Attendance Percentage (Lectures Taken %)</td>
                        <td class="text-center font-weight-bold fs-5">{{ displayData.summary?.attendancePercentage }}%</td>
                     </tr>
                  </tbody>
               </table>
            </div>
         </div>
      </div>
    `,
    coeFeeReceiptTemplate:`
      <div class="container-fluid">
         <div class="row textCenter">
            <div class="col-12">
               <h3>{{ displayData.entityName }}</h3>
               <p>
               Receipt ID: <strong>{{ transaction.receiptId }}</strong>
               </p>
               <p>
               Date:
               {{ transaction.date | date:'dd/MMM/yyyy, hh:mm a' }}
               </p>
            </div>
         </div>

         <hr />

         <div class="row">
            <div class="col-6">
               <p><strong>Student Name:</strong> {{ transaction.studentDetails.name }}</p>
               <p><strong>Reg No:</strong> {{ transaction.studentDetails.regNo }}</p>
               <p><strong>Class:</strong> {{ transaction.studentDetails.course }}</p>
            </div>

            <div class="col-6">
               <p><strong>Father Name:</strong> {{ transaction.studentDetails.fatherName }}</p>
               <p><strong>Session:</strong> {{ transaction.session }}</p>
               <p><strong>Status:</strong> {{ transaction.status | titlecase }}</p>
            </div>
         </div>

         <hr />

         <div class="row">
            <div class="col-6">
               <p><strong>Payment Mode:</strong> {{ transaction.paymentDetails.paymentMode }}</p>
            </div>
            <div class="col-6">
               <p><strong>Bank / Account:</strong> {{ transaction.paymentDetails.bankAccount }}</p>
            </div>
         </div>

         <hr />

         <table class="table table-bordered">
            <thead>
               <tr>
               <th>S.No</th>
               <th>Fee Head</th>
               <th class="textRight">Paid Amount (₹)</th>
               </tr>
            </thead>

            <tbody>
               <tr *ngFor="let item of transaction.receipt; let i = index">
               <td>{{ i + 1 }}</td>
               <td>{{ item.coeHead }}</td>
               <td class="textRight">{{ item.paidAmount }}</td>
               </tr>
            </tbody>

            <tfoot>
               <tr>
               <th colspan="2" class="textRight">Total Payable</th>
               <th class="textRight">{{ transaction.totalPaybleAmount }}</th>
               </tr>
               <tr>
               <th colspan="2" class="textRight">Total Paid</th>
               <th class="textRight">{{ transaction.totalPaidAmount }}</th>
               </tr>
            </tfoot>
         </table>

         <hr />

         <div class="row">
            <div class="col-6">
               <p><strong>Collected By:</strong> {{ transaction.userName }}</p>
               <p><strong>Mobile:</strong> {{ transaction.userMobile }}</p>
            </div>
         </div>

         <br />

         <div class="row pt30">
            <div class="col-4">
               Authorised Signature
            </div>
            <div class="col-3 offset-5 textRight">
               Principal's Signature
            </div>
         </div>

      </div>
      `,
      examRegistrationFormTemplate:`

<style>
  /* ================= ROOT CONTAINER ================= */
.container {
  width: 800px;
  margin: 20px auto;
  padding: 24px;
  border: 1px solid #ccc;
  font-family: "Segoe UI", Arial, sans-serif;
  font-size: 14px;
  color: #222;
  background: #fff;
}

/* ================= HEADER ================= */
.header {
  text-align: center;
  border-bottom: 2px solid #000;
  padding-bottom: 12px;
  margin-bottom: 20px;
}

.header img {
  max-height: 80px;
  margin-bottom: 8px;
}

.header h1 {
  font-size: 22px;
  margin: 4px 0;
  font-weight: 600;
  text-transform: uppercase;
}

.header p {
  margin: 2px 0;
  font-size: 13px;
  color: #555;
}

.header h2 {
  margin-top: 10px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.4px;
}

/* ================= SECTION TITLES ================= */
h3 {
  margin: 18px 0 8px;
  font-size: 15px;
  font-weight: 600;
  border-left: 4px solid #e95028; /* primary accent */
  padding-left: 8px;
  color: #000;
}

/* ================= TABLE COMMON ================= */
table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 14px;
}

table th,
table td {
  border: 1px solid #444;
  padding: 8px 10px;
  text-align: left;
  vertical-align: top;
}

table th {
  background: #f4f4f4;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 12px;
}

table td {
  font-size: 13px;
}

/* ================= PERSONAL DETAILS TABLE ================= */
table tr td strong {
  font-weight: 600;
}

/* ================= SUBJECT DETAILS ================= */
table tbody tr:nth-child(even) {
  background: #fafafa;
}

table tbody tr:hover {
  background: #f1f7ff;
}

/* ================= PAYMENT DETAILS ================= */
table td div {
  line-height: 1.4;
}

/* ================= CONSENT / DECLARATION ================= */
ul {
  margin: 6px 0 14px 18px;
  padding: 0;
}

ul li {
  margin-bottom: 6px;
  font-size: 13px;
  line-height: 1.5;
}

/* ================= SIGNATURE ================= */
.signature {
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
  padding-top: 12px;
  border-top: 1px dashed #000;
}

.signature p {
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  width: 40%;
}

/* ================= PRINT FRIENDLY ================= */
@media print {
  body {
    margin: 0;
  }

  .container {
    width: 100%;
    border: none;
    padding: 16px;
  }

  h3 {
    color: #000;
    border-left: 3px solid #000;
  }

  table th {
    background: #eaeaea !important;
    -webkit-print-color-adjust: exact;
  }

  .signature {
    page-break-inside: avoid;
  }
}
</style>

<ng-container *ngFor="let displayData of displayDataArray">
  <div class="container">

    <!-- ================= HEADER ================= -->
    <div class="header" *ngIf="displayData">
      <img [src]="displayData.logo" alt="Institute Logo" />
      <h1>{{ displayData.entityDisplayName }}</h1>
      <p>{{ displayData.entityAddress }}</p>
      <h2>Exam Registration Slip – Session {{ displayData.session }}</h2>
    </div>

    <!-- ================= PERSONAL DETAILS ================= -->
    <h3 *ngIf="displayData">Personal Details</h3>
    <table *ngIf="displayData">
      <tr>
        <td><strong>Name</strong></td>
        <td>{{ displayData.name }}</td>
        <td><strong>Registration No</strong></td>
        <td>{{ displayData.regNo }}</td>
      </tr>
      <tr>
        <td><strong>Course</strong></td>
        <td>{{ displayData.course }}</td>
        <td><strong>Stream</strong></td>
        <td>{{ displayData.stream }}</td>
      </tr>
      <tr>
        <td><strong>Batch</strong></td>
        <td>{{ displayData.batch }}</td>
        <td><strong>Section</strong></td>
        <td>{{ displayData.section }}</td>
      </tr>
      <tr>
        <td><strong>Session</strong></td>
        <td>{{ displayData.session }}</td>
        <td><strong>Category</strong></td>
        <td>{{ displayData.socialCategory }}</td>
      </tr>
    </table>

    <!-- ================= SUBJECT DETAILS ================= -->
    <h3 *ngIf="displayData && displayData.filteredExamRegistrations && displayData.filteredExamRegistrations.length">
      Subject Details
    </h3>

    <table *ngIf="displayData && displayData.filteredExamRegistrations && displayData.filteredExamRegistrations.length">
      <thead>
        <tr>
          <th>S.No</th>
          <th>Subject Code</th>
          <th>Subject Name</th>
          <th>Exam Type</th>
          <th>Attendance Value</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let item of displayData.filteredExamRegistrations; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ item.subjectCode }}</td>
          <td>{{ item.subjectName }}</td>
          <td>{{ item.examType | titlecase }}</td>
          <td>
            <span *ngIf="item.examDetail">
              {{ item.examDetail.attendanceValue }}
            </span>
            <span *ngIf="!item.examDetail">
              -
            </span>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- ================= PAYMENT DETAILS (SAFE, NO ?) ================= -->
    <!-- Only render if first registration exists AND has transactions -->
    <ng-container
      *ngIf="
        displayData &&
        displayData.filteredExamRegistrations &&
        displayData.filteredExamRegistrations.length &&
        displayData.filteredExamRegistrations[0].transactions &&
        displayData.filteredExamRegistrations[0].transactions.length
      "
    >
      <h3>Payment Details</h3>

      <table>
        <thead>
          <tr>
            <th>Receipt No</th>
            <th>Date</th>
            <th>Fee Head</th>
            <th>Paid Amount</th>
            <th>Mode</th>
            <th>Txn ID</th>
            <th>Status</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let txn of displayData.filteredExamRegistrations[0].transactions">
            <td>{{ txn.receiptId }}</td>
            <td>{{ txn.date | date: 'dd/MM/yyyy' }}</td>

            <td>
              <div *ngFor="let r of txn.receipt">
                {{ r.coeHead }}
              </div>
            </td>

            <td>
              <div *ngFor="let r of txn.receipt">
                ₹{{ r.paidAmount }}
              </div>
            </td>

            <td>{{ txn.paymentDetails.paymentMode }}</td>
            <td>{{ txn.paymentDetails.txnId }}</td>
            <td>{{ txn.status | titlecase }}</td>
          </tr>
        </tbody>
      </table>
    </ng-container>

    <!-- ================= CONSENT ================= -->
    <ng-container
      *ngIf="
        displayData &&
        displayData.consentDeclaration &&
        displayData.filteredExamRegistrations &&
        displayData.filteredExamRegistrations.length &&
        displayData.consentDeclaration[displayData.filteredExamRegistrations[0].examType]
      "
    >
      <h3>Consent</h3>
      <ul>
        <li
          *ngFor="
            let header of
              displayData.consentDeclaration[displayData.filteredExamRegistrations[0].examType].headers
          "
        >
          {{ header }}
        </li>
      </ul>

      <h3>Declaration</h3>
      <ul>
        <li
          *ngFor="
            let footer of
              displayData.consentDeclaration[displayData.filteredExamRegistrations[0].examType].footers
          "
        >
          {{ footer }}
        </li>
      </ul>
    </ng-container>

    <!-- ================= SIGNATURE ================= -->
    <div class="signature">
      <p><strong>Student Signature</strong></p>
      <p><strong>Controller of Examination</strong></p>
    </div>

  </div>
</ng-container>


    `,
    studentDMCTemplate:`
      <style>
         .dmc-container {
            border: 4px solid #2ba84a;
            padding: 40px;
            background-image: url('/assets/piet-watermark.png');
            background-size: cover;
            font-family: serif;
         }

         .serial-box {
            border: 2px dashed #2ba84a;
            display: inline-block;
            padding: 6px 20px;
            margin: auto;
            margin-bottom: 15px;
         }

         .institute {
            font-weight: bold;
         }

         .student-section {
            display: flex;
            justify-content: space-between;
            margin-top: 20px;
         }

         .student-photo {
            width: 110px;
            border: 2px solid #ccc;
            margin-bottom: 10px;
         }

         .marks-table {
            margin-top: 20px;
            font-size: 13px;
         }

         .summary {
            display: flex;
            justify-content: space-between;
            margin-top: 10px;
            font-weight: bold;
         }

         .footer {
            display: flex;
            justify-content: space-between;
            margin-top: 60px;
         }
         .pagebreak {
            page-break-before: always;
         }
      </style>
      <div class="pagebreak" *ngFor="let displayData of displayDataArray">
      <div class="dmc-container">

      <!-- Serial Number -->
      <div class="serial-box text-center">
         Sr. No. {{ displayData.serialNo }}
      </div>

      <!-- Header -->
      <div class="header text-center">

         <div class="logo-left">
            <img [src]="displayData.logo" class="img-rounded" style="width: 50px">
         </div>

         <h2 class="institute">{{displayData.entityName}}</h2>

         <p class="subtext">
            {{displayData.entityAddress}}
         </p>

         <h4 class="result-title">Result - Cum - Grade Card</h4>

         <h4 class="course">
            {{displayData.metadata.course}}
         </h4>

         <p>{{displayData.metadata.examCalendar}} - {{ displayData.session }}</p>

      </div>


      <!-- Student Details -->
      <div class="student-section">

         <div class="student-left">

            <p><b>Student's Name :</b> {{ displayData.student.name }}</p>
            <p><b>Mother's Name :</b> {{ displayData.student.motherName }}</p>
            <p><b>Father's Name :</b> {{ displayData.student.fatherName }}</p>
            <p><b>ABC ID :</b> {{ displayData.student.abcId }}</p>

         </div>

         <div class="student-right">

            <img class="student-photo" [src]="displayData.student.photo">

            <p><b>DMC No :</b> {{ displayData.student.dmcNo }}</p>
            <p><b>Roll No :</b> {{ displayData.student.rollNo }}</p>
            <p><b>Reg No :</b> {{ displayData.student.regNo }}</p>

         </div>

      </div>


      <!-- Marks Table -->
      <table class="table table-bordered marks-table">

         <thead>
            <tr>
            <th>Subject Type</th>
            <th>Subject Code</th>
            <th>Subject</th>
            <th>Credits</th>
            <th>Maximum Marks</th>
            <th>Marks Obtained</th>
            <th>Grade</th>
            <th>Credit Point</th>
            </tr>
         </thead>

         <tbody>

            <tr *ngFor="let sub of displayData.student.subjects">

            <td>{{ sub.subType }}</td>
            <td>{{ sub.subCode }}</td>
            <td>{{ sub.subName }}</td>
            <td>{{ sub.creditValue }}</td>
            <td>{{ sub.maxMarks }}</td>
            <td>{{ sub.marks }}</td>
            <td>{{ sub.grade }}</td>
            <td>{{ sub.gradePoints }}</td>

            </tr>

         </tbody>

      </table>


      <!-- Result Summary -->
      <div class="summary">

         <div class="left">
            Result Status : <b>{{ displayData.status }}</b>
         </div>

         <div class="right">
            SGPA : <b>{{ displayData.sgpa }}</b>
         </div>

      </div>


      <!-- Footer -->
      <div class="footer">

         <div class="barcode">
            <p>Result Declaration Date : {{ displayData.declarationDate }}</p>
         </div>

         <div class="signature text-right">
            <p>Controller of Examinations</p>
         </div>

      </div>

      </div>
      </div>`,
      resultSheetTemplate: `
   <style>
  .result-container {
    width: 100%;
    max-width: 1400px;
    margin: auto;
    font-family: "Times New Roman", serif;
    color: #000;
  }

  .text-center {
    text-align: center;
  }

  /* HEADER */

  .result-container h2 {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 2px;
  }

  .result-container h3 {
    font-size: 18px;
    font-weight: bold;
    margin: 6px 0;
  }

  .result-container h4 {
    font-size: 16px;
    font-weight: bold;
    margin: 4px 0;
  }

  .result-container div {
    font-size: 14px;
  }

  /* TABLE */

  .result-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 15px;
    font-size: 13px;
  }

  .result-table th,
  .result-table td {
    border: 1px solid #000;
    padding: 5px;
    text-align: center;
  }

  .result-table thead th {
    font-weight: bold;
  }

  .result-table tbody td:nth-child(3) {
    text-align: left;
    padding-left: 10px;
  }

  .result-table td,
  .result-table th {
    font-size: 12px;
  }

  .result-table td {
    vertical-align: middle;
  }

  /* TABLE TITLE */

  .table-title {
    font-weight: bold;
    font-size: 15px;
    background: #f2f2f2;
  }

  /* GRADING TABLE */

  .grading-wrapper {
    width: 100%;
    margin: 25px auto 0;
  }

  .grading-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
  }

  .grading-table th,
  .grading-table td {
    border: 1px solid #000;
    padding: 5px;
    text-align: center;
  }

  .grading-note {
    font-weight: bold;
  }

  /* PRINT */

  @media print {

    .result-container {
      page-break-inside: avoid;
    }

  }
</style>


<div class="result-container" *ngFor="let displayData of displayDataArray">

  <!-- HEADER -->

  <div class="text-center">

    <h2>{{ displayData.entityDisplayName | uppercase }}</h2>

    <div>
      {{ displayData.entityAddress }},
      {{ displayData.entityCity }},
      {{ displayData.entityState }} - {{ displayData.entityPin }}
    </div>

    <h4>
      Result Sheet - {{ displayData.metadata.examCalendar }}
    </h4>

    <h3>
      {{ displayData.metadata.course }}
      ({{displayData.metadata.stream}})
      - {{ displayData.metadata.batch }}
    </h3>

  </div>


  <!-- SCHEME OF EXAMINATION -->

  <table class="result-table">

    <thead>

      <tr>
        <th colspan="8" class="table-title">
          SCHEME OF EXAMINATION
        </th>
      </tr>

      <tr>
        <th rowspan="2">Sr.No.</th>
        <th rowspan="2">Subject Code</th>
        <th rowspan="2">Subject</th>
        <th rowspan="2">Internal Max. Marks</th>
        <th rowspan="2">Practical Max. Marks</th>
        <th rowspan="2">Theory Max. Marks</th>
        <th rowspan="2">Total Maximum Marks</th>
        <th rowspan="2">Credit</th>
      </tr>

    </thead>


    <tbody>
  <tr *ngFor="let student of displayData.students; let i = index">
    <td>{{ i + 1 }}</td>

    <td>
      {{ student.rollNo }} <br>
      <strong>{{ student.name }}</strong>
    </td>

    <td>{{ student.fatherName }}</td>

    <td>{{ student.motherName }}</td>

    <td>{{ student.regNo }}</td>

    <!-- SUBJECT MARKS -->
    <td *ngFor="let subject of displayData.examMaster.subjects">

      <ng-container *ngIf="student.subjectMap[subject.subjectCode] as sub; else noData">

        <span *ngIf="sub.attendance === 'detained'">
          Detained
        </span>

        <span *ngIf="sub.attendance === 'ufm'">
          UFM
        </span>

        <span *ngIf="sub.attendance !== 'detained' && sub.attendance !== 'ufm'">

          <span *ngIf="sub.internalMarks">
            I - {{ sub.internalMarks }}<br>
          </span>

          <span *ngIf="sub.externalMarks">
            E - {{ sub.externalMarks }}<br>
          </span>

          <span *ngIf="sub.marks">
            Total - {{ sub.marks }}<br>
          </span>

          <span *ngIf="sub.grade">
            {{ sub.grade }}
          </span>

        </span>

      </ng-container>

      <ng-template #noData>-</ng-template>

    </td>

    <!-- CREDIT / SGPA -->
    <td>
      <ng-container
        *ngIf="!(student.subjectMap); else failedSubjects">

        {{ student.creditEarned }}

      </ng-container>

      <ng-template #failedSubjects>
        <ng-container *ngFor="let subject of displayData.examMaster.subjects">

          <ng-container *ngIf="student.subjectMap[subject.subjectCode]?.grade == 'F'">

            {{ subject.subjectName }}<br>

          </ng-container>

        </ng-container>
      </ng-template>
    </td>

    <td>
      <ng-container
        *ngIf="!(student.subjectMap)">

        {{ student.sgpa }}

      </ng-container>
    </td>

  </tr>
</tbody>

  </table>


  <!-- GRADING SYSTEM -->

  <div class="grading-wrapper">

    <table class="grading-table">

      <tr>
        <th colspan="4" class="table-title">
          GRADING SYSTEM
        </th>
      </tr>
      <tr>
        <th>Academic Performance</th>
        <th>Range of Marks(%)</th>
        <th>Grades</th>
        <th>Grade Points</th>
      </tr>

      <tr *ngFor="let grade of displayData.gradeConfig">

        <td>{{ grade.remark?.join(', ') }}</td>

        <td>
          {{ grade.minMarks }} to {{ grade.maxMarks }}
        </td>

        <td>{{ grade.grade }}</td>

        <td>{{ grade.gradePoints }}</td>

      </tr>

    </table>
    <br>
    <br>
    <br>
    
    <!-- -->
    
  <div class="grading-wrapper">

    <table class="grading-table">

      <tr>
        <th colspan="4" class="table-title">
          Result Analyses
        </th>
      </tr>
      <tr>
        <th>S.No</th>
        <th>Subject Code</th>
        <th>Subject </th>
        <th>Type</th>
        <th>Students</th>
        <th>Pass</th>
        <th>Pass (%)</th>
        <th>Fail</th>
        <th>Fail (%)</th>
      </tr>

      <tr *ngFor="let data of displayData.resultAnalysesData.tableData;let ind=index">

        <td>{{ind+1}}</td>

        <td>
          {{ data.subjectCode }}
        </td>

        <td>{{ data.subjectName }}</td>

        <td>{{ data.subjectType }}</td>
        <td>{{ data.subjectType }}</td>
        <td>{{data.totalStudents}}</td>
        <td>{{data.passCount}}</td>
        <td>{{data.passPercentage}}</td>
        <td>{{data.failCount}}</td>
        <td>{{data.failPercentage}}</td>

      </tr>

    </table>
  </div>
    <br>
    <br>
    <br>
    <br>
    
      <table class="result-table">
        
      <thead>

        <!-- FIRST HEADER ROW -->
        
      <tr>
        <th colspan="4" class="table-title">
          Top 10 merit Students
        </th>
      </tr>
        <tr>

          <th rowspan="2">Sr.No.</th>
          <th rowspan="2">Autonomous Roll No / Name</th>
          <th rowspan="2">Father Name</th>
          <th rowspan="2">Mother Name</th>
          <th rowspan="2">College Roll No</th>

          <th *ngFor="let subject of displayData.examMaster.subjects">
            {{ subject.subjectCode }}
          </th>

          <th rowspan="2">Credit Earned</th>
          <th rowspan="2">SGPA</th>

        </tr>

      </thead>



      <tbody>

        <tr *ngFor="let student of displayData.top10MeritStudents; let i = index">

          <td>{{ i + 1 }}</td>

          <td>
            {{ student.rollNo }} <br>
            <strong>{{ student.name }}</strong>
          </td>

          <td>{{ student.fatherName }}</td>

          <td>{{ student.motherName }}</td>

          <td>{{ student.regNo }}</td>



          <!-- SUBJECT MARKS -->
          <td *ngFor="let subject of displayData.examMaster.subjects">

            <ng-container *ngIf="student.subjectMap[subject.subjectCode] as sub; else noData">

              <span *ngIf="sub.attendance === 'detained'">
                Detained
              </span>
               <span *ngIf="sub.attendance === 'ufm'">
                UFM
              </span>

              <span *ngIf="sub.attendance !== 'detained' && sub.attendance !== 'ufm'">
                <span *ngIf="sub.internalMarks">I - {{ sub.internalMarks }}<br></span>
                <span *ngIf="sub.externalMarks">E - {{ sub.externalMarks }}<br></span>
                <span *ngIf="sub.marks">Total - {{ sub.marks }}<br></span>
                <span *ngIf="sub.grade">{{ sub.grade }}</span>
              </span>


            </ng-container>

            <ng-template #noData>-</ng-template>

          </td>



          <td>{{ student.creditEarned }}</td>

          <td>{{ student.sgpa }}</td>

        </tr>

      </tbody>

    </table>
<br>
<br>
    <!-- Student Data Table -->

    <table class="result-table">

      <thead>

        <!-- FIRST HEADER ROW -->
        <tr>

          <th rowspan="2">Sr.No.</th>
          <th rowspan="2">Autonomous Roll No / Name</th>
          <th rowspan="2">Father Name</th>
          <th rowspan="2">Mother Name</th>
          <th rowspan="2">College Roll No</th>

          <th *ngFor="let subject of displayData.examMaster.subjects">
            {{ subject.subjectCode }}
          </th>

          <th rowspan="2">Credit Earned</th>
          <th rowspan="2">SGPA</th>

        </tr>

      </thead>



      <tbody>

        <tr *ngFor="let student of displayData.students; let i = index">

          <td>{{ i + 1 }}</td>

          <td>
            {{ student.rollNo }} <br>
            <strong>{{ student.name }}</strong>
          </td>

          <td>{{ student.fatherName }}</td>

          <td>{{ student.motherName }}</td>

          <td>{{ student.regNo }}</td>



          <!-- SUBJECT MARKS -->
          <td *ngFor="let subject of displayData.examMaster.subjects">

            <ng-container *ngIf="student.subjectMap[subject.subjectCode] as sub; else noData">

              <span *ngIf="sub.attendance === 'detained'">
                Detained
              </span>
               <span *ngIf="sub.attendance === 'ufm'">
                UFM
              </span>

              <span *ngIf="sub.attendance !== 'detained' && sub.attendance !== 'ufm'">
                <span *ngIf="sub.internalMarks">I - {{ sub.internalMarks }}<br></span>
                <span *ngIf="sub.externalMarks">E - {{ sub.externalMarks }}<br></span>
                <span *ngIf="sub.marks">Total - {{ sub.marks }}<br></span>
                <span *ngIf="sub.grade">{{ sub.grade }}</span>
              </span>


            </ng-container>

            <ng-template #noData>-</ng-template>

          </td>



          <td>{{ student.creditEarned }}</td>

          <td>{{ student.sgpa }}</td>

        </tr>

      </tbody>

    </table>

  </div>

</div>`,
      resultSheet: `
   <style>
  .result-container {
    width: 100%;
    max-width: 1400px;
    margin: auto;
    font-family: "Times New Roman", serif;
    color: #000;
  }

  .text-center {
    text-align: center;
  }

  /* HEADER */

  .result-container h2 {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 2px;
  }

  .result-container h3 {
    font-size: 18px;
    font-weight: bold;
    margin: 6px 0;
  }

  .result-container h4 {
    font-size: 16px;
    font-weight: bold;
    margin: 4px 0;
  }

  .result-container div {
    font-size: 14px;
  }

  /* TABLE */

  .result-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 15px;
    font-size: 13px;
  }

  .result-table th,
  .result-table td {
    border: 1px solid #000;
    padding: 5px;
    text-align: center;
  }

  .result-table thead th {
    font-weight: bold;
  }

  .result-table tbody td:nth-child(3) {
    text-align: left;
    padding-left: 10px;
  }

  .result-table td,
  .result-table th {
    font-size: 12px;
  }

  .result-table td {
    vertical-align: middle;
  }

  /* TABLE TITLE */

  .table-title {
    font-weight: bold;
    font-size: 15px;
    background: #f2f2f2;
  }

  /* GRADING TABLE */

  .grading-wrapper {
    width: 100%;
    margin: 25px auto 0;
  }

  .grading-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
  }

  .grading-table th,
  .grading-table td {
    border: 1px solid #000;
    padding: 5px;
    text-align: center;
  }

  .grading-note {
    font-weight: bold;
  }

  /* PRINT */

  @media print {

    .result-container {
      page-break-inside: avoid;
    }

  }
</style>


<div class="result-container" *ngFor="let displayData of displayDataArray">

  <!-- HEADER -->

  <div class="text-center">

    <h2>{{ displayData.entityDisplayName | uppercase }}</h2>

    <div>
      {{ displayData.entityAddress }},
      {{ displayData.entityCity }},
      {{ displayData.entityState }} - {{ displayData.entityPin }}
    </div>

    <h4>
      Result Sheet - {{ displayData.metadata.examCalendar }}
    </h4>

    <h3>
      {{ displayData.metadata.course }}
      ({{displayData.metadata.stream}})
      - {{ displayData.metadata.batch }}
    </h3>

  </div>


  <!-- SCHEME OF EXAMINATION -->

  <table class="result-table">

    <thead>

      <tr>
        <th colspan="8" class="table-title">
          SCHEME OF EXAMINATION
        </th>
      </tr>

      <tr>
        <th rowspan="2">Sr.No.</th>
        <th rowspan="2">Subject Code</th>
        <th rowspan="2">Subject</th>
        <th rowspan="2">Internal Max. Marks</th>
        <th rowspan="2">Practical Max. Marks</th>
        <th rowspan="2">Theory Max. Marks</th>
        <th rowspan="2">Total Maximum Marks</th>
        <th rowspan="2">Credit</th>
      </tr>

    </thead>


    <tbody>
  <tr *ngFor="let student of displayData.students; let i = index">
    <td>{{ i + 1 }}</td>

    <td>
      {{ student.rollNo }} <br>
      <strong>{{ student.name }}</strong>
    </td>

    <td>{{ student.fatherName }}</td>

    <td>{{ student.motherName }}</td>

    <td>{{ student.regNo }}</td>

    <!-- SUBJECT MARKS -->
    <td *ngFor="let subject of displayData.examMaster.subjects">

      <ng-container *ngIf="student.subjectMap[subject.subjectCode] as sub; else noData">

        <span *ngIf="sub.attendance === 'detained'">
          Detained
        </span>

        <span *ngIf="sub.attendance === 'ufm'">
          UFM
        </span>

        <span *ngIf="sub.attendance !== 'detained' && sub.attendance !== 'ufm'">

          <span *ngIf="sub.internalMarks">
            I - {{ sub.internalMarks }}<br>
          </span>

          <span *ngIf="sub.externalMarks">
            E - {{ sub.externalMarks }}<br>
          </span>

          <span *ngIf="sub.marks">
            Total - {{ sub.marks }}<br>
          </span>

          <span *ngIf="sub.grade">
            {{ sub.grade }}
          </span>

        </span>

      </ng-container>

      <ng-template #noData>-</ng-template>

    </td>

    <!-- CREDIT / SGPA -->
    <td>
      <ng-container
        *ngIf="!(student.subjectMap); else failedSubjects">

        {{ student.creditEarned }}

      </ng-container>

      <ng-template #failedSubjects>
        <ng-container *ngFor="let subject of displayData.examMaster.subjects">

          <ng-container *ngIf="student.subjectMap[subject.subjectCode]?.grade == 'F'">

            {{ subject.subjectName }}<br>

          </ng-container>

        </ng-container>
      </ng-template>
    </td>

    <td>
      <ng-container
        *ngIf="!(student.subjectMap)">

        {{ student.sgpa }}

      </ng-container>
    </td>

  </tr>
</tbody>

  </table>


  <!-- GRADING SYSTEM -->

  <div class="grading-wrapper">

    <table class="grading-table">

      <tr>
        <th colspan="4" class="table-title">
          GRADING SYSTEM
        </th>
      </tr>
      <tr>
        <th>Academic Performance</th>
        <th>Range of Marks(%)</th>
        <th>Grades</th>
        <th>Grade Points</th>
      </tr>

      <tr *ngFor="let grade of displayData.gradeConfig">

        <td>{{ grade.remark?.join(', ') }}</td>

        <td>
          {{ grade.minMarks }} to {{ grade.maxMarks }}
        </td>

        <td>{{ grade.grade }}</td>

        <td>{{ grade.gradePoints }}</td>

      </tr>

    </table>
    <br>
    <br>
    <br>
    
    <!-- -->
    
  <div class="grading-wrapper">

    <table class="grading-table">

      <tr>
        <th colspan="4" class="table-title">
          Result Analyses
        </th>
      </tr>
      <tr>
        <th>S.No</th>
        <th>Subject Code</th>
        <th>Subject </th>
        <th>Type</th>
        <th>Students</th>
        <th>Pass</th>
        <th>Pass (%)</th>
        <th>Fail</th>
        <th>Fail (%)</th>
      </tr>

      <tr *ngFor="let data of displayData.resultAnalysesData.tableData;let ind=index">

        <td>{{ind+1}}</td>

        <td>
          {{ data.subjectCode }}
        </td>

        <td>{{ data.subjectName }}</td>

        <td>{{ data.subjectType }}</td>
        <td>{{ data.subjectType }}</td>
        <td>{{data.totalStudents}}</td>
        <td>{{data.passCount}}</td>
        <td>{{data.passPercentage}}</td>
        <td>{{data.failCount}}</td>
        <td>{{data.failPercentage}}</td>

      </tr>

    </table>
  </div>
    <br>
    <br>
    <br>
    <br>
    
      <table class="result-table">
        
      <thead>

        <!-- FIRST HEADER ROW -->
        
      <tr>
        <th colspan="4" class="table-title">
          Top 10 merit Students
        </th>
      </tr>
        <tr>

          <th rowspan="2">Sr.No.</th>
          <th rowspan="2">Autonomous Roll No / Name</th>
          <th rowspan="2">Father Name</th>
          <th rowspan="2">Mother Name</th>
          <th rowspan="2">College Roll No</th>

          <th *ngFor="let subject of displayData.examMaster.subjects">
            {{ subject.subjectCode }}
          </th>

          <th rowspan="2">Credit Earned</th>
          <th rowspan="2">SGPA</th>

        </tr>

      </thead>



      <tbody>

        <tr *ngFor="let student of displayData.students; let i = index">

          <td>{{ i + 1 }}</td>

          <td>
            {{ student.rollNo }} <br>
            <strong>{{ student.name }}</strong>
          </td>

          <td>{{ student.fatherName }}</td>

          <td>{{ student.motherName }}</td>

          <td>{{ student.regNo }}</td>



          <!-- SUBJECT MARKS -->
          <td *ngFor="let subject of displayData.examMaster.subjects">

            <ng-container *ngIf="student.subjectMap[subject.subjectCode] as sub; else noData">

              <span *ngIf="sub.attendance === 'detained'">
                Detained
              </span>
               <span *ngIf="sub.attendance === 'ufm'">
                UFM
              </span>

              <span *ngIf="sub.attendance !== 'detained' && sub.attendance !== 'ufm'">
                <span *ngIf="sub.internalMarks">I - {{ sub.internalMarks }}<br></span>
                <span *ngIf="sub.externalMarks">E - {{ sub.externalMarks }}<br></span>
                <span *ngIf="sub.marks">Total - {{ sub.marks }}<br></span>
                <span *ngIf="sub.grade">{{ sub.grade }}</span>
              </span>


            </ng-container>

            <ng-template #noData>-</ng-template>

          </td>



          <td>{{ student.creditEarned }}</td>

          <td>{{ student.sgpa }}</td>

        </tr>

      </tbody>

    </table>

  </div>

</div>`,
      revaluationResultSheetTemplate: `
   <style>
  .result-container {
    width: 100%;
    max-width: 1400px;
    margin: auto;
    font-family: "Times New Roman", serif;
    color: #000;
  }

  .text-center {
    text-align: center;
  }

  /* HEADER */

  .result-container h2 {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 2px;
  }

  .result-container h3 {
    font-size: 18px;
    font-weight: bold;
    margin: 6px 0;
  }

  .result-container h4 {
    font-size: 16px;
    font-weight: bold;
    margin: 4px 0;
  }

  .result-container div {
    font-size: 14px;
  }

  /* TABLE */

  .result-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 15px;
    font-size: 13px;
  }

  .result-table th,
  .result-table td {
    border: 1px solid #000;
    padding: 5px;
    text-align: center;
  }

  .result-table thead th {
    font-weight: bold;
  }

  .result-table tbody td:nth-child(3) {
    text-align: left;
    padding-left: 10px;
  }

  .result-table td,
  .result-table th {
    font-size: 12px;
  }

  .result-table td {
    vertical-align: middle;
  }

  /* TABLE TITLE */

  .table-title {
    font-weight: bold;
    font-size: 15px;
    background: #f2f2f2;
  }

  /* GRADING TABLE */

  .grading-wrapper {
    width: 100%;
    margin: 25px auto 0;
  }

  .grading-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
  }

  .grading-table th,
  .grading-table td {
    border: 1px solid #000;
    padding: 5px;
    text-align: center;
  }

  .grading-note {
    font-weight: bold;
  }

  /* PRINT */

  @media print {

    .result-container {
      page-break-inside: avoid;
    }

  }
</style>


<div class="result-container" *ngFor="let displayData of displayDataArray">

  <!-- HEADER -->

  <div class="text-center">

    <h2>{{ displayData.entityDisplayName | uppercase }}</h2>

    <div>
      {{ displayData.entityAddress }},
      {{ displayData.entityCity }},
      {{ displayData.entityState }} - {{ displayData.entityPin }}
    </div>

    <h4>
      Revaluation Result Sheet - {{ displayData.metadata.examCalendar }}
    </h4>

    <h3>
      {{ displayData.metadata.course }}
      ({{displayData.metadata.stream}})
      - {{ displayData.metadata.batch }}
    </h3>

  </div>


  <!-- SCHEME OF EXAMINATION -->

  <table class="result-table">

    <thead>

      <tr>
        <th colspan="8" class="table-title">
          SCHEME OF EXAMINATION
        </th>
      </tr>

      <tr>
        <th rowspan="2">Sr.No.</th>
        <th rowspan="2">Subject Code</th>
        <th rowspan="2">Subject</th>
        <th rowspan="2">Internal Max. Marks</th>
        <th rowspan="2">Practical Max. Marks</th>
        <th rowspan="2">Theory Max. Marks</th>
        <th rowspan="2">Total Maximum Marks</th>
        <th rowspan="2">Credit</th>
      </tr>

    </thead>


    <tbody>
  <tr *ngFor="let student of displayData.students; let i = index">
    <td>{{ i + 1 }}</td>

    <td>
      {{ student.rollNo }} <br>
      <strong>{{ student.name }}</strong>
    </td>

    <td>{{ student.fatherName }}</td>

    <td>{{ student.motherName }}</td>

    <td>{{ student.regNo }}</td>

    <!-- SUBJECT MARKS -->
    <td *ngFor="let subject of displayData.examMaster.subjects">

      <ng-container *ngIf="student.subjectMap[subject.subjectCode] as sub; else noData">

        <span *ngIf="sub.attendance === 'detained'">
          Detained
        </span>

        <span *ngIf="sub.attendance === 'ufm'">
          UFM
        </span>

        <span *ngIf="sub.attendance !== 'detained' && sub.attendance !== 'ufm'">

          <span *ngIf="sub.internalMarks">
            I - {{ sub.internalMarks }}<br>
          </span>

          <span *ngIf="sub.externalMarks">
            E - {{ sub.externalMarks }}<br>
          </span>

          <span *ngIf="sub.marks">
            Total - {{ sub.marks }}<br>
          </span>

          <span *ngIf="sub.grade">
            {{ sub.grade }}
          </span>

        </span>

      </ng-container>

      <ng-template #noData>-</ng-template>

    </td>

    <!-- CREDIT / SGPA -->
    <td>
      <ng-container
        *ngIf="!(student.subjectMap); else failedSubjects">

        {{ student.creditEarned }}

      </ng-container>

      <ng-template #failedSubjects>
        <ng-container *ngFor="let subject of displayData.examMaster.subjects">

          <ng-container *ngIf="student.subjectMap[subject.subjectCode]?.grade == 'F'">

            {{ subject.subjectName }}<br>

          </ng-container>

        </ng-container>
      </ng-template>
    </td>

    <td>
      <ng-container
        *ngIf="!(student.subjectMap)">

        {{ student.sgpa }}

      </ng-container>
    </td>

  </tr>
</tbody>

  </table>


  <!-- GRADING SYSTEM -->

  <div class="grading-wrapper">

    <table class="grading-table">

      <tr>
        <th colspan="4" class="table-title">
          GRADING SYSTEM
        </th>
      </tr>
      <tr>
        <th>Academic Performance</th>
        <th>Range of Marks(%)</th>
        <th>Grades</th>
        <th>Grade Points</th>
      </tr>

      <tr *ngFor="let grade of displayData.gradeConfig">

        <td>{{ grade.remark?.join(', ') }}</td>

        <td>
          {{ grade.minMarks }} to {{ grade.maxMarks }}
        </td>

        <td>{{ grade.grade }}</td>

        <td>{{ grade.gradePoints }}</td>

      </tr>

    </table>
    <br>
    <br>
    <br>
    
    <!-- -->
    
  <div class="grading-wrapper">

    <table class="grading-table">

      <tr>
        <th colspan="4" class="table-title">
          Result Analyses
        </th>
      </tr>
      <tr>
        <th>S.No</th>
        <th>Subject Code</th>
        <th>Subject </th>
        <th>Type</th>
        <th>Students</th>
        <th>Pass</th>
        <th>Pass (%)</th>
        <th>Fail</th>
        <th>Fail (%)</th>
      </tr>

      <tr *ngFor="let data of displayData.resultAnalysesData.tableData;let ind=index">

        <td>{{ind+1}}</td>

        <td>
          {{ data.subjectCode }}
        </td>

        <td>{{ data.subjectName }}</td>

        <td>{{ data.subjectType }}</td>
        <td>{{ data.subjectType }}</td>
        <td>{{data.totalStudents}}</td>
        <td>{{data.passCount}}</td>
        <td>{{data.passPercentage}}</td>
        <td>{{data.failCount}}</td>
        <td>{{data.failPercentage}}</td>

      </tr>

    </table>
  </div>
    <br>
    <br>
    <br>
    <br>
    
      <table class="result-table">
        
      <thead>

        <!-- FIRST HEADER ROW -->
        
      <tr>
        <th colspan="4" class="table-title">
          Top 10 merit Students
        </th>
      </tr>
        <tr>

          <th rowspan="2">Sr.No.</th>
          <th rowspan="2">Autonomous Roll No / Name</th>
          <th rowspan="2">Father Name</th>
          <th rowspan="2">Mother Name</th>
          <th rowspan="2">College Roll No</th>

          <th *ngFor="let subject of displayData.examMaster.subjects">
            {{ subject.subjectCode }}
          </th>

          <th rowspan="2">Credit Earned</th>
          <th rowspan="2">SGPA</th>

        </tr>

      </thead>



      <tbody>

        <tr *ngFor="let student of displayData.students; let i = index">

          <td>{{ i + 1 }}</td>

          <td>
            {{ student.rollNo }} <br>
            <strong>{{ student.name }}</strong>
          </td>

          <td>{{ student.fatherName }}</td>

          <td>{{ student.motherName }}</td>

          <td>{{ student.regNo }}</td>



          <!-- SUBJECT MARKS -->
          <td *ngFor="let subject of displayData.examMaster.subjects">

            <ng-container *ngIf="student.subjectMap[subject.subjectCode] as sub; else noData">

              <span *ngIf="sub.attendance === 'detained'">
                Detained
              </span>
               <span *ngIf="sub.attendance === 'ufm'">
                UFM
              </span>

              <span *ngIf="sub.attendance !== 'detained' && sub.attendance !== 'ufm'">
                <span *ngIf="sub.internalMarks">I - {{ sub.internalMarks }}<br></span>
                <span *ngIf="sub.externalMarks">E - {{ sub.externalMarks }}<br></span>
                <span *ngIf="sub.marks">Total - {{ sub.marks }}<br></span>
                <span *ngIf="sub.grade">{{ sub.grade }}</span>
              </span>


            </ng-container>

            <ng-template #noData>-</ng-template>

          </td>



          <td>{{ student.creditEarned }}</td>

          <td>{{ student.sgpa }}</td>

        </tr>

      </tbody>

    </table>

  </div>

</div>`,
      revaluationResultSheet: `
   <style>
  .result-container {
    width: 100%;
    max-width: 1400px;
    margin: auto;
    font-family: "Times New Roman", serif;
    color: #000;
  }

  .text-center {
    text-align: center;
  }

  /* HEADER */

  .result-container h2 {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 2px;
  }

  .result-container h3 {
    font-size: 18px;
    font-weight: bold;
    margin: 6px 0;
  }

  .result-container h4 {
    font-size: 16px;
    font-weight: bold;
    margin: 4px 0;
  }

  .result-container div {
    font-size: 14px;
  }

  /* TABLE */

  .result-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 15px;
    font-size: 13px;
  }

  .result-table th,
  .result-table td {
    border: 1px solid #000;
    padding: 5px;
    text-align: center;
  }

  .result-table thead th {
    font-weight: bold;
  }

  .result-table tbody td:nth-child(3) {
    text-align: left;
    padding-left: 10px;
  }

  .result-table td,
  .result-table th {
    font-size: 12px;
  }

  .result-table td {
    vertical-align: middle;
  }

  /* TABLE TITLE */

  .table-title {
    font-weight: bold;
    font-size: 15px;
    background: #f2f2f2;
  }

  /* GRADING TABLE */

  .grading-wrapper {
    width: 100%;
    margin: 25px auto 0;
  }

  .grading-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
  }

  .grading-table th,
  .grading-table td {
    border: 1px solid #000;
    padding: 5px;
    text-align: center;
  }

  .grading-note {
    font-weight: bold;
  }

  /* PRINT */

  @media print {

    .result-container {
      page-break-inside: avoid;
    }

  }
</style>


<div class="result-container" *ngFor="let displayData of displayDataArray">

  <!-- HEADER -->

  <div class="text-center">

    <h2>{{ displayData.entityDisplayName | uppercase }}</h2>

    <div>
      {{ displayData.entityAddress }},
      {{ displayData.entityCity }},
      {{ displayData.entityState }} - {{ displayData.entityPin }}
    </div>

    <h4>
      Revaluation Result Sheet - {{ displayData.metadata.examCalendar }}
    </h4>

    <h3>
      {{ displayData.metadata.course }}
      ({{displayData.metadata.stream}})
      - {{ displayData.metadata.batch }}
    </h3>

  </div>


  <!-- SCHEME OF EXAMINATION -->

  <table class="result-table">

    <thead>

      <tr>
        <th colspan="8" class="table-title">
          SCHEME OF EXAMINATION
        </th>
      </tr>

      <tr>
        <th rowspan="2">Sr.No.</th>
        <th rowspan="2">Subject Code</th>
        <th rowspan="2">Subject</th>
        <th rowspan="2">Internal Max. Marks</th>
        <th rowspan="2">Practical Max. Marks</th>
        <th rowspan="2">Theory Max. Marks</th>
        <th rowspan="2">Total Maximum Marks</th>
        <th rowspan="2">Credit</th>
      </tr>

    </thead>


    <tbody>
  <tr *ngFor="let student of displayData.students; let i = index">
    <td>{{ i + 1 }}</td>

    <td>
      {{ student.rollNo }} <br>
      <strong>{{ student.name }}</strong>
    </td>

    <td>{{ student.fatherName }}</td>

    <td>{{ student.motherName }}</td>

    <td>{{ student.regNo }}</td>

    <!-- SUBJECT MARKS -->
    <td *ngFor="let subject of displayData.examMaster.subjects">

      <ng-container *ngIf="student.subjectMap[subject.subjectCode] as sub; else noData">

        <span *ngIf="sub.attendance === 'detained'">
          Detained
        </span>

        <span *ngIf="sub.attendance === 'ufm'">
          UFM
        </span>

        <span *ngIf="sub.attendance !== 'detained' && sub.attendance !== 'ufm'">

          <span *ngIf="sub.internalMarks">
            I - {{ sub.internalMarks }}<br>
          </span>

          <span *ngIf="sub.externalMarks">
            E - {{ sub.externalMarks }}<br>
          </span>

          <span *ngIf="sub.marks">
            Total - {{ sub.marks }}<br>
          </span>

          <span *ngIf="sub.grade">
            {{ sub.grade }}
          </span>

        </span>

      </ng-container>

      <ng-template #noData>-</ng-template>

    </td>

    <!-- CREDIT / SGPA -->
    <td>
      <ng-container
        *ngIf="!(student.subjectMap); else failedSubjects">

        {{ student.creditEarned }}

      </ng-container>

      <ng-template #failedSubjects>
        <ng-container *ngFor="let subject of displayData.examMaster.subjects">

          <ng-container *ngIf="student.subjectMap[subject.subjectCode]?.grade == 'F'">

            {{ subject.subjectName }}<br>

          </ng-container>

        </ng-container>
      </ng-template>
    </td>

    <td>
      <ng-container
        *ngIf="!(student.subjectMap)">

        {{ student.sgpa }}

      </ng-container>
    </td>

  </tr>
</tbody>

  </table>


  <!-- GRADING SYSTEM -->

  <div class="grading-wrapper">

    <table class="grading-table">

      <tr>
        <th colspan="4" class="table-title">
          GRADING SYSTEM
        </th>
      </tr>
      <tr>
        <th>Academic Performance</th>
        <th>Range of Marks(%)</th>
        <th>Grades</th>
        <th>Grade Points</th>
      </tr>

      <tr *ngFor="let grade of displayData.gradeConfig">

        <td>{{ grade.remark?.join(', ') }}</td>

        <td>
          {{ grade.minMarks }} to {{ grade.maxMarks }}
        </td>

        <td>{{ grade.grade }}</td>

        <td>{{ grade.gradePoints }}</td>

      </tr>

    </table>
    <br>
    <br>
    <br>
    
    <!-- -->
    
  <div class="grading-wrapper">

    <table class="grading-table">

      <tr>
        <th colspan="4" class="table-title">
          Result Analyses
        </th>
      </tr>
      <tr>
        <th>S.No</th>
        <th>Subject Code</th>
        <th>Subject </th>
        <th>Type</th>
        <th>Students</th>
        <th>Pass</th>
        <th>Pass (%)</th>
        <th>Fail</th>
        <th>Fail (%)</th>
      </tr>

      <tr *ngFor="let data of displayData.resultAnalysesData.tableData;let ind=index">

        <td>{{ind+1}}</td>

        <td>
          {{ data.subjectCode }}
        </td>

        <td>{{ data.subjectName }}</td>

        <td>{{ data.subjectType }}</td>
        <td>{{ data.subjectType }}</td>
        <td>{{data.totalStudents}}</td>
        <td>{{data.passCount}}</td>
        <td>{{data.passPercentage}}</td>
        <td>{{data.failCount}}</td>
        <td>{{data.failPercentage}}</td>

      </tr>

    </table>
  </div>
    <br>
    <br>
    <br>
    <br>
    
      <table class="result-table">
        
      <thead>

        <!-- FIRST HEADER ROW -->
        
      <tr>
        <th colspan="4" class="table-title">
          Top 10 merit Students
        </th>
      </tr>
        <tr>

          <th rowspan="2">Sr.No.</th>
          <th rowspan="2">Autonomous Roll No / Name</th>
          <th rowspan="2">Father Name</th>
          <th rowspan="2">Mother Name</th>
          <th rowspan="2">College Roll No</th>

          <th *ngFor="let subject of displayData.examMaster.subjects">
            {{ subject.subjectCode }}
          </th>

          <th rowspan="2">Credit Earned</th>
          <th rowspan="2">SGPA</th>

        </tr>

      </thead>



      <tbody>

        <tr *ngFor="let student of displayData.students; let i = index">

          <td>{{ i + 1 }}</td>

          <td>
            {{ student.rollNo }} <br>
            <strong>{{ student.name }}</strong>
          </td>

          <td>{{ student.fatherName }}</td>

          <td>{{ student.motherName }}</td>

          <td>{{ student.regNo }}</td>



          <!-- SUBJECT MARKS -->
          <td *ngFor="let subject of displayData.examMaster.subjects">

            <ng-container *ngIf="student.subjectMap[subject.subjectCode] as sub; else noData">

              <span *ngIf="sub.attendance === 'detained'">
                Detained
              </span>
               <span *ngIf="sub.attendance === 'ufm'">
                UFM
              </span>

              <span *ngIf="sub.attendance !== 'detained' && sub.attendance !== 'ufm'">
                <span *ngIf="sub.internalMarks">I - {{ sub.internalMarks }}<br></span>
                <span *ngIf="sub.externalMarks">E - {{ sub.externalMarks }}<br></span>
                <span *ngIf="sub.marks">Total - {{ sub.marks }}<br></span>
                <span *ngIf="sub.grade">{{ sub.grade }}</span>
              </span>


            </ng-container>

            <ng-template #noData>-</ng-template>

          </td>



          <td>{{ student.creditEarned }}</td>

          <td>{{ student.sgpa }}</td>

        </tr>

      </tbody>

    </table>

  </div>

</div>`,

customDoc1:
 `
 <style>
 
 .container {
  font-family: Arial, sans-serif;
   margin-top: 50px;
   text-align: center;
 }
 
 h3, h4 {
   margin: 10px 0;
 }
 
 .student-image {
   border-radius: 50%;
   width: 150px;
   height: 150px;
   margin: 20px auto;
   background: #e9e9e9 url(student-image.jpg) no-repeat center;
   background-size: cover;
 }
 
 .school-logo {
   border-radius: 50%;
   width: 100px;
   height: 100px;
   margin: 20px auto;
   background: #e9e9e9 url(school-logo.jpg) no-repeat center;
   background-size: cover;
 }
 
 .border {
   border: 1px solid #ccc;
   margin-top: 50px;
   padding: 10px;
 }
 
 .powered-by {
   margin-top: 20px;
   font-size: 12px;
 }
</style>

<section style="font-family:Arial; font-size:14px; padding:20px;">

  <!-- OFFER LETTER -->
  <div style="display:flex; justify-content:space-between;">
    <div><strong>Letter No:</strong> {{displayData.letterNo}}</div>
    <div><strong>Dated:</strong> {{displayData.date}}</div>
  </div>

  <h2 style="text-align:center;">Offer Letter</h2>

  <p>
    Mr. {{displayData.name}} <br>
    S/o Mr. {{displayData.fatherName}} <br>
    {{displayData.address}} <br>
    Mob: {{displayData.mobile}}
  </p>

  <p>Dear Mr. {{displayData.name}},</p>

  <p>
    With reference to your application and subsequent interview, we are pleased to offer you the position of 
    <strong>{{displayData.designation}}</strong> in the Department of 
    <strong>{{displayData.department}}</strong> at 
    <strong>{{displayData.organization}}</strong>.
  </p>

  <p>
    You are requested to join on or before <strong>{{displayData.joiningDate}}</strong>.
  </p>

  <ul>
    <li>Your total monthly emoluments will be Rs. {{displayData.salary}}.</li>
    <li>You will be on probation for {{displayData.probationPeriod}}.</li>
    <li>You will be a full-time employee of the institute.</li>
    <li>You must follow all institutional rules and policies.</li>
  </ul>

  <p>
    Please submit all required documents at the time of joining.
  </p>

  <p>
    Authorized Signatory <br>
    {{displayData.organization}}
  </p>

  <hr>

  <!-- EMPLOYEE ID FORM -->
  <h3 style="text-align:center;">EMPLOYEE ID CARD FORM</h3>

  <p><strong>Name:</strong> {{displayData.name}}</p>
  <p><strong>Father’s Name:</strong> {{displayData.fatherName}}</p>
  <p><strong>Department:</strong> {{displayData.department}}</p>
  <p><strong>Employee Code:</strong> {{displayData.employeeCode}}</p>
  <p><strong>Date of Joining:</strong> {{displayData.joiningDate}}</p>
  <p><strong>Date of Birth:</strong> {{displayData.dob}}</p>
  <p><strong>Designation:</strong> {{displayData.designation}}</p>
  <p><strong>Address:</strong> {{displayData.address}}</p>
  <p><strong>Contact No:</strong> {{displayData.mobile}}</p>
  <p><strong>Emergency Contact:</strong> {{displayData.emergencyContact}}</p>

  <p>
    I hereby declare that the information provided above is true.
  </p>

  <hr>

  <!-- DOCUMENT CHECKLIST -->
  <h3>Documents Checklist</h3>

  <table border="1" width="100%" cellpadding="6">
    <tr>
      <th>S.N</th>
      <th>Documents</th>
      <th>Y/N</th>
      <th>Remarks</th>
    </tr>

    <tr><td>1</td><td>Resume</td><td>{{displayData.resume}}</td><td>{{displayData.resumeRemark}}</td></tr>
    <tr><td>2</td><td>PAN Card</td><td>{{displayData.pan}}</td><td>{{displayData.panRemark}}</td></tr>
    <tr><td>3</td><td>Address Proof</td><td>{{displayData.addressProof}}</td><td>{{displayData.addressProofRemark}}</td></tr>
    <tr><td>4</td><td>Aadhar Card</td><td>{{displayData.aadhar}}</td><td>{{displayData.aadharRemark}}</td></tr>
    <tr><td>5</td><td>Experience Certificate</td><td>{{displayData.experience}}</td><td>{{displayData.experienceRemark}}</td></tr>
  </table>

  <hr>

  <!-- NO DUES FORM -->
  <h3 style="text-align:center;">NO DUES FORM</h3>

  <p><strong>Name:</strong> {{displayData.name}}</p>
  <p><strong>Date:</strong> {{displayData.date}}</p>
  <p><strong>Department:</strong> {{displayData.department}}</p>
  <p><strong>Code:</strong> {{displayData.employeeCode}}</p>

  <table border="1" width="100%" cellpadding="6">
    <tr>
      <th>S.No</th>
      <th>Department</th>
      <th>Signature</th>
      <th>Authorized Signatory</th>
    </tr>

    <tr><td>1</td><td>Library</td><td></td><td></td></tr>
    <tr><td>2</td><td>Accounts</td><td></td><td></td></tr>
    <tr><td>3</td><td>IT Cell</td><td></td><td></td></tr>
    <tr><td>4</td><td>Computer Science</td><td></td><td></td></tr>
    <tr><td>5</td><td>HOD</td><td></td><td></td></tr>
  </table>

  <hr>

  <!-- EXPERIENCE CERTIFICATE -->
  <h3 style="text-align:center;">Experience Certificate</h3>

  <p>
    This is to certify that <strong>{{displayData.name}}</strong> worked as 
    <strong>{{displayData.designation}}</strong> in the Department of 
    <strong>{{displayData.department}}</strong> from 
    <strong>{{displayData.fromDate}}</strong> to 
    <strong>{{displayData.toDate}}</strong>.
  </p>

  <p>We wish {{displayData.name}} success in future.</p>

  <p>Authorized Signatory</p>

  <hr>

  <!-- NOC -->
  <h3 style="text-align:center;">No Objection Certificate</h3>

  <p>
    This is to certify that <strong>{{displayData.name}}</strong> (Employee Code: {{displayData.employeeCode}})
    is working as <strong>{{displayData.designation}}</strong> in the Department of 
    <strong>{{displayData.department}}</strong>.
  </p>

  <p>
    The institute has no objection to {{displayData.name}} applying elsewhere.
  </p>

  <p>Authorized Signatory</p>

  <hr>

  <!-- BONAFIDE -->
  <h3 style="text-align:center;">Bonafide Certificate</h3>

  <p>
    This is to certify that <strong>{{displayData.name}}</strong>, 
    S/o {{displayData.fatherName}}, residing at {{displayData.address}}, 
    is working with <strong>{{displayData.organization}}</strong> as 
    <strong>{{displayData.designation}}</strong>.
  </p>

  <p>
    This certificate is issued for {{displayData.purpose}}.
  </p>

  <p>Authorized Signatory</p>

</section>

`
,
coeAttendanceSheetTemplate: 
`<style>
  .logo-box { width: 80px; }
  .entity-logo { width: 100%; height: auto; }
  .university-details h2 { font-size: 22px; letter-spacing: 1px; }
  .university-details h4 { font-size: 16px; color: #333; }
  .main-attendance-table { width: 100%; border-collapse: collapse; border: 1px solid #000; }
  .main-attendance-table th {
    border: 1px solid #000;
    padding: 8px;
    background-color: #f8f9fa;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: bold;
    text-align: left;
  }
  .main-attendance-table td { border: 1px solid #000; padding: 0; }
  .photo-cell { padding: 10px !important; text-align: center; }
  .photo-box { width: 80px; height: 90px; border: 1px solid #ccc; margin: 0 auto; overflow: hidden; }
  .photo-box img { width: 100%; height: 100%; object-fit: cover; }
  .details-cell { padding: 10px !important; font-size: 13px; line-height: 1.6; }
  .detail-item { margin-bottom: 4px; }
  .nested-subject-table { width: 100%; height: 100%; border-collapse: collapse; }
  .nested-subject-table tr { border-bottom: none; }
  .nested-subject-table tr:last-child { border-bottom: none; }
  .nested-subject-table td { border: none !important; padding: 8px !important; font-size: 12px; vertical-align: baseline; }
  .nested-subject-table td:last-child { border-right: none !important; }
  .subject-name { font-weight: 500; }
  .ans-book-cell, .sign-cell { position: relative; padding-top: 20px !important; }
  .dotted-line { border-bottom: 1px dashed #666; width: 100%; height: 1px; }
  .v-align-top { vertical-align: top !important; }
  .footer-note { font-size: 11px; font-style: italic; color: #444; }
  tbody tr:nth-of-type(even) { background: transparent !important; }
</style>
<div class="header-section text-center">
            <div class="d-flex justify-content-between align-items-center mb-2">
                <div class="logo-box">
                    <img [src]="displayData.logo" *ngIf="displayData.logo" alt="logo" class="entity-logo">
                </div>
                <div class="university-details">
                    <h2 class="m-0 fw-bold">{{displayData.entityName}}</h2>
                    <h4 class="m-0">Confidential List for {{displayData.courseData.course}} {{displayData.courseData.subjectType | titlecase}} {{displayData.courseData.examType | titlecase}} Exam</h4>
                </div>
                <div class="empty-box"></div>
            </div>
        </div>
        <table class="main-attendance-table">
            <thead>
                <tr>
                    <th style="width: 100px;">Photo / Sign</th>
                    <th style="width: 300px;">Candidate Details</th>
                    <th>Subjects</th>
                    <th style="width: 80px;">Date</th>
                    <th style="width: 120px;">Ans Book No.</th>
                    <th style="width: 120px;">Signature</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let student of displayData.studentList">
                    <tr>
                        <td class="photo-cell v-align-top">
                            <div class="photo-box">
                                <img [src]="student.photo || '../../../../../assets/media/avatars/001-boy.svg'" alt="student photo">
                            </div>
                            <div class="sign-placeholder mt-2">
                            </div>
                        </td>
                        <td class="details-cell v-align-top">
                            <div class="detail-item"><strong>{{displayData.displayNames.rollNo}} :</strong> {{student.rollNo}}</div>
                            <div class="detail-item"><strong>Registration No. :</strong> {{student.regNo}}</div>
                            <div class="detail-item"><strong>Candidate's Name :</strong> {{student.name}}</div>
                            <div class="detail-item"><strong>Father's Name :</strong> {{student.fatherName}}</div>
                            <div class="detail-item"><strong>Examination :</strong> {{displayData.courseData.examName}} ({{displayData.courseData.examType | titlecase}})</div>
                        </td>
                        <td colspan="4" class="p-0 v-align-top">
                            <table class="nested-subject-table">
                                <tr *ngFor="let reg of student.formattedRegistrations">
                                    <td class="subject-name">{{reg.subjectCode}} - {{reg.subjectName}} ({{reg.subjectType | titlecase}})</td>
                                    <td style="width: 80px;" class="text-center fw-bold">{{reg.examDate | date:'dd/MM/yy'}}</td>
                                    <td style="width: 120px;vertical-align: bottom !important" class="ans-book-cell">
                                        <div class="dotted-line"></div>
                                    </td>
                                    <td style="width: 120px;vertical-align: bottom !important" class="sign-cell">
                                        <div class="dotted-line"></div>
                                    </td>
                                </tr>
                                <tr *ngIf="!student.formattedRegistrations || student.formattedRegistrations.length === 0">
                                    <td colspan="4" class="text-center py-4">No subjects registered</td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
        <div class="footer-note mt-4">
            <p><strong>Note:-</strong> Centre Superintendent is requested to kindly ensure that the candidate has properly filled up all the above mentioned columns before signing the signature chart.</p>
        </div>
`,
dmcReportTemplate:
`
 <table class="table">
            <thead class="buttonTheme">
                <tr>
                    <th class="colorWhite">S.No.</th>
                    <th width="30%" class="colorWhite">Student's Detail</th>
                    <th class="colorWhite">Student Image</th>
                    <th class="colorWhite">Subject</th>
                    <th class="colorWhite tooltip-custom" title="Maximum Marks" >M.M.</th>
                    <th class="colorWhite" title="Passing Marks">P.M.</th>
                    <th class="colorWhite" title="Obtained Marks">Got</th>
                    <th class="colorWhite">Result</th>
                    <th class="colorWhite">Signature</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let record of displayData.groupedData; let i = index">
                    <tr [ngClass]="{'student-row-even-bg': i % 2 === 0, 'student-row-odd-bg': i % 2 !== 0}">
                        <!-- Student details cell with rowspan -->
                        <td [attr.rowspan]="record.subjects.length + 2">{{i+1}}</td>
                        <td [attr.rowspan]="record.subjects.length + 2">
                            <b>Name</b> : {{ record?.name }}<br>
                            <b>Father's Name</b> : {{ record?.fatherName }}<br>
                            <b>{{displayData?.displayNames.regNo}}</b> : {{ record?.regNo || '-' }}<br>
                            <b>Social Category</b> : {{ record?.socialCategory || '-' }}<br>
                            <b>{{displayData?.displayNames.rollNo}}</b> : {{ record?.rollNo || '-' }}<br>
                            <b>University Registration Number</b> : {{ record?.srn }}<br>
                            <b>Remarks</b> : <span>{{ record?.remarkList}} </span>
                        </td>
                        
                        <td [attr.rowspan]="record.subjects.length + 2"> 
                            <img *ngIf="record.photo" [src]="record.photo" width="120px" height="120px">
                        </td>
                        <!-- First subject row -->
                        <td>{{ record.subjects[0].name }}</td>
                        <td>{{ record.subjects[0].totalMarks }}</td>
                        <td>{{ record.subjects[0].passingMarks }}</td>
                        <td>{{ record.subjects[0].obtainedMarks }}</td>
                        <td>{{ record.subjects[0]?.remark?.toUpperCase() }}
                        </td>
                        <td [attr.rowspan]="record.subjects.length + 2"></td>
                    </tr>

                    <!-- Remaining subjects -->
                    <tr [ngClass]="{'student-row-even-bg': i % 2 === 0, 'student-row-odd-bg': i % 2 !== 0}" *ngFor="let sub of record.subjects.slice(1)">
                      
                        <td>{{ sub.name }}</td>
                        <td>{{ sub.totalMarks }}</td>
                        <td>{{ sub.passingMarks }}</td>
                        <td>{{ sub.obtainedMarks }}</td>
                        <td>{{ sub?.remark?.toUpperCase()  }}</td>
                    </tr>

                    <!-- Total row -->
                    <tr [ngClass]="{'student-row-even-bg': i % 2 === 0, 'student-row-odd-bg': i % 2 !== 0}">
                      
                        <td><b>Total</b></td>
                        <td>{{ getTotal(record.subjects, 'totalMarks') }}</td>
                        <td></td>
                        <td>{{ getTotal(record.subjects, 'obtainedMarks') }}</td>
                        <td>
                            ({{ (getTotal(record.subjects, 'obtainedMarks') / getTotal(record.subjects, 'totalMarks') *
                            100) | number:'1.2-2' }}%)
                        </td>
                    </tr>
                    <!-- M.Sheet Date row -->
                    <tr [ngClass]="{'student-row-even-bg': i % 2 === 0, 'student-row-odd-bg': i % 2 !== 0}">
                        
                        <td><b>M.Sheet Date :</b> {{ record.marksheetDate || '-' }}</td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
`,
resultAnalysisReportTemplate: 
     `
    <style>
      .result-container {
        width: 100%;
        max-width: 1400px;
        margin: auto;
        font-family: "Times New Roman", serif;
        color: #000;
      }

      .text-center {
        text-align: center;
      }

      .result-container h2 {
        font-size: 22px;
        font-weight: bold;
        margin-bottom: 2px;
      }

      .result-container h3 {
        font-size: 18px;
        font-weight: bold;
        margin: 6px 0;
      }

      .result-container h4 {
        font-size: 16px;
        font-weight: bold;
        margin: 4px 0;
      }

      .grading-wrapper {
        width: 100%;
        margin: 25px auto 0;
      }

      .grading-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 13px;
      }

      .grading-table th,
      .grading-table td {
        border: 1px solid #000;
        padding: 5px;
        text-align: center;
      }

      .table-title {
        font-weight: bold;
        font-size: 15px;
        background: #f2f2f2;
      }

      @media print {
        .result-container {
          page-break-inside: avoid;
        }
      }
    </style>

    <div class="result-container" >

      <!-- HEADER -->
      <div class="text-center">
        <h2>{{ displayData.entityDisplayName | uppercase }}</h2>
        <div>
          {{ displayData.entityAddress }},
          {{ displayData.entityCity }},
          {{ displayData.entityState }} - {{ displayData.entityPin }}
        </div>
        <h4>Result Analysis Report - {{ displayData.metadata.examCalendar }}</h4>
        <h3>
          {{ displayData.metadata.course }}
          ({{ displayData.metadata.stream }})
          - {{ displayData.metadata.batch }}
        </h3>
      </div>

      <div class="grading-wrapper">
        <table class="grading-table">
          <tr>
            <th colspan="9" class="table-title">
              Result Analyses
            </th>
          </tr>
          <tr>
            <th>S.No</th>
            <th>Subject Code</th>
            <th>Subject </th>
            <th>Type</th>
            <th>Students</th>
            <th>Pass</th>
            <th>Pass (%)</th>
            <th>Fail</th>
            <th>Fail (%)</th>
          </tr>
          <tr *ngFor="let data of displayData.resultAnalysesData.tableData;let ind=index">
            <td>{{ind+1}}</td>
            <td>{{ data.subjectCode }}</td>
            <td>{{ data.subjectName }}</td>
            <td>{{ data.subjectType }}</td>
            <td>{{ data.totalStudents }}</td>
            <td>{{ data.passCount }}</td>
            <td>{{ data.passPercentage }}</td>
            <td>{{ data.failCount }}</td>
            <td>{{ data.failPercentage }}</td>
          </tr>
        </table>
      </div>
    </div>
    `,
    hodResultSheetTemplate: `
   <style>
  .result-container {
    width: 100%;
    max-width: 1400px;
    margin: auto;
    font-family: "Times New Roman", serif;
    color: #000;
  }

  .text-center {
    text-align: center;
  }

  /* HEADER */

  .result-container h2 {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 2px;
  }

  .result-container h3 {
    font-size: 18px;
    font-weight: bold;
    margin: 6px 0;
  }

  .result-container h4 {
    font-size: 16px;
    font-weight: bold;
    margin: 4px 0;
  }

  .result-container div {
    font-size: 14px;
  }

  /* TABLE */

  .result-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 15px;
    font-size: 13px;
  }

  .result-table th,
  .result-table td {
    border: 1px solid #000;
    padding: 5px;
    text-align: center;
  }

  .result-table thead th {
    font-weight: bold;
  }

  .result-table tbody td:nth-child(3) {
    text-align: left;
    padding-left: 10px;
  }

  .result-table td,
  .result-table th {
    font-size: 12px;
  }

  .result-table td {
    vertical-align: middle;
  }

  /* TABLE TITLE */

  .table-title {
    font-weight: bold;
    font-size: 15px;
    background: #f2f2f2;
  }

  /* GRADING TABLE */

  .grading-wrapper {
    width: 100%;
    margin: 25px auto 0;
  }

  .grading-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
  }

  .grading-table th,
  .grading-table td {
    border: 1px solid #000;
    padding: 5px;
    text-align: center;
  }

  .grading-note {
    font-weight: bold;
  }

  /* PRINT */

  @media print {

    .result-container {
      page-break-inside: avoid;
    }

  }
</style>


<div class="result-container" *ngFor="let displayData of displayDataArray">

  <!-- HEADER -->

  <div class="text-center">

    <h2>{{ displayData.entityDisplayName | uppercase }}</h2>

    <div>
      {{ displayData.entityAddress }},
      {{ displayData.entityCity }},
      {{ displayData.entityState }} - {{ displayData.entityPin }}
    </div>

    <h4>
      HOD Result Sheet - {{ displayData.metadata.examCalendar }}
    </h4>

    <h3>
      {{ displayData.metadata.course }}
      ({{displayData.metadata.stream}})
      - {{ displayData.metadata.batch }}
    </h3>

  </div>


  <!-- SCHEME OF EXAMINATION -->

  <table class="result-table">

    <thead>

      <tr>
        <th colspan="8" class="table-title">
          SCHEME OF EXAMINATION
        </th>
      </tr>

      <tr>
        <th rowspan="2">Sr.No.</th>
        <th rowspan="2">Subject Code</th>
        <th rowspan="2">Subject</th>
        <th rowspan="2">Internal Max. Marks</th>
        <th rowspan="2">Practical Max. Marks</th>
        <th rowspan="2">Theory Max. Marks</th>
        <th rowspan="2">Total Maximum Marks</th>
        <th rowspan="2">Credit</th>
      </tr>

    </thead>


    <tbody>

      <tr *ngFor="let subject of displayData.examMaster?.subjects; let i = index">

        <td>{{ i + 1 }}</td>

        <td>{{ subject.subjectCode }}</td>

        <td>{{ subject.subjectName }}</td>

        <td>{{ subject.internalMaxMarks }}</td>

        <td>{{ subject.practicalMaxMarks }}</td>

        <td>{{ subject.externalMaxMarks }}</td>

        <td>{{ subject.maxMarks }}</td>

        <td>{{ subject.creditValue }}</td>

      </tr>

      <tr>

        <td colspan="6" class="text-center">

          <strong>Total Marks</strong>

        </td>

        <td>

          <strong>{{ displayData.totalOfAllSubjects }}</strong>

        </td>

        <td></td>

      </tr>

    </tbody>

  </table>


  <!-- RESULT TABLE -->

  <table class="result-table">

    <thead>

      <!-- FIRST HEADER ROW -->

      <tr>

        <th rowspan="2">Sr.No.</th>
        <th rowspan="2">Autonomous Roll No / Name</th>
        <th rowspan="2">Father Name</th>
        <th rowspan="2">Mother Name</th>
        <th rowspan="2">College Roll No</th>

        <th *ngFor="let subject of displayData.examMaster?.subjects">
          {{ subject.subjectCode }}
        </th>

        <th rowspan="2">Credit Earned</th>
        <th rowspan="2">SGPA</th>

      </tr>

    </thead>


    <tbody>

      <tr *ngFor="let student of displayData.students; let i = index">

        <td>{{ i + 1 }}</td>

        <td>
          {{ student.rollNo }} <br>
          <strong>{{ student.name }}</strong>
        </td>

        <td>{{ student.fatherName }}</td>

        <td>{{ student.motherName }}</td>

        <td>{{ student.regNo }}</td>

        <!-- SUBJECT MARKS -->
        <td *ngFor="let subject of displayData.examMaster?.subjects">

          <ng-container *ngIf="student.subjectMap[subject.subjectCode] as sub; else noData">

            <span *ngIf="sub.attendance === 'detained'">
              Detained
            </span>

            <span *ngIf="sub.attendance === 'ufm'">
              UFM
            </span>

            <span *ngIf="sub.attendance !== 'detained' && sub.attendance !== 'ufm'">

              <span *ngIf="sub.internalMarks">
                I - {{ sub.internalMarks }}<br>
              </span>

              <span *ngIf="sub.externalMarks">
                E - {{ sub.externalMarks }}<br>
              </span>

              <span *ngIf="sub.marks">
                Total - {{ sub.marks }}<br>
              </span>

              <span *ngIf="sub.grade">
                {{ sub.grade }}
              </span>

            </span>

          </ng-container>

          <ng-template #noData>-</ng-template>

        </td>

        <!-- CREDIT / SGPA -->
        <td>
          <ng-container
            *ngIf="!(student.subjectMap); else failedSubjects">

            {{ student.creditEarned }}

          </ng-container>

          <ng-template #failedSubjects>
            <ng-container *ngFor="let subject of displayData.examMaster?.subjects">

              <ng-container *ngIf="student.subjectMap[subject.subjectCode]?.grade == 'F'">

                {{ subject.subjectName }}<br>

              </ng-container>

            </ng-container>
          </ng-template>
        </td>

        <td>
          <ng-container
            *ngIf="!(student.subjectMap)">

            {{ student.sgpa }}

          </ng-container>
        </td>

      </tr>

    </tbody>

  </table>


  <!-- GRADING SYSTEM -->

  <div class="grading-wrapper">

    <table class="grading-table">

      <tr>
        <th colspan="4" class="table-title">
          GRADING SYSTEM
        </th>
      </tr>

      <tr>
        <th>Academic Performance</th>
        <th>Range of Marks(%)</th>
        <th>Grades</th>
        <th>Grade Points</th>
      </tr>

      <tr *ngFor="let grade of displayData.gradeConfig">

        <td>{{ grade.remark?.join(', ') }}</td>

        <td>
          {{ grade.minMarks }} to {{ grade.maxMarks }}
        </td>

        <td>{{ grade.grade }}</td>

        <td>{{ grade.gradePoints }}</td>

      </tr>

    </table>

  </div>

</div>`,
    hodResultSheet: `
   <style>
  .result-container {
    width: 100%;
    max-width: 1400px;
    margin: auto;
    font-family: "Times New Roman", serif;
    color: #000;
  }

  .text-center {
    text-align: center;
  }

  /* HEADER */

  .result-container h2 {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 2px;
  }

  .result-container h3 {
    font-size: 18px;
    font-weight: bold;
    margin: 6px 0;
  }

  .result-container h4 {
    font-size: 16px;
    font-weight: bold;
    margin: 4px 0;
  }

  .result-container div {
    font-size: 14px;
  }

  /* TABLE */

  .result-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 15px;
    font-size: 13px;
  }

  .result-table th,
  .result-table td {
    border: 1px solid #000;
    padding: 5px;
    text-align: center;
  }

  .result-table thead th {
    font-weight: bold;
  }

  .result-table tbody td:nth-child(3) {
    text-align: left;
    padding-left: 10px;
  }

  .result-table td,
  .result-table th {
    font-size: 12px;
  }

  .result-table td {
    vertical-align: middle;
  }

  /* TABLE TITLE */

  .table-title {
    font-weight: bold;
    font-size: 15px;
    background: #f2f2f2;
  }

  /* GRADING TABLE */

  .grading-wrapper {
    width: 100%;
    margin: 25px auto 0;
  }

  .grading-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
  }

  .grading-table th,
  .grading-table td {
    border: 1px solid #000;
    padding: 5px;
    text-align: center;
  }

  .grading-note {
    font-weight: bold;
  }

  /* PRINT */

  @media print {

    .result-container {
      page-break-inside: avoid;
    }

  }
</style>


<div class="result-container" *ngFor="let displayData of displayDataArray">

  <!-- HEADER -->

  <div class="text-center">

    <h2>{{ displayData.entityDisplayName | uppercase }}</h2>

    <div>
      {{ displayData.entityAddress }},
      {{ displayData.entityCity }},
      {{ displayData.entityState }} - {{ displayData.entityPin }}
    </div>

    <h4>
      HOD Result Sheet - {{ displayData.metadata.examCalendar }}
    </h4>

    <h3>
      {{ displayData.metadata.course }}
      ({{displayData.metadata.stream}})
      - {{ displayData.metadata.batch }}
    </h3>

  </div>


  <!-- SCHEME OF EXAMINATION -->

  <table class="result-table">

    <thead>

      <tr>
        <th colspan="8" class="table-title">
          SCHEME OF EXAMINATION
        </th>
      </tr>

      <tr>
        <th rowspan="2">Sr.No.</th>
        <th rowspan="2">Subject Code</th>
        <th rowspan="2">Subject</th>
        <th rowspan="2">Internal Max. Marks</th>
        <th rowspan="2">Practical Max. Marks</th>
        <th rowspan="2">Theory Max. Marks</th>
        <th rowspan="2">Total Maximum Marks</th>
        <th rowspan="2">Credit</th>
      </tr>

    </thead>


    <tbody>

      <tr *ngFor="let subject of displayData.examMaster?.subjects; let i = index">

        <td>{{ i + 1 }}</td>

        <td>{{ subject.subjectCode }}</td>

        <td>{{ subject.subjectName }}</td>

        <td>{{ subject.internalMaxMarks }}</td>

        <td>{{ subject.practicalMaxMarks }}</td>

        <td>{{ subject.externalMaxMarks }}</td>

        <td>{{ subject.maxMarks }}</td>

        <td>{{ subject.creditValue }}</td>

      </tr>

      <tr>

        <td colspan="6" class="text-center">

          <strong>Total Marks</strong>

        </td>

        <td>

          <strong>{{ displayData.totalOfAllSubjects }}</strong>

        </td>

        <td></td>

      </tr>

    </tbody>

  </table>


  <!-- RESULT TABLE -->

  <table class="result-table">

    <thead>

      <!-- FIRST HEADER ROW -->

      <tr>

        <th rowspan="2">Sr.No.</th>
        <th rowspan="2">Autonomous Roll No / Name</th>
        <th rowspan="2">Father Name</th>
        <th rowspan="2">Mother Name</th>
        <th rowspan="2">College Roll No</th>

        <th *ngFor="let subject of displayData.examMaster?.subjects">
          {{ subject.subjectCode }}
        </th>

        <th rowspan="2">Credit Earned</th>
        <th rowspan="2">SGPA</th>

      </tr>

    </thead>


    <tbody>

      <tr *ngFor="let student of displayData.students; let i = index">

        <td>{{ i + 1 }}</td>

        <td>
          {{ student.rollNo }} <br>
          <strong>{{ student.name }}</strong>
        </td>

        <td>{{ student.fatherName }}</td>

        <td>{{ student.motherName }}</td>

        <td>{{ student.regNo }}</td>

        <!-- SUBJECT MARKS -->
        <td *ngFor="let subject of displayData.examMaster?.subjects">

          <ng-container *ngIf="student.subjectMap[subject.subjectCode] as sub; else noData">

            <span *ngIf="sub.attendance === 'detained'">
              Detained
            </span>

            <span *ngIf="sub.attendance === 'ufm'">
              UFM
            </span>

            <span *ngIf="sub.attendance !== 'detained' && sub.attendance !== 'ufm'">

              <span *ngIf="sub.internalMarks">
                I - {{ sub.internalMarks }}<br>
              </span>

              <span *ngIf="sub.externalMarks">
                E - {{ sub.externalMarks }}<br>
              </span>

              <span *ngIf="sub.marks">
                Total - {{ sub.marks }}<br>
              </span>

              <span *ngIf="sub.grade">
                {{ sub.grade }}
              </span>

            </span>

          </ng-container>

          <ng-template #noData>-</ng-template>

        </td>

        <!-- CREDIT / SGPA -->
        <td>
          <ng-container
            *ngIf="!(student.subjectMap); else failedSubjects">

            {{ student.creditEarned }}

          </ng-container>

          <ng-template #failedSubjects>
            <ng-container *ngFor="let subject of displayData.examMaster?.subjects">

              <ng-container *ngIf="student.subjectMap[subject.subjectCode]?.grade == 'F'">

                {{ subject.subjectName }}<br>

              </ng-container>

            </ng-container>
          </ng-template>
        </td>

        <td>
          <ng-container
            *ngIf="!(student.subjectMap)">

            {{ student.sgpa }}

          </ng-container>
        </td>

      </tr>

    </tbody>

  </table>


  <!-- GRADING SYSTEM -->

  <div class="grading-wrapper">

    <table class="grading-table">

      <tr>
        <th colspan="4" class="table-title">
          GRADING SYSTEM
        </th>
      </tr>

      <tr>
        <th>Academic Performance</th>
        <th>Range of Marks(%)</th>
        <th>Grades</th>
        <th>Grade Points</th>
      </tr>

      <tr *ngFor="let grade of displayData.gradeConfig">

        <td>{{ grade.remark?.join(', ') }}</td>

        <td>
          {{ grade.minMarks }} to {{ grade.maxMarks }}
        </td>

        <td>{{ grade.grade }}</td>

        <td>{{ grade.gradePoints }}</td>

      </tr>

    </table>

  </div>

</div>`
  }
  



  




  

 
}
